;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking = AE.booking || (function() {
    /*
    DEPENDENCIES: AE
    */

    var APP = {
        init: function() {
            /*
            This is where we set variables and things that will only live inside the closure. Local
            variables will only live in here, and will not be accessible to the browser's inspector.

            Props are defined only upon init, so we can load the modules in any order. If we declared
            them outside of init then modules calling other modules would throw errors. This way, those
            calls are only made after everything is loaded and the various init functions are called.

            The APP object is just a shorthand so we can have an easy reference instead of the possibly
            long, dot-syntaxed name that will be returned. You can call this by "APP" only in here.
            After this is all returned, other modules will know the object by its full name. In this
            case, that would be AE.booking.
            */

            /* WEBAE3-3811 - set up data for FCR price range slider. */
            try {
                    var aJustTheRates = _.pluck(AEdata.booking.quote.oRates,'estimate');
                    var minRate = _.min(aJustTheRates),
                        maxRate = _.max(aJustTheRates),
                        priceSum = 0;
                    var minRateRounded = Math.floor(minRate),
                        maxRateRounded = Math.ceil(maxRate);
                    _.each(aJustTheRates,function(justThisRate){
                        priceSum += justThisRate;
                    });
                    var averagePrice = priceSum / aJustTheRates.length;
                    var avgPriceRounded = Math.round(averagePrice);
                } catch (err) {

                }
            /**/
            APP.props = {
                $travelDetails: $('.ae-checkout #HasTravelDetails'), // Travel Details Checkbox
                $travelComments: $('.ae-checkout #DetailsComments'), // Travel Details Comment Textarea
                $paymentType: $('.ae-checkout #paytype'), // Show Correct Payment Type
                $hostedPaymentType: $('.ae-checkout #hostedpaytype'), // Show Correct Payment Type for Hosted Checkout
                $airlineName: $('.ae-checkout #airlinename'), // Airline input for Checkout
                $airline: $('.ae-checkout #airline'), // Airline hidden input for Checkout
                $termsLink: $('.ae-checkout label[for="tc"] span a'), // Airline hidden input for Checkout
                $LongTermRentalNote: $('#aebooking a.ltrNote'), // Long Term Rental Note Link
                $upgradeButton: $('.insurance-package .package-button'), // Radio Button Container
                $upgradeRadio: $('.insurance-package .package-button input[type="radio"]'), // Insurance Upgrade Radio Buttons
                $packageHeaders: '.package-header', // Insurance Upgrade Headers - cost
                $packageHeaderTitles: '.insurance-package-title', // Insurance Upgrade Headers - title
                $packageCostInfo: '.package-cost-info', // Packages cost and note
                $packageItems: '.package-lineitems', // Insurance Upgrade Line Items
                $packagePromo: '.package-valuebar', // Insurance Upgrade Line Items
                $packageButtons: '.package-button', // Insurance Upgrade Radio Buttons
                $radioButtonLabels: '.package-button label', // Insurance Upgrade Radio Buttons Labels
                $modifySearchButton: $('.btn--modify', '#aebooking'),
                $carDetailsButton: $('.btn--car-details', '#aebooking'),
                $selectedInsurance: $('.selected input.radio__insurance'),
                $rateCeiling: maxRateRounded,
                $rateFloor: minRateRounded,
                $rateMax: maxRateRounded,
                $rateMin: minRateRounded,
                oRateObjects: (AEdata.booking && AEdata.booking.quote && AEdata.booking.quote.oRates) ? AEdata.booking.quote.oRates : {},
                oCarObjects: (AEdata.booking && AEdata.booking.quote && AEdata.booking.quote.oCars) ? AEdata.booking.quote.oCars : {},
                oTrustScore: {'bUseTrustScore' : oSite.useTrustScore, 'strTrustScoreScript' : oSite.muraPluginPath + 'lib/trustScoreManager.cfc'}, //we currently only use trustscore in booking
                resultsLayout: oSite.resultsLayout // WEBAE3-6161 Determines which results layout to use (matrix or no matrix)
            };

            //FCR price slider
            if ((AE.props.siteCode === 'FCR' || APP.props.resultsLayout == 'nomatrix') && AEdata.booking.state.step === 'getrates') {
                var sliderlow = document.getElementById('slider_thumb_low');
                sliderlow.setAttribute("aria-valuemin", minRateRounded);
                sliderlow.setAttribute("aria-valuemax", maxRateRounded);
                sliderlow.setAttribute("aria-valuenow", minRateRounded);
                $(sliderlow).find('.mdc-slider__value-indicator-text').text(minRateRounded);

                var sliderhigh = document.getElementById('slider_thumb_high');
                sliderhigh.setAttribute("aria-valuemin", minRateRounded);
                sliderhigh.setAttribute("aria-valuemax", maxRateRounded);
                sliderhigh.setAttribute("aria-valuenow", maxRateRounded);
                $(sliderhigh).find('.mdc-slider__value-indicator-text').text(maxRateRounded);

                var elPrefix = AE.props.siteCode === 'FCR' ? 'fcr-' : '';
                if (AE.props.affiliate == 'FLIGHTCTRZA') {
                    $rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
                    $rateFingerRateCurrencySymbol.addClass(elPrefix+'currency-symbol-sub');
                    $rateFingerRateCurrencySymbol.append('R')

                    document.getElementById(elPrefix+'avgtotal').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>R</span>"+avgPriceRounded;
                    document.getElementById(elPrefix+'minprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>R</span>"+minRateRounded;
                    document.getElementById(elPrefix+'maxprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>R</span>"+maxRateRounded;
                } else if (AE.props.affiliate == 'FLIGHTCTRGB') {
                    $rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
                    $rateFingerRateCurrencySymbol.addClass(elPrefix+'currency-symbol-sub');
                    $rateFingerRateCurrencySymbol.append('£')

                    document.getElementById(elPrefix+'avgtotal').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>£</span>"+avgPriceRounded;
                    document.getElementById(elPrefix+'minprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>£</span>"+minRateRounded;
                    document.getElementById(elPrefix+'maxprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>£</span>"+maxRateRounded;
                } else {
                    document.getElementById(elPrefix+'avgtotal').innerHTML = "$"+avgPriceRounded;
                    document.getElementById(elPrefix+'minprice').innerHTML = "$"+minRateRounded;
                    document.getElementById(elPrefix+'maxprice').innerHTML = "$"+maxRateRounded;
                }

            }

            AE.ui.addBodyClickTask({ func: APP.onBodyClick });
            if (AEdata && AEdata.booking && AEdata.booking.events){
                AE.ga.gaArrayProcess(AEdata.booking.events);
            }
            if (AEdata && AEdata.modify && AEdata.modify.events){
                AE.ga.gaArrayProcess(AEdata.modify.events);
            }

            // Do various things that happen once upon init
            if (AE.booking.matrix && $('#matrix')[0]) {
                AE.booking.matrix.init();
            }
            if (AE.booking.matrix.results && AE.props.oTranslations) {
                // Supports rendering Booking UI widgets using AE.booking.matrix.results functions on booking steps after the matrix
                AE.booking.matrix.results.initTranslations(AE.props.oTranslations);
            }
            if (AE.booking.terms) {
                AE.booking.terms.init();
            }
            if (AE.booking.optEquip) {
                AE.booking.optEquip.init();
            }
            if (AE.booking.saveQuote && $('#aebooking')[0] && AEdata.booking.props.uuid !== '' && AEdata.booking.props.uuid !== undefined && !_.contains(['searchwait', 'makebooking', 'searchagain'], AEdata.booking.state.step)) {
                AE.booking.saveQuote.init();
            }

            if (AE.booking.searchwait && (AEdata && AEdata.booking && AEdata.booking.state.step === 'searchwait')) {
                AE.booking.searchwait.init();
            }

            if (AE.booking.options && (AEdata && AEdata.booking && AEdata.booking.state.step === 'getoptions')) {
                AE.booking.options.init();
            }
            if (AE.booking.options && AE.booking.options.ui && (AEdata && AEdata.booking && AEdata.booking.state.step === 'bookform')) {
                if(AEdata.booking.quote.oQuote.oRules.oCancelIns.OFFER){// WEBAE3-3747
                    // initialize enough properties to let Checkout page use AE.booking.options.ui.updateLineItems()
                    AE.booking.options.ui.props = {
                        $lineItems: $('div.utbar__container--lineItems'),
				        $totals: $('span.total__container--utbar'),
                        lineItemProps: AE.booking.options.ui.getLineItemProps()
                    };
                }
            }

            // WEBAE3-6521 - Display charged currency if site is using a different display currency - Derek 14 Nov 2024
            if(AEdata && AEdata.booking && (AEdata.booking.state.step === 'bookform' || AEdata.booking.state.step === 'getupgrade' || AEdata.booking.state.step === 'hostedpayment') && AEdata.booking.quote.oCurrency.BASE != AEdata.booking.quote.oCurrency.QUOTE) {
                AE.booking.options.ui.updateChargeCurrencyDisplay();
            }


            if (AE.booking.hostedCheckout) {
                AE.booking.hostedCheckout.init();
            }

            APP.props.$modifySearchButton.on('click', function(event) {
                /*
                var _this = $(this);
                var _selector = _this.attr('data-selector');
                var _id= _selector.replace('#','');

                // var $fn_getInputs = AE.ui.search.autocomplete.getInputs();
                // var $puInput = $fn_getInputs.$puLoc;
                // var $doInput = $fn_getInputs.$doLoc;
                // var $chkBox = $('#chk-diff');
                //
                // if( $doInput.val() !== '' && ( $puInput.val() !== $doInput.val() ) ){
                //      $chkBox.trigger('click');
                // }

                AE.ui.dialog.launch({
                	id: _id,
                	dialogClass:'search--modify',
                	titleBar: true,
                	applyUI: false,
                	autoupdate: true,
                	draggable: false,
                	//resizable: true,
                	modal: true,
                	content: $( _selector )
                });
                return AE.ui.dialog.update(true);
                */
            }).on('mouseenter', function(event) {
                return $(this).addClass('ui-state-focus');
            }).on('mouseleave', function(event) {
                return $(this).removeClass('ui-state-focus');
            });

            APP.props.$carDetailsButton.on('mouseenter', function(event) {
                return $(this).addClass('ui-state-focus');
            }).on('mouseleave', function(event) {
                return $(this).removeClass('ui-state-focus');
            });
            //JQMIGRATE: jQuery.fn.hover() is deprecated

            /* BOOKING STEP SPECIFIC BEHAVIORS */
/*
            // GETRATES
            if ( $( '#aebooking' ).hasClass( 'getrates' ) ) {
            	// width adjust matrix map dispaly view
            	AE.addResizeTask( {
            		func: function () {
            			APP.centerMatrixViewController();
            		}
            	} );

            	APP.centerMatrixViewController();
            }
*/

            // GETOPTIONS
            if ($('#aebooking').hasClass('getoptions')) {
                // height adjust Upgrade Boxes
                AE.addResizeTask({
                    func: function() {
                        APP.optionStepResizes();
                    }
                });

                // prevent text clipping in height adjustment functions on init of resize function
                setTimeout(function() { APP.optionStepResizes(); }, 50);
            }

            // WEBAE3-6014 GA4 Ecommerce Begin_Checkout Tracking
            if (AEdata && AEdata.booking && AEdata.booking.state && AEdata.booking.state.step && AEdata.booking.state.step == 'bookform'){
                var thisRate = APP.props.oRateObjects[AEdata.booking.state.rateID];
                var eCommItem = AE.booking.matrix.events.buildGA4EcommerceItem(thisRate.ID, thisRate.carName, thisRate.suppName, thisRate.SIPP, thisRate.estimate);
                AE.booking.matrix.events.emitGA4EcommerceEvent('begin_checkout', AE.booking.matrix.events.buildEcommerceCheckout(AEdata.booking.quote.oCurrency.QUOTE, thisRate.estimate, [eCommItem]));
            }

            // BOOKFORM
            if ($('#aebooking').hasClass('bookform') || $('#aemodify .checkout_container')[0]) { //|| $('#checkout').hasClass('bookform')

                // Build Airline auto complete
                if (APP.props.$airlineName.attr('type') !== "hidden") {
                    APP.airlineNames(APP.props.$airlineName, APP.props.$airline);
                }

                // Long Term Rental Note Link Click Open Terms
                APP.props.$LongTermRentalNote.on('click', function(event) {
                    event.preventDefault(); // stop link
                    APP.props.$termsLink.trigger('click'); // trigger terms click
                });

                // Hide and Show travel to other countries comment input
                APP.props.$travelDetails.on('click', function(event) {
                    if ($(event.target).is(':checked')) {
                        APP.props.$travelComments.removeClass('visuallyhidden');
                        APP.props.$travelComments.find('textarea').prop('required', true);
                        APP.props.$travelComments.find('textarea').addClass('required');
                        APP.props.$travelComments.find('textarea').attr('tabindex', 1);
                    } else {
                        APP.props.$travelComments.addClass('visuallyhidden');
                        APP.props.$travelComments.find('textarea').prop('required', false);
                        APP.props.$travelComments.find('textarea').removeClass('required');
                        APP.props.$travelComments.find('textarea').attr('tabindex', -1);
                    }
                    //APP.props.$travelComments.toggleClass('visuallyhidden');
                });

                //WEBAE3-3718 determine which submit button was clicked and set vars to apply spinning gear appropriately
                //WEBAE3-4052 added dataBillingRequired/billingrequired attributes for validation based on button clicked
                $('#submitFormSecondary').on('click', function(event) {
                    AE.booking.saveQuote.deactivateExitModal();// Turn off "Email a Quote" pop-up when clicking on the form submit button
                    // checkoutSubmitBtn used in AE.forms.js > Validate Checkout to set spinner on clicked button only
                    checkoutSubmitBtn = {};
                    checkoutSubmitBtn.clicked = '#submitFormSecondary';
                    checkoutSubmitBtn.notclicked = '#submitForm';
                    checkoutSubmitBtn.billingrequired = 'default';
                    var dataPath = $('#submitFormSecondary').data('path');
                    var dataStep = $('#submitFormSecondary').data('step');
                    var dataBillingRequired = $('#submitFormSecondary').data('billingrequired');

                    if(dataBillingRequired){
                        checkoutSubmitBtn.billingrequired = dataBillingRequired;
                    }

                    if(dataPath && dataStep && AEdata && AEdata.booking && AEdata.booking.paths && AEdata.booking.paths[dataPath]){
                        $('#submitFormSecondary').closest('form').attr('action','https://'+AE.url.props.host+'/'+AEdata.booking.paths[dataPath]+'/');
                        $('#submitFormSecondary').closest('form').find('input[name=bookingstep]').val(dataStep);
                    }
                });
                $('#submitForm').on('click', function(event) {
                    AE.booking.saveQuote.deactivateExitModal();// Turn off "Email a Quote" pop-up when clicking on the form submit button
                    // checkoutSubmitBtn used in AE.forms.js > Validate Checkout to set spinner on clicked button only
                    checkoutSubmitBtn = {};
                    checkoutSubmitBtn.clicked = '#submitForm';
                    checkoutSubmitBtn.notclicked = '#submitFormSecondary';
                    checkoutSubmitBtn.billingrequired = 'default';
                    if(oSite.bIsDapTpDomain) {
                        //WEBAE3-5422 - we could probably use this method of reading the data attributes for all sites, but it was only an issue with DAP
                        var dataPath = $('#submitForm').attr('data-path');
                        var dataStep = $('#submitForm').attr('data-step');
                        var dataBillingRequired = $('#submitForm').attr('data-billingrequired');
                    } else {
                        var dataPath = $('#submitForm').data('path');
                        var dataStep = $('#submitForm').data('step');
                        var dataBillingRequired = $('#submitForm').data('billingrequired');
                    }

                    if(dataBillingRequired){
                        checkoutSubmitBtn.billingrequired = dataBillingRequired;
                    }

                    if(dataPath && dataStep && AEdata && AEdata.booking && AEdata.booking.paths && AEdata.booking.paths[dataPath]){
                        $('#submitForm').closest('form').attr('action','https://'+AE.url.props.host+'/'+AEdata.booking.paths[dataPath]+'/');
                        $('#submitForm').closest('form').find('input[name=bookingstep]').val(dataStep);
                    }

                });
                //WEBAE3-3718 end submit button processing

                //WEBAE3-4488 DAP payment type options
                $("input[name='dappaytype']").on('click', function(event) {
                    if(oSite.bIsDapTpDomain) {
                        var radioValue = $("input[name='dappaytype']:checked").val();
                        var dataButtonText = $('input[name="dappaytype"]:checked').attr("data-btn");
                        if(radioValue == 'invoice') {
                            $('#submitForm').html(dataButtonText);
                            $("#ae-checkout").attr('action', '/confirmation/');
                            $("#submitForm").attr('data-step', 'makebooking');
                            $("#submitForm").attr('data-path', 'B');
                            $("#submitForm").attr('data-billingrequired', 'off');
                            $("#ccInfoBlock").hide();
                            $("#cardnumber").attr('required', false);
                            $("#cvc").attr('required', false);
                            $("#expmonth").attr('required', false);
                            $("#expyear").attr('required', false);
                        } else if (radioValue == 'costestimate') {
                            $('#submitForm').html(dataButtonText);
                            $("#ae-checkout").attr('action', '/confirmation/');
                            $("#submitForm").attr('data-step', 'makebooking');
                            $("#submitForm").attr('data-path', 'B');
                            $("#submitForm").attr('data-billingrequired', 'off');
                            $("#ccInfoBlock").hide();
                            $("#cardnumber").attr('required', false);
                            $("#cvc").attr('required', false);
                            $("#expmonth").attr('required', false);
                            $("#expyear").attr('required', false);
                        } else {
                            if (oSite.useHostedCheckout) {
                                $('#submitForm').html(dataButtonText);
                                if (typeof AEdata.modify === 'undefined') {
                                    $("#submitForm").attr('data-step', 'hostedpayment');
                                    $("#ae-checkout").attr('action', '/payment/');
                                } else {
                                    $("#submitForm").attr('data-step', 'ccadd');
                                    $("#ae-checkout").attr('action', '/my-booking/');
                                }
                                $("#submitForm").attr('data-path', 'H');
                            } else {
                                $('#submitForm').html(dataButtonText);
                                if (typeof AEdata.modify === 'undefined') {
                                    $("#submitForm").attr('data-step', 'makebooking');
                                    $("#ae-checkout").attr('action', '/confirmation/');
                                    $("#ccInfoBlock").show();
                                    $("#cardnumber").attr('required', true);
                                    $("#cvc").attr('required', true);
                                    $("#expmonth").attr('required', true);
                                    $("#expyear").attr('required', true);
                                } else {
                                    $("#submitForm").attr('data-step', 'ccadd');
                                    $("#ae-checkout").attr('action', '/my-booking/');
                                }
                                $("#submitForm").attr('data-path', 'B');
                            }
                        }
                    }
                });
          
                //WEBAE3-7114 - TravelBrands: Update Checkout Page processing for Adyen Hosted Checkout
                $('#paytype').on('change', function(event) {
                    if(oSite.isTravelBrands && oSite.useHostedCheckout) {
                        var menuValue = $('#paytype').val();
                        //var dataButtonText = $('input[name="dappaytype"]:checked').attr("data-btn");
                        if(_.contains(['CH', 'WR', 'OP'], menuValue)) {
                            //$('#submitForm').html(dataButtonText);
                            //WEBAE3-7113 - for pay by check, we have different targets if new or existing bookings
                            if (typeof AEdata.modify === 'undefined') {
                                //new booking
                                $("#ae-checkout").attr('action', '/confirmation/');
                                $("#submitForm").attr('data-step', 'makebooking');
                            } else {
                                //paying quote
                                $("#ae-checkout").attr('action', '/my-booking/');
                                $("#submitForm").attr('data-step', 'ccadd');
                            }

                            $("#submitForm").attr('data-path', 'B');
                            $("#submitForm").attr('data-billingrequired', 'off');
                            $("#ccInfoBlock").hide();
                            $("#cardnumber").attr('required', false);
                            $("#cvc").attr('required', false);
                            $("#expmonth").attr('required', false);
                            $("#expyear").attr('required', false);
                        } else {
                            if (oSite.useHostedCheckout) {
                                //$('#submitForm').html(dataButtonText);
                                if (typeof AEdata.modify === 'undefined') {
                                    $("#submitForm").attr('data-step', 'hostedpayment');
                                    $("#ae-checkout").attr('action', '/payment/');
                                } else {
                                    $("#submitForm").attr('data-step', 'ccadd');
                                    $("#ae-checkout").attr('action', '/my-booking/');
                                }
                                $("#submitForm").attr('data-path', 'H');
                            } else {
                                //$('#submitForm').html(dataButtonText);
                                if (typeof AEdata.modify === 'undefined') {
                                    $("#submitForm").attr('data-step', 'makebooking');
                                    $("#ae-checkout").attr('action', '/confirmation/');
                                    $("#ccInfoBlock").show();
                                    $("#cardnumber").attr('required', true);
                                    $("#cvc").attr('required', true);
                                    $("#expmonth").attr('required', true);
                                    $("#expyear").attr('required', true);
                                } else {
                                    $("#submitForm").attr('data-step', 'ccadd');
                                    $("#ae-checkout").attr('action', '/my-booking/');
                                }
                                $("#submitForm").attr('data-path', 'B');
                            }
                        }
                    }
                });

                // Hide and Show selected payment options based on selection
                APP.props.$paymentType.on('change', function(event) {
                    // Clear out defaults
                    $('.paytype_form').addClass('visuallyhidden');
                    $('.paytype_form input,.paytype_form select').removeAttr('required');
                    $('.paytype_form .payment--input, .paytype_form .styled--select').removeClass('required ui-state-valid ui-state-invalid');
                    var payment = $(event.target).val();
                    var container = 'creditcard';

                    switch (payment) {
                        case 'DD':
                            // debit cards
                            container = 'debitcard';
                            $('.billing_container').removeClass('visuallyhidden');
                            break;
                        case 'CH':
                            // checks
                            container = 'check';
                            $('.billing_container').addClass('visuallyhidden');
                            break;
                        case 'WR':
                            container = 'check';
                            $('.billing_container').addClass('visuallyhidden');
                            break;
                        case 'OP':
                            $('.billing_container').addClass('visuallyhidden');
                            $('.check_container').addClass('visuallyhidden');
                            $('.creditcard_container').addClass('visuallyhidden');
                            //WEBAE3-7113 make sure check number input is cleared on toggle
                            $('#ae-checkout').find('#checknum').val('');

                            container = 'none';
                            break;
                        default:
                            // credit cards
                            container = 'creditcard';
                            $('.billing_container').removeClass('visuallyhidden');
                            //WEBAE3-7113 make sure check number input is cleared on toggle
                            $('#ae-checkout').find('#checknum').val('');

                            break;
                    }

                    $('.' + container + '_container').removeClass('visuallyhidden'); // Show selected container
                    $('.' + container + '_container .payment--input').addClass('required'); // Add required to show asterisk
                    $('.' + container + '_container input').attr('required', 'required'); // Add required to init validation
                    $('.' + container + '_container select').attr('required', 'required'); // Add required to init validation
                    AE.forms.props.$paymentRequire.change();
                    AE.forms.props.$debitRequire.change();
                });

                APP.props.$paymentType.change();

                // Lock driver information when modifying a voucher
                if (AEdata && AEdata.booking && AEdata.booking.props.ismodify) {
                    $('#aebooking .checkout_container').find('input#firstname,input#lastName,input#age,input#email,input#reemail').prop('readonly', true);
                    //,input#numPass,input#telephone Removed number of pass and telephone
                }
                $('#taName, #taNum, #assocName, #assocNum').on('change',function(event){
                    var toggleOpen = $(event.target).closest('.toggle').find('.toggler').hasClass('open');
                    // WEBAE3-3866 - don't clear out fields on voucher lookup page
                    if(AEdata && AEdata.modify && AEdata.modify.state === 'view') { toggleOpen = true; }
                    // WEBAE3-2270 - need to prevent clearing out taName if it's shown outside of a toggler (length = 0)
                    if (!toggleOpen && $(event.target).closest('.toggle').length != 0) { $(event.target).val(''); }

                    // WEBAE3-2766 - restore validation visibility to Travel Agent inputs
                    var thisContainer = $(event.target).closest('.ui-state-none').removeClass('ui-state-none');
                });
                $('#markupAmt').on('change',function(event){
                    var toggleOpen = $(event.target).closest('.toggle').find('.toggler').hasClass('open');

                    // WEBAE3-2766 - restore validation visibility to Travel Agent inputs
                    var thisContainer = $(event.target).closest('.ui-state-none').removeClass('ui-state-none');
                });
            }


            // HOSTEDPAYMENT
            if ($('#aebooking').hasClass('hostedpayment') || $('#aemodify').hasClass('hostedpayment'))  { //|| $('#aemodify .checkout_container')[0]) || $('#checkout').hasClass('bookform')
                // Hide and Show selected payment options based on selection
                APP.props.$hostedPaymentType.on('change', function(event) {
                    // Clear out defaults
                    $('.paytype_form').addClass('visuallyhidden');
                    $('.paytype_form .payment--input, .paytype_form .styled--select').removeClass('required ui-state-valid ui-state-invalid');
                    var payment = $(event.target).val();
                    var container = 'creditcard';

                    switch (payment) {
                        case 'DD':
                            // debit cards
                            container = 'debitcard';
                            $('.billing_container').removeClass('visuallyhidden');
                            break;
                        case 'CH':
                            // checks
                            container = 'check';
                            $('.billing_container').addClass('visuallyhidden');
                            break;
                        case 'WR':
                            container = 'checkwr';
                            $('.billing_container').addClass('visuallyhidden');
                            break;
                        default:
                            // credit cards
                            container = 'creditcard';
                            $('.billing_container').removeClass('visuallyhidden');
                            break;
                    }

                    $('.' + container + '_container').removeClass('visuallyhidden'); // Show selected container
                });

                APP.props.$hostedPaymentType.change();

            }

            // MODIFY
            if ( $("body").is("#mybooking") ) {
                APP.airlineNames(APP.props.$airlineName, APP.props.$airline);

                var $dapHideRateDD = $('select#noRateInvoiceDAP'),
                    $dapHideCommissionDD = $('select#noCommissionInvoiceDAP');
                if($dapHideRateDD.length && $dapHideCommissionDD.length){
                    if($dapHideRateDD.val() === 'true'){
                        $dapHideCommissionDD.prop('disabled',true);
                    }
                    $dapHideRateDD.on('change', function(event) {
                        if(event.target.value === 'true'){
                            $dapHideCommissionDD.prop('disabled',true);
                        } else {
                            $dapHideCommissionDD.prop('disabled',false);
                        }
                    });
                }
            }

            // RENDER UI WIDGETS
            APP.renderWidgets();

            if(AE.props.useWEBAE3_4586) {
                $('#option_update--side').addClass('visuallyhidden');
            }
        },
        processCheckout: function(event) {
        	// deprecated function that shouldn't be called per WEBAE3-1204
        	// if it is, set flag, submit form, return empty struct and move on

            // Set the flag that indicates this function, processCheckout, has already run
            AEdata.booking.state.submitConfirmed = true;

            //Re-submit the form and make the booking
            $('#ae-checkout').submit();

            return {};

        },
        centerMatrixViewController: function() {
            var windowWidth = $(window).width();
            var controllerWidth = $('#matrix__browse').width();
            var controlCenter = (windowWidth / 2) - (controllerWidth / 2);

            if (controlCenter > 0) {
                $('#matrix_and_map .control_container').css('left', controlCenter);
            }
        },
        optionStepResizes: function() {
            if(AE.props.siteCode !== 'FCR') {
                AE.heightAdjust($('ul.package-lineitems li'));
                AE.heightAdjust(APP.props.$packageHeaders); // match dark package header cost heights
                AE.heightAdjust(APP.props.$packageHeaderTitles); // match dark package header title heights
                AE.heightAdjust(APP.props.$packageItems); // match line item heights - non palm
                AE.heightAdjust(APP.props.$packagePromo); // match top value bar heights
                APP.setRadioHeight(APP.props.$packageButtons, APP.props.$packageHeaders); // set radio boxes for palm
                APP.centerRadiosMobile(APP.props.$packageButtons, APP.props.$radioButtonLabels); // set radio labels in center of container
                APP.setPackageCostPosition(); // Position cost and note to bottom of package header box on lap and desk views
            }
        },
        setRadioHeight: function() {
            var eleHeight = 0;

            $(arguments[1]).each(function() {
                eleHeight = eleHeight > $(this).height() ? eleHeight : $(this).height();
            });
            $(arguments[0]).each(function() {
                $(this).height(''); // set to auto height
            });

            if (AE.getSiteViewType() === 'palm') {
                $(arguments[0]).each(function() {
                    $(this).height(eleHeight); // set height of the tallest element
                });
            }
        },
        setPackageCostPosition: function() {
            $(APP.props.$packageCostInfo).each(function() {
                var _packCostInfo = $(this);
                if (AE.getSiteViewType() !== 'palm') {
                    _packCostInfo.position({
                        my: 'center top',
                        at: 'center top+10',
                        of: $(this).parent().parent(),
                        within: $(this).parent().parent()
                    });
                } else {
                    $(this).removeAttr('style'); // Remove styles for palm
                }
            });
        },
        centerRadiosMobile: function() {
            var buttonHeight = ($(arguments[0]).height() / 2) - 22;
            var buttonWidth = ($(arguments[0]).outerWidth() / 2) - 19;

            $(arguments[1]).each(function() {
                $(this).css('margin-top', ''); // set to auto height
                $(this).css('margin-left', ''); // set to auto width
            });
            if (AE.getSiteViewType() === 'palm') {
                $(arguments[1]).each(function() {
                    $(this).css('margin-top', buttonHeight); // set height buttons
                    $(this).css('margin-left', buttonWidth); // set width buttons
                });
            }
        },
        airlineNames: function() {
            // Cache module properties to shorter names and get data from markup.
            var $airlineName = APP.props.$airlineName,
                $airlineHid = APP.props.$airline,
                arrAirlines = $airlineName.data('airlinelist') || null,
                currentKey = null;
            // Cache the airline name data atrribute from HTML to a variable, start the current as null.
            //Forced to use a val that is not in the query was 'WI' --- WEBAE3-5499
            objDefault = { label: $('.ae-checkout #airlinename').data('default'), value: 'ZXX' },
                objCurrent = { label: $airlineName.val(), value: $airlineHid.val() };

            // If there's no value for this variable, then return.
            if (!arrAirlines) { return; }

            // Get rid of giant data attribute in the markup.
            $airlineName.removeData('airlinelist').removeAttr('data-airlinelist');

            /*
            This function is used when the autocomplete closes and when a user clicks out of the widget.
            If the input is matched to the value in the data, then it does nothing. If something doesn't
            match, then it makes adjustments.
            */
            function correctInput(type) {
                if (objCurrent) {
                     if ($airlineName.val() === objCurrent.label) {
                        // The input isn't empty, and it matches the current label, then make sure that the
                        // hidden input matches the current object's value.
                        $airlineHid.val(objCurrent.value);

                    } else if ($airlineName.val() === '') {
                        // The user has left the input empty on purpose, so leave it blank and set the
                        // hidden input to the walk-in default.
                        $airlineHid.val('ZXX');
                    } else if ($airlineHid.val() === 'ZXX' || !$airlineName.val().includes($airlineHid.val())) {
                        // The user has left the input empty on purpose, so leave it blank and set the
                        // hidden input to the walk-in default.
                        $airlineName.val('');
                    }
                } else {
                    // The objCurrent variable isn't defined, so set the inputs to their defaults.
                    $airlineName.val(objDefault.label);
                    $airlineHid.val(objDefault.value.substr(0, 2));
                }
            }

            // Convert the data string into a JSON array of objects.
            arrAirlines = JSON.parse(decodeURIComponent(arrAirlines));
            if($('html').hasClass('ua-mobile') || $('html').hasClass('tablet')) {
                /* Custom autocomplete widget built to replace jQuery ui widget below [Derek Hill - 10/11/22 - WEBAE3-5153] */
                //$('.airlinename-wrap').append('<ul id="airline_autocompletelist"></ul>');
                var $autocomp_list = $('<ul>');
                $autocomp_list.attr('id', 'airline_autocompletelist');
                for (var i = 0; i < arrAirlines.length; i++) {
                    arrAirlines[i].label = arrAirlines[i].label + ' (' + arrAirlines[i].value + ')';
                    $autocomp_list.append('<li><a>'+arrAirlines[i].label+'</a></li>');
                }

                $('.airlinename-wrap').append($autocomp_list);

                $('.airlinename-wrap #airlinename').attr('autocomplete', 'off');
                $('body').on('keypress','.airlinename-wrap #airlinename', function(e)
                {
                    /* Keyboard list navigation
                    if(e.which == 13) {
                        e.preventDefault();
                        closeAutocompleteList();
                    } else if(e.which == 40) {
                        console.log('down');
                        if($('#airline_autocompletelist li.matching.selected').length) {
                            var $selel = $('#airline_autocompletelist li.matching.selected').next();
                            $('#airline_autocompletelist li.matching.selected').removeClass('selected');
                            $selel.addClass('selected');
                        } else {
                            $('#airline_autocompletelist li.matching').eq(0).addClass('selected');
                        }
                    } else if(e.which == 38) {
                        console.log('up');
                        var $selel = $('#airline_autocompletelist li.matching.selected').prev();
                        $('#airline_autocompletelist li.matching.selected').removeClass('selected');
                        $selel.addClass('selected');
                    } else { */
                        var airlineVal = $(this).val().toLowerCase();
                        if(airlineVal.length >= 1) {
                            $('#airline_autocompletelist li').each(function()
                            {
                                if($(this).text().toLowerCase().indexOf(airlineVal) >= 0) {
                                    $(this).addClass('matching');
                                } else {
                                    $(this).removeClass('matching');
                                }
                            });

                            $autocomp_list.addClass('active');
                        } else {
                            closeAutocompleteList();
                            if ($airlineHid.val() === 'ZXX' || !$airlineName.val().includes($airlineHid.val())) {
                                // The user has left the input empty on purpose, so leave it blank and set the
                                // hidden input to the walk-in default.
                                $airlineName.val('');
                            }
                        }
                });

                $('body').on('blur', '.airlinename-wrap #airlinename', function()
                {
                    setTimeout(function()
                    {
                        closeAutocompleteList();
                        if ($airlineHid.val() === 'ZXX' || !$airlineName.val().includes($airlineHid.val())) {
                            // The user has left the input empty on purpose, so leave it blank and set the
                            // hidden input to the walk-in default.
                            $airlineName.val('');
                        }

                    }, 500);
                });

                $('.airlinename-wrap').on('click', '#airline_autocompletelist li', function()
                {
                    var thisval = $(this).text();
                    var hval = thisval.split(' (')[1].replace(')', '');

                    $('.airlinename-wrap #airlinename').val(thisval);
                    $('.airlinename-wrap #airline').val(hval);

                    closeAutocompleteList();
                   if ($airlineHid.val() === 'ZXX' || !$airlineName.val().includes($airlineHid.val())) {
                        // The user has left the input empty on purpose, so leave it blank and set the
                        // hidden input to the walk-in default.
                        $airlineName.val('');
                    }
                });

                function closeAutocompleteList()
                {
                    $autocomp_list.removeClass('active');
                }
            } else {

                /*
                Creating a custom widget which inherits from the autocomplete widget. This allows us
                to make changes without affecting any other autocomplete instances. However, it does
                allow us to make a bunch of other widgets with the new rules if we want to, by using
                the new name "airNames". This is a one-off, but it can be a template for other widgets.


                The _renderMenu and _renderItem functions will be overriden by the widget instance, so
                those are set up to run the new functions or fall back to defaults.
                */

                for (var i = 0; i < arrAirlines.length; i++) {
                    arrAirlines[i].label = arrAirlines[i].label + ' (' + arrAirlines[i].value + ')';
                }

                /* jQuery UI Accordion widget (breaking, so disabled temporarily) */

                $.widget("ui.airNames", $.ui.autocomplete, {
                    _renderItem: function(ul, item) {
                        return $('<li>')
                            .append($('<a>').html(decodeURI(item.label)))
                            .appendTo(ul);
                    }
                });

                // Creating our one-and-only airNames widget. Due to the way we've restructured the markup
                // for scrolling purposes, we need to use the appendTo method to keep the autocomplete widget
                // in the same branch of the DOM as it's source content. Since this one will never be in a
                // dialog, we'll just attach it to the scroll-content element.
                $airlineName.airNames({
                    // change source to match label and value starting values in each string
                    source: function(request, response) {
                        var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(request.term), "i");
                        response($.grep(arrAirlines, function(value) {
                            return matcher.test(value.label) || matcher.test(value.value);
                        }));
                    },
                    appendTo: '#scroll-content',
                    minLength: 2,
                    delay: 0,
                    create: function() {

                        $(this).airNames('widget')
                            .addClass('airlinemenu')
                            .css({
                                'max-height': 500,
                                'overflow-y': 'scroll',
                                'overflow-x': 'hidden'
                            });
                    },
                    //search: function( event, ui ) {
                    //	if (currentKey === 8) {
                    //		event.preventDefault();
                    //	}
                    //},
                    focus: function(event, ui) {
                        $airlineName.val(ui.item.label);
                        $airlineHid.val(ui.item.value.substr(0, 3));
                    },
                    select: function(event, ui) {
                        objCurrent = $.extend(objCurrent, { label: ui.item.label, value: ui.item.value });
                        $airlineName.val(ui.item.label);

                        // Sometimes the data has three letters, but the back-end needs no more than two.
                        //WEBAE3-5364 - VM - changed substring to 3 instead of 2 this was causing an issue
                        //Also above on focus
                        $airlineHid.val(ui.item.value.substr(0, 3));
                        return false;
                    }
                    //close: function( event, ui ) {
                    //	correctInput(event.type);
                    //}
                }).on({
                    focusout: function(event) {
                            correctInput(event.type);
                        }//,
                        //keydown: function(event) {
                        //	currentKey = event.keyCode;
                        //}
                });
            }

            // jQuery UI 11.x forces a sort of double-click effect. The hover event (the focus method) will fire
            // on a tap, with a second tap required to fire the select method. To avoid this, we disable a few
            // events on iOS mobile only.
            //
            // By using the browser class for iPhones, the methods are unchanged for other devices.
            $('.ua-ios .bookform .ui-autocomplete').off('menufocus hover mouseover mouseenter');
        },
		onBodyClick: function(event, $target) {
                        
            if (oSite.bIsDapTpDomain || oSite.bIsAeTpDomain) {
                if ($target.hasClass('sort_vouchers')) {
                    event.preventDefault();
                    AE.booking.getSortedVoucherList('TP','0',$target.attr('data-col'),$target.attr('data-dir'),$target.attr('id'),$( "#filterVouchers" ).val());
                }
            }

            if (oSite.bIsDapTpDomain || oSite.bIsAeTpDomain) {
                if ($target.hasClass('vouchPage')) {
                    event.preventDefault();
                    //console.log($target.attr('data-idxPage'),$target.attr('data-idxStart'),$target.attr('data-idxType'));
                    AE.booking.getSortedVoucherList($target.attr('data-idxType'),$target.attr('data-idxStart'),$target.attr('data-col'),$target.attr('data-dir'),$target.attr('data-sortid'),$( "#filterVouchers" ).val());
                }

                if ($target.hasClass('btnVouchSearch')) {
                    event.preventDefault();
                    //console.log($( "#searchby" ).val());
                    //console.log($( "#start-date" ).val());
                    //console.log($( "#end-date" ).val());
                    AE.booking.getSortedVoucherList('TP',0,$target.attr('data-col'),$target.attr('data-dir'),$target.attr('data-sortid'),$( "#filterVouchers" ).val(),$( "#searchby" ).val(),$( "#start-date" ).val(),$( "#end-date" ).val());
                }

            } else {
                if ($target.hasClass('vouchPage')) {
                    event.preventDefault();
    //console.log($target.attr('data-idxPage'),$target.attr('data-idxStart'),$target.attr('data-idxType'));
                    AE.booking.getVoucherList($target.attr('data-idxType'),$target.attr('data-idxStart'));
                }
            }
            // Clicking this item automatically fires
			if ($target.hasClass('trg__search--again')) {
				event.preventDefault();
				AE.ui.search.formSubmit();
			}

			// Clicking this item automatically fires
			if ($target.hasClass('btn--modify')) {

				//var _this = $(this);
				var _selector = $target.attr('data-selector');
				var _id = _selector.replace('#', '');

				//var $fn_getInputs = AE.ui.search.autocomplete.getInputs();
				//var $puInput = $fn_getInputs.$puLoc;
				//var $doInput = $fn_getInputs.$doLoc;
				//var $chkBox = $('#chk-diff');
				//
				//if ($doInput.val() !== '' && ($puInput.val() !== $doInput.val())) {
				//	$chkBox.trigger('click');
				//}

				AE.ui.dialog.launch({
					id: _id,
					dialogClass: 'search--modify',
					titleBar: true,
					applyUI: false,
					autoupdate: true,
					draggable: false,
					//resizable: true,
					modal: true,
					content: $(_selector),
					width: 950
				});
				AE.ui.dialog.update(true);
				AE.heightAdjust('.searchcrumbs_container');
			}

			//  Overrides the default click action and opens the clicked link in a new window
			if ($target.parent().hasClass('lookupError')) {
				event.preventDefault();
				var linkOverride = $(event.target);
				var linkUrl = linkOverride.attr('href');
				var linkTarget = '_blank';
				var options = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes";
				return window.open(linkUrl, linkTarget, options);
			}

            // Travel Agent Section of Checkout form conditionally include inputs in tab order
            if($target.hasClass('toggler') && $target.data('togglee') === '#ta__block--details .togglee'){
                $('#ta__block--details input').attr('tabindex', ($target.hasClass('open'))? 1 : -1);
            }

            if($target.hasClass('trg__cancel-ins--click')){
                AE.ui.disableClicks();
                $.ajax({
                    url: '/plugins/ae3/lib/BookingAjax.cfc',
                    dataType: "json",
                    data: {
                        method: 'setCancelInsurance',
                        bookingid: AEdata.booking.props.uuid,
                        rateID: AEdata.booking.state.rateID,
                        dropID: AEdata.booking.state.dropID,
                        cncl: ($target.prop('checked')) ? 1 : ''
                    },
                    success:function(data) {
                        if(data.oLineItems)
                            {AE.booking.options.ui.updateLineItems(data.oLineItems);
                            /*WEBAE3-6137 if we're showing a modify new payment note, make sure we update display price
                            if user toggles cancel insurance */
                            if ($target.prop('checked')){
                                $('#modPayNote span.newModPrice').text($('#modPayNote span.newModPrice').attr('data-withcancelins'));
                            } else {
                                $('#modPayNote span.newModPrice').text($('#modPayNote span.newModPrice').attr('data-withoutcancelins'));
                            }
                        }
                        AE.ui.enableClicks();
                    },
                    fail:function() {
                        AE.ui.enableClicks();
                    }
                });
            }

            //WEBAE3-5228 START body click for trust score matrix result
            if(AE.booking.props.oTrustScore.bUseTrustScore){
                if ( ($target.parents().hasClass('booking___trustscore') || $target.parents().hasClass('trust-score-inner') || $target.parents().hasClass('trust-score__widget') ||$target.parents().hasClass('cardetails-caroperator')) && !$target.parents().hasClass('tsWidgetIgnore') ){
                    let supp = $target.closest('div.trust-score__widget');
                    let $supplier = $target.closest('.cardetails-caroperator');
                    let supplier_name = $supplier.find('.trust-score__widget').attr('data-supplier');
                    let supplier_img = $supplier.find('img').attr('src');
                    //let country = (oSite.path_info !== '/my-booking/') ? AEdata.booking.quote.oQuote.oPU.country : $supplier.find('.trust-score__widget').attr('data-country');
                    var country = '';
                    var city    = '';
                    switch(oSite.path_info) {
                        case '/results/':
                            country = AEdata.booking.quote.oQuote.oPU.country;
                          break;
                        default:
                            country = $supplier.find('.trust-score__widget').attr('data-country');
                    }
                    AE.booking.trustScoreModal(
                        country,
                        city,
                        supplier_name.toLowerCase(),
                        supplier_img,
                        'dialog-trustScore'
                    );
                }
            }
            //WEBAE3-5228 END

            //WEBAE3-6135 Add class to checkout container based on which tab has been clicked (Allows CSS to show/hide additional info box)
            if($target.closest('[role="tab"]').length && $target.closest('.tab_container').length && $target.closest('.checkout_container').length) {
                const $tab = $target.closest('.tab_container').find('.ui-tabs-nav li[role="tab"].ui-tab.ui-tabs-active');
                const tabtarget = $tab.attr('aria-controls');
                $tab.closest('.checkout_container').addClass('curtab--'+tabtarget);
                if(tabtarget == 'tab_original--side') {
                    $tab.closest('.checkout_container').removeClass('curtab--tab_current--side');
                } else {
                    $tab.closest('.checkout_container').removeClass('curtab--tab_original--side');
                }
            }
        },
        renderWidgets: function(specs, notes, images) {
            specs = specs || true;
            notes = notes || true;
            images = images || true;
            if (specs) {
                $.each($('.trg__book-widget--car-specs'), function(i) {
                    /* EXPECTED MARKUP */
                    //<div class="trg__book-widget--car-specs" data-translbl="string" data-transfull="string" data-doors="int" data-passengers="int" data-smluggage="int"  data-mdluggage="int" data-lgluggage="int" data-hasac="boolean"></div>

                    var oSpecs = $(this).data();
                    $(this).addClass('cardetails-features push-half--bottom').append(AE.booking.matrix.results.buildSpecs(oSpecs.translbl, oSpecs.transfull, oSpecs.doors, oSpecs.passengers, oSpecs.smluggage, oSpecs.mdluggage, oSpecs.lgluggage, oSpecs.hasac));
                });
            }
            if (notes) {
                $.each($('.trg__book-widget--sippnotes'), function(i) {
                    /* EXPECTED MARKUP */
                    //<div class="trg__book-widget--sippnotes" data-sippnoteids="comma,delimited,list,of,SIPP,note,codes"></div>

                    var rawSIPPNotes = $(this).data('sippnoteids');
                    var aSIPPNotes = (rawSIPPNotes.length) ? rawSIPPNotes.split(',') : [];
                    //WEBAE3-7053 "prepend" instead of "append" sippnotes to keep upgrade page selling points at the bottom
                    $(this).addClass('cardetails-sippnotes').prepend(AE.booking.matrix.results.buildSippNotes(aSIPPNotes));
                });
            }
            if (images) {
                $.each($('.trg__book-widget--car-image'), function(i) {
                    /* EXPECTED MARKUP */
					/*
						<span class="trg__book-widget--car-image"
							data-img="URL"
							data-icon="Font Awesome Icon class"
							data-name="Title/Alt text"
						></span>
					*/
                    var $imgWidget = $(this);
                    $imgWidget.replaceWith($(document.createElement('img'))
                        .addClass('palm-one-whole cardetails-carimg')
                        .addClass($imgWidget.data('imgclass'))
                        .attr('itemprop', 'image')
                        .attr('title', $imgWidget.data('name'))
                        .attr('alt', $imgWidget.data('name'))
                        .attr('onError', 'AE.booking.matrix.results.noImage();')
                        .attr('src', $imgWidget.data('img'))
                        .attr('data-icon', $imgWidget.data('icon'))
                    );
                });
            }
        },
		applyInsuranceIncludeListOverrides: function(aIns, oArgs) {
			// A CF version of this function also exists in BookingKernel.cfc:applyInsuranceIncludeListOverrides()
			aIns = aIns || [];
			oArgs = oArgs || {};
			oRules = _.extend({ VAT: true, LIABILITY: true, FIRE: true, CALIFORNIANOTE: false }, oArgs);
            var arr = [];
			_.each(aIns, function(tempItem) {
				var vatCleared = true;
				if (!oRules.VAT) {
					if (tempItem.match(/^(\(?|\s*)(VAT|TVA|IVA)(\)?|\s*)$/i)) {
						vatCleared = false;
					}
				}

				var liabilityCleared = true;
				if (!oRules.LIABILITY) {
                //Remove the below line after Language Management gets updated (WEBAE3-3107 : 2019-10-18)
                if (tempItem.match(/Liability Insurance|Assurance résponsabilité civile|Assurance responsabilité civile ou "au tiers"|Assurance responsabilit&eacute; civile ou "au tiers"|Responsabilité civile ou "au tiers"|Responsabilit&eacute; civile ou "au tiers"|Assurance r&eacute;sponsabilit&eacute; civile|Responsabilit. civile ou "au tiers"/)) { liabilityCleared = false; }
					tempItem = tempItem.replace("showLiabilityIns", "hideLiabilityIns");

					// CA fix
					if (oRules.CALIFORNIANOTE) {
						tempItem = (AE.props.siteCode === 'CA') ? 'Assurance résponsabilité civile (sauf en California)' : 'Liability Insurance (except in California)';
					}
				}

				if (!oRules.FIRE) {
					tempItem = tempItem.replace("showFireIns", "hideFireIns");
				}

				// Add the updated insurance line back
				if (vatCleared && liabilityCleared) { arr.push(tempItem); }
			});

			return arr;
		},
        getVoucherList: function(reqType,startAt){
            //WEBAE3-3719
            if(!AEdata.voucherLists) AEdata.voucherLists = new Set();
            AE.ui.disableClicks();
            var bNotTP = false;
            if((oSite.bIsDapTpDomain == 'false' || oSite.bIsDapTpDomain == false) && (oSite.bIsAeTpDomain == 'false' || oSite.bIsAeTpDomain == false)) bNotTP = true;
            if(AEdata.voucherLists && (startAt in AEdata.voucherLists) && bNotTP) {
                //use data saved in local set instead of making XHR call
                AE.booking.renderVoucherList(AEdata.voucherLists[startAt],reqType,startAt);
                AE.ui.enableClicks();
            } else {
                //don't have this page yet so try to get it and save result
                $.ajax({
                    url: '/plugins/ae3/lib/BookingAjax.cfc',
                    dataType: "json",
                    data: {
                        method: 'getVoucherListXHR',
                        startAt: startAt,
                        reqType: reqType
                    },
                    success:function(data) {
                        AEdata.voucherLists[startAt] = data;//save in local set for use again
                        AE.booking.renderVoucherList(data,reqType,startAt);
                        AE.ui.enableClicks();
                    },
                    error:function() {
                        var failedXHR = new Set();
                        failedXHR['CURRENT'] = [];
                        AE.booking.renderVoucherList(failedXHR,reqType,startAt);
                        AE.ui.enableClicks();
                    }
                });
            }
        },
        getSortedVoucherList: function(reqType,startAt, sortCol, sortDir, sortID,searchText, searchby, startdate, enddate ){
        //this function assumes we are receiving all vouchers at once in the initial payload - WEBAE3-4640
            if(!AEdata.voucherLists) AEdata.voucherLists = new Set();
            AE.ui.disableClicks();
            
            if((AEdata.voucherLists && (startAt in AEdata.voucherLists) && typeof searchby === 'undefined') || (startAt > 0)) {

                //use data saved in local set instead of making XHR call
                AE.booking.renderVoucherList(AEdata.voucherLists[0],reqType,startAt,sortCol,sortDir,sortID,searchText);
                AE.ui.enableClicks();
            
            } else {
                //don't have this page yet so try to get it and save result

                $('.memres--curr--reservations').hide();
                //$('.dap_voucher_spinner').show();
                $('#vouchList').replaceWith('<div class="grid__item one-whole palm-one-whole soft--left" id="vouchList"><div class="wait-load  dap_voucher_spinner"><div class="wait-load push--top soft--top spinner__container"><div class="wrap" style="min-height: 74px;"><div class="spinner__div align-center fa-ae-5x"><i class="spinner fa fa-ae-spinner fa-spin fa-ae-5x spinner--black" aria-hidden="true"></i></div></div></div></div></div>');
                $.ajax({
                    url: '/plugins/ae3/lib/BookingAjax.cfc',
                    dataType: "json",
                    data: {
                        method: 'getVoucherListXHR',
                        startAt: startAt,
                        reqType: reqType,
                        searchby: searchby,
                        startdate: startdate,
                        enddate: enddate
                    },
                    success:function(data) {
                        AEdata.voucherLists[startAt] = data;//save in local set for use again
                        $('.dap_voucher_spinner').hide();
                        $('.memres--curr--reservations').show();
                        AE.booking.renderVoucherList(data,reqType,startAt,sortCol,sortDir,sortID);
                        AE.ui.enableClicks();
                    },
                    error:function() {
                        var failedXHR = new Set();
                        failedXHR['CURRENT'] = [];
                        AE.booking.renderVoucherList(failedXHR,reqType,startAt,sortCol,sortDir,sortID);
                        AE.ui.enableClicks();
                    },
                    timeout: 120000 // sets timeout to 120 seconds;
                });

            }

        },
        renderVoucherList: function(vouchers,reqType,startAt,sortCol,sortDir,sortID,searchText) {
            var displayHTML = '';
            var maxPerRequest = (oSite.bIsDapTpDomain) ? 50 : 30;//WEBAE3-5162 different pagination limits for DAP vs ATP/DTP
            if(typeof searchText === 'undefined') {
                var searchText = '';
            }
            
            // if search by Booking tab is active an no sort column has been clicked, sort by create date by default
            //WEBAE3-7044 - also check if sortID == 'undefined'
            if ($('#tabBooking').hasClass('activeVSTab') && (sortID == 0 || typeof sortID == 'undefined')) {
                sortCol = 'CREATEDATESORT';
            }
            if ($('#tabPickup').hasClass('activeVSTab') && (sortID == 0 || typeof sortID == 'undefined')) {
                sortCol = 'PUDATESORT';
            }
            if (typeof sortDir === 'undefined'){
                sortDir = 'desc';
            }

            //sort results
            //WEBAE3-7044 - do it this way
            vouchers.CURRENT = (_.sortBy(vouchers.CURRENT, sortCol));

            //sort by voucher number first, then the selected column, to keep results consistent.
            //WEBAE3-7044 - don't do it this way anymore. voucher numbers are no longer sequencial
            //initialSort = (_.sortBy(vouchers.CURRENT, 'FULLVOUCHNUM'));
            //vouchers.CURRENT = (_.sortBy(initialSort, sortCol));
            
            if(sortDir == 'desc') {
                vouchers.CURRENT = vouchers.CURRENT.reverse();
            }

            /*
            var sortedArray = _(patients).chain().sortBy(function(patient) {
                return patient[0].name;
            }).sortBy(function(patient) {
                return patient[0].roomNumber;
            }).value();
            */


            startAt = parseInt(startAt);
            //this display only supports reqType = 'TP' right now, refactor needed to support MY (my account) display
            if (!vouchers.CURRENT || (vouchers.CURRENT.length == 0 && reqType == 'TP' && startAt == 0)) {
                //if first page, show no vouchers,
                 displayHTML = AEdata.vouchListLabels.txt_no_res;//get this from JS defined on page
            } else {
                //we either have vouchers to display or went one page too far and need to keep pagination links
                //build pagination links
                var nextData = {};
                var prevData = {};
                //increment incoming index by max possible, unless less than max per request (less than max means no more coming)
                if (vouchers.CURRENT.length < maxPerRequest) {
                    nextData.activeLink = false;
                    nextData.idxStart=maxPerRequest; //this needs to have a value for vouchers to display initially.
                } else {
                    nextData.activeLink = true;
                    nextData.idxStart=startAt + maxPerRequest;
                    nextData.idxType="TP";
                    nextData.idxPage="next";
                }

                //decrement incoming index by max possible, but if first page, no active prev link
                if (startAt <= 1) {
                    prevData.activeLink = false;
                } else {
                    prevData.activeLink = true;
                    prevData.idxStart=startAt - maxPerRequest;
                    prevData.idxType="TP";
                    prevData.idxPage="prev";
                }

                if(oSite.bIsDapTpDomain) {

                    if (vouchers.CURRENT.length < (maxPerRequest+startAt)) {
                        nextData.activeLink = false;
                    }

                    //get first and last voucher index
                    firstVouch = prevData.idxStart + 1;
                    if (typeof prevData.idxStart === 'undefined'){
                        firstVouch = 1;
                        //prevData.idxStart = 0;
                    } else {
                        firstVouch = prevData.idxStart + maxPerRequest + 1;
                    }

                    /*if (vouchers.CURRENT.length < nextData.idxStart){
                        lastVouch = vouchers.CURRENT.length;
                    } else {*/
                        lastVouch = nextData.idxStart;
                   /* }*/

                   //change the sort direction class on the clicked column header after the table is rendered
                   if (sortDir == 'desc') {
                        var paginationSortOrder = 'desc';
                    } else {
                        var paginationSortOrder = 'asc';
                    }

                    if (typeof sortID === 'undefined'){
                        if ($('#tabBooking').hasClass('activeVSTab')) {
                            sortID = 'createdate_head';
                        } else {
                            sortID = 'pudate_head';
                        }

                    }

                    if (typeof sortCol === 'undefined'){
                        sortCol = 'PUDATESORT';
                    }

                    if (typeof sortDir === 'undefined'){
                        sortDir = 'desc';
                    }

                    lastdisplayStart = $('#displayStart').attr('data-val');
                    $('#displayStart').attr('data-val', (Number(lastdisplayStart)+50));
                    $('#firstshowing').replaceWith('<span id="firstshowing">'+lastdisplayStart+'</span>');
                                //alert('wait');

                    lastdisplayEnd = $('#displayEnd').attr('data-val');
                    $('#displayEnd').attr('data-val', (Number(lastdisplayEnd)+50));
                     $('#lastshowing').replaceWith('<span id="lastshowing">'+lastdisplayEnd+'</span>');
                                //alert('wait');

                        //console.log($('#displayStart').attr('data-val'));
                        //console.log($('#displayEnd').attr('data-val'));
                        //console.log('this one fired too');


                        //console.log(firstVouch);
                        //console.log(lastVouch);

                    displayHTML = '<div class="grid__item one-whole align-right">';

                    //build search/filter
                    displayHTML += '<div class="align-right three-quarters vouchcountwrapper" style="">';
                    displayHTML += '<span id="displayStart" data-val="1" style="display: none;"></span><span id="displayEnd" data-val="50" style="display: none;"></span>';
                    displayHTML += '<div class="grid__item -one-quarter palm-one-whole vouchcount" style="/*width: 250px;*/"><span class="vouchcounttext"><b><span id="vouchfound">'+vouchers.CURRENT.length+'</span> bookings</b> found for you</span> <input style="width: 220px;" type="text" name="filterVouchers" id="filterVouchers" placeholder="Narrow your search" value="'+searchText+'" size=""></div>';
                    //displayHTML += '<div class="grid__item -one-quarter palm-one-whole vouchcount" style="/*width: 250px;*/"><span class="vouchcounttext"><b>Showing bookings <span id="firstshowing">'+firstVouch+'</span> - <span id="lastshowing">'+lastVouch+'</span></b></span> <input style="width: 220px;" type="text" name="filterVouchers" id="filterVouchers" placeholder="Narrow your search" value="'+searchText+'" size=""></div>';
                    //displayHTML += '<div class="grid__item one-half palm-one-whole"><input type="text" name="filterVouchers" id="filterVouchers" placeholder="Narrow your search" value="'+searchText+'" size=""></div>';
                    displayHTML += '</div>';
                    //build page nav only if we have next/prev data. if just one page, no nav
                    if(nextData.activeLink === true || prevData.activeLink === true) {
                        displayHTML += '<div class="align-right vouchnav"><h4>';
                        if(prevData.activeLink){
                            displayHTML += '<a id="prevpage" class="vouchPage" href="" data-idxStart="'+prevData.idxStart+'" data-idxType="'+prevData.idxType+'" data-idxPage="'+prevData.idxPage+'" data-col="' + sortCol + '" data-dir="' + paginationSortOrder + '" data-sortid="' + sortID + '"><i class="push--right fa-ie-clickable fa fa-chevron-left"></i></a>';
                        } else {
                            displayHTML += '<span id="prevpage" class=""><i class="push--right fa fa-chevron-left color5"></i></span>';
                        }
                        if(nextData.activeLink){
                            displayHTML += '<a id="nextpage" class="vouchPage" href="" data-idxStart="'+nextData.idxStart+'" data-idxType="'+nextData.idxType+'" data-idxPage="'+nextData.idxPage+'" data-col="' + sortCol + '" data-dir="' + paginationSortOrder + '" data-sortid="' + sortID + '"><i class="push--left fa-ie-clickable fa fa-chevron-right"></i></a>';
                        } else {
                            displayHTML += '<span id="nextpage" class=""><i class="push--left fa fa-chevron-right color5"></i></span>';
                        }
                        displayHTML += '</h4></div>';
                    }
                    displayHTML += '</div>';
                } else {
                    //build page nav only if we have next/prev data. if just one page, no nav
                    if(nextData.activeLink === true || prevData.activeLink === true) {
                        displayHTML = '<div class="grid__item one-whole align-right"><h4>';
                        if(prevData.activeLink){
                            displayHTML += '<a class="vouchPage" href="" data-idxStart="'+prevData.idxStart+'" data-idxType="'+prevData.idxType+'" data-idxPage="'+prevData.idxPage+'"><i class="push--right fa-ie-clickable fa fa-chevron-left"></i></a>';
                        } else {
                            displayHTML += '<span class=""><i class="push--right fa fa-chevron-left color5"></i></span>';
                        }
                        if(nextData.activeLink){
                            displayHTML += '<a class="vouchPage" href="" data-idxStart="'+nextData.idxStart+'" data-idxType="'+nextData.idxType+'" data-idxPage="'+nextData.idxPage+'"><i class="push--left fa-ie-clickable fa fa-chevron-right"></i></a>';
                        } else {
                            displayHTML += '<span class=""><i class="push--left fa fa-chevron-right color5"></i></span>';
                        }
                        displayHTML += '</h4></div>';
                    }
                }
                //Special voucher list for DAP site - Mike 24 Jan 2022
                if(oSite.bIsDapTpDomain) {

                    //change the sort direction class on the clicked column header after the table is rendered
                    if (sortDir == 'desc') {
                        var sortOrder = 'asc';
                    } else {
                        var sortOrder = 'desc';
                    }

                    if(typeof searchText === 'undefined'){
                        searchText = '';
                    }


                    //build table header
                    displayHTML += '<table class="memres--curr--reservations "><tr class="cardetails-smallprint memres_row voucherlist-header"><td class="memres_puCalLabel pudatecolumn"><label style="cursor:auto;"><a id="pudate_head" class="sort_vouchers" data-col="PUDATESORT" data-dir="' + sortOrder + '">'+AEdata.vouchListLabels.pudate_label+'</a></label></td><td class="memres_puCalLabel createdatecolumn"><label style="cursor:auto;"><a id="createdate_head" class="sort_vouchers" data-col="CREATEDATESORT" data-dir="' + sortOrder + '">'+'Booking Date'+'</a></label></td><td class="memres_vouchLabel"><label style="cursor:auto;"><a id="voucher_head" class="sort_vouchers" data-col="FULLVOUCHNUM" data-dir="' + sortOrder + '">'+AEdata.vouchListLabels.voucher_label+'</a></label></td></td><td class="memres_puLocLabel visuallyhidden--palm"><label style="cursor:auto;"><a id="name_head" class="sort_vouchers" data-col="NAMELOWER" data-dir="' + sortOrder + '">'+AEdata.vouchListLabels.driver_label+'</a></label></td><td class="memres_puLocLabel visuallyhidden--palm"><label style="cursor:auto;"><a id="puloc_head" class="sort_vouchers" data-col="PUCITY" data-dir="' + sortOrder + '">'+AEdata.vouchListLabels.puloc_label+'</a></label><td class="memres_puLocLabel visuallyhidden--palm"><label style="cursor:auto;"><a id="consultant_head" class="sort_vouchers" data-col="ATTENTIONLOWER" data-dir="' + sortOrder + '">'+AEdata.vouchListLabels.consultant_label+'</a></label></td><td class="memres_statusLabel visuallyhidden--palm"><label style="cursor:auto;"><a id="status_head" class="sort_vouchers" data-col="STATUSDISPLAY" data-dir="' + sortOrder + '">'+AEdata.vouchListLabels.status_label+'</a></label></td><td class="memres_action_label numerical">&nbsp;</td> </tr>';

                    //build table rows
                    vouchers.CURRENT.forEach(function (item, index) {
                        displayHTML += '<tr class="cardetails-smallprint memres_row voucherlist-row '+index+'"><td class="memres_puCalLabel pudatecolumn" >'+item.PUDATEDISPLAY+'</td>';
                        displayHTML += '<td class="memres_puCalLabel createdatecolumn" >'+item.CREATEDATEDISPLAY+'</td>';
                        displayHTML += '<td class="memres_vouchLabel" >'+item.FULLVOUCHNUM+'</td>';
                        //displayHTML += '<td class="memres_puLocLabel visuallyhidden--palm">'+item.PULOCATION+'<br>'+item.PUCITY+', '+item.PUCTRYNAME+'</td>';
                        displayHTML += '<td class="memres_driverLabel visuallyhidden--palm">'+item.FIRSTNAME+' '+item.LASTNAME+'</td>';
                        displayHTML += '<td class="memres_puLocLabel visuallyhidden--palm">'+item.PUCITY+'</td>';
                        displayHTML += '<td class="memres_consultantLabel visuallyhidden--palm">'+item.ATTENTION+'</td>';
                        displayHTML += '<td class="memres_statusLabel visuallyhidden--palm ">'+item.STATUSDISPLAY+'</td>';
                        displayHTML += '<td class="memres_action numerical"><a href="https://'+item.DOMAIN+'/'+AEdata.vouchListLabels.lookupUrl+'/?vouchnum='+item.FULLVOUCHNUM+'&fname='+item.FIRSTNAME+'&lname='+item.LASTNAME+'&modsection=view" target="_blank">';

                        //display link text could be view or view/modify unless phone view
                        displayHTML += '<span class="visuallyhidden--desk visuallyhidden--desk-wide visuallyhidden--tablet visuallyhidden--lap">'+AEdata.vouchListLabels.view_link+'</span> <span class="visuallyhidden--palm viewmod">'+AEdata.vouchListLabels[item.LABELKEY]+'</span>';
                        displayHTML += '</a></td></tr>';

                    });
                    //close table
                    displayHTML += '</table>';
                } else {
                    var atpBookingDateLabelElement = '';
                    if(oSite.bIsAeTpDomain){
                        atpBookingDateLabelElement ='<td class="memres_bookCalLabel"><label style="cursor:auto;">'+AEdata.vouchListLabels.createdate_label+'</label></td>';
                    }
                    //build table header
                    displayHTML += '<table class="memres--curr--reservations table--striped"><tr class="cardetails-smallprint memres_row"><td class="memres_puCalLabel"><label style="cursor:auto;">'+AEdata.vouchListLabels.pudate_label+'</label></td>'+atpBookingDateLabelElement+'<td class="memres_vouchLabel"><label style="cursor:auto;">'+AEdata.vouchListLabels.voucher_label+'</label></td><td class="memres_puLocLabel visuallyhidden--palm"><label style="cursor:auto;">'+AEdata.vouchListLabels.puloc_label+'</label></td><td class="memres_statusLabel visuallyhidden--palm"><label style="cursor:auto;">'+AEdata.vouchListLabels.status_label+'</label></td><td class="memres_action_label numerical">&nbsp;</td> </tr>';
                    //build table rows
                    vouchers.CURRENT.forEach(function (item, index) {
                        displayHTML += '<tr class="cardetails-smallprint memres_row"><td class="memres_puCalLabel" >'+item.PUDATEDISPLAY+'</td>';
                        if(oSite.bIsAeTpDomain){
                            displayHTML += '<td class="memres_bookCalLabel" >'+item.CREATEDATEDISPLAY+'</td>';
                        }
                        displayHTML += '<td class="memres_vouchLabel" >'+item.FULLVOUCHNUM+'</td>';
                        displayHTML += '<td class="memres_puLocLabel visuallyhidden--palm">'+item.PULOCATION+'<br>'+item.PUCITY+', '+item.PUCTRYNAME+'</td>';
                        displayHTML += '<td class="memres_statusLabel visuallyhidden--palm ">'+item.STATUSDISPLAY+'</td>';
                        displayHTML += '<td class="memres_action numerical"><a href="https://'+item.DOMAIN+'/'+AEdata.vouchListLabels.lookupUrl+'/?vouchnum='+item.FULLVOUCHNUM+'&fname='+item.FIRSTNAME+'&lname='+item.LASTNAME+'&modsection=view" target="_blank">';

                        //display link text could be view or view/modify unless phone view
                        displayHTML += '<span class="visuallyhidden--desk visuallyhidden--desk-wide visuallyhidden--tablet visuallyhidden--lap">'+AEdata.vouchListLabels.view_link+'</span> <span class="visuallyhidden--palm">'+AEdata.vouchListLabels[item.LABELKEY]+'</span>';
                        displayHTML += '</a></td></tr>';
                    });
                    //close table
                    displayHTML += '</table>';
                    }

                //if last page, add no more vouchers message
                if (!nextData.activeLink) {
                   displayHTML += '<p>'+AEdata.vouchListLabels.txt_list_end+'</p>';
                }
            }
            //show html
            var eleVouchList = document.getElementById('vouchList');
            if(eleVouchList !== null){
                eleVouchList.innerHTML = displayHTML;
            }
            if(oSite.bIsAeTpDomain){
                if ($('#tabBooking').hasClass('activeVSTab')) {
                    $('.memres_puCalLabel').hide();
                    $('.memres_bookCalLabel').show();
                } else {
                    $('.memres_bookCalLabel').hide();
                    $('.memres_puCalLabel').show();
                }
            }
            if(oSite.bIsDapTpDomain) {

                if ($('#tabBooking').hasClass('activeVSTab')) {
                    $('.pudatecolumn').hide();
                    $('.createdatecolumn').show();
                } else {
                    $('.createdatecolumn').hide();
                    $('.pudatecolumn').show();
                }

                var lastvouchcounter = 0;
                vouchers.CURRENT.forEach(function (item, index) {
                    if ( index >= (firstVouch - 1) && index <= (lastVouch - 1)) {
                        //$('.'+index).css("display", "table-row")
                        /*lastvouchcounter = index + 1;
                        $('#lastshowing').replaceWith('<span id="lastshowing">' + lastvouchcounter + '</span>');*/
                    } else {
                        $('.'+index).addClass( "visuallyhidden" );
                    }
                })


                if (sortID !== '' && typeof sortID !== 'undefined') {
                    //selected sorting
                    $('#' + sortID).addClass(sortDir);
                } else {
                    //default sorting
                    if ($('#tabBooking').hasClass('activeVSTab')) {
                        $('#createdate_head').addClass('desc');
                        $('#createdate_head').attr('data-dir', 'asc' );
                    } else {
                        $('#pudate_head').addClass('desc');
                        $('#pudate_head').attr('data-dir', 'asc' );
                    }

                }

                if(searchText.length > 0){
                    $('#filterVouchers').val(searchText);
                    filterVouchers();
                }


                        $( "#filterVouchers" ).keyup(function() {

                            $('#prevpage').attr('data-idxStart', '0');
                            $('#nextpage').attr('data-idxStart', '50');
                            $('a#prevpage').replaceWith( '<span class=""><i class="push--right fa fa-chevron-left color5"></i></span>' );
                            filterVouchers('0');

                        });

                        function filterVouchers(startOver) {
                            var searchText = $( "#filterVouchers" ).val();

                            if (typeof startOver != 'undefined'){
                                startAt = startOver;
                                $('span#nextpage').replaceWith( '<a id="nextpage" class="vouchPage" href="" data-idxstart="50" data-idxtype="TP" data-idxpage="next" data-col="' + sortCol + '" data-dir="' + paginationSortOrder + '" data-sortid="' + sortID + '"><i class="push--left fa-ie-clickable fa fa-chevron-right"></i></a>' );
                            }

                            counter=0;
                            allcounter=0;
                            $.grep( vouchers.CURRENT, function( n, i ) {
                                DRIVERNAME = n.FIRSTNAME.toLowerCase()+' '+ n.LASTNAME.toLowerCase();
                                if(n.FIRSTNAME.toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(n.LASTNAME.toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(DRIVERNAME.toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(n.PUCITY.toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(n.FULLVOUCHNUM.toString().toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(n.PUDATEDISPLAY.toString().toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(n.ATTENTION.toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else if(n.STATUSDISPLAY.toLowerCase().search(searchText.toLowerCase()) >= 0) {
                                    allcounter=allcounter+1;
                                    if(counter <= maxPerRequest && i >= startAt) {
                                        $('.'+i).removeClass( "visuallyhidden" );
                                        counter=counter+1;
                                        lastrow = i;
                                    }
                                } else {
                                    $('.'+i).addClass( "visuallyhidden" );
                                }
                            });

                            if (typeof startOver != 'undefined'){
                                startAt = startOver;
                                $('#displayStart').attr('data-val', '1');
                                $('#firstshowing').replaceWith('<span id="firstshowing">1</span>');
                                lastdisplayEnd = $('#displayEnd').attr('data-val');
                                 $('#displayEnd').attr('data-val', (Number(lastdisplayEnd)+50));
                                $('#lastshowing').replaceWith('<span id="lastshowing">'+(counter-1)+'</span>');


                                //console.log('this fired at startOver');
                            }

                            $('#vouchfound').replaceWith( '<span id="vouchfound">'+allcounter+'</span>' );
                            if (typeof lastrow !== 'undefined'){
                                $('#nextpage').attr('data-idxStart', lastrow);
                            }
                            //console.log(counter-1);
                            //console.log(maxPerRequest+1);
                            if ((counter-1) < (maxPerRequest)){
                                $('a#nextpage').replaceWith( '<span id="nextpage" class=""><i class="push--left fa fa-chevron-right color5"></i></span>' );
                            } else {
                                $('span#nextpage').replaceWith( '<a id="nextpage" class="vouchPage" href="" data-idxStart="'+lastrow+'" data-idxType="'+nextData.idxType+'" data-idxPage="'+nextData.idxPage+'" data-col="' + sortCol + '" data-dir="' + paginationSortOrder + '" data-sortid="' + sortID + '"><i class="push--left fa-ie-clickable fa fa-chevron-right"></i></a>' );
                            }
                          }

            }
        },
        showCancelInsCostChange: function(originalCost,newCost,formId,threshold) {
            //WEBAE3-4612 - show modal with new cancel ins cost and option to keep/remove
            if ( AE.ui.dialog ) {
                var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
                var $activeForm = document.getElementById(formId);
                /*WEBAE3-4757 expand scope of this to handle change to car w/o insurance (newcost = 0)
                because that case requires different messaging and options
                */
                var newCostHasCancel = (Number(newCost.replace(/[^0-9.-]+/g,"")) !== 0);//if newCost is 0, cancel ins isn't available
                if(!newCostHasCancel){
                    //build cancel not available for upgrade rate buttons and dialog content
                    oButtons[AEdata.booking.quote.oLang.CANCELINS.BTN_MODIFYRES] = function () {
                        /* submit search again form instead of upgrade form because
                        client has opted to start over */
                        AE.ui.dialog.close();
                        AE.ui.search.formSubmit();//fire search again form
                    };

                    oButtons[AEdata.booking.quote.oLang.CANCELINS.BTN_ACCEPT] = function () {
                        /* Make sure cancel ins is removed and sumbit upgrade */
                        $('input[name="chk_cncl"]').val(0);//re oves cancel ins
                        AE.ui.dialog.close();
                        $activeForm.submit();
                    };

                    var dialogText = AEdata.booking.quote.oLang.CANCELINS.CXL_INSURANCE_REMOVED;
                    dialogText = dialogText.replace('#threshold#', threshold);

                } else {
                    //build cost change buttons and dialog content
                    oButtons[AEdata.booking.quote.oLang.CANCELINS.BTN_REMOVE] = function () {
                        /* Alter cancelIns status and submit form */
                        $('input[name="chk_cncl"]').val(0);//remove cancel ins on submit and oBK update
                        AE.ui.dialog.close();
                        $activeForm.submit();
                    };

                    oButtons[AEdata.booking.quote.oLang.CANCELINS.BTN_ACCEPT] = function () {
                        /*  Alter cancelIns status and submit form */
                        $('input[name="chk_cncl"]').val(1);//keep cancel ins on submit and oBK update
                        AE.ui.dialog.close();
                        $activeForm.submit();
                    };
                    var dialogText = AEdata.booking.quote.oLang.CANCELINS.CXL_INSURANCE_COST_CHANGE;
                    dialogText = dialogText.replace('#oldcost#', originalCost).replace('#newcost#', newCost);
                }



                //If there is no html in the text, surround it with a paragraph tag
                var htmlRegex = /^<.*>.*<\/.*>$/;

                if( htmlRegex.test(dialogText) ) {
                    dialogContent = dialogText;
                } else {
                    dialogContent = "<p>" + dialogText + "</p>";
                }

                var dialogAdditonalClass = null;

                var oContent = $( document.createDocumentFragment() )
                    .append( $( document.createElement( 'h3' ) )
                            .append(AEdata.booking.quote.oLang.CANCELINS.PRODUCT_TITLE)
                    )
                    .append( $( document.createElement( 'div' ) )
                            .append( dialogContent )
                    );
                AE.ui.dialog.launch( {
                    id: 'oneway_all2all--modal',
                    class: dialogAdditonalClass,
                    content: oContent,
                    buttons: oButtons,
                    titleBar: false,
                    buttonOpts: {
                        lastButtonClass: 'btn--primary fcr-buttom-primary',
                        firstButtonClass: 'btn--base',
                        exclusiveClose: true
                    },
                    width: ( $( window ).width() > 900 ) ? 850 : '80%'
                } );
            }
        },
        cancelModal: function() {
            //WEBAE3-4762 assemble modal content from distinct elements
            var CancelInsModalText = '<strong class="colorGreen">' + AEdata.booking.quote.oLang.CANCELINS.PRODUCT_HEADLINE + '</strong>';
            CancelInsModalText += '<p>' + AEdata.booking.quote.oLang.CANCELINS.PRODUCT_DESCRIPTION2 + '</p><hr class="topSpace">';
            CancelInsModalText += AEdata.booking.quote.oLang.CANCELINS.PRODUCT_BULLETS;
            CancelInsModalText += AEdata.booking.quote.oLang.CANCELINS.PRODUCT_PDF_LINK;
            AE.ui.dialog.launch("#save-quote", { content:"" } );
            AE.ui.dialog.addContent( CancelInsModalText );
            //special styles for this modal
            $(".ui-dialog").addClass("colorGreenBorder cancelModal");
            $("#current-dialog.ui-dialog-content > ul ").addClass("fa-ul");
            $("#current-dialog.ui-dialog-content > ul li").prepend("<i class='fa-li fa fa-check-circle'></i>");
            $("#current-dialog.ui-dialog-content > ul").wrap("<div class='checkWrap'></div>");
        },
        enableCheckoutSubmit: function(shouldEnable){
            /*
            WEBAE3-5133 - this will disable/renable checkoutn submit button(s)
            when an XHR request is triggered on checkout form page
            if shouldEnable === false, disable all checkout form submit buttons
            if shouldEnable === true, enable all checkout form submit buttons
            */
            //this only applies on bookform step
            if (AEdata && AEdata.booking && AEdata.booking.state && AEdata.booking.state.step && AEdata.booking.state.step == 'bookform'){

                //only 2 submit button ids: submitForm and submitFormSecondary: id name only, hash tag added when needed below
                var aCheckoutButtonIds = ['submitForm','submitFormSecondary'];
                //loop thru ids, easier to scale later
                var i = 0, len = aCheckoutButtonIds.length;
                while (i < len) {
                    if (document.getElementById(aCheckoutButtonIds[i]) !== null) {
                        //button exists so toggle
                        AE.booking.optEquip._toggleEnableBtnControl('#'+aCheckoutButtonIds[i], shouldEnable);
                    }
                    i++;
                }

            }
        },
        trustScoreModal: function(strCountry,strCity,strSupplier,strLogo,strId){ //WEBAE3-5228
                /* WEBAE3-5232 TRUST SCORE MODAL STUFF (Matrix suppliers on left) */
                // Get trust score data for searched country, city, and clicked supplier (passing logo fallback)
                //console.log(strLogo);
                var strCity = '';
            $.ajax({
                url: APP.props.oTrustScore.strTrustScoreScript,
                data: {
                    method:'TrustScoreModal',
                    country: strCountry,
                    city: strCity,
                    supplier: strSupplier,
                    logo: strLogo
                }
            }).done(function(result){
                // launch modal with generated trust score content

                AE.ui.dialog.launch({
                    id: strId,
                    content: result,
                    width: ( $( window ).width() > 400 ) ? 350 : '80%'
                });
                AE.ui.dialog.update(true);
            }).fail(function(result){
                //console.log('Could not retrieve Trust Score Modal');
            });
        },
        trustScoreJS: function(strCountry,strCity,strSupplier,oContainer){ //WEBAE3-5228
            /* WEBAE3-5232 TRUST SCORE MODAL STUFF (Matrix suppliers on left) */
            // Get trust score data for searched country, city, and clicked supplier (passing logo fallback)
            //console.log('fire1b');
            $.ajax({
                url: APP.props.oTrustScore.strTrustScoreScript,
                data: {
                    method:'TrustScoreJS',
                    country: strCountry,
                    city: strCity,
                    supplier: strSupplier,
                }
            }).done(function(result){
                let $starRating = $( document.createElement( 'span' ) ).append(result);
                oContainer.append( $starRating );
            }).fail(function(result){
               // console.log('Could not retrieve Trust Score JS');
            });
        }
    };
    return APP;
})();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking.matrix = AE.booking.matrix || (function () {
 /*
 DEPENDENCIES: AE, AE.booking
 */
 var resultsData = null,
   currentData = {};
 //$filteredCars = null, // A reduced set of cars which match the filters.
 var APP = {
   init: function () {
     /*
     This is where we set variables and things that will only live inside the closure. Local
     variables will only live in here, and will not be accessible to the browser's inspector.

     Props are defined only upon init, so we can load the modules in any order. If we declared
     them outside of init then modules calling other modules would throw errors. This way, those
     calls are only made after everything is loaded and the various init functions are called.

     The APP object is just a shorthand so we can have an easy reference instead of the possibly
     long, dot-syntaxed name that will be returned. You can call this by "APP" only in here.
     After this is all returned, other modules will know the object by its full name. In this
     case, that would be AE.booking.matrix.
     */
     APP.props = {
       dfd_resultsData: $.Deferred(), // Creating a Deferred Object to be resolved after we have our data.
       isDFDresolved: false, // Flag to show dfd_resultsdata has been resolved
       size: AE.getSiteViewType(), // Grabbing the initial size of the window in case we need it.
       firstRun: true, // The manageResize function is sometimes different for the initial run.
       isMoving: false, // Whether or not the full-sized matrix columns are currently moving.
       isSliding: false, // Set to true while the palm category looper is sliding, to prevent double-clicks.
       catsReady: false, // If the palm categories are in place with a center item chosen.
       $centerItem: {}, // The center list item in the palm categories. Updated on movement or redraw.
       $matrixContainer: $('#matrix_container'),
       $matrix: $('#matrix'),
       $matrixMore: $('#matrix__more--top'),
       $results: $('#car_results'),
       $resultsCountWrap: $('.number_of_results'), // Dark blue bar above car results.
       $resultsCountP: $('.number_of_results p'), // Paragraph tag which gets set to the number of visible results.
       $resultsCount: $('span#resultsCount'),
       $resultsTotal: $('div#resultsTotal, div#resultsCount'),
       $matrixFilters: $('#matrix__filters'),
       $filterChks: $('#matrix__filters input.matrix_filter'),
       $mapFilterChks: $('#matrix__filters input.map_filter'),
       $matrixWrapper: $('#matrix__wrapper'),
       $depositFilters: $('#matrix__filters--deposit div.matrix_filter input'),
       extraCols: false, // Whether the full matrix has more columns than will fit in the display area.
       cols: { // Properties of the full matrix columns.
         total: null,
         outside: null,
         inside: null,
         left: null,
         right: null
       },
       colsByCat: false, // Whether Matrix columns should be Car Categories or Suppliers
       /* ====== IMPORTANT THING THAT COULD BREAK LAYOUT =================================================================
       These next two values are also used as SASS variables in _vars.scss, so change it there if you change it here.
       This is also noted in the .scss file.

       They matter because the matrix isn't just drawn with CSS. Column widths are updated with JavaScript upon resize.
       For the math to work for the various parts, we need to know the widths from the very beginning, as well as the
       margin.

       The number of columns can be approximately figured out by dividing (1200 - categoryWidth) by (initColWidth + 2*initColMargin)
       - this includes the "Lowest Rate" column, so subtract one from the whole-number answer to get the number of
       supplier columns
       ================================================================================================================ */
       suppFilter: [], // WEBAE3-2782
       locTypeFilter: [], // WEABE3-3670
       initColWidth: 111, // Default width for columns (old value of 122 == 6 columns)
       initColMargin: 2, // This doesn't change, but needs to work with the other measurements.
       filterStorage: [], // WEABE3-3713
       eCommItems: [], // WEBAE3-6014 list of vehicle result items for GA4 ecommerce tracking
       resultsLayout: oSite.resultsLayout // WEBAE3-6161 Determines which results layout to use (matrix or no matrix)
     };
     APP.props.$results
       .data('category', '')
       .data('supplier', '');

     /* This will run as soon as the deferred object is resolved.  */
     APP.props.dfd_resultsData.done(function () {
       APP.setColumnsByCategory();
       if (AE.booking.matrix.maps) {
         AE.booking.matrix.maps.init();
       }
       if (AE.booking.matrix.locations) {
         AE.booking.matrix.locations.init();
       }
       if (AE.booking.matrix.events) {
         AE.booking.matrix.events.init();
       }
       var storedFilters = localStorage.getItem('aeFilters');
       if(storedFilters !== null && storedFilters !== undefined && typeof(storedFilters) === 'string'){
         // WEBAE3-3713 - filter selection persistence for Supplier and location type map filters
         _.each(_.uniq(JSON.parse(storedFilters)), function(item){
           APP.props.filterStorage.push(item);
           if(_.contains(['LA','LR','LD','LO'],item)){
            APP.props.locTypeFilter.push(item);
            AE.booking.matrix.maps.props.$filterMarkers.filterLocs.push(item);
            $('.map_filter.matrix_filter.loctype[data-filter="'+item+'"]').prop('checked',true);
           } else {
             var thisSupp = _.findWhere(AEdata.booking.quote.oSupps,{code:item});
             APP.props.suppFilter.push(thisSupp.filter);
             AE.booking.matrix.maps.props.$filterMarkers.filterSuppliers.push(item);
             $('.map_filter.matrix_filter.supplier[data-supplier="'+thisSupp.filter+'"]').prop('checked',true);
           }
         });
       }

       /*
       This optional code passes in the module's manageResize function into the task list in the
       primary AE module. That task list is already being called upon resize, so just pass in local
       stuff and then leave it alone. If the manageResize function needs arguments, be sure to
       add them to the args array in the task object being passed in.
       */
       resultsData = AE.booking.matrix.results.props;
       resultsData.arrFiltered = $.merge([], AE.booking.matrix.results.props.arrResults);       
       
       APP.props.$resultsTotal.html(resultsData.arrFiltered.length);

       AE.ui.removeSpinner('#' + APP.props.$matrix.attr('id'));
       APP.addListeners();
       APP.drawMatrix();
       AE.addResizeTask({
         func: function () {
           APP.manageResize();
         },
         args: []
       });
       APP.props.isDFDresolved = true;
     });
     /*
     Nothing gets started before we have the data. We would normally do this through an AJAX call, but that's a bit slow
     and by this point the user has already waited for the quote to be generated. Rather than making the user wait twice,
     we're moving initial data calls into the previous "loading" step. The JSON data that we need is stored in data
     attributes. Here's what we do next:

     1. Get the JSON data from the data attribute in the markup.
     2. Run the init function for the matrix.results module, which adds the results object to our matrix object.
     3. Cache the matrix.results object to a variable called "resultsData".
     4. Eliminate the data attribute from the markup.
     5. Now that we have all of the data, we resolve the dfd_resultsData object.
     6. Once resolved, the Deferred Object runs all "done" functions that we might create.

       AVAILABLE PROPERTIES FROM MATRIX RESULTS DATA ========================================================================

       AE.booking.matrix.results.props.oTranslations		Commonly used Strings out of CF Language Management for Rates Display (For updates and additions to translations -> plugins/ae3/modules/booking/lib/bookingVocabulary.cfc)
       AE.booking.matrix.results.props.oLocations			An Object comprised of Location Objects, keys are LOCIDs from Quote
       AE.booking.matrix.results.props.oResults 			An Object comprised of Result Objects, keys are CF UUIDs
       AE.booking.matrix.results.props.oCategories 		An Object of Category Objects with values needed for filling in Matrix Columns
       AE.booking.matrix.results.props.oRateFingers		An Object of Rate Finger Objects, keys are - delimited strings of certain properties of the object
       AE.booking.matrix.results.props.oRateChangeDetails	An Object of Rate Change Detail Objects Categorized by Pickup ID, then Dropoff ID, then SIPP code: {'PUID':{'DOID':{'SIPP':{'object'},...},...},...}
       AE.booking.matrix.results.props.oSuppliers			An Object of Supplier Objects with values needed for filling in the Matrix Columns
       AE.booking.matrix.results.props.oFilters			An Object detailing any and all desired filter/display pre-selections
       AE.booking.matrix.results.props.arrResults 			An array of truncated Result Objects with only the values needed for drawing results and the Matrix Grid
       AE.booking.matrix.results.props.arrCategories 		An array of IDs for Category Objects represented in Quote
       AE.booking.matrix.results.props.arrSuppliers		An array of Supplier Keys in oSuppliers
       AE.booking.matrix.results.props.isMapOneway 		A boolean to signal a oneway search
       AE.booking.matrix.results.props.isAllLocation		A boolean to signal an All 'Downtown' Location search
       AE.booking.matrix.results.props.quoteID  			The numeric Quote ID for the booking instance

       Objects within oLocations, oResults, and oRateFingers have elements linking them with one or more child objects in the other two parent objects:
       Location Objects have ARRRATEFINGERS and ARRRESULTS, arrays of Rate Finger and Result Object IDs.
       Result Objects have ARRRATEFINGERS and ARRLOCS, arrays of Rate Finger and Location Object IDs.
       Rate Finger Objects have PULOC, DOLOC, and RESULTID; IDs for the Pickup and Dropoff Location Objects, and the associated Result Object.
     */

     AE.ui.addSpinner('#' + APP.props.$matrix.attr('id'), {
       size: '5x',
       color: 'black'
     });
     /* This block of code is desribed above. */
     if (AEdata.booking.quote && !_.isEmpty(AEdata.booking.quote)) {
       if (AEdata.booking.quote.ERROR) {
         AE.ui.removeSpinner('#' + APP.props.$matrix.attr('id'));
         AE.booking.matrix.results.errorDialog(AEdata.booking.quote);
       } else {
         AE.booking.matrix.results.init(AEdata.booking.quote);
         $('#aebooking').attr('data-jsonresults', '');
         APP.props.dfd_resultsData.resolve(); // +See Below+
       }
     }
     /* +Regarding Above+
       We've finished getting and sorting the data, so we resolve this deferred object. All "done" functions attached to this deferred object will now run.
       These lines are placed below the "done" function to show that it is asynchronous and will wait until the resolve().
     */

     // Hide inapplicable filter options.
     APP.updateFilterDisplay();

     /* Creates a DIV for matrix category information to be added to */
     var $catInfoDiv = $(document.createElement('div')).attr('id', 'matrix__category__info').addClass('matrix__category__info--container matrix__category--info-text');
     $catInfoDiv.addClass('trulyhidden');
     $('body').append($catInfoDiv);

     /* Adds some margin to the matrix if the type/location bar is present. */
     if ($('.matrix__browse')[0]) {
       APP.props.$matrixMore.addClass('has-map');
     }

     AE.ui.addBodyClickTask({
       func: APP.onBodyClick
     });
     AE.ui.addBodyChangeTask({
       func: APP.onBodyChange
     });
     AE.addTransitionTask({
       func: function () {
         if ($('.info-tip')[0]) {
           AE.ui.dialog.close();
         }
       }
     });

     /*
     AE.addScrollTask({
       func: function () {
         var elm = document.querySelector('.number_of_results');
         var $b2t = $('#back2top');
         var rect = elm.getBoundingClientRect();
           if(rect.bottom > 0){
             $b2t.addClass('visuallyhidden');
           } else {
           $b2t.removeClass('visuallyhidden');
           }
       }
     });
     */
        // WEBAE3-6445 - Sticky Filters in matrix on scroll
        if(AE.props.siteCode != 'FCR' && APP.props.resultsLayout != 'nomatrix' && $('#matrix-redesign-container .booking-steps').length) {
          AE.addScrollTask({
            func: function()
            {
              if($('#matrix-redesign-container .booking-steps').length){
                if($(window).width() >= 1024 && $(window).scrollTop() >= ($('#matrix-redesign-container .booking-steps').offset().top + $('#matrix-redesign-container .booking-steps').height())) {
                    $('#matrix_and_map').css('margin-top', $('#matrix-redesign-container .getrates_details').height());
                    $('#matrix-redesign-container').addClass('sticky-filters');
                } else {
                    $('#matrix_and_map').css('margin-top', 0);
                    $('#matrix-redesign-container').removeClass('sticky-filters');
                }
              }
            }
        });
      }
   },
   getResultsData: function () {
     /*
     Returns the results object in it's current form. This is basically the AE.booking.matrix.results.props object, but
     it includes the updatted arrFiltered array.
     */
     return resultsData;
   },
   getResultsCars: function () {
     /* Returns the set of cars which matches the current filters. */
     return resultsData.arrFiltered;
     
   },
   /*
   setSuppliersShownText : function(cols) {
     var visibleStart	= parseInt(1 + cols.left),
       visibleEnd		= parseInt(cols.inside + cols.left);

     if ( cols.total > visibleEnd || visibleStart !== 1 ) {
       $('.matrix__showing-suppliers').html('Showing ' + visibleStart + ' - ' + visibleEnd + ' / ' + cols.total);
     } else {
       $('.matrix__showing-suppliers').empty();
     }
   },
   */
   clearSelected: function () {
     /*
     Clear the data attributes for category and supplier which are used to maintain highlighting
     while building the matrix at whatever size.
     */
     APP.props.$results.data('category', '').data('supplier', '');
     return APP.props.$results.data();
   },
   getSelected: function () {
     /* Find out which supplier and category are selected, if any. */
     return {
       cat: APP.props.$matrix.data('category') || '',
       supp: APP.props.$matrix.data('supplier') || ''
     };
   },
   placeMapToggle: function () {
     // First, find out the size and current display.
     var isMap = ($('.control_container').hasClass('loc')) ? true : false,
       //isPalm = ( AE.getSiteViewType() === 'palm' ) ? true : false;
       size = AE.getSiteViewType();

     // We initialize for palm, which works for matrix and map.
     var objPos = {//WEBAE3-4574 map button updates
       my: "center top",
       at: "center top",
       of: $('#matrix_and_map'),
       collision: 'none'
     };

     // If the view isn't palm, then placement may change between matrix and map.
     ////WEBAE3-4574 
     if (size !== "palm" ) {
      //console.log(size)
       objPos = {
         my: (APP.props.colsByCat)? "left+42 top+40" : "left+42 top+40",
         at: "left top",
         of: $('#matrix_container'),
         collision: 'none'
       };

       if ($('.control_container').hasClass('loc')) {
         objPos.my = "left+40 top+10";
         objPos.of = $('.map_container');
       }

     }

     $('.control_container').removeClass('trulyhidden').position(objPos);
   },
   drawMatrix: function (code, value, $target) {
     /*
     This function updates the car data object according to the current state of the filter checkboxes. It then
     clears the selected matrix cell before rebuilding the matrix. The matrix is built according to the current
     size of the window, with the full matrix being built at larger sizes.

     For the full matrix, we also need to update measurements for columns and rows.
     */

     var gridData = APP.runFilters(code, value);

     // Clear out the selected category and/or supplier before rebuilding the matrix
     APP.clearSelected();

      
     // Rebuild the matrix with the newly-created filterData object
     APP.buildMatrix(gridData);
     
     // If we're currently using the full matrix, then reset the measurements for the matrix
     if (APP.props.size !== 'palm' && $('#matrix__static')[0]) {
       APP.full.updateColWidth();
       APP.full.updateCols();

       //APP.setSuppliersShownText(APP.props.cols);
     }

     if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
        
       APP.showResults($target, resultsData.arrFiltered);
     }
     
     return;
   },
   clearFilters: function(){
     AE.ui.disableClicks();
     var filterKeyArray = _.keys(AEdata.booking.quote.oFilters);
     for(var filterKeyIdx in filterKeyArray){
       var filterKey = filterKeyArray[filterKeyIdx];
       if(_.isObject(AEdata.booking.quote.oFilters[filterKey])){
         var thisFilterKeyArray = _.keys(AEdata.booking.quote.oFilters[filterKey]);
         for(var keyIdx in thisFilterKeyArray){
           var key = thisFilterKeyArray[keyIdx];
          if(AEdata.booking.quote.oFilters[filterKey][key] === true){
            AEdata.booking.quote.oFilters[filterKey][key] = false;
          }
         }
       }
     }

     // WEBAE3-5492 - reset View By buttons
     $('#view_by_price').removeClass('view_by_active');
     $('#view_by_price').addClass('view_by_inactive');
      $('#view_by_most_popular').removeClass('view_by_active');
     $('#view_by_most_popular').addClass('view_by_inactive');

     // Remove hide classes for rate fingers when clear filters is clicked
     $('#car_results_row')
      .removeClass('IB_false')
      .removeClass('II_false')
      .removeClass('IZ_false')
      .removeClass('CFP_false')
      .removeClass('CFS_false')
      .removeClass('DEP0_false')
      .removeClass('DEP1_false')
      .removeClass('DEP2_false')
      .removeClass('DEP3_false')
      .removeClass('DEP4_false');

    if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {

      // price slider reset
      var sliderlow = document.getElementById('slider_thumb_low');
      sliderlow.setAttribute("aria-valuemin", AE.booking.props.$rateMin);
      sliderlow.setAttribute("aria-valuemax", AE.booking.props.$rateMax);
      sliderlow.setAttribute("aria-valuenow", AE.booking.props.$rateMin);
      sliderlow.style.transform = 'translateX(0px)';

      var sliderhigh = document.getElementById('slider_thumb_high');
      sliderhigh.setAttribute("aria-valuemin", AE.booking.props.$rateMin);
      sliderhigh.setAttribute("aria-valuemax", AE.booking.props.$rateMax);
      sliderhigh.setAttribute("aria-valuenow", AE.booking.props.$rateMax);
      sliderhigh.style.transform = 'translateX(272px)';

      var trackfill = document.getElementById('slider_trackfill');
      
      $("#slider_trackfill").css('left','0px');
      $("#slider_trackfill").css('right','unset');
      $("#slider_trackfill").css('transform','scaleX(1)');
      $("#slider_trackfill").css('transform-origin','left center');

      var sliderlow = document.getElementById('slider_thumb_low');
      var newMinRate = sliderlow.getAttribute("aria-valuemin");
      var newMinRateRounded = Math.round(newMinRate);
      $(sliderlow).find('.mdc-slider__value-indicator-text').text(newMinRateRounded);

      var sliderhigh = document.getElementById('slider_thumb_high');
      var newMaxRate = sliderhigh.getAttribute("aria-valuemax");
      var newMaxRateRounded = Math.round(newMaxRate);
      $(sliderhigh).find('.mdc-slider__value-indicator-text').text(newMaxRateRounded);
      
      var elPrefix = AE.props.siteCode === 'FCR' ? 'fcr-' : '';
      if (AE.props.affiliate == 'FLIGHTCTRZA') {
        document.getElementById(elPrefix+'minprice').innerHTML = "R"+newMinRateRounded;
        document.getElementById(elPrefix+'maxprice').innerHTML = "R"+newMaxRateRounded;
      } else if (AE.props.affiliate == 'FLIGHTCTRGB') {
        document.getElementById(elPrefix+'minprice').innerHTML = "£"+newMinRateRounded;
        document.getElementById(elPrefix+'maxprice').innerHTML = "£"+newMaxRateRounded;
      } else {
        document.getElementById(elPrefix+'minprice').innerHTML = "$"+newMinRateRounded;
        document.getElementById(elPrefix+'maxprice').innerHTML = "$"+newMaxRateRounded;
      }
      
      //reinitialize slider
       slider = document.querySelector('.mdc-slider');
				mdc.slider.MDCSlider.attachTo(slider);
				sldr = new mdc.slider.MDCSlider(document.querySelector('.mdc-slider'));
				sldr.root.addEventListener("MDCSlider:change", function() {
					$('#ps_ps').prop('checked', true).trigger('change');
				}, false);

    }

     //remember if FCR sort menu was sorted hight to low
    if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
       sorthightolow = false;
      if ($('#sp_sp').prop('checked') == true) {
        sorthightolow = true;
      }
    }
     APP.props.filterStorage = [];
     APP.props.suppFilter = [];
     AE.booking.matrix.maps.props.$filterMarkers.filterSuppliers = [];
     APP.props.locTypeFilter = [];
     AE.booking.matrix.maps.props.$filterMarkers.filterLocs = [];
     APP.props.$filterChks.prop('checked',false);
     APP.hideResults();
     APP.runFilters();
     APP.drawMatrix();
     AE.booking.matrix.maps.setFilteredMarkers();
     AE.ui.enableClicks();
     
      //FCR retain sort menu value on clear filters
      if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
        if (sorthightolow == true) {
          $('#sp_sp').prop('checked', true).trigger('change');
        }
      }
   },
   filterExists: function (str) {
     /*
     This function determines whether a given filter is used by any of the cars in the current quote. The two-letter
     filter class is entered and a boolean is returned. It's true if even one car uses the given filter.
     */
     return !resultsData ? false : _.some(resultsData.arrResults, function (item) {
       return _.find(item.aFilters, function (filter) {
         return filter === str;
       });
     });
   },
   updateFilterDisplay: function (str) {
     /*
     This function hides a filter control if there are no cars to match it. For example, if there are no cars which
     have the Basic Insurance option, then activating that filter will clear out the entire matrix. This function would
     hide that filter so the user can't activate it.
     */

     // See if the filters exist in the quote. Setting one to false is a good way to test this function.
     var oExists = {
       FE: APP.filterExists('FE'),
       FF: APP.filterExists('FF'),
       IB: APP.filterExists('IB'),
       II: APP.filterExists('II'),
       CFS: APP.filterExists('CFS'),
       IZ: APP.filterExists('IZ'),
       CFP: APP.filterExists('CFP'),
       TA: APP.filterExists('TA'),
       TM: APP.filterExists('TM'),
       DR2: APP.filterExists('DR2'),
       DR3: APP.filterExists('DR3'),
       DR4: APP.filterExists('DR4'),
       AB: APP.filterExists('AB'),
       AD: APP.filterExists('AD'),
       PL: APP.filterExists('PL'),
       YD: APP.filterExists('YD'),
       SF: APP.filterExists('SF'),
       SC: APP.filterExists('SC'),
       SK: APP.filterExists('SK'),
       GP: APP.filterExists('GP'),
       ZG: APP.filterExists('ZG'),
       FD: APP.filterExists('FD'),
       ZF: APP.filterExists('ZF'),
       UP: APP.filterExists('UP'),
       ZU: APP.filterExists('ZU'),
       GD: APP.filterExists('GD'),
       GG: APP.filterExists('GG'),
       WI: APP.filterExists('WI'),
       SN: APP.filterExists('SN'),
       ULK: APP.filterExists('ULK'),
       LK: APP.filterExists('LK'),
       ACY: APP.filterExists('ACY'),
       ACN: APP.filterExists('ACN'),
       FTV: APP.filterExists('FTV'),
       FTD: APP.filterExists('FTD'),
       FTE: APP.filterExists('FTE'),
       FTH: APP.filterExists('FTH'),
       FTR: APP.filterExists('FTR'),
       MP: APP.filterExists('MP'),
       CV: APP.filterExists('CV'), //WEBAE3-4114
       DEP: APP.filterExists('DEP'), //WEBAE3-4115
       ON: false,
       OFF: false,
       Smilerent: APP.filterExists('Smilerent')
     }
     // Hide controls based upon the oExists object.
     if (!oExists.FE) {
       $('#fuel_empty').parent().addClass('hidden-filter').hide();
     }
     if (!oExists.FF) {
       $('#fuel_full').parent().addClass('hidden-filter').hide();
     }
     // https://autoeurope.jira.com/browse/WEBAE3-1124
     if (!oExists.FE && !oExists.FF) {
      $('#matrix__filters--fuel').parent('.toggler').parent().addClass('hidden-filter').hide();
    }
    // WEBAE3-3725 - Hide autocheckin based on the oExists OBJECTS
    var hiddenACK = 1;// starts at 1 because there's a hidden "NA" option that is always false in order to get around filtersMax behavior
    if (!oExists.MP) {
      $('#ack_mp').parent().addClass('hidden-filter').hide();
      hiddenACK++;
    }
    if (!oExists.Smilerent) {
      $('#ack_smile').parent().addClass('hidden-filter').hide();
      hiddenACK++;
    }
    if(hiddenACK >= _.keys(AEdata.booking.quote.oFilters.ACK).length){
      $('#matrix__filters--autochk').closest('.grid__item').addClass('hidden-filter').hide();
     }
    // WEBAE3-4114
    var hiddenCV = 1;// starts at 1 because there's a hidden "NA" option that is always false in order to get around filtersMax behavior
    if (!oExists.CV) {
      $('#cargovans').parent().addClass('hidden-filter').hide();
      hiddenCV++;
    }
    if(hiddenCV >= _.keys(AEdata.booking.quote.oFilters.CV).length){
      $('#matrix__filters--cargovans').closest('.grid__item').addClass('hidden-filter').hide();
     }
     // WEBAE3-4115
    var hiddenDEP = 4;// starts at 4 (out of 5) because it's all or nothing
    if (!oExists.DEP) {
      $('#deposit').parent().addClass('hidden-filter').hide();
      hiddenDEP++;
    }
    if(hiddenDEP >= _.keys(AEdata.booking.quote.oFilters.DEP).length){
      $('#matrix__filters--deposit').closest('.grid__item').addClass('hidden-filter').hide();
     }

     // WEBAE3-3633 - Hide promotions based upon the oExists OBJECTS
     var hiddenPRO = 0;
     if (!oExists.AB && !oExists.AD) {
      $('#promo_ab').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.PL) {
      $('#promo_pl').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.YD) {
      $('#promo_yd').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.SF) {
      $('#promo_sf').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.SC) {
      $('#promo_sc').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.SK) {
      $('#promo_sk').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
     if (!oExists.GP && !oExists.ZG) {
      $('#promo_gp_zg').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.FD && !oExists.ZF) {
      $('#promo_fd_zf').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.UP && !oExists.ZU) {
      $('#promo_up_zu').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.GD && !oExists.GG) {
      $('#promo_gd_gg').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.WI) {
      $('#promo_wi').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if (!oExists.SN) {
      $('#promo_sn').parent().addClass('hidden-filter').hide();
      hiddenPRO++;
    }
    if(hiddenPRO >= _.keys(AEdata.booking.quote.oFilters.PRO).length){
      $('#matrix__filters--promos').closest('.grid__item').addClass('hidden-filter').hide();
     }
     // WEBAE3-3460 - Hide fuel types based upon the oExists OBJECTS
     var eFuelsOnly = false;
     if($('#matrix__filters--fuel__types').length){
      eFuelsOnly = $('#matrix__filters--fuel__types').data('efuelsonly');
     } 
     var hiddenFT = 0;
     if (!oExists.FTV || eFuelsOnly) {
       $('#fuel_type_v').parent().addClass('hidden-filter').hide();
       hiddenFT++;
     }
     if (!oExists.FTD || eFuelsOnly) {
       $('#fuel_type_d').parent().addClass('hidden-filter').hide();
       hiddenFT++;
     }
     if (!oExists.FTE) {
       $('#fuel_type_e').parent().addClass('hidden-filter').hide();
       hiddenFT++;
     }
     if (!oExists.FTH) {
       $('#fuel_type_h').parent().addClass('hidden-filter').hide();
       hiddenFT++;
     }
     if (!oExists.FTR || eFuelsOnly) {
       $('#fuel_type_r').parent().addClass('hidden-filter').hide();
       hiddenFT++;
     }
     if(hiddenFT >= _.keys(AEdata.booking.quote.oFilters.FT).length){
      $('#matrix__filters--fuel__types').closest('.grid__item').addClass('hidden-filter').hide();
     }
     // WEBAE3-3602 - Hide mileage or AC based upon the oExists OBJECTS
     var hiddenKM = 0;
     if (!oExists.ULK) {
      $('#km_ulk').parent().addClass('hidden-filter').hide();
      hiddenKM++;
    }
    if (!oExists.LK) {
      $('#km_lk').parent().addClass('hidden-filter').hide();
      hiddenKM++;
    }
    if(hiddenKM >= _.keys(AEdata.booking.quote.oFilters.KM).length){
      $('#matrix__filters--km').closest('.grid__item').addClass('hidden-filter').hide();
     }
     var hiddenAC = 0;
    if (!oExists.ACY) {
      $('#ac_yes').parent().addClass('hidden-filter').hide();
      hiddenAC++;
    }
    if (!oExists.ACN) {
      $('#ac_no').parent().addClass('hidden-filter').hide();
      hiddenAC++;
    }
    if(hiddenAC >= _.keys(AEdata.booking.quote.oFilters.AC).length){
      $('#matrix__filters--ac').closest('.grid__item').addClass('hidden-filter').hide();
     }
     // WEBAE3-3620 - Hide door based upon the oExists OBJECTS
     var hiddenDR = 0;
     if (!oExists.DR2) {
      $('#doors_2').parent().addClass('hidden-filter').hide();
      hiddenDR++;
    }
    if (!oExists.DR3) {
      $('#doors_3').parent().addClass('hidden-filter').hide();
      hiddenDR++;
    }
    if (!oExists.DR4) {
      $('#doors_4').parent().addClass('hidden-filter').hide();
      hiddenDR++;
    }
    if(hiddenDR >= _.keys(AEdata.booking.quote.oFilters.DR).length){
      $('#matrix__filters--doors').closest('.grid__item').addClass('hidden-filter').hide();
     }

     if (!oExists.IB) {
       $('#package_basic').parent().addClass('hidden-filter').hide();
     }
     if (!oExists.II && !oExists.CFS) {
       $('#package_inclusive').parent().addClass('hidden-filter').hide();
     }
     if (!oExists.IZ && !oExists.CFP) {
       $('#package_ztype').parent().addClass('hidden-filter').hide();
     }
     // WEBAE3-1124
     // WEBAE3-6525 - US,CA: Remove (hide from display) "Coverage Options" filter
     // WEBAE3-6534 - remove for EUR site but not travel partner sites
     // WEBAE3-6580 - expand 6534 to all source EU sites except AVD, FCR and travel partner sites
     // WEBAE3-6614 - expand to AU/NZ (not FCR or DAP)
     // WEBAE3-6613 - extend EU rules to GB
     // WEBAE3-7240 - extend rules to hide to DAP - removed this from the AU,NZ test: && !AE.props.bIsDapTpDomain
     if (!oExists.IB && !oExists.II && !oExists.IZ && !oExists.CFP && !oExists.CFS 
         || (['US','CA'].indexOf(AE.props.chaosSystem) >= 0) 
         || (['AU','NZ'].indexOf(AE.props.chaosSystem) >= 0) 
         || (['EU','GB'].indexOf(AE.props.chaosSystem) >= 0 && ['AVD','FCR','DTP'].indexOf(AE.props.siteCode) < 0 && !AE.props.bIsTpDomain)) {
      $('#matrix__filters--ins').parent('.toggler').parent().addClass('hidden-filter').hide();
     }

     if (!oExists.TA) {
       $('#trans_automatic').parent().addClass('hidden-filter').hide();
     }
     if (!oExists.TM) {
       $('#trans_manual').parent().addClass('hidden-filter').hide();
     }
     // https://autoeurope.jira.com/browse/WEBAE3-1124
     if (!oExists.TA && !oExists.TM) {
       $('#matrix__filters--trans').parent('.toggler').parent().addClass('hidden-filter').hide();
     }
    
    // WEBAE3-3828
    var carCount = _.keys(AEdata.booking.quote.oCars).length,
      aOnAirportCars = _.filter(AEdata.booking.quote.oCars,function(oCar){return oCar.hasOnAir;}),
      aOffAirportCars = _.filter(AEdata.booking.quote.oCars,function(oCar){return oCar.hasOffAir;});
    if(aOnAirportCars.length > 0 && aOnAirportCars.length < carCount) oExists.ON = true;
    if(aOffAirportCars.length > 0 && aOffAirportCars.length < carCount) oExists.OFF = true;
    if (!oExists.ON) {
      $('#air_on').parent().addClass('hidden-filter').hide();
    }
    if (!oExists.OFF) {
      $('#air_off').parent().addClass('hidden-filter').hide();
    }
    if (!oExists.ON && !oExists.OFF) {
      $('#matrix__filters--onair').parent('.toggler').parent().addClass('hidden-filter').hide();
      if (AE.props.siteCode == 'FCR') {
        $('#matrix__filters--onair').parent().parent().addClass('hidden-filter').hide();
      }
    }
    
    // WEBAE3-5859 - Add hidden-filter class to necessary elements above ^. Hide any completely empty filter sections and add "show more/less" toggle for larger filter lists
    $('#matrix__filters .filter-block').each(function()
    {
        if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
            var $this = $(this);
            var totalFilters  = $this.find('div.matrix_filter').length;
            var hiddenFilters = $this.find('div.matrix_filter.hidden-filter').length;
            var filterDiff    = totalFilters - hiddenFilters;
            
            if(parseInt(filterDiff) <= 0 && !$this.hasClass('priceslider-container')) {
                $this.addClass('hidden-filter-group').hide();
            } else {
                $this.on('click', '.filter-trigger', function()
                {
                    $(this).closest('.filter-block').toggleClass('collapsed');
                });
            }
        }
    });

     // Return this object for testing purposes.
     return oExists;
   },
   runFilters: function (code, value) {
     /*
     Two things are passed in from the checkbox that was just clicked.
     code:  The two-letter code for the filter. For example, "TA" means "Transmission Auto"
     value: The after-click value for the checkbox.

     If neither is passed in, then the filterKey object is used as-is. This is only likely to happen on page load,
     since the function is otherwise only called upon a checkbox click.
     */

     /* Update the filterKey object with the value from the checkbox that was just clicked. */
     if (code) {
       var aCodes = code.split('-');

       for (var category in resultsData.oFilters) {
        for (var filter in resultsData.oFilters[category]) {
          if(aCodes.length > 1){
            if(_.contains(aCodes,filter)) resultsData.oFilters[category][filter] = value;
          } else if (filter === code) {
            resultsData.oFilters[category][filter] = value;
          }
        }
       }
     } else {
       // If there's nothing passed in, then just reconcile the filter checkboxes against hte oFilters object.
     }
     
     var selectionCkdArr = [];

     var filterSelectionChecked = function () {
       $('.toggler').removeClass('selection_checked');
       selectionCkdArr.forEach(function (index) {
         $(index[0]).closest('.toggler').addClass('selection_checked')
       } )
     }
     
     APP.props.$filterChks.each(function (index) {
      var thisData = $(this).data();
      
      if(thisData['filterParent'] && thisData.filter){
        if(AEdata.booking.quote.oFilters[thisData['filterParent']]){
         if(AEdata.booking.quote.oFilters[thisData['filterParent']][thisData.filter] === true){
           $(this).prop('checked', true);
         } else if(AEdata.booking.quote.oFilters[thisData.filterParent][thisData.filter] !== undefined && $(this).prop('checked') === true){
            /* WEBAE3-3713 - LJW - Persist Filter Selections when Back Button used.
            The checkbox elements remain checked, but the filter JSON object resets.*/
            AEdata.booking.quote.oFilters[thisData['filterParent']][thisData.filter] = true;
         }
        }
      }
      
       if($(this).prop("checked") == true){
         selectionCkdArr.push($(this));
       }
      
      //  var preCheck = AE.booking.matrix.results.props.oFilters[$(this).data('filter-parent')][$(this).data('filter')];
      //  var expandParent = preCheck;
       var toggler = $(this).closest('.toggler');
      //  var togglee = $('#' + toggler.attr('data-togglee').replace('#', ''));

       /* WEBAE3-1050 - in IE 10, the matrix filters require users to click the arrow; should be able to click the entire box. */
       if (AE.legacy.grief.isIE) {
         toggler.uniqueId();

         var _forId = toggler.attr('id');
         var _label = toggler.find('label:first');
         _label.attr('for', _forId);
         _label.on('click', function (event) {
           event.preventDefault();
           event.stopImmediatePropagation();
           labelID = $(this).attr('for');
           return $('#' + labelID).trigger('click');
         });
       }

       


       /* WEBAE3-881 | Simari | 01/29/18 - When a grid filter is pre-checked, the filter should load open so the user can see the pre-check */
       /* WEBAE3-1030 | Simari | 03/02/18 - Filter dropdowns behave oddly and inconsistently */
      //  if (expandParent) {
      //    toggler.addClass('open');
      //    togglee.removeClass('visuallyhidden');
      //  }

      //  $(this).prop('checked', preCheck);
     });

     filterSelectionChecked();
     
     /* If all of the filters are on or if they're all off, then just use the initial data object. 
      * As of WEBAE3-4447 as long as oFilters.DEP is present this check should be skipped.
     */
     
     if (APP.allFiltersMax(resultsData.oFilters) === true && AE.props.siteCode !== 'FCR' && !resultsData.oFilters.DEP) {
       /* All cars are available in this case, so set the filtered cars array to the total car results. */
       resultsData.arrFiltered = $.merge([], resultsData.arrResults);
       // And if we're filtering by supplier for the alternative mobile display (2782 Leah Jay Wiley)
       if(/*APP.props.colsByCat &&*/ APP.props.suppFilter.length){
         resultsData.arrFiltered = _.filter(resultsData.arrFiltered,function(oRes){
           return _.contains(APP.props.suppFilter,AEdata.booking.quote.oSupps[oRes.suppID].filter);
         });
       }
       if(/*APP.props.colsByCat &&*/ APP.props.locTypeFilter.length){
        resultsData.arrFiltered = _.filter(resultsData.arrFiltered,function(oRes){
          var theseLocTypes = AEdata.booking.quote.oCars[oRes.ID].aLocTypes;
          return _.intersection(APP.props.locTypeFilter,theseLocTypes).length > 0;
        });
      }
     } else {
       /*
       The filters are mixed, so we need to determine what the grid values should be before we build. We'll run are
       function to return a reduced set of cars which matches the filters.
       */
     
       resultsData.arrFiltered = $.merge([], filterCars());
     }

      if(!resultsData.arrFiltered.length) {
        if ($('.toggler').hasClass('open')) {
					$('.toggler').removeClass('open')
					$('.toggler').addClass('closed')
					AE.ui.slideUp($('.togglee'));
				}
        $('.no_filter_results').removeClass('trulyhidden')
        $('.no_filter_results').addClass('show_message')
        $('#matrix_and_map').addClass('trulyhidden')
        // $("#matrix_and_map").html(resultsData.arrFiltered.length)
      }else{
        if ($('.no_filter_results').hasClass('show_message')) {
          $('.no_filter_results').removeClass('show_message')
          $('.no_filter_results').addClass('trulyhidden')
        }
        $('#matrix_and_map').removeClass('trulyhidden')
      }

     APP.props.$resultsTotal.html(resultsData.arrFiltered.length);
     /* Create a data object suited for building the matrix grid. */
     return buildGridData(resultsData.arrFiltered);

      function depositAllowedByFilters(deposit) {
        var filtersDEP = $.merge([], APP.getFilterArray(resultsData.oFilters.DEP));

        // Early return, no deposit filters are enabled
        if (filtersDEP.isEmpty())
          return true;

        try {
          var floatDeposit = parseFloat(deposit);
          var actualFilters = APP.props.$depositFilters.map((_, t) => parseFloat(t.dataset.filterAmount));

          return deposit == 0 || deposit == 0.01 // WEBAE3-5760 LJW - includes 0.01 deposits in 0 behavior
          || filtersDEP.includes("DEP1") && floatDeposit <= actualFilters[1]
          || filtersDEP.includes("DEP2") && floatDeposit <= actualFilters[2]
          || filtersDEP.includes("DEP3") && floatDeposit <= actualFilters[3]
          || filtersDEP.includes("DEP4") && floatDeposit <= actualFilters[4];
        } catch (e) {
          return false;
        }
      }

      function insuranceAllowedByFilters(insurance) {
        var filtersIN = $.merge([], APP.getFilterArray(resultsData.oFilters.IN));

        // Early return, no insurance filters are enabled
        if (filtersIN.isEmpty())
          return true;

        // If this is a "custom" insurance check the class field, else compare the package type
        return filtersIN.some(f => {
          if (["CFP","CFS"].includes(f))
            return insurance.class.includes(f)
          else
            return insurance.packageType == f;
        });
      }

     function filterCars() {
       /*
       This function creates a reduced set of car results based upon the current resultsData.oFilters object. When finished,
       this function will return an array which will be set as the new resultsData.arrFiltered array. This will be used to rebuild
       the matrix grid, and will later be used to select specific cars from a matrix cell.
       */


       /*
       Get an array of filter classses to check against the cars. Checking each general filter category separately because their
       logic is different.
       */
       var filtersTR = $.merge([], APP.getFilterArray(resultsData.oFilters.TR)),
         filtersFP = $.merge([], APP.getFilterArray(resultsData.oFilters.FP)),
         filtersIN = $.merge([], APP.getFilterArray(resultsData.oFilters.IN)),
         /* WEBAE3-3460 */
         filtersFT = $.merge([], APP.getFilterArray(resultsData.oFilters.FT)),
         /* WEBAE3-3725 */
         filtersACK = $.merge([], APP.getFilterArray(resultsData.oFilters.ACK)),
         /* WEBAE3-3633 */
         filtersPRO = $.merge([], APP.getFilterArray(resultsData.oFilters.PRO)),
         /* WEBAE3-3620 */
         filtersDR = $.merge([], APP.getFilterArray(resultsData.oFilters.DR)),
         /* WEBAE3-3828 */
         filtersAIR = $.merge([], APP.getFilterArray(resultsData.oFilters.AIR)),
         /* WEBAE3-3602 */
         filtersKM = $.merge([], APP.getFilterArray(resultsData.oFilters.KM)),
         filtersCX = $.merge([], APP.getFilterArray(resultsData.oFilters.CX)),
         filtersAC = $.merge([], APP.getFilterArray(resultsData.oFilters.AC)),
         /* WEBAE3-3811 */
         filtersPS = $.merge([], APP.getFilterArray(resultsData.oFilters.PS)),
         /* WEBAE3-4114 */
         filtersCV = $.merge([], APP.getFilterArray(resultsData.oFilters.CV)),
         /* WEBAE3-4115 */
         filtersDEP = $.merge([], APP.getFilterArray(resultsData.oFilters.DEP));
        // Run logic to apply filters to rate fingers
        if (!_.isEmpty(filtersIN) && _.size(filtersIN) < 3) {
          var allFiltersIN = ["IB", "II", "IZ", "CFS", "CFP"];
          var hiddenRate = _.difference(allFiltersIN, filtersIN);
          _.map(hiddenRate, function (item) {
            return $('#car_results_row').addClass('' + item + '_false');
          });
        }
        const allFiltersDEP = ["DEP0", "DEP1", "DEP2", "DEP3", "DEP4"];
        allFiltersDEP.forEach(item => $('#car_results_row').removeClass('' + item + '_false'));
        if (!_.isEmpty(filtersDEP)) {
          var highestEnabledDEP = filtersDEP.sort()[filtersDEP.length - 1];
          var hiddenRate = allFiltersDEP.slice(allFiltersDEP.indexOf(highestEnabledDEP), allFiltersDEP.length);
          _.map(hiddenRate, (item) => $('#car_results_row').addClass('' + item + '_false'));
        }

       /*
       Make a reduced set of cars from the resultsData object's ARRRESULTS array.
       */
       return _.filter(resultsData.arrResults, function (item) {
         var keepItem = true;
         if (keepItem && filtersTR.length > 0 && filtersTR.length < 2) {
           for (var i = 0; i < filtersTR.length; i++) {
             if (!_.contains(item.aFilters, filtersTR[i])) {
               keepItem = false;
             }
           };
         }
         /* WEBAE3-4034 FCR Car Size Filter */
         if(keepItem && filtersCX.length > 0 && (AE.props.siteCode === 'FCR' || APP.props.resultsLayout == 'nomatrix')){
             //console.log('CX');
             //console.log(filtersCX);
          keepItem = false;
          for (var i = 0; i < filtersCX.length; i++) {
            if (_.contains(item.aFilters, filtersCX[i])) {
              keepItem = true;
            }
          };
         }
         
         /* WEBAE3-3811 FCR Price Slider Filter */
         if(keepItem && (AE.props.siteCode === 'FCR' || APP.props.resultsLayout == 'nomatrix')){
          keepItem = false;
          var sliderhigh = document.getElementById('slider_thumb_high');
          highprice = sliderhigh.getAttribute("aria-valuenow");
          var sliderlow = document.getElementById('slider_thumb_low');
          lowprice = sliderlow.getAttribute("aria-valuenow");
          if (item.sortPrice >= Math.floor(lowprice) && item.sortPrice <= Math.ceil(highprice)) {
            keepItem = true;
          }
         }
         /* WEBAE3-3460 Hans added fuel types */
         if (keepItem && filtersFT.length > 0) {
           keepItem = false;
           for (var i = 0; i < filtersFT.length; i++) {
             if (_.contains(item.aFilters, filtersFT[i])) {
               keepItem = true;
             }
           };
         }
         /* WEBAE3-3828 Leah added On/Off Airport */
         if (keepItem && filtersAIR.length > 0) {
          keepItem = false;
          if(AEdata.booking.quote.oFilters.AIR.ON && AEdata.booking.quote.oCars[item.ID].hasOnAir) keepItem = true;
          if(AEdata.booking.quote.oFilters.AIR.OFF && AEdata.booking.quote.oCars[item.ID].hasOffAir) keepItem = true;
        }
         /* WEBAE3-3725 Leah added autocheckin */
         if (keepItem && filtersACK.length > 0) {
          keepItem = false;
          for (var i = 0; i < filtersACK.length; i++) {
            if (_.contains(item.aFilters, filtersACK[i])) {
              keepItem = true;
            }
          };
        }
         /* WEBAE3-3633 Leah added Promotions */
         if (keepItem && filtersPRO.length > 0) {
          keepItem = false;
          if(filtersPRO.length === _.intersection(item.aFilters,filtersPRO).length){
            keepItem = true;
          }
        }
         /* WEBAE3-3620 Leah added doors */
         if (keepItem && filtersDR.length > 0) {
          keepItem = false;
          for (var i = 0; i < filtersDR.length; i++) {
            if (_.contains(item.aFilters, filtersDR[i])) {
              keepItem = true;
            }
          };
        }
         /* WEBAE3-3602 Leah added mileage and AC */
         if (keepItem && filtersKM.length > 0) {
          keepItem = false;
          for (var i = 0; i < filtersKM.length; i++) {
            if (_.contains(item.aFilters, filtersKM[i])) {
              keepItem = true;
            }
          };
        }
        if (keepItem && filtersAC.length > 0) {
          keepItem = false;
          for (var i = 0; i < filtersAC.length; i++) {
            if (_.contains(item.aFilters, filtersAC[i])) {
              keepItem = true;
            }
          };
        }
         /* WEBAE3-4114 Mike added Cargo Vans */
         if (keepItem && filtersCV.length > 0) {
          keepItem = false;
          for (var i = 0; i < filtersCV.length; i++) {
            if (_.contains(item.aFilters, filtersCV[i])) {
              keepItem = true;
            }
          };
        }
				
        // WEBAE3-4447 "keepItem" in this context means an entire row
        // so only set keepItem to false if the entire row should be hidden
        // i.e. all fingers.
        if (keepItem && filtersDEP.length > 0) {
          // If every rate fails the filter, keepItem is false and the row is hidden
          keepItem = AEdata.booking.quote.oCars[item.ID].aRates.some((r) => {
            var cc_deposit = parseFloat(AEdata.booking.quote.oRates[r].ccDeposit);
            return depositAllowedByFilters(cc_deposit);
          })
        }
		
        // If it's still true after that...
        if (keepItem && filtersFP.length > 0 && filtersFP.length < 2) {
          for (var i = 0; i < filtersFP.length; i++) {
            if (!_.contains(item.aFilters, filtersFP[i])) {
              keepItem = false;
            }
          };

          // Double-check. At this point we have one fuel policy filter checked. Having both or neither keeps the car, and having
          // one checked keeps only a car that matches the chosen filter. However, we need to make sure that cars with no fuel policy
          // at all will still show per ticket WEBAE3-856. These cars are immune to fuel policy filters.
          if (!_.contains(item.aFilters, "FF") && !_.contains(item.aFilters, "FE")) {
            keepItem = true;
          }
        }

        // And if it's still true even after that...
        if (keepItem && filtersIN.length > 0) {
          keepItem = false;
          for (var i = 0; i < filtersIN.length; i++) {
            if (_.contains(item.aFilters, filtersIN[i])) {
              keepItem = true;
            }
          };
        }

        // And if we're filtering by supplier for the alternative mobile display (2782 Leah Jay Wiley)
        if(keepItem && /*APP.props.colsByCat &&*/ APP.props.suppFilter.length){
          keepItem = _.contains(APP.props.suppFilter,AEdata.booking.quote.oSupps[item.suppID].filter);
        }
        if(keepItem && /*APP.props.colsByCat &&*/ APP.props.locTypeFilter.length) {
          var theseLocTypes = AEdata.booking.quote.oCars[item.ID].aLocTypes;
          keepItem = _.intersection(APP.props.locTypeFilter,theseLocTypes).length > 0;
        }
		
         // After all of those tests, we return the final value of the dropItem variable.
         return keepItem;
       });
       
     }

     function buildGridData(setOfCars) {
       /*
       This function creates a new object with the format needed to build the matrix.
       */

       /* Cache the existing matrix columns to variables. */
       var $allSuppliers = $('#matrix__static').find('.matrix__column').not('.matrix__column--static'),
         $columns = $('#matrix__scroll-container').find('.matrix__column');

       var newData = {
         allSuppliers: {
           cells: [],
           title: {
             name: resultsData.oTranslations.ALL_RESULTS
           }
         },
         categories: [],
         columns: []
       };
       for (var i = 0; i < resultsData.arrCategories.length; i++) {
         var filter = resultsData.arrCategories[i];

         var tempCategory = {
           filter: filter,
           name: resultsData.oCategories[filter].label,
           track: resultsData.oCategories[filter].label
         };
         newData.categories.push(tempCategory);
        }

       /* Loop through the columns in the newData object. */
       if (APP.props.colsByCat) {

         _.each(newData.categories, function (oCat) {
           var tempCat = resultsData.oCategories[oCat.filter];
           var aCarsInCat = _.sortBy(_.filter(setOfCars, function (oCar) {
             var tempCar = AEdata.booking.quote.oCars[oCar.ID];
             var tempRE = new RegExp(tempCat.sippMaskRE);
             return tempCar.catID === tempCat.filter || tempCar.SIPP.match(tempRE);
           }), 'rate');
           var column = {
             title: {
               filter: oCat.filter,
               name: tempCat.label,
               logoURL: tempCat.imgURL,
               note: tempCat.label,
               rating: 0
             },
             cells: []
           };
           var lowCell = {
             count: aCarsInCat.length,
             rate: Number(1000000000000),
             lowestItem: true,
             category: '',
             price: '--',
             track: ''
           };
           _.each(_.sortBy(resultsData.arrSuppliers, 'rank'), function (supID) {
             var tempSup = AEdata.booking.quote.oSupps[supID];
             var aCellCars = _.filter(aCarsInCat, function (tempCar) {
               return tempCar.suppID === supID;
             });
             var cell = {
               count: aCellCars.length,
               lowestItem: false,
               category: '',
               rate: 0,
               price: '--',
               track: ''
             };
             if (aCellCars.length > 0) {
               var oCellCar = aCellCars[0];
               var oCellPrice = getPrice(oCellCar);
               cell.price = oCellPrice.price;
               cell.rate = oCellPrice.rate;
               cell.category = tempSup.filter;
               cell.track = tempCat.track;
               if (cell.rate < lowCell.rate) { 
               //if (cell.price < lowCell.price) { // WEBAE3-4740 Switched to price sort per changes made on WEBAE3-4719
                 lowCell.rate = cell.rate;
                 lowCell.price = cell.price;
               }
             }
             column.cells.push(cell);
           });
           _.each(column.cells, function (cell) {
             if (lowCell.rate === cell.rate) cell.lowest = true;
           });
           column.cells.unshift(lowCell);
           newData.columns.push(column);
         });
       } else {
         for (var i = 0; i < resultsData.arrSuppliers.length; i++) {

           /* The supplier for this column. */
           var tempSupplier = resultsData.oSuppliers[resultsData.arrSuppliers[i]];
           var tempNote = '';
           var ltrOnly = (resultsData.oFilters.EXCLUSIVE && resultsData.oFilters.LTR)? true : false;
           // LTR SEARCH MIGHT MUSH NON AIRPORT LOCATIONS
           if (resultsData.isAirportPickup && !resultsData.isAllLocation && !ltrOnly) {
             tempNote = (tempSupplier.hasOnAirPuLoc) ? resultsData.oTranslations.ONAIRPORT : resultsData.oTranslations.OFFAIRPORT;
           }
           if(tempSupplier.prom){// suppress new messaging WEBAE3-2498 NW
             tempNote = '<div class="matrix__supplier--feature">'+AEdata.booking.quote.oLang.PROMOTED_SUPPLIER+'</div>'+tempNote;
           }
           
           /* WEBAE3-4614 Flip logoURL logic to look for tempSupplier.logoURL before resultsDate.oLogos */
           
           var column = {
             title: {
               filter: tempSupplier.filter,
               name: tempSupplier.name,
               logoURL: tempSupplier.logoURL || resultsData.oLogos[tempSupplier.masterCode],
               note: tempNote,
               rating: tempSupplier.rating
             },
             cells: []
           };

           /* Loop through the cells in this column. */
           for (var j = 0; j < resultsData.arrCategories.length; j++) {

             var cell = {};

             /* Build a selector and use it to find cars from the results which will match this cell. */
             var tempCategory = resultsData.arrCategories[j];

             /* Cars for the current column. */

             var cellCars = _.filter(setOfCars, function (item) {
               return ((_.contains(item.aFilters, column.title.filter)) && (_.contains(item.aFilters, tempCategory)));
             });

             /*
             The cell object has the following structure which we will need to update:
             cell = {
               category:		The type of car, whether a compact or a midsize. Set to an empty string for cells with no car results.
               count:			The number of cars that the cell represents. If there are no cars, then this has a zero value.
               displayOrder:	The number associated with the category. Used to build the column class, such as "C1".
               lowest:			Whether or not this is the lowest prise for that category in the grid.
               price:			Translated string for the price in the markup, including monetary text. Ex: "$531 CAD"
               rate:			A number version of the price, used for sorting and finding out which one is lowest.
               track:			Same as category. Currently not used, but left over from tracking efforts in the past.
             };

             Since we're selecting for cars from the same supplier and category, there's no need to alter these properties unless we
             have an empty cell. Track will also be left alone unless the cell is empty.
             */

             cell.count = cellCars.length;
             cell.lowestItem = false; /* This could be set to true later, but we'll default to false. */

             if (cellCars.length > 0) {
               cell.category = resultsData.arrCategories[j];

               // Setting a large starting number for sortrate so I don't have to run a function to get the highest value from data.
               var lowestItem = {
                 index: 0,
                 sortrate: Number(1000000000000)
               };

               // Sort cellCars by filter-relevant starting rate WEBAE3-2501 NW
               var sortKey = 'rate';
               if(AEdata.booking.quote.oFilters.IN.II){
                 sortKey = 'inclusiveStartRate';
               } else if(AEdata.booking.quote.oFilters.IN.IZ){
                 sortKey = 'zxStartRate';
               }
               // Find the lowest price among the cars, using the sortrate. The sortrate property is a numeric version of the price.
               var lowestItem = [];
               if(sortKey === 'rate'){
                 lowestItem = (_.sortBy(cellCars, sortKey));
                 lowestItem = lowestItem[0];
               } else {
                 lowestItem = _.sortBy(cellCars, function(tempCar){
                   return AEdata.booking.quote.oCars[tempCar.ID][sortKey];
                 });
                 lowestItem = lowestItem[0];
               }

               // Get the lowest price for this car, using the insurance levels available from the filter selection.
               var objPrice = getPrice(lowestItem);

               // Make a jQuery object out of the car with the lowest price. This will go into the new matrix grid.
               cell.rate = objPrice.rate;
               cell.price = objPrice.price;
             } else {
               // If the cell has no cars, then we need to show that in the grid.
               cell.category = '';
               cell.track = '';
               cell.rate = 0;
               cell.price = '--';
             }
             column.cells.push(cell);
           };
           newData.columns.push(column);
         };
       }
       // Takes a car and checks its prices using the insurance filters, returning an object with a rate and a display price.
       function getPrice(car) {
         // Get the full object for this car so we can use all three insurance price levels. Also get the insurance
         // filter object to use as a filter key.
         var srcCar = AE.booking.matrix.getResultsData().oResults[car.ID],
          filterKey = resultsData.oFilters.IN,
          rate = Number(0), price = '--';

         var allowedDepositRates = srcCar.aRates
          .map(r => AEdata.booking.quote.oRates[r])
          .filter(ro => depositAllowedByFilters(ro.ccDeposit));

         var allowedInsuranceRates = allowedDepositRates
          .filter(ro => insuranceAllowedByFilters({
            packageType: ro.packageType,
            class: ro.class
          }));

         //Early exit, no rates qualified
         if (allowedDepositRates.isEmpty())
          return {
            rate: rate,
            price: price
          };
        
         if (APP.filtersMax(filterKey)) {
           // No insurance filters applied, find the lowest lead rate with an acceptable deposit
           var leadRate = allowedDepositRates.reduce((ro1, ro2) => (ro1.rate < ro2.rate) ? ro1 : ro2);
           rate = leadRate.rate;
           if(AE.props.addFeesToRate){
             var tempEstimate = Math.trunc(Number(leadRate.estimate));
             rate = tempEstimate;
             price = resultsData.oTranslations.CURRENCY_TEMPLATE.replace('.',tempEstimate);
            } else {
              price = leadRate.rateCurr.split('.')[0];
            }
         } else if (allowedInsuranceRates.length) {
           var leadRate = allowedInsuranceRates.reduce((ro1, ro2) => (ro1.rate < ro2.rate) ? ro1 : ro2);
           rate = leadRate.rate;
           if(AE.props.addFeesToRate){
            var tempEstimate = Math.trunc(Number(leadRate.estimate));
            rate = tempEstimate;
            price = resultsData.oTranslations.CURRENCY_TEMPLATE.replace('.',tempEstimate);
           } else {
             price = leadRate.rateCurr.split('.')[0];
           }
         }
         return {
           rate: rate,
           price: price
         }
       }

       /* Looping through the rows. We want a value for that row in each column. */
       if (!APP.props.colsByCat) {
         for (var rowID = 0; rowID < resultsData.arrCategories.length; rowID++) {

           /* Setting lowestRate variable to a large number so we don't have to grab the real highest number from another loop. */
           var lowColID = null,
             lowestRate = Number(1000000000000),
             lowestCell = {};

           /* Going through the columns now. Checking the same index in each one so we can compare rows. */
           for (var colID = 0; colID < newData.columns.length; colID++) {
             if (newData.columns[colID].cells[rowID]) {
               var rate = newData.columns[colID].cells[rowID].rate;
               newData.columns[colID].cells[rowID].lowest = false;
             } else {
               var rate = 0;
             }

             /* Empty cells have a zero to indicate that there's no car available. We don't want to set that as the lowest. */
             if (rate < lowestRate && rate > 0) {
               lowColID = colID;
               lowestRate = rate;
             }
           }
           /*
           lowColID is initialized at null, and only gets set to something else if there's a non-zero rate somewhere in the row.
           If it's still null at this point, then there are no rates in the row.
           */
           if (lowColID === null) {
             /* All cells in this row are empty. Use the first one as a base to get a cell with no price. */
             $.extend(true, lowestCell, newData.columns[0].cells[rowID]);
           } else {
             /* Extend the newData.allSuppliers cell with the values from the newData.columns cell. */
             $.extend(true, lowestCell, newData.columns[lowColID].cells[rowID]);

             /* Set the 'lowest' property to true so the source cell can be marked as having the lowest price. */
             newData.columns[lowColID].cells[rowID].lowest = true;
           }

           newData.allSuppliers.cells.push(lowestCell);
         }
       }

       return newData;
       
     }

   },
   getFilterArray: function (filterKey) {
     /*
     Returns an array of filter values to match against the ARRFILTERS property of a car.
     */
     var arrFilters = [];
     for (var filter in filterKey) {
       if (filterKey[filter] === true) {
         arrFilters.push(filter);
       }
     }
     return arrFilters;
   },
   filtersMax: function (filterKey) {
     /*
     When all filters are false, it's basically the same as all filters being true. Filters are grouped into Transmission types,
     Fuel Options and Coverage Options. The code for the group being checked is passed into this function and it's properties
     are read for boolean values. If all of properties are true or if they're all false, then this function returns true.
     */
     var allMaxed = false,
       allTrue = true,
       allFalse = true;

     /*
     We loop through the three category objects within the filterKey object. We need to know if all properties in all categories are
     either all true or all false. This is to determine whether the filters are maxed out one way or the other.
     */
     for (var filter in filterKey) {
       if (filterKey[filter] === true) {
         /* If any filter is true, then allFalse is false.  */
         allFalse = false;
       } else {
         /* If any filter is false, then allTrue is false.  */
         allTrue = false;
       }
     }
     if (allTrue || allFalse) {
       /* If all of the filters are all true or all of the filters are false, then allMaxed is true. */
       allMaxed = true;
     }
     return allMaxed;
   },
   allFiltersMax: function (filterKey) {
     /*
     Similar to the filtersMax() function above, but with the entire filterKey object. For this to return true, all three categories
     must return a filtersMax() value of true.
     WEBAE3-3460 added && APP.filtersMax(filterKey.FT)
     WEBAE3-3602 added && APP.filtersMax(filterKey.KM) && APP.filtersMax(filterKey.AC)
     WEBAE3-3620 added && APP.filtersMax(filterKey.DR)
     WEBAE3-3633 added && APP.filtersMax(filterKey.PRO)
     WEBAE3-3725 added && APP.filtersMax(filterKey.ACK)
     WEBAE3-3828 added && APP.filtersMax(filterKey.AIR)
     WEBAE3-4114 added && APP.filtersMax(filterKey.CV)
     WEBAE3-4447 filterKey.DEP no longer has this equivalence between allFalse and allTrue
     */

    if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
      return (APP.filtersMax(filterKey.CX) && APP.filtersMax(filterKey.TR) && APP.filtersMax(filterKey.FP) && APP.filtersMax(filterKey.IN) && APP.filtersMax(filterKey.FT) && APP.filtersMax(filterKey.KM) && APP.filtersMax(filterKey.AC) && APP.filtersMax(filterKey.DR) && APP.filtersMax(filterKey.PRO) && APP.filtersMax(filterKey.ACK) && APP.filtersMax(filterKey.AIR) && APP.filtersMax(filterKey.PS));
    } else {
     return (APP.filtersMax(filterKey.TR) && APP.filtersMax(filterKey.FP) && APP.filtersMax(filterKey.IN) && APP.filtersMax(filterKey.FT) && APP.filtersMax(filterKey.KM) && APP.filtersMax(filterKey.AC) && APP.filtersMax(filterKey.DR) && APP.filtersMax(filterKey.PRO) && APP.filtersMax(filterKey.ACK) && APP.filtersMax(filterKey.AIR) && APP.filtersMax(filterKey.CV));
    }

   },
   hideResults: function () {
     /* Hide all of the car results. */
     APP.props.$resultsCountWrap.addClass('empty');
     $('#matrix__noresults').addClass('trulyhidden');
     APP.props.$results.css('min-height', 'auto').find('.result_container').hide();
   },
   showResults: function ($target, setOfCars, clickedMapID) {
     clickedMapID = clickedMapID || false;
     var haveSpinner = true; // This will get set to false after the first car is displayed.
     /*
     This function shows car results which match the filters as well as the matrix cell which was clicked by the user.
     The array of cars has already been filtered or unfiltered by now, so we just operate from the array that's been
     passed into the function.

     The initial spans in the markup are hidden by default, but the final markup for a car is visible. Hide all rendered cars.
     We're going to show the appropriate cars in a moment. In the meantime, we will show a spinner.
     */

     /* Find out if we have a category and/or supplier. Also check for a location. Set to null if we don't have them. */
    if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
        var stats = {
            category: null,
            supplier: null,
            location: null
        }
    }else{
      var stats = {
        category: ($target.closest('li').data('category') && $target.closest('li').data('category') !== '') ? $target.closest('li').data('category') : null,
        supplier: ($target.closest('li').data('supplier') && $target.closest('li').data('supplier') !== '') ? $target.closest('li').data('supplier') : null,
        location: ($target.data('location') && $target.data('location') !== '') ? $target.data('location') : null
      };
    };

      /* WEBAE3-5142 
          Find out if we have any insurance filters to limit the results and refigure lowest price for carid for the standard view 
          If found, return the applicable codes (IZ,II,IB)
      */
      var objResultInsuranceFilter = AE.booking.matrix.results.props.oFilters.IN;
      var aInsuranceFilters = Object.keys(objResultInsuranceFilter).filter(function(k){return objResultInsuranceFilter[k]}).map(String);
     //WEBAE3-5142

     /* Setting the data attributes for the car results so we can apply the "selected" class to the appropriate parts of the matrix. */
     APP.props.$results
       .data('category', (stats.category ? stats.category : ''))
       .data('supplier', (stats.supplier ? stats.supplier : ''));

     /* Hide all of the car results, because we're going to show the proper results. */
     APP.hideResults();

     /* Set the results count to a blank result. */
     //APP.props.$resultsCount.html('--');

     /* Add a spinner while the cars load. */
     AE.ui.addSpinner('#car_results', {
       size: '5x',
       color: 'black',
     });
     
     //FCR testing - alert('addSpinner fired');

     /*
     Scroll to the top of the car results. Using HTML and BODY because different browsers are different and either could be used
     for scrolling. Although the scroll animation will only work once, jQuery will try twice. This means that the callback function
     will fire twice. We're using the "ranOnce" variable to skip the callback function on the second pass.
     */
     var setOfLocs = getFilteredSetOfLocs($target);
     var reducedCars = getFilteredSetOfCars(stats, setOfCars, setOfLocs);
     
     /*
     Stretch results container height so we can scroll before images load and reveal their heights, but not if there won't be any
     results. Minimum height will be reset to 'auto' later.
     */
     if (setOfCars.length > 0) {
       APP.props.$results.css('min-height', '430px');
     }

     // The current scroll position of the main content container, plus the current offset of the results row container. Since the
     // scrolling anti-propagation feature was put in, these items now return their offset position from the top of the window,
     // because their offset container is set to the size of the window.
     //			var scrollTarget = parseInt($('#car_results_row').prev().offset().top + AE.props.$scrollContent.scrollTop());
     // jOlivier 2018-04-05 : This was changed due to a race condition where the scrollTarget was beyond the size of
     // the page due to the results DIV still being empty at the time of the scroll
     // (eg. it took too long to fill w/results. This can be duplicated with a LTR in Paris, click on the Peugeot logo)
     
    // WEBAE3-5390 Target .number_of_results since it's always on the page,
    // and add current scrollTop - 10px offset to account for
    // open reservation info when modifying a reservation
    
    // WEBAE3-6445 Offset scroll top by negative height of filters since they are now sticky
    
    //Orig: parseInt($('#matrix_and_map').outerHeight())
    var scrollTarget = parseInt($('.number_of_results').offset().top) + AE.props.$scrollContent.scrollTop() - 10 - $('.getrates_details').height();
    
    if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
      if($target) {
        if($target.hasClass("matrix_filter")){
          var fcrStopScroll = true;
        };
      }else{
        var fcrStopScroll = false;
        var scrollTarget = '0';
      };
    };

    if(!fcrStopScroll) {
      AE.props.$scrollContent.stop().animate({
        scrollTop: parseInt(scrollTarget)
      },'fast');
    }


    if(AE.props.siteCode !== 'FCR'){//WEBAE3-6277 create the presortedCars variable for non-FCR
      presortedCars = getLowestPricedSetofCarsBasedOnFilter(reducedCars,aInsuranceFilters);//WEBAE3-5142
      displayResults(presortedCars, clickedMapID);//WEBAE3-5142 
    }else{
      displayResults(reducedCars, clickedMapID);//WEBAE3-6277 use the original (pre-WEBAE3-5142) variable instead of overhead of processing getLowestPricedSetofCarsBasedOnFilter()
    }
    //displayResults(reducedCars, clickedMapID);// Changed from reduced cars for WEBAE3-5142
    APP.props.$resultsCount.html(APP.props.$results.children(':visible').length);
    APP.props.$resultsCountWrap.removeClass('empty');

    //  AE.props.$scrollContent.stop().animate({
    //      scrollTop: parseInt(scrollTarget)
    //    },
    //    'fast',
    //    function () {
    //      // The functions called below are detailed below, within the scope of showResults().
    //      // We have the number of cars that we're going to display, so it's time to update the text and show the container.
    //      displayResults(reducedCars, clickedMapID);
    //      APP.props.$resultsCount.html(APP.props.$results.children(':visible').length);
    //      APP.props.$resultsCountWrap.removeClass('empty');
    //    }
    //  );
    /* These functions are only needed within showResults(), so they're local to this scope. */

    //added for WEBAE3-5142
     function getLowestPricedSetofCarsBasedOnFilter(setOfCars, ainsuranceFilters){//added for WEBAE3-5142
      
        var postSetOfCars = setOfCars.slice();
        var tmpSetOfCars = [];
        if (ainsuranceFilters === undefined) {
            var ainsuranceFilters = [];
        }
        _.each(postSetOfCars, function (car) {
          var afilteredRates = [];
          var thisRateCeilingTmp  = 100000000000000.00;
          var tmpResultData       = AE.booking.matrix.results.props.oResults[car.ID];
          var tmpLowestRate       = thisRateCeilingTmp;
          if(ainsuranceFilters.length){
            ainsuranceFilters.forEach(function(item, index, arr){
              afilteredCur = tmpResultData.aRates.filter(function(val){ return val.startsWith(item); });
              afilteredRates =  afilteredRates.concat(afilteredCur);
            })
          }else{
            afilteredRates = tmpResultData.aRates;
          }
          afilteredRates = _.sortBy(afilteredRates,function(thisRateID){
            return AE.booking.matrix.results.props.oRateFingers[thisRateID].rate;
          });
          _.each(afilteredRates,function(thisRateID){
            var thisRate = AE.booking.matrix.results.props.oRateFingers[thisRateID];
            if(tmpLowestRate>thisRate.rate){
                tmpLowestRate = thisRate.rate;
            }
          })
          car.lowestRate = tmpLowestRate;
          car.rate = tmpLowestRate;
        })
        postSetOfCars.sort(function(a, b){return a.lowestRate - b.lowestRate});
       return postSetOfCars;
     }

     function getFilteredSetOfCars(stats, setOfCars, setOfLocs) {
       /*
       Some cells will have only a supplier or only a category. To prevent an unplanned trip to Error Town, we'll
       check them individually. If there's a data attribute for the supplier and it's not empty, then we filter the
       cars. Once that's done, we do it again for the category.

       We're using UnderscoreJS to filter the arrays. When complete, we'll have a small set of cars which match up with
       the filters and the clicked cell.
       */
       var carArray = $.merge([], setOfCars);
       
       if (stats.category) {
         carArray = _.filter(carArray, function (car) {
           return (_.contains(car.aFilters, stats.category));
         });
       }
       if (stats.supplier) {
         carArray = _.filter(carArray, function (car) {
           return (_.contains(car.aFilters, stats.supplier));
         });
       }
       if (stats.location) {
         carArray = _.filter(carArray, function (car) {
           return (_.intersection(car.ID, setOfLocs.ID));
         });
       }
       //STORE-1504 suppress cover genius cars on matrix
       /* Don't think we need this now that Cover Genius is an IZ "packagetype"  
       carArray = _.filter(carArray, function (car) {
           return (!AE.booking.matrix.results.props.oResults[car.ID].isCoverGeniusSipp);
         });
       */
       return carArray;
     }

     function getFilteredSetOfLocs($target) {
       var setOfLocs = [];
       if (stats.location) {
         var setOfLocs = _.filter(AE.booking.matrix.results.props.oResults, function (item) {
           return (_.contains(item.aLocs, stats.location));
         });
       }
       return setOfLocs;
     }

     function loadResult(car) {
       /*
       This function loads a specific car result. It's not concerned with filters or anything else. It just replaces the initial span
       in the markup with a fully-built document fragment.
       */
       //console.log('loadResult () car', car);
       /* The buildResult method of the results module returns the document fragment that we need. */
       var documentFragment = AE.booking.matrix.results.buildResult(
         AE.booking.matrix.results.props.oResults[car.ID]
       );

       /* Find the span in the mark up with the appropriate ID and replace it with this document fragment. */
       $('#' + car.ID).replaceWith(documentFragment);
       //$('#' + car.ID).replaceWith(documentFragment).show();

       /*
       Find the index of this car in both arrays of the resultsData object. These will be different if the filters are mixed, so we have
       to check them both.
       */
       var indexF = _.findIndex(resultsData.arrFiltered, function (item) {
           return item.ID === car.ID;
         }),
         indexA = _.findIndex(resultsData.arrResults, function (item) {
           return item.ID === car.ID;
         });


       /*
       Now that we have the index values, we cn reference then directly and set the car's LOADED property to 'true'. This will prevent
       the car from being loaded a second time.
       */
       if (indexF > -1) resultsData.arrFiltered[indexF].LOADED = true;
       if (indexA > -1) resultsData.arrResults[indexA].LOADED = true;
       resultsData.oResults[car.ID].LOADED = true;
     }

     function sortByInsuranceFilters(setOfCars) {
       var sortField = 'rate';
       // Commented out WEBAE3-5142
      //  if (AE.booking.matrix.results.props.oFilters.IN.IB) {
      //    sortField = 'basicStartRate';
      //  } else if (AE.booking.matrix.results.props.oFilters.IN.II) {
      //    sortField = 'inclusiveStartRate';
      //  } else if (AE.booking.matrix.results.props.oFilters.IN.IZ) {
      //    sortField = 'zxStartRate';
      //  } else 
       if (AE.booking.matrix.results.props.oFilters.IN.CFS) {
         sortField = 'cfsStartRate';
       } else if (AE.booking.matrix.results.props.oFilters.IN.CFP) {
         sortField = 'cfpStartRate';
       }

      //handle FCR sort sort by rate DESC, else sort by rate ASC
      if((AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') && $('#sp_sp').prop('checked') == true) { 
        return _.sortBy(setOfCars, function (car) {
          return AE.booking.matrix.results.props.oResults[car.ID][sortField];
        }).reverse();
      } else {
        return _.sortBy(setOfCars, function (car) {
          return AE.booking.matrix.results.props.oResults[car.ID][sortField];
        });
      }
     }
  
     function displayResults(setOfCars, clickedMapID) {
       if (setOfCars.length > 0) {
        //WEBAE3-5849 - This is needed to ensure correct sort order when fees have been added to the initial rate. FCR has its own sorting routine above - Mike 9 Nov 2023
        if(AE.props.siteCode !== 'FCR') {
          setOfCars = _.sortBy(setOfCars, function (car) {
            // WEBAE3-6371 Determine vehicle sort based on insurance filters (if applicable) - Derek 21 Aug 2024
            var insFilters = AE.booking.matrix.results.props.oFilters.IN;
            var sortVal = AE.booking.matrix.results.props.oResults[car.ID].SORTPRICE;
            // Need to use "=== true" because CFS is set to "NO" if false and will return true without the strict check
            if(insFilters.IB === true || insFilters.II === true || insFilters.IZ === true || insFilters.CFP === true || insFilters.CFS === true) {
                var sortPrices = [];
                // sort by basic
                if(insFilters.IB === true) {
                    var sortField = AE.booking.matrix.results.props.oResults[car.ID].aStartRates.find(e => e.PACKAGE === 'basic');
                    if(typeof(sortField) != 'undefined' && sortField) {
                        sortPrices.push(parseFloat(sortField.RATE));
                    }
                }
                // sort by inclusive
                if(insFilters.II === true) {
                    var sortField = AE.booking.matrix.results.props.oResults[car.ID].aStartRates.find(e => e.PACKAGE === 'inclusive');
                    if(typeof(sortField) != 'undefined' && sortField) {
                        sortPrices.push(parseFloat(sortField.RATE));
                    }
                }
                // sort by Zx (no deductible)
                if(insFilters.IZ === true) {
                    var sortField = AE.booking.matrix.results.props.oResults[car.ID].aStartRates.find(e => e.PACKAGE.indexOf('Z') === 0);
                    if(typeof(sortField) != 'undefined' && sortField) {
                        sortPrices.push(parseFloat(sortField.RATE));
                    }
                }
                // sort by CFS (travel partner inclusive)
                if(insFilters.CFS === true){
                    var sortField = AE.booking.matrix.results.props.oResults[car.ID].aStartRates.find(e => e.PACKAGE === 'CFS');
                    if(typeof(sortField) != 'undefined' && sortField) {
                        sortPrices.push(parseFloat(sortField.RATE));
                    }
                }
                // sort by CFP (travel partne no deductible)
                if(insFilters.CFP === true) {
                    var sortField = AE.booking.matrix.results.props.oResults[car.ID].aStartRates.find(e => e.PACKAGE === 'CFP');
                    if(typeof(sortField) != 'undefined' && sortField) {
                        sortPrices.push(parseFloat(sortField.RATE));
                    }
                }
                
                if(sortPrices.length > 0) {
                    sortVal = Math.min(...sortPrices);
                }
            }
            
            if (typeof sortVal !== 'undefined') {
                return sortVal;
            }
          });
            var mytmp = AE.booking.matrix.results.reBuildPlaceholders(setOfCars);//WEBAE3-5142 //WEBAE3-6277 Moved here to only happen for non FCR sites 
            $('#results_loading_cover').stop().fadeOut(100);
        }else{
          $('.searchwait-container').removeClass('trulyhidden');
        }
        //var mytmp = AE.booking.matrix.results.reBuildPlaceholders(setOfCars);//WEBAE3-5142
         /* If a car hasn't been loaded yet, then load it. Either way, show the car. */
         _.each(setOfCars, function (car) {
          if(AE.props.siteCode == 'FCR'){ //WEBAE3-6277
            if (!car.LOADED ) { //WEBAE3-6277 reenabled car.loaded for FCR
              loadResult(car);
             }
          }else{
            loadResult(car); //WEBAE3-5142 just load due to neeaded rebuild
          }
           /*
           For All Location / All Downtown Results,
           Initialize visibility CSS for "Rates Starting At" Block and
           "Round Trip" Blocks revealed by Main Map Clicks
           */

           $('#' + car.ID).show(); // map containers don't render correctly unless they're visible first
           if (AE.booking.matrix.results.props.oResults[car.ID].showMultiLoc) {
             $('#' + car.ID + ' .roundTripBlock').addClass('trulyhidden');
             $('#' + car.ID + ' .startRateBlock').removeClass('trulyhidden');
             if (clickedMapID) {
               if (AE.booking.matrix.results.props.oResults[car.ID].needsRoundTrips && AE.booking.matrix.results.props.oLocations[clickedMapID].doStatus !== 'C') {
                 $('#' + car.ID + ' .roundTripBlock, #' + car.ID + ' .startRateBlock').addClass('trulyhidden');
                 $('#' + car.ID + ' .' + clickedMapID + '.roundTripBlock').removeClass('trulyhidden');
               }

               // Only if a map for result has already been loaded
               if ($('#' + car.ID).hasClass('map-visible')) {
                 var mapDirection = (AE.booking.matrix.maps.props.$isMapOneway) ? 'PU' : 'DO';
                 // ONEWAY - reset preselected pickups to the selected large map location
                 // SAME - set pickup location and show drop off location map markers and location list
                 AE.booking.matrix.locations.showRelevantMarkers(car.ID, mapDirection, clickedMapID);

                 // if map object exists, map block is open and a resize happened refresh maps
                 if ($('#' + car.ID + ' .startRateBlock button.location_button').hasClass('open')) {
                   AE.booking.matrix.locations.resetRateFingerMapView(car.ID);
                 }
               }
             }
           }

           if (clickedMapID) {
             $('#' + car.ID + ' .startRateBlock button.location_button').addClass('map_version').attr('data-locid', clickedMapID);
           } else {
             $('#' + car.ID + ' .startRateBlock button.location_button').removeClass('map_version').attr('data-locid', '');
           }
           if (haveSpinner) {
             AE.ui.removeSpinner('#car_results');
             haveSpinner = false;
             if(AE.props.siteCode == 'FCR') { //WEBAE3-6277 manually removed spinner loader for FCR
              $('.searchwait-container').addClass('trulyhidden');
             }    
           }
           return;
         });
        //_.each(sortByInsuranceFilters(setOfCars), function (car) {     //WEBAE3-5142
        //if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {

          //console.log(setOfCars);

          // _.each(sortByInsuranceFilters(setOfCars), function (car) {
          //   //$('#car_results').append($('#' + car.ID));
          // });
        //}
         //White Label w/in an iFrame
         if (AE.props.isWhiteLabelIFrame === true) {
           if ('parentIFrame' in window) {
             window.parentIFrame.scrollToOffset(0, scrollTarget);
             window.parentIFrame.getPageInfo(false); //stop trying to auto-scroll
           }
         }
       } else {
         $('#matrix__noresults').removeClass('trulyhidden');
         if(AE.props.siteCode == 'FCR') { //WEBAE3-6277 manually removed spinner loader for FCR
          $('.searchwait-container').addClass('trulyhidden');
         }
         AE.ui.removeSpinner('#car_results');
       }
       // WEBAE3-6014 Emit GA4 ecommerce view list event with vehicle results
          // WEBAE3-6243 - when displaying a large number of results at once, GA returns a 'payload too large' error. So, we're going to send those results in batches of 100.
          if (APP.props.eCommItems.length > 100) {

            let i = 0;
            while (i < APP.props.eCommItems.length) {

                if(APP.props.eCommItems.length > 100){
                  ecomItemsNext100 = APP.props.eCommItems.splice(0,100);
                } else {
                  ecomItemsNext100 = APP.props.eCommItems.splice(0,APP.props.eCommItems.length);
                }
                
                AE.booking.matrix.events.emitGA4EcommerceEvent('view_item_list', AE.booking.matrix.events.buildEcommerceViewList('matrix_results', 'Matrix Results', ecomItemsNext100))

                i++;
            }
            
        } else {
          //original WEBAE3-6014 method
          AE.booking.matrix.events.emitGA4EcommerceEvent('view_item_list', AE.booking.matrix.events.buildEcommerceViewList('matrix_results', 'Matrix Results', APP.props.eCommItems)); 
        }
       ; 
       APP.props.eCommItems = []; // reset items list to prevent conflicts with other events
       
       // WEBAE3-6279 - Minimize and move site-specific css to after all results are loaded
        if(['AUS', 'NZL'].indexOf(AE.props.siteCode) >= 0) {
            $( ".pfcancel_style" ).css( "color", "#0b2033" );
            $( ".fcancel_style" ).css( "color", "#0b2033" );
        } else if(['GCR'].indexOf(AE.props.siteCode) >= 0) { 
            $( ".pfcancel_style" ).css( "color", "#295ca9" );
            $( ".fcancel_style" ).css( "color", "#295ca9" );
            $( ".filter-color" ).css("filter", "invert(30%) sepia(72%) saturate(844%) hue-rotate(182deg) brightness(93%) contrast(90%)");
        } else if(['DAU', 'DNZ', 'DAP'].indexOf(AE.props.siteCode) >= 0) { 
            $( ".pfcancel_style" ).css({'color': 'rgba(35, 31, 32, .5)'});
            $( ".fcancel_style" ).css({'color': 'rgba(35, 31, 32, .5)'});
            $( ".filter-color" ).css({'opacity': '.4'});
        }
     }
   },
   onBodyChange: function (event, $target) {
     if ($target.is('input.matrix_filter') || $target.is('input.map_filter')) {
       // Setting the target variable for use by all conditions
       var $target = $(event.target);
       var isChecked = $target.prop('checked');
      
      // WEBAE3-5492 activate/deactivate Most Popular button
      if($('#package_ztype').prop('checked') && $('#fuel_full').prop('checked')) {
        $('#view_by_most_popular').addClass('view_by_active');
      }
      if($('.matrix_filter').find('input[type=checkbox]:checked').length > 2) {
        $('#view_by_most_popular').removeClass('view_by_active');
        $('#view_by_most_popular').addClass('view_by_inactive');
      }

       // Remove hide classes for rate fingers every time a filters is clicked
       $('#car_results_row').removeClass('IB_false').removeClass('II_false').removeClass('IZ_false').removeClass('CFP_false').removeClass('CFS_false'); //remove all classes

       // Hide the results because the filters have changed
       APP.hideResults();

       // Pass two things into this function from the checkbox that was just clicked: It's filter data attribute and its post-click value
       if(/*APP.props.colsByCat &&*/ $target.hasClass('map_filter') && $target.hasClass('supplier')){
         var thisSuppFilter = $target.data('supplier'),
        thisSupp = _.findWhere(AEdata.booking.quote.oSupps,{filter:thisSuppFilter});
        if(thisSupp !== undefined){
          thisSuppCode = thisSupp.code;
          // ONLY Run this IF the filter IS a Supplier filter element. WEBAE3-3606 LJW 2020-5-5
          if($target.prop('checked') === true){
            APP.props.suppFilter.push(thisSuppFilter);
            APP.props.filterStorage.push(thisSuppCode);
          } else {
            APP.props.suppFilter = _.without(APP.props.suppFilter,thisSuppFilter);
            APP.props.filterStorage = _.without(APP.props.filterStorage,thisSuppCode);
          }
        }
       }
        // Location Type Map Filter
        if($target.hasClass('map_filter') && $target.hasClass('loctype')){
          var thisLocType = $target.data('filter');
        if($target.prop('checked') === true){
            APP.props.locTypeFilter.push(thisLocType);
            APP.props.filterStorage.push(thisLocType);
          } else {
            APP.props.locTypeFilter = _.without(APP.props.locTypeFilter,thisLocType);
            APP.props.filterStorage = _.without(APP.props.filterStorage,thisLocType);
          }
        }
       APP.drawMatrix($target.data('filter'), isChecked, $target );

       // If top map exists run filtering function to display only locations matching filter settings
       // This contains logic for Map only filters
       if (AE.booking.matrix.maps.props.$supplierMap !== '') {
         //var $target = $(this);				// Target event clicked
         var $data = $target.data('filter'); // filter data

         // If a supplier filter is clicked
         if ($target.is('[name^="supplier_"]')) {
           $data = $data.toUpperCase();
           if ((_.contains(AE.booking.matrix.maps.props.$filterMarkers.filterSuppliers, $data) !== true)  && isChecked) {
             AE.booking.matrix.maps.props.$filterMarkers.filterSuppliers.push($data);
           } else {
             AE.booking.matrix.maps.props.$filterMarkers.filterSuppliers = _.without(AE.booking.matrix.maps.props.$filterMarkers.filterSuppliers, $data);
           }
         }

         // If a location type filter is clicked
         if ($target.is('[name^="loctype_"]')) {
           if ((_.contains(AE.booking.matrix.maps.props.$filterMarkers.filterLocs, $data) !== true)) {
             AE.booking.matrix.maps.props.$filterMarkers.filterLocs.push($data);
           } else {
             AE.booking.matrix.maps.props.$filterMarkers.filterLocs = _.without(AE.booking.matrix.maps.props.$filterMarkers.filterLocs, $data);
           }
         }

         // Filter large map pins based on filters
         AE.booking.matrix.maps.setFilteredMarkers();
       }
       
     }

     
   },
   onBodyClick: function (event, $target) {
     /*
     The "closest" method starts with the current element, so it's useful for checking on click targets. If you click on the correct thing,
     then great. But if you click on a div or a span or an image or something within the correct target element, then the "closest" method
     will find it.
     */

     // Back to Top Button Behavior
     /*
     if($target.hasClass('btn--back2top') || $($target.parent()).hasClass('btn--back2top')){
       document.getElementById('getrates_top').scrollIntoView();
     }
     */
    
     //WEBAE3-5492 - "Most Popular" matrix filter option
     if ($target.is('button#view_by_most_popular')){
       $('.trg__clear-filters').click();
       $('#fuel_full').click();
       $('#package_ztype').click();
       $('#view_by_most_popular').removeClass('view_by_inactive');
       $('#view_by_most_popular').addClass('view_by_active');
       $('#view_by_price').removeClass('view_by_active');
       $('#view_by_price').addClass('view_by_inactive');
     }
     if ($target.is('button#view_by_price')){
       $('.trg__clear-filters').click();
       $('#view_by_price').removeClass('view_by_inactive');
       $('#view_by_price').addClass('view_by_active');
       $('#view_by_most_popular').removeClass('view_by_active');
       $('#view_by_most_popular').addClass('view_by_inactive');
     }
     if ($target.is('.matrix_filter.trg__ga--Checkbox')){
       $('#view_by_price').removeClass('view_by_active');
       $('#view_by_price').addClass('view_by_inactive');
       $('#view_by_most_popular').removeClass('view_by_active');
       $('#view_by_most_popular').addClass('view_by_inactive');
     };

    //WEBAE3-4574
    if($target.hasClass('rateIcon')){
        //show modal 
        AE.booking.cancelModal()
        }

      //WEBAE3-4749 - change rate finger price to reflect cancel checkbox status
      if($target.hasClass('trg__cancelCost-ins--click')){
        var rateDisplayId = $target[0].id.replace("cancelCostCheckbox_","dsprate_"); //get rate h3 ID from checkbox ID
        var rateToShow = ($target[0].checked) ? $target[0].dataset.totalcncl : $target[0].dataset.totalorig; //set rate based on check status
        document.getElementById(rateDisplayId).innerHTML = rateToShow;//update rate display
      }

     // If have a palm matrix, we've clicked on something in the categories area, and the palm categories are not currently sliding
     if ($target.closest('.matrix--palm__categories')[0] && !($target.closest('li').hasClass('selected')) && APP.props.isSliding === false) {
       if ($target.closest('li').hasClass('category')) {
         // Clicked on a list item in the categories looper
         APP.props.isSliding = true;





         // Now we need to figure out which direction from the center was ckicked so we can slide the category Looper in that direction
         var centerOfContainer = $(".matrix--palm__categories").outerWidth(true) / 2;
         var direction = ($target[0].offsetLeft < centerOfContainer) ? 'prev' : 'next';

         // Before we move the categories, we need to figure out how many categories away from the center we clicked
         var jumpNumber = 0;
         while (true) {
           jumpNumber++;
           if (direction == 'prev') {
             if ($target.closest('li').nextAll(':eq(' + (jumpNumber - 1) + ')').hasClass('selected')) {
               break;
             }
           } else {
             if ($target.closest('li').prevAll(':eq(' + (jumpNumber - 1) + ')').hasClass('selected')) {
               break;
             }
           }
         }

         APP.palm.moveCats(direction, jumpNumber);
       } else if ($target.closest('div').hasClass('palm__categories__nav')) {
         // Clicked on a prev/next navigation icon. Set isSliding to true until the animation is done
         APP.props.isSliding = true;

         // Now we need to know which icon was clicked so we can slide the category Looper in that direction
         var direction = $target.closest('div').hasClass('prev') ? 'prev' : 'next';
         APP.palm.moveCats(direction, 1);
       }
     } else if ($target.closest('li').hasClass('matrix--palm__supplier')) {
       $('.matrix--palm__supplier.selected').removeClass('selected');
       $target.closest('li').addClass('selected');
       APP.showResults($target, resultsData.arrFiltered);
     } else if ($target.closest('li').hasClass('trg__matrix--event')){
      // WEBAE3-5814 - Restore hidden matrix link that shows all rates - Mike 31 Oct 2023
      var eCodes = $target.closest('li').data('event-code');
      if(typeof(eCodes) === 'string'){
        var aCodes = eCodes.split(',');
        if(eCodes.length !== 0){
          if(_.contains(aCodes,'AC') && _.contains(aCodes,'AS')){// first column / row (lowest rate) heading
            APP.showResults($target, resultsData.arrFiltered);
          }
        }
      }
     }



     // By checking for the existence of the matrix_static container, we are confirming that we have a full-sized matrix in place.
     if ($('#matrix__static')[0]) {
       // Matrix and map view switch is handled in AE.booking.matrix.maps.js
       if ($target.closest('div').is('#matrix__more--tl')) {
         APP.full.moveColumns('right');
       } else if ($target.closest('div').is('#matrix__more--tr')) {
         APP.full.moveColumns('left');
       }

       if (APP.props.colsByCat) { // Alternate matrix column-row orientation
         if(($target.closest('.supp-item').hasClass('matrix__supplier--star')) && AE.booking.props.oTrustScore.bUseTrustScore ) {
             /* WEBAE3-5232 TRUST SCORE MODAL STUFF (Matrix suppliers on left) */
             var $supplier = $target.closest('li.matrix__supplier--container');
             var supplier_name = $supplier.attr('data-suppname');

              AE.booking.trustScoreModal(
                AEdata.booking.quote.oQuote.oPU.country,
                '',//AEdata.booking.quote.oQuote.oPU.city,
                supplier_name.toLowerCase(),
                $supplier.find('.matrix__supplier--logo img').attr('src'),
                'dialog-trustScore'
              );

         } else if (($target.closest('.supp-item').hasClass('matrix__supplier--logo')) || $target.closest('.supp-item').hasClass('matrix__supplier--star')) {
           var selectedSupplier = $target.closest('li').data('filter');
           $('.matrix__supplier--container').removeClass('selected');
           $target.closest('li').addClass('selected');
           APP.showResults($target.closest('li'), resultsData.arrFiltered);
         }
         
         $('.matrix__column__header').removeClass('no-rate');
         $('.matrix__column__header .matrix__category--info-top i.fa').addClass('text--primary').removeClass('text--accent');
         if ($target.hasClass('matrix__category--info-top')) {
           var thisCat = $target.data('category');
           var thisImg = $target.data('img');
           $target.find('i.fa').removeClass('text--primary').addClass('text--accent');
           $target = $target.closest('.matrix__column__header');
           $target.addClass('no-rate');
           AE.ui.dialog.launch({
             id: 'dialog-tip',
             dialogClass: 'io-observable',
             type: 'infoTip',
             autoupdate: false,
             pos: {
               my: "left+5 top",
               at: "right top",
               of: '.matrix__column__header[data-supplier="' + thisCat + '"]',
               collision: 'fit fit'
             },
             content: APP.buildCarCategoryInfo(thisCat, thisImg)
           });
           AE.ui.dialog.update(true);
         }
       }

       // The div wrapped around the icon in the category name cell.
       if (($target.closest('div').is('.matrix__category--info'))) {
         $target = $target.closest('div');

         // We've turned off the autoupdate for these dialogs because the matrix is redrawn on resize.
         // The update function needs to be called manually, after the matrix has been rebuilt.
         AE.ui.dialog.launch({
           id: 'dialog-tip',
           dialogClass: 'io-observable',
           type: 'infoTip',
           autoupdate: false,
           pos: {
             my: "left+5 top",
             at: "right top",
             of: '#' + ($target.closest('.matrix__category').attr('id')),
             collision: 'fit fit'
           },
           content: APP.buildCarCategoryInfo($target.data('category'))
         });

         AE.ui.dialog.update(true);
       }  else if(($target.hasClass('.matrix__column__rating') || $target.closest('.supp-item').hasClass('matrix__column__rating')) && AE.booking.props.oTrustScore.bUseTrustScore) {
            /* WEBAE3-5232 TRUST SCORE MODAL STUFF (Matrix suppliers on top) */
            var $supplier = $target.closest('li.matrix__column__header');
            var supplier_name = $supplier.attr('data-suppname');

              AE.booking.trustScoreModal(
                AEdata.booking.quote.oQuote.oPU.country,
                '',
                supplier_name.toLowerCase(),
                $supplier.find('.matrix__supplier--logo img').attr('src'),
                'dialog-trustScore'
              );

         } else if (($target.closest('li').is('.matrix__cell')) || ($target.closest('.supp-item').hasClass('matrix__column__logo')) || ($target.closest('div').hasClass('matrix__category--name')) || $target.hasClass('.matrix__column__rating') || $target.closest('.supp-item').hasClass('matrix__column__rating')) {
         /*
         The top-left "cell" in the matrix is a blank column header which calls for results without a supplier or a car class. This means
         that all results would be shown. We currently don't use this button for the full matrix, but we can label it and enable it later
         if we want to.
         */
         if ($target.closest('li').is($('#matrix__static').children('ul').first().children('li').first())) {
           return;
         }

         /* If clicking on a child item of the column header, then we set the target to the parent LI item where the data attributes are. */
         $target = $target.closest('li');

         if (!$target.hasClass('no-rate')) {
           /*
           By now, the $filteredCars collection has either been matched to the filters or set to the complet list of cars. We're passing
           it into this funciton so that showResults doesn't have to worry about which data it's using. It simply accepts cars and shows
           the ones which match the cell that the user just clicked.
           */
           APP.showResults($target, resultsData.arrFiltered);
         }

         $('.matrix__cell.selected, .matrix__category.selected, .matrix__supplier--container.selected').removeClass('selected');
         $target.closest('li').addClass('selected');
        }
     }


     // WEBAE3-3708 - Set up clearFilters trigger LJW
     if($target.hasClass('trg__clear-filters') && APP.props.isDFDresolved){
       $target.addClass('cf-active');
       APP.clearFilters();
       setTimeout(function () {$target.removeClass('cf-active');},400);
     }

   },
   addListeners: function () {
     if (!AE.props.isLegacy) {
       APP.props.$matrix.on(AE.props.transEnd, ".matrix__scroll-container", function (event) {
         APP.full.moveComplete('addListeners > transEnd');
       });
     }
   },
   full: {
     updateColWidth: function () {
       /* Caching jQuery collections to variables. */
       var $staticColumn = $('#matrix__static').find('.matrix__column--static'),
         $allColumns = $('#matrix').find('.matrix__column').not('.matrix__column--static'),
          $columns = $('#matrix__scroll-container').find('.matrix__column');

          //APP.props.colsByCat ? $('#matrix__dynamic').find('.matrix__column--dynamic') :

       /* Full width of a column at default size. */
       var initColOuterWidth = APP.props.initColWidth + (APP.props.initColMargin * 2);

       var availableWidth = APP.props.$matrix.outerWidth() - $staticColumn.outerWidth(true),
         dynamicWidth = $('#matrix__dynamic').outerWidth(true),
         scrollWidth = initColOuterWidth * $columns.length;

       currentLeft = $('#matrix__scroll-container').position().left;

       /* Total number of visible columns. */
       var allVisibleCols = Math.floor(availableWidth / initColOuterWidth),
         dynamicVisibleCols = Math.floor(dynamicWidth / initColOuterWidth);

       /* Are there extra columns outside the container? */
        var extraColumns = (initColOuterWidth * $allColumns.length <= availableWidth) ? false : true;

       /*
       Determine the proper width. If we don't have extra columns, then the ones we do have must be stretched
       to fit the total available space. If we do have extra columns, then their widths must be adjusted so that
       they fit evenly within the space available.
       */
       var newColWidth;
       if (!extraColumns) {

         APP.props.extraCols = false;
         /* We have extra space, so we need to stretch the columns. */

         /*
         The math below is a bit weird, so I'm breaking it up, indenting it and explaining it.
         1) Get the outer width of the entire matrix, including that hefty left padding, as it exists right now.
         2) Get the outer width of the category column and subtract it. This gives you the remaining available space.
         3) Divide that by the number of columns. We add one to it because we're also adjusting the All Suppliers column.
         4) We subtract the column margins, because jQuery's .width() method doesn't account for these.
         5) Now we have the width that we should apply to all columns except for the category column.
         */
         newColWidth = Math.floor(
           (
             (
               APP.props.$matrix.outerWidth(true) - $staticColumn.outerWidth(true)
             ) / ($columns.length + (APP.props.colsByCat ? 0 : 1))
           ) -
           (APP.props.initColMargin * 2)
         );
       } else {
         /* We have extra columns, so we need to make them all fit evenly. */
         APP.props.extraCols = true;
         newColWidth = (Math.floor((availableWidth / allVisibleCols)) - (APP.props.initColMargin * 2));
       }
        $allColumns.css('width', newColWidth + 'px');

       /*
       Division won't always evenly distribute, so we may have a few extra pixels on the right side.
       1. Take the available width and remove one column (with margins) That's our dynamic available space.
       2. Find out the total width of all visible columns, minus the "All Suppliers" column.
       3. Subtract the second thing from the first thing. That's how many extra pixels we have.
       */
       var fullColWidth = (Math.floor((availableWidth / allVisibleCols)));
       var extraPX = (availableWidth - fullColWidth) - (fullColWidth * (allVisibleCols - 1));

       /*
       Matrix container gets appropriate left-padding. Add the extra pixels to the padding and to the
       "All Suppliers" column, leaving the other columns at a uniform size.
       */
       if (APP.props.colsByCat) {
         newColWidth = 0;
          extraPX = 0;

          APP.props.$matrixContainer.addClass('matrix--reverse');
       }


       var matrixPadding = $staticColumn.outerWidth(true) + newColWidth + (APP.props.initColMargin * 2);
       APP.props.$matrix.css('padding-left', matrixPadding + extraPX + 'px');
       $allColumns.first().css('width', ($allColumns.first().width() + extraPX));

       /*
       Time to see if the columns are out of position. If they've been moved, then resizing up could leave empty
       space on the right. Now that we have our column widths established, we need to make sure we adjust the left
       position to correct the display.
       */

       if (!extraColumns) {
         /* The column container is larger than the total width of all columns at default size. Stretch the columns. */
         $('#matrix__scroll-container').css('left', '0');

       } else {
         /* There are extra columns outside the container, and they need to be managed. */

         /* Number of inside columns we should have in the dynamic container, using the current actual width. */
         var insideCols = Math.floor(dynamicWidth / $columns.outerWidth(true));

         /* Number of outside columns we should have. */
         var outsideCols = Math.floor($columns.length - insideCols);

         /* Number of outside columns we have with the current actual width. */
         var outsideLeft = Math.abs(Math.round(currentLeft / $columns.outerWidth(true)));
         var leftoverRightCols = $columns.length - outsideLeft;
         var newLeft = -(outsideLeft * $columns.outerWidth(true));
         var newScrollWidth = $columns.outerWidth(true) * $columns.length;

         /* Left limit determined by total columns. */
         var leftLimit = -(($columns.outerWidth(true) * $columns.length) - $('#matrix__dynamic').outerWidth(true));

         /* The left position cannot be more than the left limit. If it's less, then reset it to the left limit. */
         newLeft = (newLeft < leftLimit) ? leftLimit : newLeft;

         $('#matrix__scroll-container').css('left', newLeft + 'px');
       }
     },
     updateCols: function () {
       /*
       This function will update the cols object in props, which will be used by other updating functions
       to determine the shape and position of matrix columns.
       */

       /* Cache columns to a variable and get their total width. */
       var $columns = $('#matrix__scroll-container').find('.matrix__column'),
          cols = {};
       /*
       This is the container that we move, but we don't use it's width for measurements. It's very wide to make sure that
       it always has room for however many columns we get. It exists only to move all of the columns together.
       */
       var $scrollContainer = $('#matrix__scroll-container');

       /*
       scrollWidth: We get the total width of all columns together at their current size.
       containerWidth: This is the container that we use to compare widths.
       console.log(['updateCols(): currentLeft', currentLeft, $('#matrix__scroll-container').position()]);
       currentLeft: The current CSS "left" style of the scroll container, with the "px" stripped out.
       */
       var scrollWidth = $columns.outerWidth(true) * $columns.length,
         containerWidth = $('#matrix__dynamic').outerWidth(true),
         currentLeft = $scrollContainer.position().left;

       if (APP.props.extraCols === false) {
         /*
         No extra columns, so all columns are inside. Setting because a 1-pixel difference after width adjustment could
         result in a false positive for an outsice column.
         */
         cols = {
           total: $columns.length,
           outside: 0,
           inside: $columns.length,
           left: 0,
           right: 0
          };

       } else {

         /* We have extra columns, so calculate them accordingly. */
         var approxInside = containerWidth / $columns.outerWidth(true);
         cols = {
           total: $columns.length,
           outside: 0,
           inside: Math.floor(approxInside),
          //  inside: (APP.props.colsByCat) ? Math.ceil(approxInside) : Math.floor(approxInside),
           left: (currentLeft < 0) ? Math.abs(Math.floor(currentLeft) / $columns.outerWidth(true)) : 0,
           right: 0
         };
         cols.right = cols.total - cols.left - cols.inside;
          cols.outside = cols.total - cols.inside;
        }

       /*
       Set parent class to indicate where the extra columns are. CSS may then be used to show/hide the
       matrix__more buttons.
       */
       if (cols.left > 0) {
         APP.props.$matrixContainer.addClass('matrix--extra-left');
       } else {
         APP.props.$matrixContainer.removeClass('matrix--extra-left');
       }
       if (cols.right > 0) {
         APP.props.$matrixContainer.addClass('matrix--extra-right');
       } else {
         APP.props.$matrixContainer.removeClass('matrix--extra-right');
       }
       APP.props.cols = cols;

       // Now that the columns are placed, update the arrows.
       APP.full.placeArrows();

       return cols;
     },
     moveColumns: function (direction) {
       /*
       Used for the full-sized matrix. The goal is to move the columns by one column-width in either direction. This
       gets the current column width, so it works no matter what they'be been set to by the updateColWidth() method.
        */

       // If the columns are already moving, then return without doing anything.
       if (APP.props.isMoving !== false) {
         return; // Returning because the columns are already moving.
       }

       APP.props.isMoving = true;

       // BELOW THIS LINE ONLY RUNS WHEN COLUMNS ARE NOT ALREADY MOVING.
       // ==============================================================
       var canMove = false,
         direction = (direction.toLowerCase() === 'right') ? 'right' : 'left',
         columnWidth = $('#matrix__scroll-container').find('.matrix__column').outerWidth(true);

       var scrollOperator = (direction === 'right') ? '+=' : '-=',
         multiplier = (direction === 'right') ? 1 : -1;

       /*
       The matrix columns should have a page size of no more than the number of visible columns. Otherwise we could skip
       some. For example, if four columns are visible and we move five columns to the left, then we'll skip one. Below,
       we'll also determine if there are that many columns remaining on the outside. If three are visible but there are
       only two columns outside, then we're just going to move two columns.
       */
       var pageSize = APP.props.cols.inside;

       /*
       This is the container that we move, but we don't use it's width for measurements. It's very wide to make sure that
       it always has room for however many columns we get. It exists only to move all of the columns together.
       */
       var $scrollContainer = $('#matrix__scroll-container');

       /*
       Determine if it's possible to move in the direction indicated. This depends upon the cols object in the module's
       props object. If there are no extra columns outside of the dynamic container on that side, then we can't move.
       */
       if (direction === "right") {
         canMove = APP.props.cols.left > 0 ? true : false;
         pageSize = (APP.props.cols.left >= pageSize) ? pageSize : APP.props.cols.left;
       } else {
         canMove = APP.props.cols.right > 0 ? true : false;
         pageSize = (APP.props.cols.right >= pageSize) ? pageSize : APP.props.cols.right;
       }

       if (canMove === true) {
         // Not currently moving and there are outside columns, so it's time to move the columns.

         if (!AE.props.isLegacy) {
           var moveTo = (
             $scrollContainer.position().left + // Where it is now
             (columnWidth * multiplier * pageSize) // How far to move it, positive or negative.
           ) + 'px';;
           $scrollContainer.css('left', moveTo);

         } else {
           $scrollContainer.animate({
             left: scrollOperator + '' + (columnWidth * pageSize)
           }, {
             duration: 500,
             specialEasing: {
               left: "linear"
             },
             complete: function () {
               APP.full.moveComplete('jQuery');
             }
           });
         }
       } else {
         // If you click on a gray "more suppliers" arrow, we need to reset this variable
         APP.props.isMoving = false;
       }
     },
     moveComplete: function (string) {
       APP.full.updateCols();
       //APP.setSuppliersShownText(APP.props.cols);
       APP.full.placeArrows();
       APP.props.isMoving = false;
     },
     placeArrows: function () {
       $('#matrix__more--tl').position({
         my: "right top+10",
         at: "left+6 top",
         of: $('#matrix__dynamic'),
         collision: 'none'
       });

       $('#matrix__more--tr').position({
         my: "left top+10",
         at: "right top",
         of: $('#matrix__dynamic'),
         collision: 'none'
       });

       APP.full.updateSupplierCounts();
     },
     updateSupplierCounts: function () {
       // If there is no pagination, do not show the text "Showing x Of y Suppliers"
       if (APP.props.cols.outside != 0) {
         if(!(APP.props.colsByCat && AEdata.booking.quote.oQuote.allLocations)){
           $('#matrix__supplier-x-of-y').show();
         } else {
           $('#matrix__supplier-x-of-y').hide();
         }
       } else {
         $('#matrix__more--tl').hide();
         $('#matrix__more--tr').hide();
         $('#matrix__supplier-x-of-y').hide();
       }

       $('#matrix__supplier-x-of-y').position({
         my: "right top",
         at: "left-36 top+15",
         of: $('#matrix__dynamic'),
         collision: 'none'
       });
       var $xFrom_columns = (APP.props.cols.left + 1);
       var $xTo_columns = (APP.props.cols.right > 0 && APP.props.colsByCat) ? (APP.props.cols.total - APP.props.cols.right) + 1 : (APP.props.cols.total - APP.props.cols.right);
       var $x_columns = Math.trunc($xFrom_columns) + ' - ' + Math.trunc($xTo_columns);
       var $showingSuppliersTxt = (APP.props.colsByCat) ? resultsData.oTranslations.SHOWINGXOFYCATEGORIES : resultsData.oTranslations.SHOWINGXOFYSUPPLIERS;
       $showingSuppliersTxt = $showingSuppliersTxt.replace('[x]', $x_columns).replace('[y]', APP.props.cols.total);

       $('#matrix__supplier-x-of-y').html($showingSuppliersTxt);
     }
   },
   palm: {
     posCats: function (category) {
       if(APP.props.colsByCat) { return false; }
       // The list items for palm categories are absolutely positioned, so we're using jQuery UI's extended
       // position method to place them where they belong. The list is passed in, along with a category string
       // which matches the data attribute we use on the matrix container or on the list items themselves. For
       // example, if "C4" is passed in, then the center item will be "Midsize". All other list items will be
       // placed before or after that.

       // Caching our list to a jQuery object.
       var $list = $('.matrix--palm__categories > ul');


       // If a truthy value for category was passed in, then find the item with that data attribute. Otherwise,
       // just use the "All Suppliers" item as a default.
       if (category) {
         APP.props.$centerItem = $list.find('li.category[data-category="' + category + '"]');
       } else {
         APP.props.$centerItem = $list.find('li.category[data-index="0"]');
       }


       // Now that it's set properly, caching the center item to save some characters below.
       var $centerItem = APP.props.$centerItem;
       APP.palm.equalizeCats($centerItem);


       // Place the center list item in the center of the nav.
       $centerItem.position({
         my: "center top",
         at: "center top",
         of: $($list),
         collision: "none none"
       });

       // Place list items before the target in a row to the left.
       $centerItem.prevUntil().each(function (index) {
         var $this = $(this);
         $this.position({
           my: "right top",
           at: "left top",
           of: $this.next(),
           collision: "none none"
         });
       });

       // Place subsequent list items in order to the right.
       $centerItem.nextUntil().each(function (index) {
         var $this = $(this);
         $this.position({
           my: "left top",
           at: "right top",
           of: $this.prev(),
           collision: "none none"
         });
       });

       // Set the center item to selected.
       APP.props.$centerItem.addClass('selected');
       // Declare the menu to be ready for moving, in case this is the first setup.
       APP.props.catsReady = true;
     },
     moveCats: function (direction, jumpNumber) {
       if(APP.props.colsByCat) { return false; }
       jumpNumber = jumpNumber || 1;

       // This function won't run until the categories are set up for the first time.
       if (!APP.props.catsReady) {
         return
       };

       // Caching our list to a jQuery object.
       var $list = $('.matrix--palm__categories > ul');

       // The center item is about to be redefined, so we're going to cache the current one so we can still use it.
       var $oldCenterItem = APP.props.$centerItem;

       // Set the module-wide variable for the center item to its new value, and then use the old center item to
       // calculate the distance to move in either direction. (prevAll() and nextAll() are zero-based, so subtract 1 fromn jumpnumber)
       if (direction === "prev") {
         // For a previous list item
         APP.props.$centerItem = APP.props.$centerItem.prevAll(':eq(' + (jumpNumber - 1) + ')');
         var distanceFromEdge = $oldCenterItem.prevAll(':eq(' + (jumpNumber - 1) + ')').offset().left;
         var middleOfElement = $oldCenterItem.prevAll(':eq(' + (jumpNumber - 1) + ')').outerWidth() / 2;
       } else {
         // For the next list item
         APP.props.$centerItem = APP.props.$centerItem.nextAll(':eq(' + (jumpNumber - 1) + ')');
         var distanceFromEdge = $oldCenterItem.nextAll(':eq(' + (jumpNumber - 1) + ')').offset().left;
         var middleOfElement = $oldCenterItem.nextAll(':eq(' + (jumpNumber - 1) + ')').outerWidth() / 2;
       }
       var centerOfEl = distanceFromEdge + middleOfElement;
       var centerOfContainer = $(".matrix--palm__categories").outerWidth(true) / 2;
       var difference = centerOfContainer - centerOfEl;

       $list.find('.selected').removeClass('selected');
       APP.props.$centerItem.addClass('selected')

       // All of these elements get their own animation, so the "done" will fire for each one. If we moved the
       // list itself then we would have to reset somehow and then deal with the list items anyway. So we're
       // going to keep a count and check it against the length of the collection so we can run things only
       // for the last done() function call.
       var count = 0;
       $list.find('li').animate({
         left: "+=" + difference
       }, {
         duration: 500,
         done: function () {
           count++;
           if (count === $list.find('li').length) {
             // Last time through. No longer sliding, and save the category to a variable.
             APP.props.isSliding = false;
             var category = APP.props.$centerItem.data("category");

             // If the category variable is undefined, set it to an empty string.
             category = !category ? '' : category;

             // Reposition the elements to make up or any drift which may be caused by browsers choosing
             // to round decimals differently.
             APP.palm.posCats(category);

             // Set the matrix container's data attribute to the new category and rebuild the supplier list.
             APP.props.$matrix.data('category', category);
             APP.buildPalmSuppliers(category);
           }
         }
       });
     },
     equalizeCats: function ($centerItem) {
       if(APP.props.colsByCat) { return false; }
       // This function takes jQuery objects for a list and for whichever item belongs in the center of the menu.
       // List items will be removed and replaced until the "center" item has roughly the same number of list items
       // before it and after it. This way, you can render the menu with the first or last element of the category
       // in the center, without any blank spaces. This gives us a never-ending carousel.

       // Caching our list to a jQuery object.
       var $list = $('.matrix--palm__categories > ul');

       var numItems = $list.length,
         itemsBefore = $centerItem.prevUntil().length,
         itemsAfter = $centerItem.nextUntil().length;

       // If the items before/after are equal or there's just one extra one on a side, then stop here. No need to
       // do anything else. There are enough items before and after the center to prevent blank spaces in the carousel.
       if (Math.abs(itemsBefore - itemsAfter) < 2) {
         return;
       };

       // We have at least two extra list items on one end, so we're going to move some of them.
       if (itemsBefore > itemsAfter) {
         // More items in front, so remove the first list item and place it at the end.
         $list.find('li').first().detach().appendTo($list);
       } else {
         // More items at the end, so remove the last one and put it in the front.
         $list.find('li').last().detach().prependTo($list);
       }
       // Run this function again. This will keep going until the conditional above fails.
       APP.palm.equalizeCats($centerItem);
     }
   },
   manageResize: function () {

     APP.props.size = AE.getSiteViewType();
    
     // Check viewport size and site code to determine which matrix orientation to use
     APP.setColumnsByCategory();

     // Anything that this module may need to do upon resize
     if (APP.props.firstRun === false) {
       APP.drawMatrix();
     }

     // Worth it to run this before and after the matrix is redrawn, to avoid seeing the toggle jump
     APP.placeMapToggle();

     // Once this has run, turn off the firstRun variable
     APP.props.firstRun = false;

   
 },
   buildMatrix: function (data) {
     /*
     The data variable is used to populate the matrix grid. This will come from the initial matrix data object
     or the adjusted data object which gets updated as the filters change. It's all the same to this function,
     however. Whatever the values, the object format will be the same.
     */

     // Set this higher-scoped variable so we can access it while building palm suppliers.
     currentData = data;

     //WEBAE3-6278 don't draw matrix if we don't need it
     if(AE.props.siteCode !== 'FCR' && APP.props.resultsLayout !== 'nomatrix'){
      // If a matrix type is passed into this function, then we build that type of matrix, palm or full
      if (APP.props.size !== 'palm') {
        APP.props.$matrix.removeAttr('style').removeClass('matrix--palm ').addClass('matrix--full ');
        $('.full__filters').removeClass('no_results'); // prevent errors on filters when no results are retutned this unhides filters
        APP.buildFull(APP.props.$matrix, data);
      } else {
        APP.props.$matrix.removeAttr('style').removeClass('matrix--full ').addClass('matrix--palm ');
        $('.palm__filters').removeClass('no_results'); // prevent errors on filters when no results are retutned this unhides filters
        APP.buildPalm(APP.props.$matrix, data);
      }
     }
    },
   buildFull: function ($matrix, data) {
     /*
     This function runs whenever the matrix is redrawn. The data passed in contains data for every column in the matrix. Depending upon filters, it's possible
     for a column to have no prices available. If every cell in a column is empty, then we won't display that
     column. This solves and issue for the European site where the first few columns are empty, making it look
     like the matrix has no cars when it actually has some off-screen.
     */
     for (var i = data.columns.length - 1; i >= 0; i--) {
       // Looping through the columns, checking the cells array in each one.
       if (_.every(data.columns[i].cells, function (item) {
           return item.rate === 0;
         })) {
         // This loop runs backwards so we can remove items without disturbing the index for the next iteration.
         data.columns.splice(i, 1);
       }
     }

     /*
     Our primary document fragment will hold all of the nodes for the matrix, and will be added to
     the matrix container during a single reflow of the browser window. Translations are included
     in the server response, so they don't need to be considered here.
     */
     var $documentFragment = $(document.createDocumentFragment());

     /*
     Building the static container and its contents. This will have more code than
     the dynamic container, which can be built entirely with loops.
     */
     var $matrixStatic = $(document.createElement('div')),
       // Static columns: The category names column and the All Suppliers column
       $colCategory = $(document.createElement('ul')),
       $colAllSuppliers = $(document.createElement('ul'));


     // Setting the id and classes for the static container
     $matrixStatic.attr('id', 'matrix__static').addClass('matrix__static').attr('data-event-code','AC,AS');

     // Adding classes to the category column
     $colCategory.addClass('nav nav--stacked nav--block matrix__column matrix__column--static');

     // Making the header for the categories column
     
     var $colCatHeader = $(document.createElement('li')),
       $columnCatNote = $(document.createElement('div'));

    //  var carsAvail = AE.booking.matrix.results.props.arrResults.length;
    //  var carsAvailTranslation = AE.booking.matrix.results.props.oTranslations.CARS_AVAILABLE;

    //  if (carsAvail && carsAvailTranslation) {
    //    var $totalCarsAvailable = (carsAvail + ' ' + carsAvailTranslation);
    //    $headerCarsAvail = $(document.createElement('div')).addClass('matrix__header-cars-avail').html($totalCarsAvailable);
    //    $colCatHeader.first().addClass('matrix_column_header-first').append($headerCarsAvail);
    //  };
    
    // WEBAE3-5814 - Added event codes to restore hidden matrix link that shows all rates - Mike 31 Oct 2023
     $colCatHeader.addClass('matrix__column__header trg__matrix--event').attr('data-event-code','AC,AS');
     // $colCatHeader.attr('data-gaarray', encodeURIComponent('[{"GACATEGORY":"matrixInteractions","GAACTION":"classClick","GALABEL":"allClasses"}]'));
     //$columnCatNote.addClass('matrix__column__note matrix__showing-suppliers center-block trg__ga--Child soft--left');

     // Adding the wrap to the header and the header to the column
     //$colCatHeader.append($columnCatNote);
     $colCategory.append($colCatHeader);

     // Loop through the cells in the column's data to add the categories as list items
     
     if (APP.props.colsByCat) {
       var $allSuppLI = $(document.createElement('li'))
         .addClass('matrix__supplier--container trg__matrix--event')
         .attr('id', 'supplier-icon-all').attr('data-event-code','AC,AS')
         .append($(document.createElement('div')).addClass('matrix__supplier--logo allLogo').append(AEdata.booking.quote.oLang.ALL_RESULTS));
       $colCategory.append($allSuppLI);
       _.each(_.sortBy(resultsData.arrSuppliers, 'rank'), function (supID) {
         var tempSup = AEdata.booking.quote.oSupps[supID];
         //console.log('tempSup',tempSup);
         var starVal = (oSite.useTrustScore && typeof tempSup.TRUSTSCORE !== 'undefined' ) ? tempSup.TRUSTSCORE : tempSup.rating;
         //console.log(starVal);
         var $LI = $(document.createElement('li'))
           .addClass('matrix__supplier--container trg__matrix--event')
           .attr('id', 'supplier-icon-' + tempSup.filter)
           .attr('data-supplier', tempSup.filter)
           .attr('data-suppname', tempSup.Opname2)
                       .attr('data-event-code', 'AC,'+tempSup.filter),
           $suppLogoContainer = $(document.createElement('div')).addClass('supp-item matrix__supplier--logo'),
           $suppStarContainer = $(document.createElement('div')).addClass('supp-item matrix__supplier--star'),
           $suppLogo = $(document.createElement('img')).attr('src', tempSup.logoURL).attr('alt', tempSup.name),
           $suppStars = $(document.createElement('div')).addClass('tiny-stars')
           .html(AE.booking.matrix.results.buildStars(starVal));
         if (resultsData.isAirportPickup && !resultsData.isAllLocation) {
           $suppStars.append($(document.createElement('div'))
             .append((tempSup.hasOnAirPuLoc) ? resultsData.oTranslations.ONAIRPORT : resultsData.oTranslations.OFFAIRPORT));
         }
         if(tempSup.prom){// suppress new messaging WEBAE3-2498 NW
           $suppStars.prepend($(document.createElement('div'))
             .addClass('matrix__supplier--feature').css('marginBottom','3px')
             .append(AEdata.booking.quote.oLang.PROMOTED_SUPPLIER)
           );
         }

         $LI.append($suppLogoContainer.append($suppLogo));
         $LI.append($suppStarContainer.append($suppStars));
         $colCategory.append($LI);
       });
     } else {
       for (var i = 0; i < data.categories.length; i++) {
         var $LI = $(document.createElement('li')).addClass('matrix__category matrix__category--container').attr('id', 'category-icon-' + data.categories[i].filter),
           $LIDiv111 = $(document.createElement('div')).addClass('matrix__category--name'),
           $LIMoreInfo = $(document.createElement('div')).addClass('matrix__category--info'),
           $LIMoreInfoIcon = $(document.createElement('i')).addClass('fa fa-info-circle');

         $LI.addClass('trg__matrix--event')
                     .attr('data-category',data.categories[i].filter)
                     .attr('data-event-code',data.categories[i].filter);
         // $LI.attr('data-category', data.categories[i].filter); //data.categories[i].filter );
         // $LI.attr('data-gaarray', encodeURIComponent('[{"GACATEGORY":"matrixInteractions","GAACTION":"classClick","GALABEL":"' + AE.booking.matrix.results.props.oCategories[data.categories[i].filter].track + '"}]'));
         if(_.contains(['DEU','AUT','CHE'],AE.props.siteCode) && AEdata.booking.quote.oCats[data.categories[i].filter].ID === 358){
           $LIDiv111.css('text-transform','none');
         }
         $LIDiv111.html(data.categories[i].name);
         $LIMoreInfo.attr('data-category', data.categories[i].filter);

         $LI.append($LIDiv111).append($LIMoreInfo.append($LIMoreInfoIcon));

         $colCategory.append($LI);
       };
     }

     /* Now we'll build the "All Suppliers" column. */
     $colAllSuppliers.addClass('nav nav--stacked nav--block matrix__column');

     /* Making the header for the column. */
     var $colASHeader = $(document.createElement('li')),
       $colASWrap = $(document.createElement('div'));

     /* Adding classes and setting the text for the header and its child element. */
     $colASHeader.addClass('matrix__column__header trg__matrix--event').attr('data-event-code','AS,AC');
     $colASWrap.addClass('matrix__column__note center-block').html(data.allSuppliers.title.name);
     // $colASHeader.addClass('matrix__column__header trg__ga--Click');
     // $colASHeader.attr('data-gaarray', encodeURIComponent('[{"GACATEGORY":"matrixInteractions","GAACTION":"allResultsClick","GALABEL":"allClasses"}]'));
     // $colASWrap.addClass('matrix__column__note center-block trg__ga--Child').html(data.allSuppliers.title.name);

     /* Add the wrap to the header and the header to the column. */
     $colASHeader.append($colASWrap);
     $colAllSuppliers.append($colASHeader);

     /* Append the "lowest price" cells to the All Suppliers column as list items. */
     for (var i = 0; i < data.allSuppliers.cells.length; i++) {
       var $LI = $(document.createElement('li')),
         $LISpan = $(document.createElement('span'));
       $LI.addClass('matrix__cell trg__matrix--event')
         .attr('data-supplier',data.allSuppliers.cells[i].category)
                   .attr('data-event-code','AS,'+data.allSuppliers.cells[i].category);
       $LISpan.html(data.allSuppliers.cells[i].price);

        
/* WEBAE3-5927 no longer need this because code to show full price handles this
       if (_.contains(['CAE','CA'],AE.props.siteCode) && (data.allSuppliers.cells[i].price !== '--' )){
        $LISpan.append( ' ' + AEdata.booking.quote.oCurrency.BASE);
       }
*/
       // $LI.attr('data-category', (data.allSuppliers.cells[i].category));
       // $LI.attr('data-gaarray', encodeURIComponent('[{"GACATEGORY":"matrixInteractions","GAACTION":"allResultsClick","GALABEL":"' + AE.booking.matrix.results.props.oCategories[data.categories[i].filter].track + '"}]'));
       $LI.append($LISpan);
       $colAllSuppliers.append($LI);
     };

     /* Append the category column and the All Suppliers column to the static container. */
     $matrixStatic.append($colCategory);
     if (!APP.props.colsByCat) $matrixStatic.append($colAllSuppliers);

     /*
     The dynamic container will have pricing columns from individual suppliers. These will be constructed from
     a two-dimensional loop and added to the document fragment.
     */
     var $matrixDynamic = $(document.createElement('div')),
       /* The scroll container is the part that actually moves around, bringing the dynamic columns with it. */
       $scrollContainer = $(document.createElement('div'));


     /* Adding classes and attributes to the container. */
     $matrixDynamic.attr('id', 'matrix__dynamic');
      $matrixDynamic.addClass('matrix__dynamic');

     $scrollContainer.attr('id', 'matrix__scroll-container');
     $scrollContainer.addClass('matrix__scroll-container');

     // If using a modern browser, add a CSS3 transition class.
     if (!AE.props.isLegacy) {
       $scrollContainer.addClass('trans-left');
     }

     /* Now we'll add the pricing columns to the scroll container. */
    
     

     for (var i = 0; i < data.columns.length; i++) {
       var columnData = data.columns[i],
         $column = $(document.createElement('ul')).addClass('nav nav--stacked nav--block matrix__column'),
         $columnHeader = $(document.createElement('li')).addClass('matrix__column__header trg__matrix--event').attr('data-supplier', columnData.title.filter).attr('data-event-code', columnData.title.filter).attr('data-suppname', columnData.title.name),
         //$columnTitle = $(document.createElement('div')).addClass('matrix__title'),
         $columnNote = $(document.createElement('div')).addClass('matrix__column__note center-block').html(columnData.title.note),
         // $columnHeader = $(document.createElement('li')).addClass('matrix__column__header trg__ga--Click').attr('data-supplier', columnData.title.filter),
         // $columnTitle = $(document.createElement('div')).addClass('matrix__title trg__ga--Child'),
         // $columnNote = $(document.createElement('div')).addClass('matrix__column__note center-block trg__ga--Child').html(columnData.title.note),

         $columnStars = $(document.createElement('span')).addClass('supp-item matrix__column__rating medium-stars')
          .html(AE.booking.matrix.results.buildStars(columnData.title.rating)),

         $fakeTable = $(document.createElement('div')).addClass('supp-item matrix__column__logo center-block'),
         $fakeRow = $(document.createElement('div')),
         $fakeCell = $(document.createElement('div')),
         $columnLogo = $(document.createElement('img')).attr('src', columnData.title.logoURL).attr('alt', columnData.title.name);//.addClass('trg__ga--Child');
      if (typeof showSupplierRatings !== 'undefined' && !showSupplierRatings) {
        $columnStars = '';
      }
       if (APP.props.colsByCat) {
         if (_.contains(['DEU','AUT','CHE'],AE.props.siteCode) && AEdata.booking.quote.oCats[columnData.title.filter].ID === 358){
           $columnNote.css('text-transform','none');
         }
         $columnLogo.css('maxHeight', '60px');
         $columnNote
           .addClass('matrix__category--info-top')
           .attr('data-category', columnData.title.filter)
           .attr('data-img', columnData.title.logoURL)
           .append(' ', $(document.createElement('i')).addClass('fa fa-info-circle text--primary'));
       }

       //if (!APP.props.colsByCat) $columnHeader.append($columnTitle);
       $columnHeader
         .append($fakeTable
           .append($fakeRow
             .append($fakeCell
               .append($columnLogo))));
       if (!APP.props.colsByCat) $columnHeader.append($columnStars);
       $columnHeader.append($columnNote);

       $column.append($columnHeader);

       for (var j = 0; j < columnData.cells.length; j++) {
         $cell = $(document.createElement('li'));
         $cellSpan = $(document.createElement('span'));
         $cell.addClass('matrix__cell trg__matrix--event');
         if (columnData.cells[j].lowest === true) {
           $cell.addClass('lowest');
         }
         if (columnData.cells[j].rate === 0) {
           $cell.addClass('no-rate');
         }
         $cell.attr('data-category',columnData.cells[j].category)
                       .attr('data-supplier',columnData.title.filter)
                       .attr('data-event-code',columnData.cells[j].category+','+columnData.title.filter);
         // $cell.attr('data-supplier', (APP.props.colsByCat) ? columnData.cells[j].category : columnData.title.filter);
         // $cell.attr('data-category', (APP.props.colsByCat) ? columnData.title.filter : columnData.cells[j].category);
         // $cell.attr('data-gaarray', encodeURIComponent('[{"GACATEGORY":"matrixInteractions","GAACTION":"supplierClick","GALABEL":"' + AE.booking.matrix.results.props.oCategories[data.categories[j].filter].track + '"}]'));

         $cellSpan.html(columnData.cells[j].price);


/* WEBAE3-5927 no longer need this because code to show full price handles this
          if (_.contains(['CAE','CA'],AE.props.siteCode) && (columnData.cells[j].price !== '--' )){
            $cellSpan.append(' ' + AEdata.booking.quote.oCurrency.BASE);
          }
*/
         $cell.append($cellSpan);
         $column.append($cell);
         if(_.intersection(AEdata.booking.quote.aPS,
           [columnData.cells[j].category,columnData.title.filter]).length
         ){
           $cell.addClass('matrix__cell--ps');
         }
       };
       $scrollContainer.append($column);
     };

     /* Add the scroll container to the dynamic container. */
     $matrixDynamic.append($scrollContainer);

     /* Add the static and dynamic containers to our document fragment. */
     $documentFragment
       .append($matrixStatic)
       .append($matrixDynamic);

     // Adding arrows for moving columns.
     
     var $arrowLeft = $(document.createElement('div')).attr('id', 'matrix__more--tl').addClass('matrix__more matrix__more--left text--center visuallyhidden--palm'),
       $iconLeft = $(document.createElement('i')).addClass('fa fa-lg fa-chevron-left'),
       $arrowRight = $(document.createElement('div')).attr('id', 'matrix__more--tr').addClass('matrix__more matrix__more--right text--center visuallyhidden--palm'),
       $iconRight = $(document.createElement('i')).addClass('fa fa-lg fa-chevron-right'),
       $supplierCounts = $(document.createElement('div')).attr('id', 'matrix__supplier-x-of-y').addClass('showing_supplier text--center visuallyhidden--palm');
      
     /* DONE WITH THE DOCUMENT FRAGMENT.
     /* ============================================================================================ */

     /* Empty the matrix and refill it with our primary document fragment. */
     //$matrix.find('.matrix--palm__categories').destroy();
     $matrix.empty();
     $('.matrix__more').remove();
     $matrix.append($documentFragment).ready(function () {
       // Call map module function to set the position for the map/matrix toggle each time the full matrix is built.
       APP.placeMapToggle();

      //WEBAE3-5492 - for some reason adding this extra markup above the matrix was causing these arrows to be appended twice, so now I check to see if they already exist first. - Mike 23 Mar 2023
      if($('#matrix__more--tl').length === 0 && $('#matrix__more--tr').length === 0) {
        APP.props.$matrixContainer
          .append($arrowLeft.append($iconLeft))
          .append($arrowRight.append($iconRight))
          .append($supplierCounts)
          .ready(function () {
            APP.full.placeArrows();
          });
      }
     });

     /* Apply "selected" class where applicable. */
     var objData = APP.props.$results.data();

     if (objData.category && objData.supplier) {
       APP.props.$matrix.find('[data-category="' + objData.category + '"][data-supplier="' + objData.supplier + '"]').addClass('selected');
     } else if (!APP.props.colsByCat) {
       APP.props.$matrix.find('[data-category="' + objData.category + '"]').not('.matrix__cell').addClass('selected');
       APP.props.$matrix.find('[data-supplier="' + objData.supplier + '"]').not('.matrix__cell').addClass('selected');
     }

     AE.ui.dialog.update(true);
   },
   buildPalm: function ($matrix, data) {
     var $documentFragment = $(document.createDocumentFragment());

     // Wrapper for it all.
     var $categoryBox = $(document.createElement('div'));

     $categoryBox.addClass('matrix--palm__categories');

     var $categoryList = $(document.createElement('ul')).addClass(''),
       $looperPrev = $(document.createElement('div')).addClass('palm__categories__nav prev'),
       $looperNext = $(document.createElement('div')).addClass('palm__categories__nav next'),
       $iconPrev = $(document.createElement('span')).addClass('fa fa-chevron-left'),
       $iconNext = $(document.createElement('span')).addClass('fa fa-chevron-right');

     // Builds an "All Categories" button if called with no argument.
     if(!APP.props.colsByCat) $categoryList.append(buildCategoryLI());

     // Build the rest of the category list items.
     for (var i = 0; i < resultsData.arrCategories.length; i++) {
       var filter = resultsData.arrCategories[i];
       $categoryList.append(buildCategoryLI(resultsData.oCategories[filter], i + 1));
     }

     // Category list goes into the Looper container, then the container and the buttons are appended to the Category container.
     // Note that the prev/next buttons need to have icons added inside them. If the icons themselves are the buttons, then the
     // prev/next divs won't respond to clicks.
     if(!APP.props.colsByCat){
       $categoryBox.append(
         $categoryList
       ).append(
         $looperPrev.append($iconPrev)
       ).append(
         $looperNext.append($iconNext)
       );
     }

     if(!APP.props.colsByCat){
       $documentFragment.append($categoryBox).ready(function () {
         // Call map module function to set the position for the map/matrix toggle each time the palm matrix is built.
         APP.placeMapToggle();
       });
     } else {
       APP.placeMapToggle();
     }

     //$matrix.empty().append($documentFragment);
     $matrix.empty().append($documentFragment).ready(function () {
       // Set widths to prevent them changing during scrolling. This prevents the widths from changing when the
       // window is resized, but there may be a CSS solution for this which we could use instead.
       $categoryList.find("li").each(function () {
         var $this = $(this);
         $this.css("width", $this.innerWidth());
       });

       if ($('#aebooking').hasClass('search-type--luxury') && _.contains(AE.booking.matrix.getResultsData().arrCategories, 'C6')) {
         APP.palm.posCats('C6');
       } else {
         APP.palm.posCats(APP.getSelected().cat);
       }
       APP.buildPalmSuppliers($('#matrix').data('category') || '');
     });

     $categoryBox.ready(function () {
       //AE.heightAdjust( $categoryList.children() );
       //$categoryList.css('height', ($categoryList.children().first().outerHeight() )+'px' );

       if ($('#aebooking').hasClass('search-type--luxury') && _.contains(AE.booking.matrix.getResultsData().arrCategories, 'C6')) {
         APP.palm.posCats('C6');
       } else {
         APP.palm.posCats(APP.getSelected().cat);
       }
     });

     /* Apply "selected" class where applicable. */
     var objData = APP.props.$results.data();
     /*
     if (objData.category) {
       APP.props.$matrix.find( '[data-category="' + objData.category + '"]' ).addClass('selected');
     } else {
       $('.matrix--palm__categories li').first().addClass('selected');
     }
     */
     APP.props.$matrix.find('[data-supplier="' + objData.supplier + '"]').addClass('selected');

     function adjustULWidth($UL) {
       /*
       Adjust width of list items. List starts with crazy-big width, then shortened to match total of
       list items. Initial width
       */
       var accum_width = 0;
       $UL.find('li').each(function () {
         var myWidth = Math.ceil($(this)[0].getBoundingClientRect().width);
         accum_width += (myWidth);
       });
       return accum_width;
     }

     function buildCategoryLI(item, index) {
       var $LI = $(document.createElement('li')).addClass('category');

       if (item) {
         // If there's an item then we're past the first "All Categories" list item. Add one to the index.
         $LI
           .attr('data-index', index + 1)
           .attr('data-category', item.filter)
           .html(item.label);
         if(_.contains(['DEU','AUT','CHE'],AE.props.siteCode) && AEdata.booking.quote.oCats[item.filter].ID === 358){
           $LI.css('text-transform','none');
         }
       } else {
         // If there's no item, then we're creating the first one. It gets a zero.
         $LI
           .html(resultsData.oTranslations.CLASSLABELS.LABEL_ALL)
           .attr('data-index', 0);
       }

       return $LI;
     }
   },
   buildPalmSuppliers: function (category) {
     // If the category variable is undefined, set it to an empty string.
     category = !category ? '' : category;

     /*
     This function builds the supplier list. It isn't worried about showing car results at all.
     That work will be done in a separate function when a supplier is clicked. Each supplier
     listed will display the lowest price available for that supplier in the given category. If
     no category is given, then the lowest price for each supplier will include all categories.

     NOTE: Filters are irrelevent for this function because it works with post-filter results.
     */

     var $matrix = APP.props.$matrix;

     $matrix.find('.matrix--palm__suppliers').remove();

     var $supplierList = $(document.createElement('ul'));
     $supplierList.addClass('matrix--palm__suppliers');
     if(APP.props.colsByCat){
       $supplierList.addClass('matrix--palm__cats');
     }
     // Get an array of objects to build our palm supplier list items from.
     var arrSuppliers = buildListObjects(category);
     for (var i = 0; i < arrSuppliers.length; i++) {
       $supplierList.append(buildSupplierLI({
         supplier: arrSuppliers[i],
         category: category
       }));
     }

     if ($supplierList.find('li').length > 0) {
       $matrix.append($supplierList);
       AE.heightAdjust($('li.matrix--palm__supplier'));
     } else {
       $supplierList.remove();
     }

     function buildListObjects(category) {
       var arrTemp = [];

       for (var i = 0; i < currentData.columns.length; i++) {
         var column = currentData.columns[i];

         if (category) {

           var lowestItem = _.find(column.cells, function (item) {
             return (item.category === category);
           });
         } else {

           var lowestItem = _.min(column.cells, function (item) {
             if (item.rate > 0) {
               return (item.rate)
             };
           });
         }

         if (lowestItem && lowestItem.price) {
           var oSupp = _.filter(AEdata.booking.quote.oSupps,function(thisSupp) {
             return _.contains([column.title.filter,lowestItem.category], thisSupp.filter);
           });
           var isProm = false;
           if(oSupp.length){
             if(_.isObject(oSupp[0]) && oSupp[0].hasOwnProperty('prom')){
               isProm = oSupp[0].prom;
             }
           }
           
           arrTemp.push({
             isAll: false,
             filter: column.title.filter,
             logoURL: column.title.logoURL,
             name: column.title.name,
             note: column.title.note,
             rating: column.title.rating,
             rate: lowestItem.rate,
             category: lowestItem.category,
             price: lowestItem.price,
             prom: isProm
           });
         }
       }



       // Add all suppliers item.
       var lowestOfAll = _.min(arrTemp, function (item) {
         if (item.rate > 0) return (item.rate);
       });

       arrTemp.unshift({
         isAll: true,
         filter: '',
         logoURL: '',
         name: resultsData.oTranslations.ALL_RESULTS,
         note: '',
         rating: null,
         category: lowestOfAll.category,
         rate: lowestOfAll.rate,
         price: lowestOfAll.price
       });

       return arrTemp;
     }

     function buildSupplierLI(settings) {
       // We're getting All Suppliers first, then this function will be called for each supplier available.
       var $logo = null,
         $stars = null,
         options = $.extend(true, {
           supplier: null,
           category: null
         }, settings);
       var category = options.category,
         supplier = options.supplier;

       // Sort out the logo between "All Suppliers" and supplier logos.
       if (supplier.isAll === true) {
         $logo = $(document.createElement('div')).addClass('matrix--palm__all');
         $logo.html(supplier.name);
       } else {
         $logo = $(document.createElement('img')).addClass('matrix--palm__logo').attr('alt', supplier.name).attr('src', supplier.logoURL);
         if(APP.props.colsByCat) $logo.css('maxHeight','40px').addClass('push-half--top');
       }

       // Establish the star count.
       if (supplier && supplier.rating) {
        var starsVal = -1;
          if(oSite.useTrustScore){
            starsVal = supplier.TRUSTSCORE;
          }else{
            starsVal = supplier.rating;
          }
          $stars = $(document.createElement('div')).addClass('best').addClass('matrix--palm__stars tiny-stars').html(AE.booking.matrix.results.buildStars(starsVal));
       }

       // Document fragments.
       var $LI = $(document.createElement('li')),
         $supplierWrap = $(document.createElement('div')).addClass('matrix--palm__wrap'),
         $rateWrap = $(document.createElement('div')).addClass('matrix--palm__rate matrix--palm__cell'),
         $best = $(document.createElement('div')).addClass('best'),
         $price = $(document.createElement('div')).addClass('rate'),
         $infoWrapContainer = $(document.createElement('div')).addClass('matrix--palm__info-container');
         $infoWrap = $(document.createElement('div')).addClass('matrix--palm__info matrix--palm__cell');

       // Add supplier and category data attributes.
       $LI.attr('data-category', category);
       if (supplier.filter !== '') {
         $LI.attr('data-supplier', supplier.filter);
       }

       $price.html(supplier.price);
       $rateWrap.append($best).append($price);
       $infoWrap.append($infoWrapContainer);
       $infoWrapContainer.append($logo);
       if ($stars) {
         $infoWrap.append($stars);
       }
       if(APP.props.colsByCat && !supplier.isAll){
         var catName = supplier.name;
         var catTransform = true;
         if(_.contains(['DEU','AUT','CHE'],AE.props.siteCode) && AEdata.booking.quote.oCats[supplier.filter].ID === 358){
             catTransform = false;
         }
         var $catTitle = $(document.createElement('strong')).html( catName );
         if(catTransform) $catTitle.css('textTransform','uppercase');
         $infoWrap.append(
           $(document.createElement('div')).addClass('cardetails-smallprint').append( $catTitle )
         );
       }
       if(supplier.prom){// Apply Promoted Supplier styles WEBAE3-2503 NW 4/22/2019
         // suppress new messaging WEBAE3-2498 NW
         $rateWrap.addClass('matrix--palm--ps').append(
           $(document.createElement('div')).addClass('cardetails-smallprint')
           .append(AEdata.booking.quote.oLang.PROMOTED_SUPPLIER.toUpperCase())
         );
       }
       $LI.addClass('matrix--palm__supplier cf').append($supplierWrap.append($rateWrap).append($infoWrap));

       return $LI;
     }
   },
   setColumnsByCategory: function () {
     if (AE.getSiteViewType() === 'palm') {
       APP.props.colsByCat = AEdata.booking.props.mobileCategoryMatrix;
     } else { // Site code trigger
               APP.props.colsByCat = !AEdata.booking.props.supplierColumns;
     }
   },
   buildCarCategoryInfo: function (category, argURL) {
     category = category || '';
     argURL = argURL || '';
     var oCategory = resultsData.oCategories[category];
     var $df = $(document.createDocumentFragment());
     var imgURL = oCategory.imgURL; //argURL;

     // Car Class Overrides
     // WEBAE3-1487 :: Hard code car class image within the matrices
     //  var _label = oCategory.label.replace(/\s/g, "").toLowerCase();

     // var _classImgOverrides = {
     // 	 'compact': 'compact.jpg',
     // 	 'convertible': 'convertible.jpg',
     // 	 'economy': 'economy.jpg',
     // 	 'estate': 'estate.jpg',
     // 	 'familysize': 'family.jpg',
     // 	 'large': 'large.jpg',
     // 	 'luxury/cabrio': 'luxury-cabrio.jpg',
     // 	 'luxury/convertible': 'convertible.jpg',
     // 	 'luxury/sportscar': 'luxury.jpg',
     // 	 'midsize': 'midsize.jpg',
     // 	 'mini': 'mini.jpg',
     // 	 'minivan': 'minivan.jpg',
     // 	 'motorcycle': 'motorcycle.jpg',
     // 	 'small': 'small.jpg',
     // 	 'stationwagon': 'stationwagon.jpg',
     // 	 'suv/4wd': 'suv.jpg',
     // 	 'vans': 'vans.jpg',
     // 	'7-12passengervans': 'sevennine.jpg'
     // };

     // for (var i in _classImgOverrides) {
     // 	if (_classImgOverrides[_label]) {
     // 		imgURL = 'https://www.globalmediaserver.com/AE3/matrix_cars/' + _classImgOverrides[_label];
     // 		oCategory.imgURL = imgURL;
     // 	}
     // }

     if (oCategory) {
       if (false && resultsData.oButtonValBase.EXCL_LTR == true) {// Rely on locations submitted by search form to limit to LTR WEBAE3-3408 LW 1/13/2020
         //start with LTR cars only
         ResultsForCat = _.filter(resultsData.oResults, function (carltr) {
           return (carltr.isLTR === true);
         });

       } else {
         //use all cars
         ResultsForCat = resultsData.oResults;
       }
       if (imgURL === '') {
         var aCarsInCat = _.filter(ResultsForCat, function (car) {
             return (_.contains(car.aFilters, oCategory.filter));
           }),
           imgURL = (!_.isEmpty(aCarsInCat)) ? aCarsInCat[0].img : '';

       }
       var $label = $(document.createElement('h4')).addClass('bg--tertiary push-half--bottom').append(oCategory.label);
       var $wrapperDIV = $(document.createElement('div')).addClass('category-wrapper').addClass('border--bottom cf');
       var $description = $(document.createElement('div')).addClass('category-description').append(oCategory.description);
       $description.append(' <span class="category-tip">' + resultsData.oTranslations.TIP + ':</span> ');
       $description.append(oCategory.tip);

       $wrapperDIV.append($description);

       if (imgURL !== '') {
         $wrapperDIV.append($(document.createElement('img')).attr('src', imgURL));
       }

       var $categoryDetails_Specs = $(document.createElement('div')).addClass('cardetails-features fcr_cardetails-features')
         .append(AE.booking.matrix.results.buildSpecs('', '', '', oCategory.passengers, oCategory.smLuggage, oCategory.mdLuggage, oCategory.lgLuggage, '', ''));

       $df.append($label).append($wrapperDIV).append($categoryDetails_Specs);
       if(_.contains(['DEU','AUT','CHE'],AE.props.siteCode) && oCategory.ID === 358){
         $label.css('text-transform','none');
       }
     } else {
       $df.append('<p>wut</p>').addClass("NOPE");
     }

     return $df;
   } //End of functions

   
 };

 return APP;
 
})();






;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking.matrix.results = AE.booking.matrix.results || ( function () {
	/*
	DEPENDENCIES: AE, AE.booking, AE.booking.matrix
	*/
	var APP = {
		dialogQ: [], // Queue of dialog launch parameters
		init: function ( resultsDataObj ) {
			resultsDataObj = resultsDataObj || {};
			resultsDataObj.aDebug = resultsDataObj.aDebug || [];
			resultsDataObj.oQuote = resultsDataObj.oQuote || {};
			resultsDataObj.oAff = resultsDataObj.oAff || {};
			resultsDataObj.aCars = resultsDataObj.aCars || [];
			resultsDataObj.aCats = resultsDataObj.aCats || [];
			resultsDataObj.aSupps = resultsDataObj.aSupps || [];
			resultsDataObj.oSupps = resultsDataObj.oSupps || {};
			resultsDataObj.oOrSimilar = resultsDataObj.oOrSimilar || {};
			resultsDataObj.oLogos = resultsDataObj.oLogos || {};
			resultsDataObj.oLang = resultsDataObj.oLang || {};
			resultsDataObj.oCats = resultsDataObj.oCats || {};
			resultsDataObj.oLocs = resultsDataObj.oLocs || {};
			resultsDataObj.oTags = resultsDataObj.oTags || {};
			resultsDataObj.BASEBUTTONVAL = resultsDataObj.BASEBUTTONVAL || {};
			resultsDataObj.oCars = resultsDataObj.oCars || {};
			resultsDataObj.oRates = resultsDataObj.oRates || {};
			resultsDataObj.oRateChangeDetails = resultsDataObj.oRateChangeDetails || {};
			resultsDataObj.oCurrency = resultsDataObj.oCurrency || {};
			resultsDataObj.oFilters = resultsDataObj.oFilters || {};
			resultsDataObj.quoteID = resultsDataObj.quoteID || 0;
			resultsDataObj.totalDays = resultsDataObj.totalDays || 0;
			resultsDataObj.allLocations = resultsDataObj.allLocations || false;
			var oRateChoiceGA = { // GOOGLE ANALYTICS RATE SELECTION EVENT OBJECTS BASE
				GACATEGORY: ( AEdata.booking.props.ismodify )? 'Modify2_matrixRateChoice' : 'matrixRateChoice',
				GAACTION: 'rateChosen_' + resultsDataObj.oQuote.oPU.country
			};

			APP.props = {
				aDebug: resultsDataObj.aDebug,
				oQuote: resultsDataObj.oQuote,
				oAff: resultsDataObj.oAff,
				oTranslations: resultsDataObj.oLang,
				oLocations: resultsDataObj.oLocs,
				oResults: resultsDataObj.oCars,
				oCategories: resultsDataObj.oCats,
				oCurrency: resultsDataObj.oCurrency,
				oSuppliers: resultsDataObj.oSupps,
				oOrSimilar: resultsDataObj.oOrSimilar,
				oLogos: resultsDataObj.oLogos,
				oRateFingers: resultsDataObj.oRates,
				oRateChangeDetails: resultsDataObj.oRateChangeDetails,
				oFilters: resultsDataObj.oFilters,
				oCarTags: resultsDataObj.oTags,
				oButtonValBase: resultsDataObj.BASEBUTTONVAL,
				arrBGA: encodeURIComponent( JSON.stringify( [ _.extend( { GALABEL: 'basic' }, oRateChoiceGA ) ] ) ),
				arrIGA: encodeURIComponent( JSON.stringify( [ _.extend( { GALABEL: 'inclusive' }, oRateChoiceGA ) ] ) ),
				arrResults: resultsDataObj.aCars,
				arrCategories: resultsDataObj.aCats,
				arrSuppliers: resultsDataObj.aSupps,
				isMapOneway: ( resultsDataObj.oQuote.oOW.city || resultsDataObj.oQuote.oOW.country  || resultsDataObj.oQuote.oOW.locList ) ? true : false,
				isAllLocation: resultsDataObj.oQuote.allLocations,
				isAirportPickup: ( resultsDataObj.oQuote.oPU.isAirport ) ? true : false,
				quoteID: resultsDataObj.quoteID,
				totalDays: resultsDataObj.totalDays,
				placeholdersBuilt: false,
				trustScoreUrl: '/plugins/ae3/lib/trustScoreManager.cfc',
				buildRateFingersCount: 0,//WEBAE3-4721 - used to make sure cancel ins checkbox IDs are unique
				resultsLayout: oSite.resultsLayout // WEBAE3-6161 Determines which results layout to use (matrix or no matrix)
			};
            
			/* EXTERNALLY AVAILABLE PROPERTIES FROM MATRIX RESULTS DATA

			AE.booking.matrix.results.props.oTranslations         Commonly used Strings out of CF Language Management for Rates Display
			AE.booking.matrix.results.props.oLocations            An Object comprised of Location Objects, keys are LOCIDs from Quote
			AE.booking.matrix.results.props.oResults              An Object comprised of Result Objects, keys are CF UUIDs
			AE.booking.matrix.results.props.oCategories           An Object of Category Objects with values needed for filling in Matrix Columns
			AE.booking.matrix.results.props.oSuppliers            An Object of Supplier Objects with values needed for filling in the Matrix Columns
			AE.booking.matrix.results.props.oRateFingers          An Object of Rate Finger Objects, keys are - delimited strings of certain properties of the object
			AE.booking.matrix.results.props.oRateChangeDetails    An Object of Rate Change Detail Objects Categorized by Pickup ID, then Dropoff ID, then SIPP code: {'PUID':{'DOID':{'SIPP':{'object'},...},...},...}
			AE.booking.matrix.results.props.oFilters              An Object detailing any and all desired filter/display pre-selections
			AE.booking.matrix.results.props.arrResults            An array of truncated Result Objects with only the values needed for drawing results and the Matrix Grid
			AE.booking.matrix.results.props.arrCategories         An array of IDs for Category Objects represented in Quote
			AE.booking.matrix.results.props.arrSuppliers          An array of Supplier Keys in oSuppliers
			AE.booking.matrix.results.props.isMapOneway           A boolean to signal a oneway search
			AE.booking.matrix.results.props.isAllLocation         A boolean to signal an All 'Downtown' Location search
			AE.booking.matrix.results.props.quoteID               The numeric Quote ID for the booking instance

			Objects within oLocations, oResults, and oRateFingers have elements linking them with one or more child objects in the other two parent objects:
			Location Objects have ARRRATEFINGERS and ARRRESULTS, arrays of Rate Finger and Result Object IDs.
			Result Objects have ARRRATEFINGERS and ARRLOCS, arrays of Rate Finger and Location Object IDs.
			Rate Finger Objects have PULOC, DOLOC, and RESULTID; IDs for the Pickup and Dropoff Location Objects, and the associated Result Object.

			*/
            
			/*	Alert User To Possibility of One Way Fees	*/
			if ( APP.props.isMapOneway ) { APP.oneWayDialog(); }
			if ( !APP.props.placeholdersBuilt ) {
				APP.buildNoResultsMessage();
				APP.applyExlusiveFilters();
				APP.buildPlaceholders();
			}

			// FCR sort menu
			if(AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') {
				$( function() {
					$( ".sortbyprice" ).selectmenu({
						appendTo: '#aebooking'
					  });
				} );

				$( ".sortbyprice" ).selectmenu({
					change: function( event, ui ) {
						if (ui.item.value == 'high') {
							$('#sp_sp').prop('checked', true).trigger('change');
						} else if (ui.item.value == 'low') {
							$('#sp_sp').prop('checked', false).trigger('change');
						}
					}
				});

				APP.fcrTogglePriceFilter();
			}

			//FCR and matrix-less results page price slider
			if((AE.props.siteCode == 'FCR' || APP.props.resultsLayout == 'nomatrix') && typeof(mdc) !== 'undefined') {
                APP.initRateSlider();
                
                // nomatrix results page-specific stuff
                if(APP.props.resultsLayout == 'nomatrix') {
                    $('#matrix__filters .priceslider-container').addClass('collapsed');
                    
                    // WEBAE3-6260 reinitialize the rate slider whenever the filter is toggled
                    // because MDC Slider relies [too] heavily on initial slider position
                    $('body').on('click', '#matrix__filters .priceslider-container .filter-trigger', function()
                    {
                        APP.initRateSlider();
                    });
                }
			}
            
			// Only submit a ratefinger button through the bodyclick task.
			$( ".rateFinger__button" ).on( "click", function ( event ) {
				event.preventDefault();
			} );
            
			AE.ui.addBodyClickTask( { func: APP.onBodyClick } );
		},
        initRateSlider: function() { // WEBAE3-6260 move rate slider initialization to separate function so we can easily make multiple calls if necessary
            slider = document.querySelector('.mdc-slider');
            mdc.slider.MDCSlider.attachTo(slider);
            sldr = new mdc.slider.MDCSlider(document.querySelector('.mdc-slider'));

            sldr.root.addEventListener("MDCSlider:change", function() {
                $('#ps_ps').prop('checked', true).trigger('change');
                
                var elPrefix = AE.props.siteCode === 'FCR' ? 'fcr-' : '';
                var sliderlow = document.getElementById('slider_thumb_low');
                var newMinRate = sliderlow.getAttribute("aria-valuenow");
                var newMinRateRounded = Math.floor(newMinRate);

                var sliderhigh = document.getElementById('slider_thumb_high');
                var newMaxRate = sliderhigh.getAttribute("aria-valuenow");
                var newMaxRateRounded = Math.ceil(newMaxRate);
                
                if (AE.props.affiliate == 'FLIGHTCTRZA') {
                    document.getElementById(elPrefix+'minprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>R</span>"+newMinRateRounded;
                    document.getElementById(elPrefix+'maxprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>R</span>"+newMaxRateRounded;
                } else if (AE.props.affiliate == 'FLIGHTCTRGB') {
                    document.getElementById(elPrefix+'minprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>£</span>"+newMinRateRounded;
                    document.getElementById(elPrefix+'maxprice').innerHTML = "<span class='"+elPrefix+"priceslider-currency-symbol-sub'>£</span>"+newMaxRateRounded;
                } else {
                    document.getElementById(elPrefix+'minprice').innerHTML = "$"+newMinRateRounded;
                    document.getElementById(elPrefix+'maxprice').innerHTML = "$"+newMaxRateRounded;
                }
            }, false);
        },
		initTranslations: function ( translationObj ) {
			translationObj = translationObj || {};
			if ( !_.isObject( translationObj ) ) translationObj = {};
			APP.props = APP.props || {};
			APP.props.oTranslations = APP.props.oTranslations || {};
			_.extend( APP.props.oTranslations, translationObj );
		},
		applyExlusiveFilters: function () {
			if ( APP.props.oFilters.EXCLUSIVE ) {
				var arrFilterCats = _.intersection( APP.props.arrCategories, _.keys( _.omit( APP.props.oFilters.CX, function ( val, key ) { return !val } ) ) );
				if ( arrFilterCats[ 0 ] ) { // Category Exclusive
					APP.props.arrCategories = arrFilterCats;
					APP.props.arrResults = _.filter( APP.props.arrResults,
							function ( res ) { return ( _.intersection( APP.props.arrCategories, res.aFilters )[ 0 ] ) ? true : false; }
					);
					APP.props.arrSuppliers = _.uniq( _.pluck( APP.props.arrResults, 'suppID' ) );
					for ( var i = 0; i < APP.props.arrSuppliers.length; i++ ) {
							var thisSupplierFingers = _.sortBy(
								_.filter(
									APP.props.oRateFingers,
									function ( rate ) {
										return (
												_.contains( _.pluck( APP.props.arrResults, 'ID' ), rate.carID ) &&
												rate.suppID === APP.props.arrSuppliers[ i ]
										);
									}
								),
								'rate'
							);
							if ( thisSupplierFingers.length ) {
								APP.props.oSuppliers[ APP.props.arrSuppliers[ i ] ].rank = thisSupplierFingers[ 0 ].rate + APP.props.oCategories[ APP.props.oResults[ thisSupplierFingers[ 0 ].carID ].catID ].rankModifier;
								//console.log(thisSupplierFingers[ 0 ].rate);
								APP.props.arrSuppliers = _.intersection(
									_.pluck( _.sortBy( APP.props.oSuppliers, function ( supp ) { return supp.rank; } ), 'ID' ),
									APP.props.arrSuppliers
								);
							}
					}
				}
				if ( APP.props.oFilters.LTR ) { // Long Term Rental/Leasing/Buyback Exclusive
					APP.props.arrSuppliers = _.filter( APP.props.arrSuppliers, function ( supp ) { return APP.props.oSuppliers[ supp ].isLTR } );
					APP.props.arrResults = _.filter( APP.props.arrResults, function ( res ) { return _.contains( res.aFilters, 'LTR' ) } );
					APP.props.arrCategories = _.filter( APP.props.arrCategories, function ( cat ) { return APP.props.oCategories[ cat ].LTRcount > 0; } );
				}
			}
		},
		buildNoResultsMessage: function () {
			var $df = $( document.createDocumentFragment() ),
				$island = $( document.createElement( 'div' ) )
				.attr( 'id', 'matrix__noresults' )
				.addClass( 'island remove-rhythm trulyhidden' ),
				$div = $( document.createElement( 'h3' ) )
				.css( 'margin', '0' )
				.html( APP.props.oTranslations.NO_RESULTS );
			$df.append( $island.append( $div ) );
			$( 'div#car_results.car_results' ).parent().prepend( $df );
		},
		buildPlaceholders: function () { 		//where initial sort order happens ?????
			APP.props.placeholdersBuilt = true;
			var $df = $( document.createDocumentFragment() );
			for ( var resIdx = 0; resIdx < APP.props.arrResults.length; resIdx++ ) {
				$df.append( $( document.createElement( 'span' ) )
					.attr( 'id', APP.props.arrResults[ resIdx ].ID )
					.addClass( 'result_not_loaded trulyhidden ' + APP.props.arrResults[ resIdx ].filterClasses )
				);
			}
			$( 'div#car_results.car_results' ).append( $df );
		},
		reBuildPlaceholders: function (data) { 		// WEBAE3-5142 Threw this in for a rebuild of the spans  
			APP.props.placeholdersBuilt = true;
			$( 'div#car_results.car_results' ).empty(); //Threw this in to start from scratch
			var $df = $( document.createDocumentFragment() );
			for ( var resIdx = 0; resIdx < data.length; resIdx++ ) {
				$df.append( $( document.createElement( 'span' ) )
					.attr( 'id', data[ resIdx ].ID )
					.addClass( 'result_not_loaded trulyhidden ' + data[ resIdx ].filterClasses )
				);
			}
			$( 'div#car_results.car_results' ).append( $df );
		},
		buildResult: function ( resultData ) {
			//WEBAE3-6512 - trim insurance packages, etc before building results
			resultData.aRatesTrimmed = APP.trimRateFingers(resultData.aRates);//used for actual rate finger build
			resultData.aStartRatesTrimmed = APP.trimRateFingers(resultData.aStartRates);//used for all location starting at rates
			
			resultData.aRatesTrimmed = _.sortBy(resultData.aRatesTrimmed,function(thisRateID){
				return APP.props.oRateFingers[thisRateID].rate;
			});//AE.booking.options.sortRateIDs(resultData.aRates);
			var dspSIPPs = [],pdarFound=false,guaranteeTag=false;
			_.each(resultData.aRatesTrimmed,function(thisRateID){
				var thisRate = APP.props.oRateFingers[thisRateID];
				if(!_.contains(dspSIPPs,thisRate.SIPP)) dspSIPPs.push(thisRate.SIPP);
				if(thisRate.SIPP === 'PDAR') pdarFound=true;
				if(AEdata.booking.quote.oTags[thisRate.tagID]){
					if(AEdata.booking.quote.oTags[thisRate.tagID].message === 'Guaranteed_Make_Model'){
						guaranteeTag = true;
					}
				}
                // WEBAE3-6014 Create vehicle result item and push into array for GA4 tracking
                var eCommItem = AE.booking.matrix.events.buildGA4EcommerceItem(thisRate.ID, thisRate.carName, thisRate.suppName, thisRate.SIPP, thisRate.estimate);
                AE.booking.matrix.props.eCommItems.push(eCommItem);
				
			});
		
			resultData.aLocs = _.uniq(resultData.aLocs);
			var $documentFragment = $( document.createDocumentFragment() );

			var $resultContainer = $( document.createElement( 'div' ) )
				.attr( 'id', resultData.ID )
				.attr( 'data-pulocid', resultData.aLocs.toString() )
				.attr( 'data-dolocid', APP.props.oLocations[ resultData.aLocs[ 0 ] ].aDOs.toString() )
				.attr( 'data-sortrate', resultData.rate )
				.addClass( 'result_container shadow_container apply-rhythm apply-half-rhythm ' + resultData.filterClasses );

			if ( resultData.aOffers.length ) $resultContainer.append( APP.buildGreenPromoBar( resultData.aOffers ) );

			var $resultContentGrid = $( document.createElement( 'div' ) ).addClass( 'grid result_content' );

			var $carDetailsContainer = $( document.createElement( 'div' ) )
				.addClass( 'grid__item two-thirds palm-one-whole carDetailsContainer' );

			var $carDetailsGrid = $( document.createElement( 'div' ) ).addClass( 'grid carDetailsGrid' );

			var $carDetailsImgBlock = $( document.createElement( 'div' ) ).addClass( 'car_details-img-block');

			var $carDetailsPalm = $( document.createElement( 'div' ) )
				.addClass( 'grid__item palm-one-whole trulyhidden--desk-wide trulyhidden--desk trulyhidden--lap carDetailsPalm' );

			var $carDetailsPalm_head = $( document.createElement( 'h2' ) )
				.addClass( 'flush--bottom carDetailsPalm_head' )
				.append( $.trim( resultData.iName ) );

			$carDetailsPalm.append( $carDetailsPalm_head );
			var GUARANTEETXT = ( APP.props.oOrSimilar[ resultData.suppCode ] ) ? APP.props.oTranslations.SIMILAR : APP.props.oTranslations.GUARANTEED;
			if(guaranteeTag) GUARANTEETXT = APP.props.oTranslations.GUARANTEED;
			if(APP.props.oSuppliers[ resultData.suppID ]){
				if(APP.props.oSuppliers[ resultData.suppID ].isLTR ||
					(APP.props.oSuppliers[ resultData.suppID ].name === 'AE PRESTIGE' && pdarFound)
				){
					GUARANTEETXT = APP.props.oTranslations.GUARANTEED;
				}
			}
 			GUARANTEETXT += ' |';
			var FULLCLASS = APP.props.oTranslations.CLASSLABELS[ 'LABEL_' + resultData.catKey ];

			//WEBAE3-6276 - convert from cascading if statements on same expression to switch statement
			switch(resultData.SIPP.substring(0,2)){
				case 'CF':
				case 'DF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_COMPACT + ' ' + resultData.catKey;
					break;
				
				case 'EF':
				case 'HF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_ECONOMY + ' ' + resultData.catKey;
					break;

				case 'IF':
				case 'JF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_INTERMEDIATE + ' ' + resultData.catKey;
					break;
				
				case 'FF':
				case 'GF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_FULLSIZE + ' ' + resultData.catKey;
					break;

				case 'SF':
				case 'RF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_STANDARD + ' ' + resultData.catKey;
					break;
				
				case 'MF':
				case 'NF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_MINI + ' ' + resultData.catKey;
					break;

				case 'PF':
				case 'UF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_PREMIUM + ' ' + resultData.catKey;
					break;
				
				case 'LF':
				case 'WF':
					FULLCLASS = APP.props.oTranslations.CLASSLABELS.LABEL_LUXURY + ' ' + resultData.catKey;
					break;
			}
			
			if ( APP.props.oTranslations.usePostpositiveAdjectives) {
				FULLCLASS = APP.props.oTranslations.CLASS_TXT + ' ' + FULLCLASS;
			} else {
				FULLCLASS += ' ' + APP.props.oTranslations.CLASS_TXT;
			}

			var $carDetailsPalm_body = $( document.createElement( 'div' ) )
				.addClass( 'cardetails-cartype push-half--bottom' )
				.append( $.trim( GUARANTEETXT ).toUpperCase() + ' ' )
				.append( $.trim( FULLCLASS ).toUpperCase() );
			//WEBAE3-5555 added rule to not add sipp to car label on DAP domain per Shelley/Charlie
			if ( (!AE.props.isLiveServer || AE.props.showSipp === true) && !oSite.bIsDapTpDomain ) $carDetailsPalm_body.append( ' (' + $.trim( dspSIPPs.toString() ).toUpperCase() + ')' );

			$carDetailsPalm.append( $carDetailsPalm_body );

			if(AE.props.siteCode !== 'FCR') {
				$carDetailsGrid.append( $carDetailsPalm );
			}

			// $carDetailsImgBlock.append( $carDetailsPalm )
			// 	.append( $carDetailsImage )

			var $carDetailsImage = $( document.createElement( 'div' ) )
				.addClass( 'grid__item one-half palm-one-whole carDetailsImage' );

			var $carDetailsMobileGrid = $( document.createElement( 'div' ) )
				.addClass( 'grid carDetailsMobileGrid' );

			var $carDetailsImageGridItem = $( document.createElement( 'div' ) )
				.addClass( 'grid__item one-whole palm-one-half carDetailsImageGridItem' );

			$carDetailsMobileGrid.append( $carDetailsImageGridItem );

			var $carDetailsImage_Car = $( document.createElement( 'img' ) )
				.addClass( 'palm-one-whole cardetails-carimg' )
				.attr( 'title', resultData.iName + ' | ' + FULLCLASS )
				.attr( 'width', 350 )
				.attr( 'onError', 'AE.booking.matrix.results.noImage("' + resultData.ID + '");' )
				.attr( 'src', resultData.img + resultData.imgSuffix )
				.attr( 'data-icon', resultData.icon )
				.attr( 'alt', resultData.iName + ' | ' + FULLCLASS );

			$carDetailsImageGridItem.append( $carDetailsImage_Car );

			var $carDetailsImage_Stars = $( document.createElement( 'div' ) )
				.addClass( 'grid__item cardetails-caroperator small-stars palm-one-half push-half--top' );

			var $starRatingContainer = $( document.createElement( 'span' ) );

			var $supplierLogo = $( document.createElement( 'img' ) )
				.attr( 'src', APP.props.oLogos[ resultData.suppCode ] || APP.props.oSuppliers[ resultData.suppID ].logoURL)
				.attr( 'alt', APP.props.oSuppliers[ resultData.suppID ].name );

			$starRatingContainer.append( $supplierLogo );

			//WEBAE3-6253 - don't build supplier stars for FCR because we don't show them
			if(AE.props.siteCode !== 'FCR'){
				if ( !AE.booking.props.oTrustScore.bUseTrustScore ){
					var $starRating = $( document.createElement( 'span' ) )
					.attr( 'title', APP.props.oSuppliers[ resultData.suppID ].name + ' ' + APP.props.oSuppliers[ resultData.suppID ].rating + '/5' )
					.append( APP.buildStars( APP.props.oSuppliers[ resultData.suppID ].rating ) );
					$starRatingContainer.append( $starRating );
				}else{
					let obj = APP.props.oSuppliers[ resultData.suppID ].OTRUSTSCORE.TRUSTSCOREWIDGET; //injected in bookingengine3.cfc
					let trustScoreWidget =  `
					<div class="trust-score__widget " ${obj.TSDATAINJECT}>
						<div class="trust-score-inner" ${obj.TSTITLE}>
							<div class="rating-score">${obj.RATINGSCORE}</div>
							<div class="rating-banner">${obj.LOCTITLE}</div>
							<div class="rating-stars">${obj.TSWIDGETHTML}</div>
						</div>
					</div>`;
					$starRatingContainer.append(trustScoreWidget);
					$carDetailsImage_Stars.css("cursor", "pointer");
				}
			}
			var $carDetailsPalm_TogglerContainer = $( document.createElement( 'div' ) )
				.addClass( 'cardetails-data-toggler trulyhidden' );

			var $carDetailsPalm_Toggler = $( document.createElement( 'div' ) )
				.addClass( 'toggler toggler--special align-left' )
				.attr( 'data-togglee', '#' + $.trim( resultData.ID ) + ' .cardetails-data-togglee' )
				.attr( 'data-size', 'palm' )
				.append( APP.props.oTranslations.SIPPNOTEHEAD );

			$carDetailsPalm_TogglerContainer.append( $carDetailsPalm_Toggler );

			$starRatingContainer.append( $carDetailsPalm_TogglerContainer );

			$carDetailsImage_Stars.append( $starRatingContainer );

			$carDetailsMobileGrid.append( $carDetailsImage_Stars );

			$carDetailsImage.append( $carDetailsMobileGrid );

			if(AE.props.siteCode !== 'FCR') {
				$carDetailsGrid.append( $carDetailsImage );
			}

			var $carDetailsFull = $( document.createElement( 'div' ) )
				.addClass( 'cardetails-data-toggle grid__item one-half palm-one-whole toggle' );

			var $carDetailsFull_head = $carDetailsPalm_head.clone().addClass( 'trulyhidden--palm' );

			$carDetailsFull.append( $carDetailsFull_head );

			var $carDetailsFull_body = $carDetailsPalm_body.clone().addClass( 'trulyhidden--palm' );

			$carDetailsFull.append( $carDetailsFull_body );

			/*var $carDetailsPalm_TogglerContainer = $(document.createElement('div'))
			.addClass('cardetails-data-toggler grid__item palm-one-half trulyhidden--lap-and-up');

			var $carDetailsPalm_Toggler = $(document.createElement('div'))
				.addClass('toggler toggler--special align-left')
				.attr('data-togglee', '#'+$.trim(resultData.ID)+' .cardetails-data-togglee')
				.attr('data-size', 'palm')
				.append(APP.props.oTranslations.SIPPNOTEHEAD);

			$carDetailsPalm_TogglerContainer.append($carDetailsPalm_Toggler);

			$carDetailsFull.append($carDetailsPalm_TogglerContainer);*/

			if(AE.props.siteCode == "FCR"){
				var $carDetails_SpecsNotesContainer = $( document.createElement( 'div' ) )
				.addClass( 'cardetails-data-togglee' );


            }else{
				var $carDetails_SpecsNotesContainer = $( document.createElement( 'div' ) )
				.addClass( 'cardetails-data-togglee' );
			}

			//WEBAE3-6276 removed APP.props.oTranslations from arguments list in buildSpecs - not needed
			var $carDetails_Specs = $( document.createElement( 'div' ) )
				.addClass( 'cardetails-features fcr_detail-features push-half--bottom' )
				.append( APP.buildSpecs( APP.props.oTranslations.TRANSMISSION[ resultData.transmission ].LBL, APP.props.oTranslations.TRANSMISSION[ resultData.transmission ].FULL, resultData.doors, resultData.passengers, resultData.smLuggage, resultData.mdLuggage, resultData.lgLuggage, resultData.hasAC ) );

			
			$carDetails_SpecsNotesContainer.append( $carDetails_Specs );
				
            // console.log(resultData.zxType);    
			//console.log(resultData);
			//console.log("MatrixResSIPP",resultData.aSIPPNotes);
			//console.log("SIPP_TEXT", AEdata.booking.quote.oLang.SIPPNOTES.PFCANCEL.TEXT)

			if(AE.props.siteCode == 'FCR') {
				// Added to clean out 'RE' from aSIPPNotes
				var $carDetails_SanitizeNotes = $.inArray(resultData.zxType,resultData.aSIPPNotes);
				if ( ~$carDetails_SanitizeNotes ) resultData.aSIPPNotes.splice($carDetails_SanitizeNotes,1);
				
				var $carDetails_Notes = $( document.createElement( 'div' ) )
					.addClass( 'cardetails-sippnotes' )
					.append( APP.buildSippNotes( resultData.aSIPPNotes, '') )
					.append( APP.buildTermsLink( resultData ) );
				
				/*if(APP.props.oQuote.aff !== 'FLIGHTCTRCA') {
				var $carDetails_InsNotes = $( document.createElement( 'div' ) )
					.addClass( 'cardetails-sippnotes' )
					.append( APP.buildSippNotes( '', resultData.zxType) )
					.append( APP.buildTermsLink( resultData ) );
				}*/
			} else if(oSite.bIsDapTpDomain && resultData.isInstantPurchase) {
				var $carDetails_Notes = $( document.createElement( 'div' ) )
                    .addClass( 'cardetails-sippnotes' )
                    .append( APP.buildSippNotes( resultData.aSIPPNotes, resultData.zxType) )
                    .append( APP.buildTermsLink( resultData ) )
                    .append( APP.buildInstantPurchase() );
			} else {
				var $carDetails_Notes = $( document.createElement( 'div' ) )
                    .addClass( 'cardetails-sippnotes' )
                    .append( APP.buildSippNotes( resultData.aSIPPNotes, resultData.zxType) )
                    .append( APP.buildTermsLink( resultData ) );
			}

			// WEBAE3-6253 this is used for all location results in buildLocFingerBlock   
			if(AE.props.siteCode == 'FCR' && resultData.showMultiLoc) {
				termsData = APP.buildTermsLink( resultData );
			}

			$carDetails_SpecsNotesContainer.append( $carDetails_Notes );

			/*if(AE.props.siteCode == 'FCR' && typeof(resultData.zxType) !== 'undefined' && resultData.zxType.length != 0)
				$carDetails_SpecsNotesContainer.append( $carDetails_InsNotes );*/

			$carDetailsFull.append( $carDetails_SpecsNotesContainer );

			$carDetailsGrid.append( $carDetailsFull );

			if(AE.props.siteCode == 'FCR') {
				$carDetailsImgBlock.append( $carDetailsPalm )
				.append( $carDetailsImage );
				$carDetailsGrid.append( $carDetailsImgBlock );

				var $fcrPalmTermsLink = $( document.createElement( 'div' ) );
				$fcrPalmTermsLink.addClass('fcr_mobile-termslink');
				$fcrPalmTermsLink.append( APP.buildTermsLink( resultData ) );
				$carDetailsFull.append( $fcrPalmTermsLink );

			}

			

			$carDetailsContainer.append( $carDetailsGrid );

			$resultContentGrid.append( $carDetailsContainer );

			var $rateFingersContainer = $( document.createElement( 'div' ) ).addClass( 'rate_container fcr-rate_container grid__item one-third palm-one-whole' );

			if ( resultData.showMultiLoc ) {
				var puLocs = _.pluck(_.filter(AEdata.booking.quote.oLocs,function(tempLoc){
					return _.contains(tempLoc.aCars,resultData.ID) && tempLoc.isPU && tempLoc.puStatus === 'O';
				}),'ID');
				if(false && puLocs.length === 1){// WEBAE3-1066 - NW - disable this as it is confusing - 3/9/2018
					puLocs =  _.pluck(_.filter(AEdata.booking.quote.oLocs[puLocs[0]].aDOs,function(tempLocID){
						var tempLoc = AEdata.booking.quote.oLocs[tempLocID];
						return tempLoc.isDO && tempLoc.doStatus !== 'C';
					}),'ID');
				}
				var MULTILOCNOTE = APP.props.oTranslations.MULTILOC.replace( '#loccount#', puLocs.length );
				// Invisible container gets all the round trip rate finger blocks
				$rateFingersContainer.append( APP.buildLocFingerBlock( resultData.aStartRatesTrimmed, resultData.ID, MULTILOCNOTE, '', resultData ) );
			} else {
				$rateFingersContainer.append( APP.buildRateFingerBlock( resultData.aRatesTrimmed, false, '', '', undefined, resultData.aTags, '', resultData, false) );
			}

			$resultContentGrid.append( $rateFingersContainer );

			$resultContainer.append( $resultContentGrid );

			if ( resultData.showMultiLoc ) {
				$resultContainer.append( APP.buildMapBlock( resultData.aLocs, resultData.ID ) );
				if ( resultData.needsRoundTrips ) {
					for ( var i = 0; i < resultData.aLocs.length; i++ ) {
							$rateFingersContainer.append( APP.buildRoundTripRateFingerBlock( resultData.ID, resultData.aLocs[ i ] ) );
					}
				}
			}

			$documentFragment.append( $resultContainer );            
			return $documentFragment;
		},
		buildGreenPromoBar: function ( arrPromos ) {
			arrPromos = arrPromos || [];
			var $documentFragment = $( document.createDocumentFragment() );
			if ( arrPromos.length ) {
				var $topPromoContainer = $( document.createElement( 'div' ) )
					.addClass( 'top_promo_container apply-half-rhythm full-bleed' )
					.append( $.trim( APP.props.oTranslations.SPECOFF ) );
				$documentFragment.append( $topPromoContainer );
				for ( var promoIdx = 0; promoIdx < arrPromos.length; promoIdx++ ) {
					$topPromoContainer
							.append( $( document.createElement( 'i' ) ).addClass( 'fa fa-circle' ) )
							.append( $.trim( arrPromos[ promoIdx ][ 1 ].replace( '<br>', ' <i class="fa fa-circle"></i>' ) ) );
				}
			}
			return $documentFragment;
		},
		buildStars: function ( score ) {
			var $documentFragment = $( document.createDocumentFragment() );
			for ( var loopTick = 0, score; loopTick < 5 || score > 0; loopTick++, score-- ) {
				var $loopIcon = $( document.createElement( 'i' ) );
				if ( score >= 0.4 ) {
					if ( score > 0.5 ) {
							$loopIcon.addClass( 'fa fa-star star-rating' );
					} else {
							var $halfStar = $( document.createElement( 'i' ) );
							$halfStar.addClass( 'fa fa-star half off star-rating' );
							$documentFragment.append( $halfStar );
							// $documentFragment.append( ' ' );
							
							$loopIcon.addClass( 'fa fa-star-half star-rating' );
					}
				} else {
					$loopIcon.addClass( 'fa fa-star off star-rating' );
				}
				$documentFragment.append( $loopIcon );
			}
			if (typeof showSupplierRatings !== 'undefined' && !showSupplierRatings) {
				$documentFragment = '';
			}
			return $documentFragment;
		},
		buildSpecs: function ( transmission, transmissionTitle, doors, passengers, smallSuitcases, mediumSuitcases, largeSuitcases, hasAC ) {
			var oLabels = { NUMDOORS: '', NUMPAX: '', SMLUGGAGE: '', MDLUGGAGE: '', LGLUGGAGE: '', AC: 'Air Conditioning ' };
			if ( APP.props && APP.props.oTranslations ) {
				oLabels.NUMDOORS = $.trim( APP.props.oTranslations.NUMDOORS );
				oLabels.NUMPAX = $.trim( APP.props.oTranslations.NUMPAX );
				oLabels.SMLUGGAGE = $.trim( APP.props.oTranslations.SMLUGGAGE );
				oLabels.MDLUGGAGE = $.trim( APP.props.oTranslations.MDLUGGAGE );
				oLabels.LGLUGGAGE = $.trim( APP.props.oTranslations.LGLUGGAGE );
				oLabels.AC = $.trim(APP.props.oTranslations.AIRCOND);
			}

				

			var $documentFragment = $( document.createDocumentFragment() );
			// if ( $.trim( transmission ).length ) {
			// 	var $tranSpan = $( document.createElement( 'span' ) )
			// 		.attr( 'title', AE.ui.decodeHtml( transmissionTitle ) )
			// 		.addClass( 'transmission' )
			// 		.append( $.trim( transmission ) );
			// 		if(AE.props.siteCode == 'FCR') {
			// 			// $tranSpan.prepend($( document.createElement( 'i' ) ).addClass( 'fa fa-car' ))
			// 			$tranSpan.prepend($( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/transmission.svg' ).addClass( 'fcr-transmission-icon' ));

			// 		}
			// 	$documentFragment.append( $tranSpan );
			// }
			// if ( $.isNumeric( doors ) && doors > 0 ) {
			// 	var $doorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door.png' ).addClass( 'trulyhidden--print' );
			// 	var $printDoorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door_reverse.png' ).addClass( 'print--only' );
			// 	var $doorSpan = $( document.createElement( 'span' ) )
			// 		.attr( 'title', doors + ' ' + oLabels.NUMDOORS )
			// 		.append( $doorImg )
			// 		.append( $printDoorImg )
			// 		.append( ' ' + doors );
			// 		if(AE.props.siteCode == 'FCR') {
			// 			$doorSpan.append( ' ' + oLabels.NUMDOORS );
			// 		}
			// 	$documentFragment.append( ' ' );
			// 	$documentFragment.append( $doorSpan );
			// }
			// if ( ( $.isNumeric( passengers ) && passengers > 0 ) || ( !( $.isNumeric( passengers ) ) && ( passengers.length ) ) ) {
			// 	var $paxIcon = $( document.createElement( 'i' ) ).addClass( 'fa fa-user fa-inverse' );
			// 	var $paxSpan = $( document.createElement( 'span' ) )
			// 		.attr( 'title', passengers + ' ' + oLabels.NUMPAX )
			// 		.append( $paxIcon )
			// 		.append( ' ' + passengers );
			// 		if(AE.props.siteCode == 'FCR') {
			// 			$paxSpan.append( ' ' + oLabels.NUMPAX );
			// 		}
			// 	$documentFragment.append( ' ' );
			// 	$documentFragment.append( $paxSpan );
			// }

			if(AE.props.siteCode == 'FCR') {
				if ( $.trim( transmission ).length ) {
					var $tranSpanDesk = $( document.createElement( 'span' ) )
						.attr( 'title', AE.ui.decodeHtml( transmissionTitle ) )
						.addClass( 'transmission  car_detail_span_desk' )
						.append( $.trim( transmission ) );
						$tranSpanDesk.prepend($( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/transmission.svg' ).addClass( 'fcr-transmission-icon' ));

					var $tranSpanPalm = $( document.createElement( 'span' ) )
						.attr( 'title', AE.ui.decodeHtml( transmissionTitle ) )
						.addClass( 'transmission car_detail_span_palm' )
						.append( $.trim( transmission[0] ) );
						$tranSpanPalm.prepend($( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/transmission.svg' ).addClass( 'fcr-transmission-icon' ));

					$documentFragment.append($tranSpanPalm);
					$documentFragment.append($tranSpanDesk );
				}
				if ( $.isNumeric( doors ) && doors > 0 ) {
					var $doorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door.png' ).addClass( 'trulyhidden--print' );
					var $printDoorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door_reverse.png' ).addClass( 'print--only' );
					var $doorSpanDesk = $( document.createElement( 'span' ) )
						.attr( 'title', doors + ' ' + oLabels.NUMDOORS )
						.addClass('car_detail_span_desk')
						.append( $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door.png' ).addClass( 'trulyhidden--print' ) )
						.append( $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door_reverse.png' ).addClass( 'print--only' ) )
						.append( ' ' + doors )
						.append( ' ' + oLabels.NUMDOORS );

					var $doorSpanPalm = $( document.createElement( 'span' ) )
						.attr( 'title', doors + ' ' + oLabels.NUMDOORS )
						.addClass('car_detail_span_palm')
						.append( $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door.png' ).addClass( 'trulyhidden--print' ) )
						.append( $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door_reverse.png' ).addClass( 'print--only' ) )
						.append( ' ' + doors )

					$documentFragment.append( ' ' );
					$documentFragment.append( $doorSpanDesk );
					$documentFragment.append( $doorSpanPalm );
				}
				if ( ( $.isNumeric( passengers ) && passengers > 0 ) || ( !( $.isNumeric( passengers ) ) && ( passengers.length ) ) ) {
					var $paxIcon = $( document.createElement( 'i' ) ).addClass( 'fa fa-user fa-inverse' );
					var $paxSpanDesk = $( document.createElement( 'span' ) )
						.attr( 'title', passengers + ' ' + oLabels.NUMPAX )
						.addClass('car_detail_span_desk')
						.append($( document.createElement( 'i' ) ).addClass( 'fa fa-user fa-inverse' ))
						.append( ' ' + passengers )
						.append( ' ' + oLabels.NUMPAX );

					var $paxSpanPalm = $( document.createElement( 'span' ) )
						.attr( 'title', passengers + ' ' + oLabels.NUMPAX )
						.addClass('car_detail_span_palm')
						.append($( document.createElement( 'i' ) ).addClass( 'fa fa-user fa-inverse' ))
						.append( ' ' + passengers )
					$documentFragment.append( ' ' );
					$documentFragment.append( $paxSpanDesk );
					$documentFragment.append( $paxSpanPalm );
				}
				if ( smallSuitcases > 0 || mediumSuitcases > 0 || largeSuitcases > 0 ) {
					// var $bagIcon = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/suitcase.svg' ).addClass( 'print--only' );

					// generate title attribute value
					var luggageTitle = '';
					if(smallSuitcases > 0) {
						luggageTitle = smallSuitcases + ' ' + oLabels.SMLUGGAGE;
					}
					if(mediumSuitcases > 0) {
						if ( luggageTitle !== '') {
							luggageTitle = luggageTitle + ', ';
						}
						luggageTitle = luggageTitle + mediumSuitcases + ' ' + oLabels.MDLUGGAGE;
					}
					if(largeSuitcases > 0) {
						if ( luggageTitle !== '') {
							luggageTitle = luggageTitle + ', ';
						}
						luggageTitle = luggageTitle + largeSuitcases + ' ' + oLabels.LGLUGGAGE;
					}
					luggageTitle = luggageTitle + ' luggage';
					
					var $bagSpanDesk = $( document.createElement( 'span' ) )
					.attr( 'title', luggageTitle )
					.addClass('car_detail_span_desk')
					.append($( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/suitcase.svg' ).addClass( 'print--only' ))
					if(smallSuitcases > 0) {
						$bagSpanDesk.append(smallSuitcases + ' ' + oLabels.SMLUGGAGE );
						if(mediumSuitcases > 0 || largeSuitcases > 0 ) {
							$bagSpanDesk.append(', ')
						}
					}
					if(mediumSuitcases > 0) {
						$bagSpanDesk.append(mediumSuitcases + ' ' + oLabels.MDLUGGAGE );
						if(largeSuitcases > 0 ) {
							$bagSpanDesk.append(', ')
						}
					}
					if(largeSuitcases > 0) {
						$bagSpanDesk.append(largeSuitcases + ' ' + oLabels.LGLUGGAGE );
					}

					var $bagSpanPalm = $( document.createElement( 'span' ) )
					.attr( 'title', luggageTitle )
					.append($( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/suitcase.svg' ).addClass( 'print--only' ))
					.addClass('car_detail_span_palm')
					if(smallSuitcases > 0) {
						$bagSpanPalm.append(smallSuitcases + ' ' + oLabels.SMLUGGAGE);
						if(mediumSuitcases > 0 || largeSuitcases > 0 ) {
							$bagSpanPalm.append(', ')
						}
					}
					if(mediumSuitcases > 0) {
						$bagSpanPalm.append(mediumSuitcases + ' ' + oLabels.MDLUGGAGE);
						if(largeSuitcases > 0 ) {
							$bagSpanPalm.append(', ')
						}
					}
					if(largeSuitcases > 0) {
						$bagSpanPalm.append(largeSuitcases + ' ' + oLabels.LGLUGGAGE);
					}

					var $luggageSpan = $( document.createElement( 'span' ) ).addClass('car_detail_span_desk').append( ' luggage' )

					$bagSpanDesk.append($luggageSpan)
					$documentFragment.append( ' ' );
					$documentFragment.append( $bagSpanDesk );
					$documentFragment.append( $bagSpanPalm );

				}

				if ( hasAC === true || hasAC === 'YES') {
					var $acSpanDesk = $( document.createElement( 'span' ) )
						.attr( 'title', oLabels.AC )
						.addClass('car_detail_span_desk')
						.append($( document.createElement( 'i' ) ).addClass( 'fa fa-snowflake fa-inverse cardetail-fa-lg' ))
						.append( ' ' + oLabels.AC );
						

					var $acSpanPalm = $( document.createElement( 'span' ) )
						.attr( 'title', oLabels.AC )
						.addClass('car_detail_span_palm')
						.append($( document.createElement( 'i' ) ).addClass( 'fa fa-snowflake fa-inverse cardetail-fa-lg' ))
						.append( ' AC');
						
					$documentFragment.append( ' ' );
					$documentFragment.append( $acSpanDesk );
					$documentFragment.append( $acSpanPalm );
				}

			} else if(AE.props.siteCode == 'DAU' || AE.props.siteCode == 'DNZ' || AE.props.siteCode == 'DAP') {
                var iconPath = '/'+AE.props.siteCode+'/themes/'+AE.props.siteCode+'1/images/ico';
                
				if ( $.trim( transmission ).length ) {
					var $tranSpan = $( document.createElement( 'span' ) )
						.attr( 'title', AE.ui.decodeHtml( transmissionTitle ) )
						.addClass( 'transmission' )
						.append( $.trim( transmission ) );
					$documentFragment.append( $tranSpan );
				}
				if ( $.isNumeric( doors ) && doors > 0 ) {
                    var ds = doors > 1 ? 's' : '';
                    var $doorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( iconPath ) + '/door-icon.png' );
                    var $doorSpan = $( document.createElement( 'span' ) )
                        .attr( 'title', doors + ' ' + oLabels.NUMDOORS + ds )
                        .append( $doorImg )
                        .append( ' ' + doors );
                    $documentFragment.append( ' ' );
                    $documentFragment.append( $doorSpan );
                }
                if ( ( $.isNumeric( passengers ) && passengers > 0 ) || ( !( $.isNumeric( passengers ) ) && ( passengers.length ) ) ) {
                    var $paxImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( iconPath ) + '/person-icon.png' );
                    var $paxSpan = $( document.createElement( 'span' ) )
                        .attr( 'title', passengers + ' ' + oLabels.NUMPAX )
                        .append( $paxImg )
                        .append( ' ' + passengers );
                    $documentFragment.append( ' ' );
                    $documentFragment.append( $paxSpan );
                }
				if ( $.isNumeric( smallSuitcases ) && smallSuitcases > 0 ) {
                    var sms = smallSuitcases > 1 ? 's' : '';
                    var $smBagImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( iconPath ) + '/S-luggage-icon.png' );
					var $smBagSpan = $( document.createElement( 'span' ) )
						.attr( 'title', smallSuitcases + ' ' + oLabels.SMLUGGAGE + sms )
                        .append( $smBagImg )
						.append( ' ' + smallSuitcases );
					
					$documentFragment.append( ' ' );
					$documentFragment.append( $smBagSpan );
				}
				if ( $.isNumeric( mediumSuitcases ) && mediumSuitcases > 0 ) {
                    var ms = mediumSuitcases > 1 ? 's' : '';
                    var $mdBagImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( iconPath ) + '/M-luggage-icon.png' );
					var $mdBagSpan = $( document.createElement( 'span' ) )
						.attr( 'title', mediumSuitcases + ' ' + oLabels.MDLUGGAGE + ms )
						.append( $mdBagImg )
						.append( ' ' + mediumSuitcases );
                        
					$documentFragment.append( ' ' );
					$documentFragment.append( $mdBagSpan );
				}
				if ( $.isNumeric( largeSuitcases ) && largeSuitcases > 0 ) {
                    var ls = largeSuitcases > 1 ? 's' : '';
                    var $lgBagImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( iconPath ) + '/L-luggage-icon.png' );
					var $lgBagSpan = $( document.createElement( 'span' ) )
						.attr( 'title', largeSuitcases + ' ' + oLabels.LGLUGGAGE + ls )
						.append( $lgBagImg )
						.append( ' ' + largeSuitcases );
                        
					$documentFragment.append( ' ' );
					$documentFragment.append( $lgBagSpan );
				}

				if ( hasAC === true || hasAC === 'YES') {
                    var $acImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( iconPath ) + '/snow-icon.png' );
					var $acSpan = $( document.createElement( 'span' ) )
						.attr( 'title', oLabels.AC )
						.append( $acImg )
	
					$documentFragment.append( ' ' );
					$documentFragment.append( $acSpan );
				}
            }else{
				if ( $.trim( transmission ).length ) {
					var $tranSpan = $( document.createElement( 'span' ) )
						.attr( 'title', AE.ui.decodeHtml( transmissionTitle ) )
						.addClass( 'transmission' )
						.append( $.trim( transmission ) );
						if(AE.props.siteCode == 'FCR') {
							// $tranSpan.prepend($( document.createElement( 'i' ) ).addClass( 'fa fa-car' ))
							$tranSpan.prepend($( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/transmission.svg' ).addClass( 'fcr-transmission-icon' ));
	
						}
					$documentFragment.append( $tranSpan );
				}
				if ( $.isNumeric( doors ) && doors > 0 ) {
                    var $doorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door.png' ).addClass( 'trulyhidden--print' );
                    var $printDoorImg = $( document.createElement( 'img' ) ).attr( 'src', $.trim( AE.props.muraThemePath ) + '/images/ico/door_reverse.png' ).addClass( 'print--only' );
                    var $doorSpan = $( document.createElement( 'span' ) )
                        .attr( 'title', doors + ' ' + oLabels.NUMDOORS )
                        .append( $doorImg )
                        .append( $printDoorImg )
                        .append( ' ' + doors );
                        if(AE.props.siteCode == 'FCR') {
                            $doorSpan.append( ' ' + oLabels.NUMDOORS );
                        }
                    $documentFragment.append( ' ' );
                    $documentFragment.append( $doorSpan );
                }
                if ( ( $.isNumeric( passengers ) && passengers > 0 ) || ( !( $.isNumeric( passengers ) ) && ( passengers.length ) ) ) {
                    var $paxIcon = $( document.createElement( 'i' ) ).addClass( 'fa fa-user fa-inverse' );
                    var $paxSpan = $( document.createElement( 'span' ) )
                        .attr( 'title', passengers + ' ' + oLabels.NUMPAX )
                        .append( $paxIcon )
                        .append( ' ' + passengers );
                        if(AE.props.siteCode == 'FCR') {
                            $paxSpan.append( ' ' + oLabels.NUMPAX );
                        }
                    $documentFragment.append( ' ' );
                    $documentFragment.append( $paxSpan );
                }
				if ( $.isNumeric( smallSuitcases ) && smallSuitcases > 0 ) {
					var $smBagIcon = $( document.createElement( 'i' ) ).addClass( 'fas fa-briefcase fa-inverse' );
					var $smBagSpan = $( document.createElement( 'span' ) )
						.attr( 'title', smallSuitcases + ' ' + oLabels.SMLUGGAGE )
						.append( $smBagIcon )
						.append( ' ' + smallSuitcases );
						if(AE.props.siteCode == 'FCR') {
							$smBagSpan.append( ' ' + oLabels.SMLUGGAGE );
						}
					
					$documentFragment.append( ' ' );
					$documentFragment.append( $smBagSpan );
				}
				if ( $.isNumeric( mediumSuitcases ) && mediumSuitcases > 0 ) {
					var $mdBagIcon = $( document.createElement( 'i' ) ).addClass( 'fa fa-suitcase fa-inverse' );
					var $mdBagSpan = $( document.createElement( 'span' ) )
						.attr( 'title', mediumSuitcases + ' ' + oLabels.MDLUGGAGE )
						.append( $mdBagIcon )
						.append( ' ' + mediumSuitcases );
						if(AE.props.siteCode == 'FCR') {
							$mdBagSpan.append( ' ' + oLabels.MDLUGGAGE );
						}
					$documentFragment.append( ' ' );
					$documentFragment.append( $mdBagSpan );
				}
				if ( $.isNumeric( largeSuitcases ) && largeSuitcases > 0 ) {
					var $lgBagIcon = $( document.createElement( 'i' ) ).addClass( 'fa fa-suitcase fa-inverse cardetail-fa-lg' );
					var $lgBagSpan = $( document.createElement( 'span' ) )
						.attr( 'title', largeSuitcases + ' ' + oLabels.LGLUGGAGE )
						.append( $lgBagIcon )
						.append( ' ' + largeSuitcases );
						if(AE.props.siteCode == 'FCR') {
							$lgBagSpan.append( ' ' + oLabels.LGLUGGAGE );
							
						}
					$documentFragment.append( ' ' );
					$documentFragment.append( $lgBagSpan );
				}

				if ( hasAC === true || hasAC === 'YES') {
					var $acIcon = $( document.createElement( 'i' ) ).addClass( 'fa fa-snowflake fa-inverse cardetail-fa-lg' );
					var $acSpan = $( document.createElement( 'span' ) )
						.attr( 'title', oLabels.AC )
						.append( $acIcon )
						if(AE.props.siteCode == 'FCR') {
							$acSpan.append( ' ' + oLabels.AC )
						}
	
					$documentFragment.append( ' ' );
					$documentFragment.append( $acSpan );
				}
			}

			return $documentFragment;
		},
		buildSippNotes: function ( noteIDArray, zxType ) {
			noteIDArray = noteIDArray || [];
			var notesArray = [];
			var usedNotes  = [];
			var noteLibrary = ( APP.props && APP.props.oTranslations ) ? APP.props.oTranslations.SIPPNOTES : {};
			
			if(noteLibrary === undefined) noteLibrary = {};
			for ( var j = 0; j < noteIDArray.length; j++ ) {
				if ( noteLibrary.hasOwnProperty(noteIDArray[ j ]) ) notesArray.push( noteLibrary[ noteIDArray[ j ] ] );
			}
			var $documentFragment = $( document.createDocumentFragment() );
			if (AE.props.siteCode == 'FCR' && typeof(zxType) !== 'undefined' && zxType.length != 0) {
				var insurancePackage = APP.props.oTranslations.INSURANCES[ zxType ].TITLE;
				notesArray.push({"SYMBOL": "fa fa-chevron-right", "TEXT": insurancePackage});
			}
			for ( var i = 0; i < notesArray.length; i++ ) {
				var validSippNote = false;
				var $noteDiv = $( document.createElement( 'div' ) );
				//WEBAE3-4905 -- Added style property to bookingVocabulary to pass a class foreach
				$noteDiv.addClass(notesArray[ i ].STYLE);
				if ( typeof notesArray[ i ].CLASS !== 'undefined' ) $noteDiv.addClass( $.trim( notesArray[ i ].CLASS ) );
				var $noteFragment = $( document.createDocumentFragment() );
				var $noteIcon = $( document.createElement( 'i' ) );

				if ( typeof notesArray[ i ].SYMBOL !== 'undefined' && $.trim( notesArray[ i ].SYMBOL ).length > 0 ) {
					$.trim( $noteIcon.addClass( notesArray[ i ].SYMBOL ) );
				} else {
					$noteIcon.addClass( 'fa fa-chevron-right' );
				}

				if ( typeof notesArray[ i ].IMAGE !== 'undefined' ) {
					var $noteImage = $( document.createElement( 'img' ) );
					$noteImage.addClass('filter-color');
					$noteImage.attr( 'src', $.trim( notesArray[ i ].IMAGE ) );
					$noteFragment.append( $noteImage );
				} else {
					$noteFragment.append( $noteIcon );
				}

				if ( typeof notesArray[ i ].TEXT !== 'undefined' ) {
					$noteFragment.append( ' ' + $.trim( notesArray[ i ].TEXT ) );
					validSippNote = true;
				} else {
					if ( notesArray[ i ] === null || typeof notesArray[ i ] !== 'object' ) {
							$noteFragment.append( ' ' + $.trim( notesArray[ i ] ) );
							validSippNote = true;
					}
				}

				if ( typeof notesArray[ i ].URL !== 'undefined' ) {
					var $noteLink = $( document.createElement( 'a' ) );
					$noteLink.attr( 'href', $.trim( notesArray[ i ].URL ) );
					$noteLink.attr( 'target', '_new' );
					$noteLink.append( $noteFragment );
					$noteDiv.append( $noteLink );
				} else {
					$noteDiv.append( $noteFragment );
				}

				if ( typeof notesArray[ i ].ARRATTRIBUTES !== 'undefined' && typeof notesArray[ i ].STATTRIBUTES !== 'undefined' ) {
					for ( var attrIdx = 0; attrIdx < notesArray[ i ].ARRATTRIBUTES.length; attrIdx++ ) {
							var thisAttr = notesArray[ i ].ARRATTRIBUTES[ attrIdx ];
							$noteDiv.attr( thisAttr, notesArray[ i ].STATTRIBUTES[ thisAttr ] );
					}
				}

				if(AE.props.siteCode == 'FCR' && validSippNote) {
					//console.log(noteIDArray);
					//var fingerData = APP.props.oRateFingers[ fingerID ];
					//console.log(fingerData.package);
					if (i !== (notesArray.length - 1)) {
						$noteDiv = $.trim( notesArray[ i ].TEXT + ',&nbsp;' );
					} else {
						$noteDiv = $.trim( notesArray[ i ].TEXT );
					}
					
                    if(!usedNotes.includes(notesArray[ i ].TEXT.toLowerCase())) {
                        $documentFragment.append( $noteDiv );
                        usedNotes.push(notesArray[ i ].TEXT.toLowerCase());
                    }
				} else{
					if(validSippNote && !usedNotes.includes(notesArray[ i ].TEXT.toLowerCase())) {
                        $documentFragment.append( $noteDiv );
                        usedNotes.push(notesArray[ i ].TEXT.toLowerCase());
                    }
				}
			}
			return $documentFragment;
		},
		//WEBAE3-4586 This function will generate the data attr content needed to fire a redbook terms call
		cloneExtendTNC: function ( resultData ) {
			resultData = resultData || {};
			var oTnC = _.extend( _.clone( APP.props.oTranslations.TNC_DIALOG ), {
				CARNAME: resultData.iName || '',
				CARCLASS: APP.props.oTranslations.CLASSLABELS[ 'LABEL_' + resultData.catKey ] || '',
				OPERATORDISPLAYNAME: APP.props.oSuppliers[ resultData.suppID ].name || '',
				ZTITLE: ( resultData.zxType !== '' ) ? APP.props.oTranslations.INSURANCES[ resultData.zxType ].TITLE : ''
			} );

			if ( APP.props.oTranslations.usePostpositiveAdjectives ) {
				oTnC.CARCLASS = APP.props.oTranslations.CLASS_TXT + ' ' + oTnC.CARCLASS;
			} else {
				oTnC.CARCLASS += ' ' + APP.props.oTranslations.CLASS_TXT;
			}

			return oTnC;
		},
		buildTermsLink: function ( resultData ) {
			//WEBAE3-4586 No rate details get built for this feature
			if (AE.props.useWEBAE3_4586)
				return;

			resultData = resultData || {};
			var oTnC = _.extend( _.clone( APP.props.oTranslations.TNC_DIALOG ), {
				CARNAME: resultData.iName || '',
				CARCLASS: APP.props.oTranslations.CLASSLABELS[ 'LABEL_' + resultData.catKey ] || '',
				OPERATORDISPLAYNAME: APP.props.oSuppliers[ resultData.suppID ].name || '',
				ZTITLE: ( resultData.zxType !== '' ) ? APP.props.oTranslations.INSURANCES[ resultData.zxType ].TITLE : ''
			} );
		
			if ( APP.props.oTranslations.usePostpositiveAdjectives ) {
				oTnC.CARCLASS = APP.props.oTranslations.CLASS_TXT + ' ' + oTnC.CARCLASS;
			} else {
				oTnC.CARCLASS += ' ' + APP.props.oTranslations.CLASS_TXT;
			}
			var $df = $( document.createDocumentFragment() );
			var $linkDiv = $( document.createElement( 'div' ) )
				.addClass( 'text--primary car-terms' )
				.append( $( document.createElement( 'i' ) ).addClass( 'fa fa-plus' ) )
				.append( APP.props.oTranslations.TERMSLINK )
				.attr( 'DATA-CAR-TERMS', encodeURIComponent( JSON.stringify( oTnC ) ) );
			$df.append( $linkDiv );
			return $df;
		},
        buildInstantPurchase: function() {
            // Add Instant Purchase label on select vehicles (DAP)
            var $df = $( document.createDocumentFragment() );
            var $instantPurchase = $( document.createElement( 'div' ) )
				.addClass( 'instant-purchase-label' )
                .append( $( document.createElement( 'i' ) ).addClass( 'fa fa-dollar-sign' ) )
                .append( 'Instant Purchase' );
            $df.append( $instantPurchase );
            return $df;
        },
		getDefaultDropoffID: function ( locID ) {
			locID = locID || _.first( _.keys( APP.props.oLocations ) );
			if ( APP.props.oLocations[ locID ] ) {
				// Check for multiple locations otherwise split function will throw and typeError if is only one
				var aQuoteDOs = _.pluck(_.filter(AEdata.booking.quote.oLocs,function(loc){
					return loc.doStatus !== 'C' && loc.isDO
				}),'ID');
				var aDOLocList = (typeof(AEdata.booking.quote.oQuote.oDO.locList) === 'string')? AEdata.booking.quote.oQuote.oDO.locList.split(',') : [AEdata.booking.quote.oQuote.oDO.locList.toString()];
				var aDOs = _.intersection(aQuoteDOs,APP.props.oLocations[ locID ].aDOs);
				var aSuppMatchDOs = _.filter(aDOs,function(tempLocID){
					return APP.props.oLocations[ locID ].suppCode === APP.props.oLocations[ tempLocID ].suppCode;
				});
				if(aSuppMatchDOs.length){
					if(_.without(aSuppMatchDOs,locID).length){
						aDOs = aSuppMatchDOs;
					}
				}
				if(!APP.props.oLocations[ locID ].lxStatus){
					var aLxMatchDOs = _.filter(aDOs,function(tempLocID){
						return !APP.props.oLocations[ tempLocID ].lxStatus;
					});
					if(aLxMatchDOs.length){
						if(_.without(aLxMatchDOs,locID).length){
							aDOs = aLxMatchDOs;
						}
					}
				}
				aDOs = _.filter(aDOs,function(tempLocID){
					return _.contains(aDOLocList,Number(tempLocID).toString());
				});
				var defID = ( _.contains( aDOs, locID ) && !APP.props.isMapOneway ) ? locID : _.first( _.without( aDOs, locID ) );
				var sameLocType = (defID !== undefined && AEdata.booking.quote.oLocs[locID].type === AEdata.booking.quote.oLocs[defID].type)? true : false;
				var sameSearchLocType = AEdata.booking.quote.oQuote.oPU.deskType === AEdata.booking.quote.oQuote.oDO.deskType;
				if(!sameSearchLocType){
					var aVariantAirportCheck = _.union(
						['AIRPORT','AIRPORT_TERMINAL--ITEM'],
						[AEdata.booking.quote.oQuote.oPU.deskType, AEdata.booking.quote.oQuote.oDO.deskType]
					);
					if(aVariantAirportCheck.length === 2){
						sameSearchLocType = true;
					}
					if(AEdata.booking.quote.oQuote.oDO.deskType === 'CITY' && APP.props.isAllLocation){
						sameSearchLocType = true;
					}
				}
				if((defID === locID || sameLocType) && !sameSearchLocType){
					var filterType = (
						AEdata.booking.quote.oQuote.oDO.deskType === 'AIRPORT' || 
						AEdata.booking.quote.oQuote.oDO.deskType === 'AIRPORT_TERMINAL--ITEM'
					)? 'A' : 'O';
					if(AEdata.booking.quote.oQuote.oDO.deskType === 'RAIL') filterType = 'R';
					if(AEdata.booking.quote.oQuote.oDO.deskType === 'CITY') filterType = 'D';
					defID = _.first(_.filter(_.without( aDOs, locID ),function(tempLocID){return AEdata.booking.quote.oLocs[tempLocID].type === filterType} ));
				}
				if(AEdata.booking.quote.oQuote.oPU.deskType === AEdata.booking.quote.oQuote.oDO.deskType){
					if(AEdata.booking.quote.oQuote.oPU.name !== AEdata.booking.quote.oQuote.oDO.name){
						if(AEdata.booking.quote.oLocs[defID] && AEdata.booking.quote.oLocs[locID]){
							if(AEdata.booking.quote.oLocs[defID].IATA === AEdata.booking.quote.oLocs[locID].IATA){
								var aDifferentIATADOs = _.filter(aDOs,function(tempID){
									return AEdata.booking.quote.oLocs[tempID].IATA !== AEdata.booking.quote.oLocs[locID].IATA;
								});
								defID = _.first(aDifferentIATADOs);
							}
						}
					}
				}
			}
			return (APP.props.oLocations[defID] !== undefined) ? defID : locID;
		},
		buildRateFinger: function ( fingerID, doLocID, rateCount, commonTagID, termsLinkData) {		
			//WEBAE3-4721 Added fingerCount attribute to make sure all fingers have unique ids
			var fingerCount = APP.props.buildRateFingersCount++;//WEBAE3-4721 - used to make sure cancel ins checkbox IDs are unique
			let offerCancelInsurance = AEdata.booking.quote.oQuote.oRules.oCancelIns.OFFER;
			commonTagID = commonTagID || '';
			var fingerData = APP.props.oRateFingers[ fingerID ];
			var supplierData = AEdata.booking.quote.oSupps[fingerData.suppID];
			//WEBAE3-6268 - All location 1-ways - Update rate associated with yellow rate finger to come from the AE_Details response
			var oRateChangeDetails = APP.props.oRateChangeDetails[ fingerID ][ doLocID ];
			//WEBAE3-6426 add check for oSite.addFeesToRate because this doesn't apply if not showing full cost
			if (!_.isEmpty( APP.props.oRateChangeDetails[ fingerID ][ doLocID ] ) 
				&& ( oRateChangeDetails.oEvent && oRateChangeDetails.oDialog && oRateChangeDetails.oDialog.showDialog && ( oRateChangeDetails.oDialog.dropfee || oRateChangeDetails.oDialog.rate ) )  
				&& AEdata.booking.quote.oCars[fingerData.carID].showMultiLoc
				&& oSite.addFeesToRate===true){
				var rateTypeObject = 'o'+fingerID.substring(0,2);
				if (rateTypeObject == 'oIZ') {
					var rateTypeObject = 'oII';
				}
				Object.assign(fingerData.oOW, oRateChangeDetails.oOW);
				if (AE.props.siteCode == 'FCR') {
					fingerData.rate = oRateChangeDetails.oOW.RATE;
					fingerData.estimate = oRateChangeDetails.oOW.RATE;
				} else {
					fingerData.rate = oRateChangeDetails[rateTypeObject].rate;
					fingerData.estimate = oRateChangeDetails[rateTypeObject].estimate;
					//WEBAE3-6366 update cancel insurance cost
					fingerData.cancelCost =  Number(oRateChangeDetails[rateTypeObject].cancelCost);
					fingerData.cancelCostCurr =  oRateChangeDetails[rateTypeObject].cancelCostCurr;
					fingerData.cancelRetail =  oRateChangeDetails[rateTypeObject].cancelRetail.toFixed(2);
				}
			}
			var fingerPackage = fingerData.package;
			if(!APP.props.oTranslations.INSURANCES.hasOwnProperty(fingerPackage)) fingerPackage = 'basic';
			var defaultDO = APP.getDefaultDropoffID( fingerData.locID );
			doLocID = doLocID || defaultDO;
			if ( !APP.props.oLocations[ doLocID ] && doLocID !== defaultDO ) doLocID = defaultDO;
			var $documentFragment = $( document.createDocumentFragment() );
			if ( fingerData.tagID !== undefined && fingerData.tagID !== "" && fingerData.tagID !== '' && fingerData.tagID !== commonTagID && (rateCount == 0
			|| !_.contains( APP.props.oResults[ fingerData.carID ].aTags, fingerData.tagID ))
			) {
				var $rateFingerPromoBar = $( document.createElement( 'div' ) );
				$rateFingerPromoBar.addClass( 'package_promo_bar bg--primary inverse remove-rhythm' );
				var $rateFingerPromoText = $( document.createElement( 'p' ) ).addClass( 'soft-half flush align-center' );
				var $rateFingerPromoTextMsgDesk = $( document.createElement( 'span' ) ).addClass( 'trulyhidden--palm' );
				$rateFingerPromoTextMsgDesk.append( $.trim( APP.props.oTranslations.carTags[ APP.props.oCarTags[ fingerData.tagID ].message ].message ) );
				$rateFingerPromoText.append( $rateFingerPromoTextMsgDesk );
				var $rateFingerPromoTextMsgPalm = $( document.createElement( 'span' ) ).addClass( 'trulyhidden--lap-and-up' );
				$rateFingerPromoTextMsgPalm.append( $.trim( APP.props.oTranslations.carTags[ APP.props.oCarTags[ fingerData.tagID ].message ].shortMessage ) );
				$rateFingerPromoText.append( $rateFingerPromoTextMsgPalm );
				$rateFingerPromoText.attr('data-tag',fingerData.tagID);
				$rateFingerPromoBar.append( $rateFingerPromoText );
				if ( APP.props.oCarTags[ fingerData.tagID ].hasOwnProperty('bgcolor') ) {
					$rateFingerPromoBar.css( 'backgroundColor', '#' + APP.props.oCarTags[ fingerData.tagID ].bgcolor );
					$rateFingerPromoBar.css( 'borderColor', '#' + APP.props.oCarTags[ fingerData.tagID ].bgcolor );
					$rateFingerPromoBar.css( 'marginTop', '-2px' );
					$rateFingerPromoBar.css( 'paddingTop', '2px' );
				}
				$documentFragment.append( $rateFingerPromoBar );
				

			}
			var $rateFingerContainer = $( document.createElement( 'div' ) );
			$rateFingerContainer.attr( 'id', $.trim( fingerData.ID ) + '-' + doLocID + '-' + fingerCount);
			$rateFingerContainer.addClass( $.trim( fingerData.class ) + ' package_container inverse--light' );
			if(AEdata.booking.quote.oCars[fingerData.carID].showMultiLoc) $rateFingerContainer.addClass('allDowntown_rateFinger');
			$rateFingerContainer.attr( 'data-puloc', $.trim( fingerData.locID ) );
			$rateFingerContainer.attr( 'data-doloc', $.trim( doLocID ) );
			
			
			var $rateFingerToggle = $( document.createElement( 'div' ) );
			$rateFingerToggle.addClass( 'toggle rate_finger_wrapper' );

			var $rateFingerPrice = $( document.createElement( 'div' ) );
			$rateFingerPrice.addClass( 'grid__item one-half lap-one-whole package--half-side' );
			var $rateFingerPricing = $( document.createElement( 'div' ) );
			$rateFingerPricing.addClass( 'package_pricing' );
			if ( fingerData.BEFORESALE > 0 && fingerData.beforeSale > fingerData.rate && !_.contains(['AUS','NZL','GCR'],AEdata.booking.quote.props.siteid )) {
				var $beforeSaleHead = $( document.createElement( 'h6' ) );
				$beforeSaleHead.addClass( 'cardetails-beforesale' );
				$beforeSaleHead.append( $.trim( fingerData.beforeSaleCurr ) );
				$rateFingerPricing.append( $beforeSaleHead );
			}
			var someSortOfOW = ( APP.props.oQuote.oOW.country || APP.props.oQuote.oOW.city || APP.props.oQuote.oOW.locList );
			var displayRate = fingerData.rateCurr;
			if(AE.props.siteCode == 'FCR') {
				var displayRate = fingerData.rate.toFixed(2);
				// console.log("displayRate == ", displayRate)
				// console.log("displayRateNoMath == ", fingerData.rate)
			}
			if(AE.props.addFeesToRate){
				if(typeof(fingerData.estimate) === 'number' && Number(fingerData.estimate) > 0){
					var tempEstimate = Math.abs(Math.round(Number(fingerData.estimate)*100)/100).toFixed(2);
					displayRate = APP.props.oTranslations.CURRENCY_TEMPLATE.replace('.',tempEstimate);
				} else if(fingerData.oOW.APPLYFEE && someSortOfOW){
					displayRate = fingerData.oOW.RATECURR;
				}
			}
			var $rateFingerRate = $( document.createElement( 'h3' ) );
			$rateFingerRate.addClass( 'cardetails-rate' );
			$rateFingerRate.append( $.trim( displayRate ) );
			//WEBAE3-4749 add ID to rate finger for targeting on possible cancel ins click
			$rateFingerRate.attr( 'id', 'dsprate_' + $.trim( fingerData.ID ) + '-' + doLocID + '-' + fingerCount);
			
			if(AE.props.siteCode == 'FCR') {
				$rateFingerRateCurrencyType = $( document.createElement( 'div' ) );
				$rateFingerRateCurrencyType.addClass('fcr-currency-type');
				if (APP.props.oQuote.aff == 'FLIGHTCTRZA') {
					//$rateFingerRateCurrencyType.append('ZAR')
					$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
					$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
					$rateFingerRateCurrencySymbol.append('R')
				} else if (APP.props.oQuote.aff == 'FLIGHTCTRGB') {
					//$rateFingerRateCurrencyType.append('ZAR')
					$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
					$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
					$rateFingerRateCurrencySymbol.append('£')
				} else if (APP.props.oQuote.aff == 'FLIGHTCTRNZ' || AEdata.booking.quote.oAff.code == 'FLIGHTCTRNZ' || window.location.hostname == 'cars.flightcentre.co.nz') {
					$rateFingerRateCurrencyType.append('NZD')
					$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
					$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
					$rateFingerRateCurrencySymbol.append('$')
				} else if (APP.props.oQuote.aff == 'FLIGHTCTRCA' || AEdata.booking.quote.oAff.code == 'FLIGHTCTRCA' || window.location.hostname == 'cars.flightcentre.ca') {
					$rateFingerRateCurrencyType.append('CAD')
					$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
					$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
					$rateFingerRateCurrencySymbol.append('$')
				} else {
					$rateFingerRateCurrencyType.append('AUD')
					$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
					$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol');
					$rateFingerRateCurrencySymbol.append('$')
				}
				
				$rateFingerRate.append($rateFingerRateCurrencyType)
				$rateFingerRate.prepend($rateFingerRateCurrencySymbol)
			}
			$rateFingerPricing.append( $rateFingerRate );
			var $rateFingerRateType = $( document.createElement( 'div' ) );
			$rateFingerRateType.addClass( 'cardetails-ratetype more-info-tip' );
			//WEBAE3-4586 [I]nfo links for rate fingers, modify behavior
			if (AE.props.useWEBAE3_4586) {
				$rateFingerRateType.removeClass('more-info-tip').addClass('car-terms');
				$rateFingerRateType.attr( 'DATA-CAR-TERMS', encodeURIComponent( JSON.stringify( this.cloneExtendTNC(termsLinkData) ) ) );
				$rateFingerRateType.attr( 'DATA-RATE-ID', fingerID );
			}
			//WEBAE3-2196 - add sipp to rate finger for travel partners 
			var fingerTitle = (APP.props.oAff.isTP && APP.props.oAff.isTP == 'Y') ? fingerData.SIPP + ' - ' : '';//|| AE.props.showSipp === true (maybe use this too but tied to other behaviors)
			fingerTitle += $.trim(APP.props.oTranslations.INSURANCES[ fingerPackage ].TITLE );
			$rateFingerRateType.append(fingerTitle);
			if(AEdata.booking.quote.oQuote.system === 'EU'){// WEBAE3-5981
				$rateFingerRateType.addClass('point-to-rate-title').append($('<br/>')).append($('<span/>').addClass('rate-title').append(APP.props.oTranslations.MOREINFO));
			}
			
			var $rateFingerIncludes = $( document.createElement( 'div' ) ).addClass( 'more-info-text' );

			var $rateFingerIncludesHead = $( document.createElement( 'strong' ) ).addClass( 'includes-title' ).append( $.trim( APP.props.oTranslations.INSURANCES[ fingerPackage ].INCLUDES ) );
			$rateFingerIncludes.append( $rateFingerIncludesHead );
			var ARRINSURANCE = APP.props.oTranslations.INSURANCES[ fingerPackage ].ARR || [];
			if(supplierData.isLTR){// WEBAE3-6327 - Use alternative package insurance arrays for lease rates
				if(APP.props.oTranslations.INSURANCES[ fingerPackage ].hasOwnProperty('ARRLTR')){
					ARRINSURANCE = APP.props.oTranslations.INSURANCES[ fingerPackage ].ARRLTR;
				}
			}
			ARRINSURANCE = AE.booking.applyInsuranceIncludeListOverrides(ARRINSURANCE,APP.props.oResults[fingerData.carID].packagesDoInclude);
			for ( var i = 0; i < ARRINSURANCE.length; i++ ) {
				$rateFingerIncludes.append( $( document.createElement( 'br' ) ) ).append( $.trim( ARRINSURANCE[ i ] ) );
			}
			if ( $.trim( fingerData.packageType ) === 'IB' ) {
				$rateFingerIncludes.addClass( 'grid' ).wrapInner( '<div class="grid__item one-half"></div>' );
				$rateFingerIncludes.append( $( document.createElement( 'div' ) ).addClass( 'grid__item one-half soft-half--left' )
					.append( $( document.createElement( 'strong' ) ).append( $.trim( APP.props.oTranslations.STBASICEXCLUSIONS.HEAD ) ) )
					.append( $( document.createElement( 'br' ) ) )
					.append( $.trim( APP.props.oTranslations.STBASICEXCLUSIONS.BODY ) )
				);
			}
			$rateFingerRateType.append( $rateFingerIncludes );
			if( fingerData.oOW.inFees || ((fingerData.oOW.IncludedInRate === 'Y' || fingerData.oOW.INCLUDEDINRATE === 'Y')  || (fingerData.oOW.AMOUNT > 0 && AE.props.addFeesToRate))){// Show One Way Fee Included Message
                // WEBAE3-6099 add prepaid or paid locally to text 
				if(fingerData.oOW.AMOUNT > 0){
					var OWFIncludePaid = (fingerData.oOW.IncludedInRate === 'Y' || fingerData.oOW.INCLUDEDINRATE === 'Y') ? APP.props.oTranslations.OWF_PREPAID : APP.props.oTranslations.OWF_PAID_LOCALLY;
				} else {
					// WEBAE3-6192 - Do not display "prepaid" with "includes one way fee"
					var OWFIncludePaid = (fingerData.oOW.IncludedInRate === 'Y' || fingerData.oOW.INCLUDEDINRATE === 'Y') ? '' : APP.props.oTranslations.OWF_PAID_LOCALLY;
				}
				
				var OWFIncludeAmount = (fingerData.oOW.AMOUNT > 0)? fingerData.oOW.AMOUNTCURR : '';
                
				if(fingerData.oOW.inFees){
					var quoteCurrencyCode = AEdata.booking.quote.oCurrency.QUOTE;
					var baseCurrencyCode = AEdata.booking.quote.oCurrency.BASE;
					var reverseConvert = (quoteCurrencyCode !== baseCurrencyCode)? true : false;
					var doubleConvert = false;
					var baseConversionRate = 1;
					var quoteConversionRate = 1;
					var feeConversionRate = 1;
					if(AEdata.booking.quote.oCurrency[baseCurrencyCode]){
						baseConversionRate = AEdata.booking.quote.oCurrency[baseCurrencyCode].EX2;// EX2 maps to Exch2, EX1 maps to Exch?
					}
					if(AEdata.booking.quote.oCurrency[quoteCurrencyCode]){
						quoteConversionRate = AEdata.booking.quote.oCurrency[quoteCurrencyCode].EX2;// EX2 maps to Exch2, EX1 maps to Exch?
					}
					var oTempOW = _.findWhere(fingerData.aFees,{Purpose:2});
					var convertedAmount = oTempOW.Amount;
					var feeCurrencyCode = oTempOW.CurrencyCode || quoteCurrencyCode;
					if(feeCurrencyCode !== quoteCurrencyCode && AEdata.booking.quote.oCurrency[feeCurrencyCode]){
						feeConversionRate = AEdata.booking.quote.oCurrency[feeCurrencyCode].EX2;
					}
					if(feeCurrencyCode !== quoteCurrencyCode && feeCurrencyCode !== baseCurrencyCode && reverseConvert){
						doubleConvert = true;
					} else if(feeCurrencyCode !== quoteCurrencyCode && reverseConvert){
						feeConversionRate = quoteConversionRate;
					}
					if(doubleConvert){
						convertedAmount = convertedAmount/feeConversionRate;
						convertedAmount = convertedAmount*quoteConversionRate;
					} else {
						convertedAmount = (reverseConvert)? convertedAmount*feeConversionRate : convertedAmount/feeConversionRate;
					}
					convertedAmount = Math.abs(Math.round(convertedAmount*100)/100).toFixed(2);
					OWFIncludeAmount = (convertedAmount > 0)? APP.props.oTranslations.CURRENCY_TEMPLATE.replace('.',convertedAmount) : '';
				}

				// WEBAE3-6192 - Do not display "prepaid" with "includes one way fee"
				if(OWFIncludePaid === ''){
					// this removes the extra space before the [PAID] variable
					var dropFeeTxt = APP.props.oTranslations.LINE.INCLUDES_DROP_FEE.replace(' [PAID]', OWFIncludePaid);
				} else {
					var dropFeeTxt = APP.props.oTranslations.LINE.INCLUDES_DROP_FEE.replace('[PAID]', OWFIncludePaid);
				}
                                
				if (AE.props.siteCode == 'FCR'){
					OWFIncludeAmount = fingerData.oOW.EstimatedInQCurrency.toFixed(2);
					if (AE.props.affiliate == 'FLIGHTCTRZA') {
						var OWFIncludeNote = dropFeeTxt.replace('[FEE]','<span style="font-size: 9px;">R</span>'+OWFIncludeAmount+' ZAR');
					}
					if (AE.props.affiliate == 'FLIGHTCTRGB') {
						var OWFIncludeNote = dropFeeTxt.replace('[FEE]','£'+OWFIncludeAmount+' GBP');
					}
					if (AE.props.affiliate == 'FLIGHTCTRCA' || AEdata.booking.quote.oAff.code == 'FLIGHTCTRCA' || window.location.hostname == 'cars.flightcentre.ca') {
						var OWFIncludeNote = dropFeeTxt.replace('[FEE]','$'+OWFIncludeAmount+' CAD');
					}
					if (AE.props.affiliate == 'FLIGHTCTRNZ' || AEdata.booking.quote.oAff.code == 'FLIGHTCTRNZ' || window.location.hostname == 'cars.flightcentre.co.nz') {
						var OWFIncludeNote = dropFeeTxt.replace('[FEE]','$'+OWFIncludeAmount+' NZD');
					}
					if (AE.props.affiliate == 'FLIGHTCENTREAU') {
						var OWFIncludeNote = dropFeeTxt.replace('[FEE]','$'+OWFIncludeAmount+' AUD');
					}
					//WEBAE3-6334 - FCR: Remove the one way fee amount when the amount is $0
					if(OWFIncludePaid === ''){
						var OWFIncludeNote =dropFeeTxt.replace(' [FEE]', OWFIncludePaid);
					}
				} else {
					var OWFIncludeNote = dropFeeTxt.replace('[FEE]',OWFIncludeAmount);
                    
				}
				if(fingerData.locID !== doLocID) {
                    $rateFingerPricing.append( $( document.createElement( 'p' ) ).addClass('small--note').append(OWFIncludeNote) );
                }
			} else if( (fingerData.oOW.IncludedInRate === 'N' || fingerData.oOW.INCLUDEDINRATE === 'N') && (fingerData.oOW.Prepaid === 'N' || fingerData.oOW.PREPAID === 'N') && fingerData.oOW.v === 0 ){
                /*
                WEBAE3-6215
                    - added this rule
                WEBAE3-6268
                    - check for all caps INCLUDEDINRATE and PREPAID keys too
                    - changed to else if so we avoid potentially showing two notes (Guerin AUS site Lisbon All Locs - Portoi All Locs)
                */
				$rateFingerPricing.append( $( document.createElement( 'p' ) ).addClass('small--note').append(APP.props.oTranslations.INCLUDES_OWF) );
			}
			$rateFingerPricing.append( $rateFingerRateType );
			$rateFingerPrice.append( $rateFingerPricing );
			$rateFingerToggle.append( $rateFingerPrice );

			var $spinnerContainer = $( document.createElement( 'div' ) );
			$spinnerContainer.attr( 'id', 'Spin-' + $.trim( fingerData.ID ) + '-' + doLocID + '-' + fingerCount );
			$spinnerContainer.addClass( 'grid__item one-half visuallyhidden rateFinger__spinner' );
			$rateFingerToggle.append( $spinnerContainer );

			var $rateFingerFormContainer = $( document.createElement( 'div' ) );
			
			$rateFingerFormContainer.addClass( 'button_container grid__item one-half lap-one-whole' );

			var $rateFingerForm = $( document.createElement( 'form' ) );

			$rateFingerForm.attr( 'id', $.trim( fingerData.formID ) + '-' + doLocID + '-' + fingerCount );
			$rateFingerForm.attr( 'name', $.trim( fingerData.formName ) + fingerData.row );
			$rateFingerForm.attr( 'method', 'post' );
			$rateFingerForm.attr( 'action', AE.props.sslDomain + '/' + $.trim( fingerData.carpath ) + '/' );

			var $bookingStepInput = $( document.createElement( 'input' ) );
			$bookingStepInput.attr( 'type', 'hidden' );
			$bookingStepInput.attr( 'name', 'jsonPost' );
			$bookingStepInput.attr( 'value', APP.buildRateFingerButtonValue( fingerData, doLocID ) );
			var $AffiliateInput = $( document.createElement( 'input' ) );
			$AffiliateInput.attr( 'type', 'hidden' );
			$AffiliateInput.attr( 'name', 'aff' );
			$AffiliateInput.attr( 'value', APP.props.oQuote.aff );

			// WEBAE3-4412 add in cancel insurance checkbox if allowed
			// WEBAE3-6276 adjusted test and cancelCost references to use local vars
			if(offerCancelInsurance && fingerData.cancelCost > 0) {

				// WEBAE3-4721 added doLocID and the fingerCount to checkbox IDs to make sure they're unique
				var cancelInputId = 'cancelCostCheckbox_' + $.trim( fingerData.ID ) + '-' + doLocID + '-' + fingerCount;
				
				var $cancelCheckbox = $( document.createElement( 'input' ) );
				$cancelCheckbox.attr( 'type', 'checkbox' );
				$cancelCheckbox.attr( 'name', 'chk_cncl' );
				$cancelCheckbox.attr( 'id', cancelInputId);
				$cancelCheckbox.attr( 'value', 1 );
				$cancelCheckbox.addClass( 'trg__cancelCost-ins--click' );
				//WEBAE3-4749 add data attributes for total cost with and without cancel ins to toggle display price
				//when checked. easier to set this now instead of recalculating finger display cost on bodyclick (too many rules)
				var origTotal =  Number(displayRate.replace(/[^0-9.-]+/g,""));//isolate numeric value of original total
				var cancelTotal = origTotal + Number(fingerData.cancelCost);//add cancel insurance to it
				cancelTotal = cancelTotal.toFixed(2);//trim that funky number
				var cancelTotalCurr = displayRate.replace(origTotal.toFixed(2),cancelTotal); //replace original total with cancel total in currency display
				$cancelCheckbox.attr( 'data-totalorig',$.trim( displayRate ) );
				$cancelCheckbox.attr( 'data-totalcncl',$.trim( cancelTotalCurr ) );				

				// ::NOTE:: want to add in label to hold cancel cost amount display
				var $cancelCheckboxLabel = $( document.createElement( 'label' ) );
				$cancelCheckboxLabel.addClass('fingerCancelLink');//4574 add the class here 
				$cancelCheckboxLabel.attr( 'for', cancelInputId);
				let str = AEdata.booking.quote.oLang.CANCELINS.RATE_FINGER;
				fixedCost = str.replace('#cost#',fingerData.cancelCostCurr);
				$cancelCheckboxLabel.append(innerHTML = fixedCost);
			}

			var $jsonPostInput = $( document.createElement( 'input' ) );
			$jsonPostInput.attr( 'type', 'hidden' );
			$jsonPostInput.attr( 'name', 'bookingstep' );
			$jsonPostInput.attr( 'value', 'getoptions' );
			var $rateFingerButton = $( document.createElement( 'button' ) );
			$rateFingerButton.attr( 'id', $.trim( fingerData.buttonID ) + '-' + doLocID  + '-' + fingerCount);
			$rateFingerButton.attr( 'type', 'submit' );
			$rateFingerButton.attr( 'data-finger-id', $.trim( fingerData.ID ) );
			$rateFingerButton.attr( 'data-dolocid', doLocID );
			$rateFingerButton.attr( 'data-gaarray', ( fingerData.packageType == 'IB' ) ? APP.props.arrBGA : APP.props.arrIGA );
			$rateFingerButton.addClass( 'rateFinger__button btn--primary one-whole' );
			if ( !APP.props.isMapOneway && !APP.props.isAllLocation ) $rateFingerButton.addClass( 'trg__ga--Click' );
			if ( APP.props.oResults[ fingerData.carID ].isLTR ) $rateFingerButton.addClass( 'rateFinger__button--ltr' );
			if ( APP.props.oLocations[ doLocID ].doStatus === 'D' ) $rateFingerButton.addClass( 'rateFinger__button--dropbox' );


// move DOM for WEBA3-4574 ---

// I- wrap $rateFingerForm inside $rateFingerContainer around third col conten that has two columns and move checkbox to third col inside it
// II- $rateFingerToggle inside $rateFingerForm
// III-  $rateFingerFormContainer inside $rateFingerToggle
// IV- move button $rateFingerButton inside $rateFingerFormContainer
// V- add new row for the checkbox to go $thirdRow inside $rateFingerForm
//add icon to checkbox

		var addInfoIcon="<i class='rateIcon fa fa-info-circle text--primary'></i>"


			//button
			$rateFingerButton.append( $.trim( APP.props.oTranslations.BTN_RATEFINGER ) );
			$rateFingerFormContainer.append( $bookingStepInput );
			$rateFingerFormContainer.append( $AffiliateInput );
			$rateFingerFormContainer.append( $rateFingerButton );

			//form
			$rateFingerContainer.append($rateFingerForm);
			$rateFingerForm.append($rateFingerToggle);

			/*add new row*/
			var $thirdRow = $( document.createElement( "div" ) );// this will only show if the conditions are set to display it for now 
			
	if(AEdata.booking.quote.oQuote.oRules.oCancelIns.OFFER && AEdata.booking.quote.oRates[fingerID].cancelCost > 0) {
			//checkbox moved here 
			$rateFingerForm.append( $thirdRow );//this is the greenbox where the checkbox is moved to 
			$thirdRow.addClass( 'bottomRow' );
			$thirdRow.append( $cancelCheckbox );
			$thirdRow.append( $cancelCheckboxLabel );
	
			$thirdRow.append( addInfoIcon );//add icon

		}
			
			$rateFingerToggle.append( $rateFingerFormContainer );

//


//end WEBAE-4574--

			$documentFragment.append( $rateFingerContainer );

			if(AE.props.siteCode == 'FCR' && typeof termsLinkData !== 'undefined') {
				var $fcrDeskTermsLink = $( document.createElement( 'div' ) )
				$fcrDeskTermsLink.addClass( 'fcr_desk-terms-link' );
				$fcrDeskTermsLink.append( APP.buildTermsLink( termsLinkData ) );
				$rateFingerPricing.append( $fcrDeskTermsLink );
			}

			return $documentFragment;
		},
		buildRoundTripRateFingerBlock: function ( resultID, locationID ) {
			var $documentFragment = $( document.createDocumentFragment() );

			if ( APP.props.oResults[ resultID ] !== undefined && APP.props.oLocations[ locationID ] ) {
				var resultData = APP.props.oResults[ resultID ];
				var arrRoundTripFingers = [];

				for ( var i = 0; i < resultData.aRates.length; i++ ) {
					var thisFingerID = resultData.aRates[ i ];
					if ( APP.props.oRateFingers[ thisFingerID ].locID == locationID ) {
							arrRoundTripFingers.push( thisFingerID );
					}
				}
				//WEBAE3-6512 trim ratefingers before building them
				arrRoundTripFingers = APP.trimRateFingers(arrRoundTripFingers);//used for actual rate finger build

				var $thisRoundTripBlock = $( document.createElement( 'div' ) ).addClass( $.trim( locationID ) + ' roundTripBlock ' ); // remove trulyhidden for testing Nate W 2016-05-20
				if ( APP.props.oLocations[ locationID ].doStatus !== 'C' ) {
					$thisRoundTripBlock.append( APP.buildRateFingerBlock( arrRoundTripFingers, true, '', locationID, undefined, resultData.aTags, false, resultData ) );
					$thisRoundTripBlock.children().removeClass( 'allDowntown_rateFinger' );
				} else {
					$thisRoundTripBlock.append( APP.buildAddressBlock( APP.props.oLocations[ locationID ].locName, APP.props.oLocations[ locationID ].cityName, APP.props.oLocations[ locationID ].country, '' ) );
				}
				var $showLocButtonDiv = $( document.createElement( 'div' ) )
					.addClass( 'package_container inverse--light' );

				var $showLocPricingDiv = $( document.createElement( 'div' ) )
					.addClass( 'package_pricing button_container grid__item one-whole flush--top align-right' );

				var $showLocButton = $( document.createElement( 'button' ) )
					.addClass( 'btn--secondary toggler one-whole location_button map_version' )//toggler--manual
					.attr( 'type', 'button' )
					.attr( 'data-togglee', '#' + resultData.ID + ' .location_container' )
					.attr( 'data-resultmapid', resultData.ID )
					.attr( 'data-locid', locationID )
					.append( $.trim( APP.props.oTranslations.BTN_DIFFDROPOFF ) );

				$showLocPricingDiv.append( $showLocButton );

				$showLocButtonDiv.append( $showLocPricingDiv );

				$thisRoundTripBlock.append( $showLocButtonDiv );

				$documentFragment.append( $thisRoundTripBlock );
			}

			return $documentFragment;
		},

		buildRateFingerBlock: function ( fingerIDArray, emailTop, pickupID, dropoffID, emptyText, commonTagArray, objCallback, termsLinkData ) {
			emptyText = emptyText || APP.props.oTranslations.ONEWAY_INVALID;
			emailTop = emailTop || false;
			var $documentFragment = $( document.createDocumentFragment() );
			if(_.isEmpty(fingerIDArray)){
				var $invalidOneWayMessage = $( document.createElement( 'div' ) )
						.addClass( 'island' )
						.attr( 'data-cy', 'nofingers' );//WEBAE3-6601 added data-cy attribute so we can automate testing for this div
					$invalidOneWayMessage.append( $.trim( emptyText ) );
					$documentFragment.append( $invalidOneWayMessage );
				return $documentFragment;
			}
			var blockCarID = ( !_.isEmpty(fingerIDArray) ) ? APP.props.oRateFingers[ fingerIDArray[ 0 ] ].carID : '';
			var showMultiLoc = ( APP.props.oResults[ blockCarID ] ) ? APP.props.oResults[ blockCarID ].showMultiLoc : false;
			var showEmail = ( AEdata.booking.props.showEmailQuote && APP.props.oResults[ blockCarID ] ) ? !showMultiLoc : false;
			commonTagArray = commonTagArray || [];
			objCallback = objCallback || false;
			if ( emailTop !== false ) emailTop = true;
			var blockPULocID = ( pickupID && pickupID.length ) ? pickupID : APP.props.oRateFingers[ fingerIDArray[ 0 ] ].locID;
			var blockDOLocID = ( dropoffID && dropoffID.length ) ? dropoffID : APP.getDefaultDropoffID( blockPULocID );
			var blockPUStatus = ( APP.props.oLocations[ blockPULocID ] ) ? APP.props.oLocations[ blockPULocID ].puStatus : 'C';
			var blockPUType = APP.props.oLocations[ blockPULocID ].type;
			var blockDOStatus = ( APP.props.oLocations[ blockDOLocID ] ) ? APP.props.oLocations[ blockDOLocID ].doStatus : 'C';



			// Save Email Content for later use when we determine the position
			var $emailIcon = '';//$( document.createElement( 'i' ) ).addClass( 'fa fa-envelope' );
			var $emailQuoteBlock = ''; /* WEBAE3-7083 - Remove email quote $( document.createElement( 'div' ) ).append( APP.props.oTranslations.EMAILQUOTE + ' ' ).append( $emailIcon )
				.addClass( 'email-quote cursor--pointer align-right soft--right' )
				.attr( 'data-fingers', encodeURIComponent( JSON.stringify( fingerIDArray ) ) )
				.attr( 'data-dolocid', blockDOLocID );*/
		
			if ( blockPUStatus !== 'C' && blockDOStatus !== 'C' ) {
				
				if ( emailTop && !AEdata.booking.props.ismodify && !AEdata.booking.props.iswl && showEmail && fingerIDArray.length ) { $documentFragment.append( $emailQuoteBlock ); }

				var $fingersPromoBar = $( document.createElement( 'div' ) ).addClass( 'package_promo_bar bg--primary inverse remove-rhythm' );
				var showFingersPromoBar = true;
				var commonTagID = '';
				if ( APP.props.isAllLocation && !showMultiLoc ) {
					
					var $fingersPromoText = $( document.createElement( 'p' ) ).addClass( 'soft-half flush' );
					$fingersPromoText.append( APP.props.oTranslations.SINGLELOC + ' ' + APP.props.oLocations[ blockPULocID ].name + '.' );
					$fingersPromoBar.append( $fingersPromoText );
					
				} else if ( commonTagArray.length ) {
					
					var tagTextID = APP.props.oCarTags[ commonTagArray[ 0 ] ];

					commonTagID = tagTextID.id;

					var tagTextIDLocType = APP.props.oCarTags[ commonTagArray[ 0 ] ].loctype;
					//tagTextIDLocType !=='[]' && 
					if(tagTextIDLocType !== '.'){
						if(	!tagTextIDLocType.includes(blockPUType)){
							showFingersPromoBar = false;
						}
					}


					if ( APP.props.oTranslations.carTags[ tagTextID.message ] ) {
							var $fingersPromoText = $( document.createElement( 'p' ) ).addClass( 'soft-half flush align-center' );
							var $fingersPromoTextMsgDesk = $( document.createElement( 'span' ) ).addClass( 'trulyhidden--palm' );
							$fingersPromoTextMsgDesk.append( $.trim( APP.props.oTranslations.carTags[ tagTextID.message ].message ) );
							$fingersPromoText.append( $fingersPromoTextMsgDesk );
							var $fingersPromoTextMsgPalm = $( document.createElement( 'span' ) ).addClass( 'trulyhidden--lap-and-up' );
							$fingersPromoTextMsgPalm.append( $.trim( APP.props.oTranslations.carTags[ tagTextID.message ].shortMessage ) );
							$fingersPromoText.append( $fingersPromoTextMsgPalm );
							$fingersPromoText.attr('data-tag',tagTextID.id);
							$fingersPromoBar.append( $fingersPromoText );

							if ( tagTextID.hasOwnProperty('bgcolor') ) {
								$fingersPromoBar.css( 'backgroundColor', '#' + tagTextID.bgcolor );
								$fingersPromoBar.css( 'borderColor', '#' + tagTextID.bgcolor );
								$fingersPromoBar.css( 'marginTop', '-2px' );
								$fingersPromoBar.css( 'paddingTop', '2px' );
							}
					}
				}
				//console.log('$fingersPromoBar');
				//console.log($fingersPromoBar);
				if (showFingersPromoBar){
					$documentFragment.append( $fingersPromoBar );
				}
				if ( !fingerIDArray.length && ( APP.props.isMapOneway || APP.props.isAllLocation ) ) {
					var $invalidOneWayMessage = $( document.createElement( 'div' ) ).addClass( 'island' );
					$invalidOneWayMessage.append( $.trim( emptyText ) );
					$documentFragment.append( $invalidOneWayMessage );
				}
				for ( var i = 0; i < fingerIDArray.length; i++ ) {
					$documentFragment.append( APP.buildRateFinger( fingerIDArray[ i ], dropoffID, i, commonTagID, termsLinkData ) );
				}

				if ( pickupID !== undefined && APP.props.oLocations[ pickupID ] !== undefined ) {

					$addressContainer = $( document.createElement( 'div' ) ).addClass( 'grid push--top cardetails-smallprint' );

					if ( dropoffID !== undefined && pickupID !== dropoffID && APP.props.oLocations[ dropoffID ] !== undefined ) {
							$addressContainer.append( APP.buildAddressBlock( APP.props.oLocations[ pickupID ].locName, APP.props.oLocations[ pickupID ].cityName, APP.props.oLocations[ pickupID ].country, APP.props.oTranslations.PUHEAD ) );

							$addressContainer.append( APP.buildAddressBlock( APP.props.oLocations[ dropoffID ].locName, APP.props.oLocations[ dropoffID ].cityName, APP.props.oLocations[ dropoffID ].country, APP.props.oTranslations.DOHEAD ) );
					} else {
							$addressContainer.append( APP.buildAddressBlock( APP.props.oLocations[ pickupID ].locName, APP.props.oLocations[ pickupID ].cityName, APP.props.oLocations[ pickupID ].country, APP.props.oTranslations.RTHEAD ) );
					}

					$documentFragment.append( $addressContainer );

				}

				if ( !emailTop && !AEdata.booking.props.ismodify && !AEdata.booking.props.iswl && showEmail && fingerIDArray.length ) $documentFragment.append( $emailQuoteBlock );
			} else {
				if ( blockPUStatus === 'C' ) {
					$documentFragment.append( $( document.createElement( 'div' ) ).addClass( 'grid' )

							.append( APP.buildAddressBlock( APP.props.oLocations[ blockPULocID ].locName, APP.props.oLocations[ blockPULocID ].cityName, APP.props.oLocations[ blockPULocID ].country, APP.props.oTranslations.PUCLOSED, 'flush--bottom' ) )
							.append( APP.buildHoursBlock( APP.props.oLocations[ blockPULocID ].aHours ) ) );
				}
				if ( blockDOStatus === 'C' && APP.props.oLocations[ blockDOLocID ] ) {
					$documentFragment.append( $( document.createElement( 'div' ) ).addClass( 'grid' )
							.append( APP.buildAddressBlock( APP.props.oLocations[ blockDOLocID ].locName, APP.props.oLocations[ blockDOLocID ].cityName, APP.props.oLocations[ blockDOLocID ].country, APP.props.oTranslations.DOCLOSED, 'flush--bottom' ) )
							.append( APP.buildHoursBlock( APP.props.oLocations[ blockDOLocID ].aHours ) ) );
				}
			}
						return $documentFragment;
		},
		buildHoursBlock: function ( aHours ) {
			aHours = aHours || [];
			linesAdded = false;
			var $documentFragment = $( document.createDocumentFragment() );
			var $hourBlock = $( document.createElement( 'div' ) ).addClass( 'grid__item one-whole' );
			for ( var i = 0; i < aHours.length; i++ ) {
				linesAdded = true;
				$hourBlock.append( $( document.createElement( 'div' ) ).addClass( 'location-address' ).append( aHours[ i ] ) );
			}
			if ( linesAdded ) $documentFragment.append( $hourBlock );
			return $documentFragment;
		},
		buildAddressBlock: function ( address, city, country, label, labelClass ) {
			address = address || '';
			city = city || '';
			city = city.replace(' PGT','').replace(' Pgt','').replace(' LEASE','').replace(' Lease','');
			country = country || '';
			label = label || '';
			labelClass = labelClass || 'flush';
			var $documentFragment = $( document.createDocumentFragment() );

			if ( $.trim( address ).length ) {

				$addressBlock = $( document.createElement( 'div' ) ).addClass( 'grid__item one-whole' );

				if ( $.trim( label ).length ) {
					$addressHeader = $( document.createElement( 'h6' ) ).addClass( labelClass ).append( $.trim( label ) );
					$addressBlock.append( $addressHeader );
				}

				$addressDiv = $( document.createElement( 'div' ) ).addClass( 'location-address' );

				$addressDiv.append( $.trim( address ) ).append( '<br/>' + $.trim( city ) );

				if(country !== 'PU') $addressDiv.append( ', ' + $.trim( country ) );

				$addressBlock.append( $addressDiv );

				$documentFragment.append( $addressBlock );

			}

			return $documentFragment;
		},
		buildLocFingerBlock: function ( fingerArray, containerID, promoText ) {
			//console.log('trigger5');
			promoText = promoText || '';
			var $documentFragment = $( document.createDocumentFragment() );

			var $locFingerContainer = $( document.createElement( 'div' ) ).addClass( 'startRateBlock' );

			var $fingersPromoBar = $( document.createElement( 'div' ) ).addClass( 'package_promo_bar bg--primary inverse remove-rhythm' );

			if ( $.trim( promoText ).length && !AE.props.siteCode == "FCR") {
				var $fingersPromoText = $( document.createElement( 'p' ) )
					.addClass( 'soft-half flush' )
					.append( $.trim( promoText ) );

				$fingersPromoBar.append( $fingersPromoText );
				//console.log('trigger6');
			}
			/*
			WEBAE3-2446
			- need to add ins package class to turn off rate loc starting at fingers based on filters chosen
			also need to use rate value to map CFP/CFS psuedo filter classes to II/IZ rates
			*/
			var cfpRate = 0;
			var cfsRate = 0;
			for ( var i = 0; i < fingerArray.length; i++ ) {
				if(fingerArray[i].PACKAGE == 'CFP'){
					cfpRate = fingerArray[i].RATE;
				}
				if(fingerArray[i].PACKAGE == 'CFS'){
					cfsRate = fingerArray[i].RATE;
				}
			}
			$locFingerContainer.append( $fingersPromoBar );
			//console.log('trigger7');
			for ( var i = 0; i < fingerArray.length; i++ ) {
				//console.log(fingerArray[i]);
				/*
				WEBAE3-2196 - don't build for Custom Filters because they're duplicates for other II/Zx rates 
				and we want to use more descriptive II/Zx labels instead of creating/using generic preferred/other labels
				remember that Zx products can be CFS secondary filter
				*/
				if(fingerArray[i].PACKAGE !== 'CFS' && fingerArray[i].PACKAGE !== 'CFP') {
					//WEBAE3-2446 - set up insClasses
					//console.log(fingerArray[i].PACKAGE);
					var insClass = '';
					switch (fingerArray[i].PACKAGE) {
						case 'basic':
							insClass = ' IB';
							break;
						case 'inclusive':
							insClass = ' II';
							break;
						default:
							insClass = ' IZ';
					}
					//override default ins package grouping by rates
					if(fingerArray[i].RATE == cfpRate) {
						insClass = ' CFP';
					}
					if(fingerArray[i].RATE == cfsRate) {
						insClass = ' CFS';
					}
					var $fingerDiv = $( document.createElement( 'div' ) ).addClass( 'package_container inverse--light ' + insClass );

					var $fingerGridItem = $( document.createElement( 'div' ) ).addClass( 'grid__item one-whole package--half-side' );

					var $fingerPriceDiv = $( document.createElement( 'div' ) ).addClass( 'package_pricing align-right soft--right' );

					/*if(AE.props.siteCode == 'FCR' && APP.props.oQuote.aff !== 'FLIGHTCTRCA'){
						var $fingerPriceLabel = $( document.createElement( 'h6' ) )
						.addClass( 'align-left lap-one-whole push-half--bottom' )
						// .append( APP.props.oTranslations.INSURANCES[ fingerArray[ i ].PACKAGE ].TITLE )
						// .append( document.createElement( 'br' ) )
						.append( APP.props.oTranslations.START_AT );
					} else*/ if (AE.props.siteCode == 'FCR') { 
						//WEBAE3-5264
						var $fingerPriceLabel = $( document.createElement( 'h6' ) )
						.addClass( 'align-left lap-one-whole push-half--bottom' )
						.append( APP.props.oTranslations.INSURANCES[ fingerArray[ i ].PACKAGE ].TITLE )
						.append( document.createElement( 'br' ) )
						.append( APP.props.oTranslations.START_AT );
					}else{
						var $fingerPriceLabel = $( document.createElement( 'h6' ) )
						.addClass( 'float--left align-left flush--top one-half lap-one-whole push-half--bottom' )
						.append( APP.props.oTranslations.INSURANCES[ fingerArray[ i ].PACKAGE ].TITLE )
						.append( document.createElement( 'br' ) )
						.append( APP.props.oTranslations.START_AT );
					}

					// var $fingerPriceLabel = $( document.createElement( 'h6' ) )
					// 	.addClass( 'float--left align-left flush--top one-half lap-one-whole push-half--bottom' )
					// 	.append( APP.props.oTranslations.INSURANCES[ fingerArray[ i ].PACKAGE ].TITLE )
					// 	.append( document.createElement( 'br' ) )
					// 	.append( APP.props.oTranslations.START_AT );

					$fingerPriceDiv.append( $fingerPriceLabel );

					if(AE.props.siteCode == 'FCR'){
						
						var displayRate = fingerArray[ i ].RATE.toFixed(2);

						var $fingerPriceAmount = $( document.createElement( 'h3' ) );
						$fingerPriceAmount.addClass( 'cardetails-rate' )
						.append( $.trim( displayRate ) );

						$rateFingerRateCurrencyType = $( document.createElement( 'div' ) );
						$rateFingerRateCurrencyType.addClass('fcr-currency-type');
						if (APP.props.oQuote.aff == 'FLIGHTCTRZA') {
							//$rateFingerRateCurrencyType.append('ZAR')
							$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
							$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
							$rateFingerRateCurrencySymbol.append('R')

							$fingerPriceAmount.append($rateFingerRateCurrencyType)
							$fingerPriceAmount.prepend($rateFingerRateCurrencySymbol)
						} else if (APP.props.oQuote.aff == 'FLIGHTCTRGB') {
							//$rateFingerRateCurrencyType.append('ZAR')
							$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
							$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
							$rateFingerRateCurrencySymbol.append('£')

							$fingerPriceAmount.append($rateFingerRateCurrencyType)
							$fingerPriceAmount.prepend($rateFingerRateCurrencySymbol)
						} else if (APP.props.oQuote.aff == 'FLIGHTCTRNZ' || window.location.hostname == 'cars.flightcentre.co.nz') {
							$rateFingerRateCurrencyType.append('NZD')
							$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
							$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
							$rateFingerRateCurrencySymbol.append('$')

							$fingerPriceAmount.append($rateFingerRateCurrencyType)
							$fingerPriceAmount.prepend($rateFingerRateCurrencySymbol)
						} else if (APP.props.oQuote.aff == 'FLIGHTCTRCA' || window.location.hostname == 'cars.flightcentre.ca') {
							$rateFingerRateCurrencyType.append('CAD')
							$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
							$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol-sub');
							$rateFingerRateCurrencySymbol.append('$')

							$fingerPriceAmount.append($rateFingerRateCurrencyType)
							$fingerPriceAmount.prepend($rateFingerRateCurrencySymbol)
						} else {
							$rateFingerRateCurrencyType.append('AUD')
								
							$rateFingerRateCurrencySymbol = $( document.createElement( 'span' ) );
							$rateFingerRateCurrencySymbol.addClass('fcr-currency-symbol');
							$rateFingerRateCurrencySymbol.append('$')

							$fingerPriceAmount.append($rateFingerRateCurrencyType)
							$fingerPriceAmount.prepend($rateFingerRateCurrencySymbol)
						}
						
						
					}else{
						var $fingerPriceAmount = $( document.createElement( 'h3' ) )
						.append( $.trim( fingerArray[ i ].CURR ) );
					}

					$fingerPriceDiv.append( $fingerPriceAmount );
					$fingerGridItem.append( $fingerPriceDiv );

					if(AE.props.siteCode == 'FCR'){
						$fingerPriceDiv.append( termsData )
					}

					$fingerDiv.append( $fingerGridItem );

					$locFingerContainer.append( $fingerDiv );
				}
			}

			var $showLocButtonDiv = $( document.createElement( 'div' ) )
				.addClass( 'package_container inverse--light' );

			var $showLocPricingDiv = $( document.createElement( 'div' ) )
				.addClass( 'package_pricing button_container grid__item one-whole flush--top align-right' );

			var $showLocButton = $( document.createElement( 'button' ) )
				.addClass( 'btn--secondary toggler one-whole location_button' )//toggler--manual
				.attr( 'type', 'button' )
				.attr( 'data-togglee', '#' + $.trim( containerID ) + ' .location_container' )
				.attr( 'data-resultmapid', $.trim( containerID ) )
				.append( $.trim( APP.props.oTranslations.BTN_SHOWLOC ) );

			$showLocPricingDiv.append( $showLocButton );

			$showLocButtonDiv.append( $showLocPricingDiv );

			$locFingerContainer.append( $showLocButtonDiv );

			$documentFragment.append( $locFingerContainer );

			return $documentFragment;
		},
		buildMapBlock: function ( locationIDArray,carID ) {
			//console.log('trigger8');
			var aAsterixCheck = _.filter( APP.props.oLocs, function ( loc ) {
				return ( _.contains( locationIDArray, loc.ID ) && loc.locOverlap );
			} );
			needsAsterix = ( aAsterixCheck.length ) ? true : false;
			//needsAsterix = needsAsterix || false;// This Flag USED to mean a duplicate location listing would appear. This hasn't been the case for a week 2016-12-21 NW
			var $documentFragment = $( document.createDocumentFragment() );

			var $mapGrid = $( document.createElement( 'div' ) ).addClass( 'grid push--top extend--bottom extend--right' );

			var $locationContainer = $( document.createElement( 'div' ) )
				.addClass( 'grid__item one-whole soft--top hard--top hard--left location_container toggle inverse--light visuallyhidden' );

			var $locMapColumn = $( document.createElement( 'div' ) )
				.addClass( 'grid__item one-third lap-one-whole palm-one-whole hard--left' );

			var $mapContainer = $( document.createElement( 'div' ) )
				.addClass( 'result_map_container' )
				.attr( 'data-resultmap', encodeURIComponent( JSON.stringify( locationIDArray ) ) );
			$mapContainer.append(
				$( document.createElement( 'div' ) ).addClass('pu_map'),
				$( document.createElement( 'div' ) ).addClass('do_map')
			);

			$locMapColumn.append( $mapContainer );

			$locationContainer.append( $locMapColumn );

			var $locListColumn = $( document.createElement( 'div' ) )
				.addClass( 'grid__item one-third lap-one-half palm-one-whole hard--left' );

			var $locListContainer = $( document.createElement( 'div' ) ).addClass( 'result_list_container' ),
				$directionBar = $( document.createElement( 'div' ) ).addClass( 'direction_bar' ).attr('data-resultmapid',carID),
				$fakeTable = $( document.createElement( 'div' ) ).addClass( 'fake_table' ),
				$switchPU = $( document.createElement( 'span' ) ).addClass( 'switch_pu current' ).attr('data-di','PU'),
				$switchDO = $( document.createElement( 'span' ) ).addClass( 'switch_do disabled' ).attr('data-di','DO');
				$switchPU.append(APP.props.oTranslations.PULABEL);
				$switchDO.append(APP.props.oTranslations.DOLABEL);
				$fakeTable.append($switchPU,$switchDO);
				$directionBar.append($fakeTable);
				$locListContainer.append($directionBar);
				$locListContainer.append($( document.createElement( 'div' ) ).attr('id',carID+'--locList' ).addClass('location_lists'));

			$locListColumn.append( $locListContainer );

			$locationContainer.append( $locListColumn );

			var $locRateColumn = $( document.createElement( 'div' ) )
				.addClass( 'grid__item one-third lap-one-half palm-one-whole soft--right soft-half--bottom' );

			var $locRateContainer = $( document.createElement( 'div' ) )
				.addClass( 'result_rate_container' );

			$locRateColumn.append( $locRateContainer );

			$locationContainer.append( $locRateColumn );

			if ( needsAsterix ) $locationContainer.append( '<div class="grid__item one-whole">'+APP.props.oTranslations.ADDITIONAL+'</div>' ); // DEV Stand in. Translation Needed.

			$mapGrid.append( $locationContainer );

			$documentFragment.append( $mapGrid );

			return $documentFragment;
		},
		buildRateFingerButtonValue: function ( fingerData, doLocID ) {
			fingerData = fingerData || {};
			var defaultDO = APP.getDefaultDropoffID( fingerData.locID );
			doLocID = doLocID || defaultDO;
			if ( !APP.props.oLocations[ doLocID ] && doLocID !== defaultDO ) doLocID = defaultDO;
			var oVal = _.clone( APP.props.oButtonValBase );
			oVal.SUBMITFORM = fingerData.submitForm;
			oVal.ROWID = fingerData.row;
			oVal.RATEID = fingerData.ID;
			oVal.SIPP = fingerData.SIPP;
			oVal.PULOC = fingerData.locID;
			oVal.DOLOC = doLocID;
			oVal.PULOCNAME = APP.props.oLocations[ fingerData.locID ].locName;
			oVal.DOLOCNAME = APP.props.oLocations[ doLocID ].locName;
			return encodeURIComponent( JSON.stringify( oVal ) );
		},
		errorDialog: function ( oError ) {
			oError.HEAD = oError.HEAD || 'ERROR';
			oError.MSG = oError.MSG || '';
			oError.P1 = oError.P1 || '';
			oError.MIDH = oError.MIDH || '';
			oError.P2 = oError.P2 || '';
			$( '#search--again__msg' ).empty();
			
			if (AE.props.siteCode == 'FCR') {
				var $df = $( document.createDocumentFragment() )
				.append('<div class="fcr-close_wrapper" style="margin-bottom: 20px;"><div class="fcr_close fcr-search--again_close-container"><i class="fas fa-times fcr_close fcr_close-icon"></i></div></div>')
				.append( $( document.createElement( 'p' ) ).addClass( 'error_head' ).append( $.trim( oError.HEAD ) ) )
				.append( $( document.createElement( 'p' ) ).append( $.trim( oError.MSG ) ) );
			} else {
				var $df = $( document.createDocumentFragment() )
				.append( $( document.createElement( 'p' ) ).addClass( 'error_head' ).append( $.trim( oError.HEAD ) ) )
				.append( $( document.createElement( 'p' ) ).append( $.trim( oError.MSG ) ) );
			}
			
			$( '#search--again__msg' ).removeClass( 'trulyhidden' ).append( $df );
			$('body').removeClass('moz-noscroll');
			AE.ui.dialog.launch( {
				id: 'search--again',
				dialogClass: 'search--modify',
				titleBar: true,
				close: function () {
					$('body').addClass('moz-noscroll');
					$( '#search--again__msg' ).addClass( 'trulyhidden' )
					$('#search-form .fcr-close_wrapper').removeClass( 'trulyhidden' )
				},
				applyUI: false,
				autoupdate: true,
				draggable: true,
				modal: true
			} );

			// Append Error Msg after search so it's same size as search form container
			if (AE.props.siteCode == 'FCR') {
				$( '#search--again' ).prepend( $( '#search--again__msg' ) );
				$('#search-form .fcr-close_wrapper').addClass( 'trulyhidden' )
			} else {
				if ( AE.getSiteViewType() === 'palm' ) {
					$( '#search--again' ).prepend( $( '#search--again__msg' ) );
				} else {
					$( '#search--again' ).append( $( '#search--again__msg' ) );
				}
			}
			
		},
		oneWayDialog: function () {
			var showOWdialog = (AEdata.booking.quote.oQuote.oOW.skipNote)? false : true;
			if(showOWdialog && AEdata.booking.quote.oFilters.EXCLUSIVE === true && AEdata.booking.quote.oFilters.LTR === true) showOWdialog = false;
			if ( AE.ui.dialog && showOWdialog) {
				var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
				oButtons[ $.trim( APP.props.oTranslations.ONEWAY_DIALOG.BUTTON ) ] = function () {
					AE.ui.dialog.close();
				};


				var dialogText = $.trim( APP.props.oTranslations.ONEWAY_DIALOG.INFO ); 

				//If there is no html in the text, surround it with a paragraph tag
				var htmlRegex = /^<.*>.*<\/.*>$/;
			
				if( htmlRegex.test(dialogText) ) {
					dialogContent = dialogText;
				} else {
					dialogContent = "<p>" + dialogText + "</p>";
				}

				if(AE.props.siteCode == 'FCR'){
					var dialogAdditonalClass = 'fcr-oneway_note'
				}else{
					var dialogAdditonalClass = null
				}

				var oContent = $( document.createDocumentFragment() )
					.append( $( document.createElement( 'h3' ) )
							.append( $.trim( APP.props.oTranslations.ONEWAY_DIALOG.HEAD ) )
					)
					.append( $( document.createElement( 'div' ) )
							.append( dialogContent )
					);
				AE.ui.dialog.launch( {
					id: 'oneway_all2all--modal',
					class: dialogAdditonalClass,
					content: oContent,
					buttons: oButtons,
					titleBar: false,
					buttonOpts: {
							buttonsClass: 'btn--primary fcr-buttom-primary',
							exclusiveClose: true
					},
					width: ( $( window ).width() > 900 ) ? 850 : '80%'
				} );
			}
		},
		oneWayFeeCheck: function ( $button ) {
			var fingerID = $button.data( 'finger-id' );
			var doLocID = $button.data( 'dolocid' );
			var oFinger = APP.props.oRateFingers[ fingerID ];
			var dfd_RateChangeCheck = $.Deferred();
			var activeFormID = 
			dfd_RateChangeCheck.done( function () {
				if ( oFinger.locID !== doLocID ) {
					// check whether one way fee alert is needed
					var oRateChanges = APP.props.oRateChangeDetails[ fingerID ][ doLocID ];
					if ( oRateChanges.oOW && oRateChanges.oEvent ) { // Confirms existence of formatted DROPFEE object - safe to assume other elements present at this point
							// Update Event Tracking Text
							var supplier = APP.props.oSuppliers[ oFinger.suppID ].fullName;
							var puCountry = APP.props.oLocations[ oFinger.locID ].country;
							var puCity = APP.props.oLocations[ oFinger.locID ].cityName;
							var puLocName = APP.props.oLocations[ oFinger.locID ].locName;
							var doCountry = APP.props.oLocations[ doLocID ].country;
							var doCity = APP.props.oLocations[ doLocID ].cityName;
							var doLocName = APP.props.oLocations[ doLocID ].locName;
							var rateString = ( oFinger.packageType === 'IB' ) ? oRateChanges.oIB.rateCurr : oRateChanges.oII.rateCurr;
							oRateChanges.oEvent.CLICK_LABEL = oRateChanges.oEvent.CLICK_LABEL.replace( '--RATEFRMT--', rateString );
							oRateChanges.oEvent.VIEW_LABEL = oRateChanges.oEvent.VIEW_LABEL
								.replace( '--QUOTEID--', APP.props.quoteID )
								.replace( '--SUPPLIER--', supplier )
								.replace( '--PUCOUNTRY--', puCountry )
								.replace( '--PUCITY--', 'augh' ) //(puCity === doCity)? puLocName : puCity)
								.replace( '--DOCOUNTRY--', doCountry )
								.replace( '--DOCITY--', ( puCity === doCity ) ? doLocName : doCity )
								.replace( '--RATEFRMT--', rateString );
					}
                    if ( oRateChanges.oEvent && oRateChanges.oDialog && oRateChanges.oDialog.showDialog && ( oRateChanges.oDialog.dropfee || oRateChanges.oDialog.rate ) ) { // Confirms existence of formatted DROPFEE object - safe to assume other elements present at this point
						// If so, send GA Tracking event that the dialog was triggered, and trigger dialog
						AE.ga.gaArrayProcess( [ {
							GACATEGORY: oRateChanges.oEvent.CATEGORY,
							GAACTION: oRateChanges.oEvent.VIEW_ACTION,
							GALABEL: oRateChanges.oEvent.VIEW_LABEL
						} ] );

						//WEBAE3-6268 - All location 1-ways - Don't show the dialog. Add ONEWAYFEEALREADYCHECKED to the form scope and just submit to next step 
						//WEBAE3-6426 add check for oSite.addFeesToRate because this doesn't apply if not showing full cost
						if (typeof carID !== 'undefined' && APP.props.oResults[carID].showMultiLoc && oSite.addFeesToRate===true) {
							$( document.createElement( 'input' ) ).attr( 'name', 'ONEWAYFEEALREADYCHECKED' )
								.attr( 'type', 'hidden' ).attr( 'value', true ).appendTo( '#' + $button[0].form.id );
						} else {
							APP.oneWayFeeDialog( oFinger, oRateChanges.oOW, oRateChanges.oDialog, oRateChanges.oEvent, doLocID, $button[0].form.id );
						}		

						if(APP.popDialog()){
							//WEBAE3-4721 get form from button/target instead of building string
							//old way: $( '#' + oFinger.formID + '-' + doLocID ).submit();
                            APP.logSelection();
							$button[0].form.submit();
						}
					} else {
							if ( AE.ga ) {
								AE.ga.gaArrayProcess( JSON.parse( decodeURIComponent( ( oFinger.packageType == 'IB' ) ? APP.props.arrBGA : APP.props.arrIGA ) ) );
								if ( oRateChanges.oOW && oRateChanges.oEvent && oRateChanges.oEvent.VIEW_ACTION ) { // Confirms existence of formatted DROPFEE object - safe to assume other elements present at this point
									if ( oRateChanges.oEvent.VIEW_ACTION === 'included' ) {
										// If One Way Fee Included In Rate, fire GA events as if modal was shown and accept button clicked
										AE.ga.gaArrayProcess( [
												{
													GACATEGORY: oRateChanges.oEvent.CATEGORY,
													GAACTION: oRateChanges.oEvent.VIEW_ACTION,
													GALABEL: oRateChanges.oEvent.VIEW_LABEL
									},
												{
													GACATEGORY: oRateChanges.oEvent.CATEGORY,
													GAACTION: oRateChanges.oEvent.CLICK_ACTION_Y,
													GALABEL: oRateChanges.oEvent.CLICK_LABEL
									}
								] );
									}
								}
							}
							// Pass without Dialog, Offerchanged logic might still trigger in /car_includes/car_after_rates_lg.cfm
							if(APP.popDialog()){
								//WEBAE3-4721 get form from button/target instead of building string
								//old way: $( '#' + oFinger.formID + '-' + doLocID ).submit();
                                APP.logSelection();
								$button[0].form.submit();
							}
					}
				} else {
					// Pass round trips right through
					AE.ga.gaArrayProcess( JSON.parse( decodeURIComponent( ( oFinger.packageType == 'IB' ) ? APP.props.arrBGA : APP.props.arrIGA ) ) );
					//WEBAE3-4721 get form from button/target instead of building string
					//old way  $( '#' + oFinger.formID + '-' + doLocID ).submit();
                    APP.logSelection();
					$button[0].form.submit();
				}
			} );

			if ( oFinger.locID === doLocID ) { // If Not a One Way Search (possible in All Location Searches)
				// not a one way
				dfd_RateChangeCheck.resolve();
			} else {
				if ( APP.props.oRateChangeDetails[ fingerID ][ doLocID ] &&
					!_.isEmpty( APP.props.oRateChangeDetails[ fingerID ][ doLocID ] )
				) { // Rate Change Details Struct Available
					// rate change struct exists
					dfd_RateChangeCheck.resolve();
				} else { // Rate Change Details Struct Unavailable
					// requesting rate change struct
					$.ajax( {
							url: '/plugins/ae3/lib/BookingAjax.cfc',
							dataType: 'json',
							data: {
								method: 'getRateChangeDetails',
								bookingid: AEdata.booking.props.uuid,
								rates: fingerID,
								dolocid: doLocID
							}
					} ).done( function ( data ) {
							// AJAX - getRateChangeDetails Success
							APP.props.oRateChangeDetails[ fingerID ][ doLocID ] = data[ oFinger.ID ][ doLocID ];
							dfd_RateChangeCheck.resolve();
					} ).fail( function ( event ) {
							// AJAX - getRateChangeDetails Failure
							//Set some kind of failure flag so the DONE() function will know not to go looking
							APP.props.oRateChangeDetails[ fingerID ][ doLocID ] = { oDialog: { showDialog: false } };
							dfd_RateChangeCheck.resolve();
					} );
				}
			}
		},
		rateChangeDialog: function ( oFinger, oRateChanges ) {
			oFinger = oFinger || {};
			oRateChanges = oRateChanges || {};
			var newRate;
			if ( !_.isEmpty( oFinger ) && !_.isEmpty( oRateChanges ) ) {
				if ( oFinger.packageType === 'IB' ) {
					newRate = oRateChanges.oIB.rate;
				} else {
					newRate = oRateChanges.oII.rate;
				}
			}
		},
		oneWayFeeDialog: function ( oFinger, oDropfee, oDialog, oEvent, doLocID, formID ) {
			oFinger = oFinger || {};
			oDropfee = oDropfee || {};
			oDialog = oDialog || {};
			oEvent = oEvent || {};
			var defaultDO = APP.getDefaultDropoffID( oFinger.locID );;
			doLocID = doLocID || defaultDO;
			if ( !APP.props.oLocations[ doLocID ] && doLocID !== defaultDO ) doLocID = defaultDO;
			if ( AE.ui.dialog && !_.isEmpty( oFinger ) && !_.isEmpty( oDropfee ) ) {
				//WEBAE3-4721 get form from button/target instead of building string
				//old way  var $form = $( '#' + oFinger.formID + '-' + doLocID );
				var $form = $('#' + formID);
				var oResult = APP.props.oResults[ oFinger.carID ];
				var oButtons = {};
				oButtons[ APP.props.oTranslations.BTN_DECLINE ] = function () { // Decline Button
					// Send GA Tracking Event
					if ( AE.ga ) {
							AE.ga.gaArrayProcess( [ {
								GACATEGORY: oEvent.CATEGORY,
								GAACTION: oEvent.CLICK_ACTION_N,
								GALABEL: oEvent.CLICK_LABEL
					} ] );
					}
					APP.restoreRateFingers( oFinger.ID + '-' + doLocID );
					// Dialog will be destroyed by default upon closing.
					AE.ui.dialog.close();
				};
				if ( $form.length ) { // If we can't find the right rate finger form to submit, don't offer an accept button
					oButtons[ $.trim( oDialog.ACCEPT ) ] = function ( event ) { // Accept Button
							AE.forms.addSpinGear( $( '.ui-dialog' ).find( 'button.btn--primary' ) );
							// Send GA Tracking Event
							if ( AE.ga ) {
								AE.ga.gaArrayProcess( [ {
									GACATEGORY: oEvent.CATEGORY,
									GAACTION: oEvent.CLICK_ACTION_Y,
									GALABEL: oEvent.CLICK_LABEL
						} ] );
								AE.ga.gaArrayProcess( JSON.parse( decodeURIComponent( ( oFinger.packageType == 'IB' ) ? APP.props.arrBGA : APP.props.arrIGA ) ) );
							}
							// Add One Way Fee Already Checked Field to Bypass Coldfusion offerchanged bookingstep - which would display all the same messaging and
							$( document.createElement( 'input' ) ).attr( 'name', 'ONEWAYFEEALREADYCHECKED' )
								.attr( 'type', 'hidden' ).attr( 'value', true ).appendTo( '#' + formID );
							if(APP.dialogQ.length){
								if(APP.popDialog()){
                                    APP.logSelection();
									$form.submit();
								}
							} else {
                                APP.logSelection();
								$form.submit();
							}
					};
				} 
				// Dialog Content
				var $documentFragment = $( document.createDocumentFragment() )
					.append( $( document.createElement( 'h3' ) ).addClass( 'apply-half-rhythm' ).append( oDialog.HEAD ) )
					.append( $( document.createElement( 'p' ) ).addClass( 'apply-half-rhythm' ).append( oDialog.MSG + ' ' + oDialog.VAT ) );
				// New Total Line
				var $ratePlusFee = $( document.createElement( 'div' ) ).append( $( document.createElement( 'strong' ) ).append( oDialog.MATH ) );
				if ( oEvent.VIEW_ACTION === 'local' && AE.props.siteCode !== 'FCR') {
					$documentFragment.append( $( document.createElement( 'h5' ) ).addClass( 'flush' ).append( oDialog.EST_HEAD ) )
							.append( $ratePlusFee );
				}
				// Button Pane Text
				var $buttonPaneContent = $( document.createElement( 'div' ) ).addClass( 'grid push--left soft--right' )
					.append( $( document.createElement( 'h4' ) ).addClass( 'grid__item one-whole push-half--bottom hard--left align-center' ).append( oDialog.PROMPT ) );

				APP.dialogQ.push( {
					id: 'OneWayDialog-' + oFinger.ID,
					class: 'fcr-oneway_note',
					content: $documentFragment,
					open: function () {
							// Enable clicks if they've been disabled. We don't want people clicking things after clicking a ratefinger, but we want to make sure
							// that all of the links and buttons in the dialog are available.
							AE.ui.enableClicks();
							$( '.rateFinger__button' ).addClass( 'btn--no-icon' );
							AE.forms.addSpinGear( $('#Button-'+oFinger.ID+'-'+doLocID) );
					},
					close: function () {
							APP.restoreRateFingers( oFinger.ID + '-' + doLocID );
							AE.ui.dialog.close();
					},
					buttons: oButtons,
					titleBar: false,
					buttonOpts: {
							firstButtonClass: 'palm-one-whole btn--cancel btn--base',
							lastButtonClass: 'btn--primary palm-one-whole btn--keep-icon',
							exclusiveClose: true
					},
					width: ( $( window ).width() > 900 ) ? 850 : '80%'
				} );
			}
		},
		ltrDialog: function ( $target ) {
			var oFinger = APP.props.oRateFingers[ $target.data( 'finger-id' ) ];
			var doLocID = $target.data( 'dolocid' );
			oFinger = oFinger || {};
			if ( AE.ui.dialog && !_.isEmpty( oFinger ) ) {
				var oResult = APP.props.oResults[ oFinger.carID ];
				//WEBAE3-4721 get form from button/target instead of building string
				//old way: var $form = $( '#' + oFinger.formID + '-' + doLocID );
				var $form = $target[0].form;

				// WEBAE3-5568 - EU/GB/AU/NZ lease: options page should be skipped
				if(['EU','GB','AU','NZ'].indexOf(AE.props.chaosSystem) >= 0 && AE.props.siteCode !== 'FCR') {
					var $form = $('#'+($($target).attr('id').replace('Button', 'Form')));
					$form.attr('action', $form.attr('action').replace('options', 'checkout'));
					AEdata.booking.quote.oRates[oFinger.ID].carpath = 'checkout';
					$form.find('input[name="jsonPost"]').val($form.find('input[name="jsonPost"]').val().replace('getoptions', 'bookform'));
				}

				var oButtons = {};

				oButtons[ APP.props.oTranslations.BTN_DECLINE ] = function () { // Decline Button
					// Send GA Tracking Event
					if ( AE.ga ) {
							/*AE.ga.gaArrayProcess([{
							GACATEGORY 	: 	oDropfee.EVENTS.CATEGORY,
							GAACTION	: 	oDropfee.EVENTS.CLICK_ACTION_N,
							GALABEL		: 	oDropfee.EVENTS.CLICK_LABEL
							}]);*/
					}

					// This function call includes restoring body clicks.
					APP.restoreRateFingers( oFinger.ID + '-' + doLocID );

					// Dialog will be destroyed by default upon closing.
					AE.ui.dialog.close();
				};
				if ( $form.length ) { // If we can't find the right rate finger form to submit, don't offer an accept button
					oButtons[ APP.props.oTranslations.BTN_RATEFINGER ] = function () { // Accept Button
							// Send GA Tracking Event
							if ( AE.ga ) {
								/*AE.ga.gaArrayProcess([{
								GACATEGORY 	: 	oDropfee.EVENTS.CATEGORY,
								GAACTION	: 	oDropfee.EVENTS.CLICK_ACTION_Y,
								GALABEL		: 	oDropfee.EVENTS.CLICK_LABEL
								}]);*/
								AE.ga.gaArrayProcess( JSON.parse( decodeURIComponent( ( oFinger.PACKAGETYPE == 'IB' ) ? APP.props.arrBGA : APP.props.arrIGA ) ) );
							}
							// Disable clicks so that the selected ratefinger button doesn't get changed by other click events.
							AE.ui.disableClicks();

							// Add One Way Fee Already Checked Field to Bypass Coldfusion offerchanged bookingstep - which would display all the same messaging and
							if(APP.dialogQ.length){
								if(APP.popDialog()){
                                    APP.logSelection();
									$form.submit();
								}
							} else {
                                APP.logSelection();
								$form.submit();
							}
					};
				}
				// Dialog Content
				var LTRcode = 'PGT';
				if(APP.props.oTranslations.LTR[ oResult.suppCode ]) LTRcode = oResult.suppCode;
				var $documentFragment = $( document.createDocumentFragment() )
					.append( $( document.createElement( 'h3' ) ).addClass( 'apply-half-rhythm' ).append( $.trim( APP.props.oTranslations.LTR[ LTRcode ].TITLE ) ) )
					.append( $( document.createElement( 'p' ) ).append( $.trim( APP.props.oTranslations.LTR[ LTRcode ].CONTENT ) ) );
				// Peugeot Outside France Fees Note
				if ( oResult.isLTR && ( oResult.suppM === 'PGT' || oResult.suppM === 'EAP' || oResult.suppM === 'EAR' || oResult.suppM === 'CITROEN' || oResult.suppM === 'DSEUROPASS' || oResult.suppM === 'RENAULT' ) ) {
					$documentFragment
							.append( $( document.createElement( 'h5' ) ).addClass( 'apply-half-rhythm' ).append( $.trim( APP.props.oTranslations.LTRHEAD ) ) )
							.append( $( document.createElement( 'p' ) ).append( $.trim( APP.props.oTranslations.LTRNOTE ) ) );
				}
				// Drop boox note
				if ( oResult.DROPBOX ) {
					$documentFragment
							.append( $( document.createElement( 'h3' ) ).addClass( 'apply-half-rhythm' ).append( $.trim( APP.props.oTranslations.DROPBOX_HD ) ) )
							.append( $( document.createElement( 'p' ) ).append( $.trim( APP.props.oTranslations.DROPBOX_TXT ) ) );
				}

				APP.dialogQ.push( {
					id: 'LTRDialog-' + oFinger.ID,
					class: 'fcr-longterm_note',
					content: $documentFragment,
					open: function () {
							// Enable clicks if they've been disabled. We don't want people clicking things after clicking a ratefinger, but we want to make sure
							// that all of the links and buttons in the dialog are available.
							AE.ui.enableClicks();
							$( '.rateFinger__button' ).addClass( 'btn--no-icon' );
							AE.forms.addSpinGear( $target );
					},
					close: function () {
							APP.restoreRateFingers( oFinger.ID + '-' + doLocID );
							AE.ui.dialog.close();
					},
					buttons: oButtons,
					titleBar: false,
					buttonOpts: {
							firstButtonClass: 'btn--cancel btn--base',
							lastButtonClass: 'btn--primary btn--keep-icon',
							exclusiveClose: true
					},
					width: ( $( window ).width() > 900 ) ? 850 : '80%'
				} );
			}
		},
		dropboxDialog: function ( $target ) {
			var oFinger = APP.props.oRateFingers[ $target.data( 'finger-id' ) ];
			var doLocID = $target.data( 'dolocid' );
			oFinger = oFinger || {};
			if ( AE.ui.dialog && !_.isEmpty( oFinger ) ) {
				var oResult = APP.props.oResults[ oFinger.carID ];
				//WEBAE3-4721 get form from button/target instead of building string
				//old way: var $form = $( '#' + oFinger.formID + '-' + doLocID );
				var $form = $target[0].form;
				var oButtons = {};
				oButtons[ APP.props.oTranslations.BTN_DECLINE ] = function () { // Decline Button
					// Send GA Tracking Event
					if ( AE.ga ) {
							/*AE.ga.gaArrayProcess([{
							GACATEGORY 	: 	oDropfee.EVENTS.CATEGORY,
							GAACTION	: 	oDropfee.EVENTS.CLICK_ACTION_N,
							GALABEL		: 	oDropfee.EVENTS.CLICK_LABEL
							}]);*/
					}
					APP.restoreRateFingers( oFinger.ID + '-' + doLocID );
					// Dialog will be destroyed by default upon closing.
					AE.ui.dialog.close();
				};
				if ( $form.length ) { // If we can't find the right rate finger form to submit, don't offer an accept button
					oButtons[ APP.props.oTranslations.ONEWAY_DIALOG.BUTTON ] = function () { // Accept Button
							// Send GA Tracking Event
							if ( AE.ga ) {
								/*AE.ga.gaArrayProcess([{
								GACATEGORY 	: 	oDropfee.EVENTS.CATEGORY,
								GAACTION	: 	oDropfee.EVENTS.CLICK_ACTION_Y,
								GALABEL		: 	oDropfee.EVENTS.CLICK_LABEL
								}]);*/
								AE.ga.gaArrayProcess( JSON.parse( decodeURIComponent( ( oFinger.PACKAGETYPE == 'IB' ) ? APP.props.arrBGA : APP.props.arrIGA ) ) );
							}
							// Add One Way Fee Already Checked Field to Bypass Coldfusion offerchanged bookingstep - which would display all the same messaging and
							if(APP.dialogQ.length){
								if(APP.popDialog()){
                                    APP.logSelection();
									$form.submit();
								}
							} else {
                                APP.logSelection();
								$form.submit();
							}
					};
				}
				// Dialog Content
				var $documentFragment = $( document.createDocumentFragment() )
					.append( $( document.createElement( 'h3' ) ).addClass( 'apply-half-rhythm' ).append( $.trim( APP.props.oTranslations.DROPBOX_HD ) ) )
					.append( $( document.createElement( 'p' ) ).append( $.trim( APP.props.oTranslations.DROPBOX_TXT ) ) );

				APP.dialogQ.push( {
					id: 'DPBXDialog-' + oFinger.ID,
					class: 'fcr-dropbox_note',
					content: $documentFragment,
					open: function () {
							// Enable clicks if they've been disabled. We don't want people clicking things after clicking a ratefinger, but we want to make sure
							// that all of the links and buttons in the dialog are available.
							AE.ui.enableClicks();
							$( '.rateFinger__button' ).addClass( 'btn--no-icon' );
							AE.forms.addSpinGear( $target );
					},
					close: function () {
							APP.restoreRateFingers( oFinger.ID + '-' + doLocID );
							AE.ui.dialog.close();
					},
					buttons: oButtons,
					titleBar: false,
					buttonOpts: {
							firstButtonClass: 'btn--cancel btn--base',
							lastButtonClass: 'btn--primary btn--keep-icon',
							exclusiveClose: true
					},
					width: ( $( window ).width() > 900 ) ? 850 : '80%'
				} );
			}
		},
		rateFingerClicked: function ( $target ) {
				$( '.rateFinger__button' ).addClass( 'btn--no-icon' );
				AE.forms.addSpinGear( $target );
				if(!$target.data('family-found')){
					$target.data('family-found',true);
					var formSelector = '#Form-'+$target.data('finger-id')+'-'+$target.data('dolocid');
					var aRateFamily = AE.booking.options.findRateFamily(true,true,$target.data('finger-id'));
                    $target.attr('data-family', aRateFamily.toString());
					$(document.createElement('input'))
						.attr('name','availablePackages').attr('type','hidden')
						.attr('value',aRateFamily.toString()).appendTo(formSelector);
				}
                
                // WEBAE3-6014 Create vehicle result item and push into array for GA4 tracking
                AE.booking.matrix.props.eCommItems = [];
                var thisRate = APP.props.oRateFingers[$target.data('finger-id')];
                var eCommItem = AE.booking.matrix.events.buildGA4EcommerceItem(thisRate.ID, thisRate.carName, thisRate.suppName, thisRate.SIPP, thisRate.estimate);
                AE.booking.matrix.props.eCommItems.push(eCommItem);
			
		},
		restoreRateFingers: function ( rateID ) {
			rateID = rateID || '';
			//AE.ui.removeSpinner('div#Spin-'+rateID+'.rateFinger__spinner');
			//$('.rateFinger__spinner').addClass('visuallyhidden');
			//$('.button_container.grid__item').removeClass('visuallyhidden');
			AE.forms.removeSpinGear( $( '[id^="Button-'+rateID+'"]' ) );
			$( '.rateFinger__button' ).removeClass( 'btn--no-icon' );
			$('button.rateFinger__button').removeAttr('disabled');
			$('.fingerCancelLink').css('pointer-events', 'all');
			AE.ui.enableClicks();
		},
		noImage: function ( resultID ) {
			resultID = resultID || '';
			if ( resultID.length ) resultID = '#' + resultID;
			var $carImg = $( resultID + ' img.cardetails-carimg' );
			if ( $carImg[ 0 ] ) {
				$thisImg = $( $carImg[ 0 ] );
				$carImg.replaceWith( $( document.createElement( 'i' ) )
					.attr( 'title', $thisImg.attr( 'alt' ) )
					.addClass( 'color5 push--top push--left fa fa-5x ' + $thisImg.data( 'icon' ) )
				);
			}
		},
		popDialog: function (){
			APP.dialogQ = APP.dialogQ || [];
			if(APP.dialogQ.length >= 1){				
				var thisDialog = APP.dialogQ.pop();
				AE.ui.dialog.close();
				if(thisDialog !== undefined){
					AE.ui.dialog.launch(thisDialog);
				}
				return false;
			} else {
				return true;
			}
		},
		fcrTogglePriceFilter: function(){
			var $filterToggleBtn = $(".fcr_mobile-filter-toggle-container").find($(".toggler"))

			$filterToggleBtn.on( 'click', function() {
				$("#sortbyprice-mobile-button").toggle();
			})
		},
		onBodyClick: function ( event, $target ) {
			var $testOpenElements = document.querySelectorAll('.toggler.open:not(.sitepicker-heading):not(.sitepicker-heading-alt):not(.main-footer__header)');

			if ($testOpenElements.length !== 0 ){

				var $openElems = {};
				var $toggler={};
				var $togglee={};
					/* WEBAE3-1934 - Close Utility bar when other element (not contained) is clicked. */
				if($target.is(':not(.toggler--top-utbar.toggler.open)') && $('.toggler--top-utbar.toggler').is('.open')){
					$openElems = document.querySelectorAll('[data-togglee=\'.togglee--top-utbar\']');

						for (var i = 0; i < $openElems.length; i++){
							$toggler = $($openElems[i]);
							$togglee = $($toggler.attr('data-togglee'));

							if($togglee.has($target).length === 0){
								$toggler.removeClass('open');
								$togglee.addClass('visuallyhidden');
							}
						}
					}

					/* WEBAE3-1934 - Matrix filters element (not contained) is clicked. */
				if($target.is(':not(.toggler.filter.toggler--filter.toggler--special.open)') && $('#matrix__filters').is(':not(.visuallyhidden--palm)')){
					$openElems = document.querySelectorAll('[data-togglee=\'.togglee--filter\']');

					for (var i = 0; i < $openElems.length; i++){
						$toggler = $($openElems[i]);
						$togglee = $($toggler.attr('data-togglee'));

						if($('#matrix__filters').has($target).length === 0){
							$toggler.removeClass('open');
							$togglee.addClass('visuallyhidden--palm');
						}
					}
				}
			}

			if ( $target.hasClass( 'rateFinger__button' ) ) {
				APP.rateFingerClicked( $target );
				
				// WEBAE3-3713 - Filter Selection Persistence
				localStorage.setItem('aeFilters',JSON.stringify(AE.booking.matrix.props.filterStorage));
                
				var clickRateID = $target.data( 'finger-id' ), clickDOID = $target.data( 'dolocid' ), clickPUID = '';
				clickPUID = AEdata.booking.quote.oRates[clickRateID].locID;
                
				var defDialog = false;
				var checkSkipOptionsDone = false;//WEBAE3-6418 added this to prevent calling checkSkipOptionsPage twice in same button click
				APP.dialogQ = [];
				if ( $target.hasClass( 'rateFinger__button--dropbox' ) ) {
					event.preventDefault();
					APP.dropboxDialog( $target );
				}
				if ( $target.hasClass( 'rateFinger__button--ltr' ) ) {
					event.preventDefault();
					APP.ltrDialog( $target );
				}
				if ( clickPUID !== clickDOID && clickPUID !== '' /*APP.props.isMapOneway || APP.props.isAllLocation */) {
					AE.ui.disableClicks();
                    event.preventDefault();
                    //WEBAE3-5596 - disable rate fingers after one is clicked
                    $('button.rateFinger__button').attr('disabled', true);
                    //WEBAE3-5753 - disable cancellation cover checkbox once rate finger is clicked
                    $('.fingerCancelLink').css('pointer-events', 'none');
					defDialog = true;// Ad hoc deferral of dialog processing until any asynch calls for One Way are processed
					checkSkipOptionsDone = true;
					APP.checkSkipOptionsPage($target[0], clickRateID);
                    APP.oneWayFeeCheck( $target );
				}
                
				if(!defDialog){// OWF dialog will kick the process off if it went so that asynch rates calls can complete
					if(APP.dialogQ.length){// After processing, there really are dialogs to show
	                	APP.checkSkipOptionsPage($target[0], clickRateID);
						APP.popDialog();
					} else {
						AE.ui.disableClicks();
						event.preventDefault();
                       
                        //WEBAE3-5468 - check if options page should be skipped
						APP.checkSkipOptionsPage($target[0], clickRateID);
						
						//WEBAE3-4955 - disable rate fingers after one is clicked
						$('button.rateFinger__button').attr('disabled', true);
                        //WEBAE3-5753 - disable cancellation cover checkbox once rate finger is clicked
                        $('.fingerCancelLink').css('pointer-events', 'none');
						
						//WEBAE3-4721 - submit the target's parent form instead so this process can handle
						//changes to how rate finger IDs are built
						//old way can't be syn with naming changes --> $( '#Form-' + clickRateID + '-' + clickDOID ).submit();
                        APP.logSelection();
						$target[0].form.submit();
                        
					}
				} else if (!checkSkipOptionsDone) {
                    //WEBAE3-5547 - check if options page should be skipped for one-way rentals
					APP.checkSkipOptionsPage($target[0], clickRateID);
                }
			}
			if ( $target.hasClass( 'email-quote' ) ) {
				AE.booking.saveQuote.dialog( event );
			}
		},
        checkSkipOptionsPage: function($selectedRate, clickRateID)
        {
            //WEBAE3-5468 - update rate finger submit action to bypass options page if applicable
			//WEBAE3-6402 extend this setting to US,CA
            if(['EU','GB','AU','NZ','US','CA'].indexOf(AE.props.chaosSystem) >= 0 && AE.props.siteCode !== 'FCR') {
                var $form = $('#'+($($selectedRate).attr('id').replace('Button', 'Form')));
                var rateFamily = $($selectedRate).attr('data-family').split(',');

                //WEBAE3-6418 if this ratefamily is for a OneWay we might need to check oRateChangeDetails
				rateFamily = APP.checkRateFamilyOW(rateFamily,$($selectedRate).attr('data-dolocid'));
				//now run disownRateFamily based on CF version to check for insurance upgrades
				rateFamily = AE.booking.options.disownRateFamily(clickRateID,rateFamily);
				
                if(rateFamily.length <= 1) {
                    $form.attr('action', $form.attr('action').replace('options', 'upgrade'));
                    AEdata.booking.quote.oRates[clickRateID].carpath = 'upgrade';
                    $form.find('input[name="jsonPost"]').val($form.find('input[name="jsonPost"]').val().replace('getoptions', 'getupgrade'));
                }
                
                //if no insurance upgrade, check for car class upgrade - async is false so we wait on response
                if(AEdata.booking.quote.oRates[clickRateID].carpath === 'upgrade'){
                    $.ajax({
                        url: '/plugins/ae3/lib/BookingAjax.cfc',
                        async: false,
                        dataType: "json",
                        data: {
                            method: 'checkRate',
                            bookingID: AEdata.booking.props.uuid,
                            rateID: clickRateID
                        },
                        success: function(data) {
                            if(data.upgradeID.length === 0) {
                                $form.attr('action', $form.attr('action').replace('upgrade', 'checkout'));
                                AEdata.booking.quote.oRates[clickRateID].carpath = 'checkout';
                                $form.find('input[name="jsonPost"]').val($form.find('input[name="jsonPost"]').val().replace('getupgrade', 'bookform'));
                            }
                        }
                                
                    });
                }
            }
        },
        logSelection: function()
        {
            // WEBAE3-6014 Emit GA4 tracking items for selected vehicle
            AE.booking.matrix.events.emitGA4EcommerceEvent('view_item', AE.booking.matrix.events.buildEcommerceViewItem(APP.props.oCurrency.QUOTE, AE.booking.matrix.props.eCommItems[0].price, AE.booking.matrix.props.eCommItems));
            AE.booking.matrix.events.emitGA4EcommerceEvent('add_to_cart', AE.booking.matrix.events.buildEcommerceViewItem(APP.props.oCurrency.QUOTE, AE.booking.matrix.props.eCommItems[0].price, AE.booking.matrix.props.eCommItems));
            AE.booking.matrix.props.eCommItems = []; // reset items list to prevent conflicts with other events
        },
		checkRateFamilyOW: function(aRateFamily,doLocId) {
			/* 
			WEBAE3-6418
			For All location OW searches, we will and present updated rate info based on details calls.
			This may mean that rates in the rateFamily based on original Quote data may not be the same
			after a details call. This function checks oRateChangeDetails for a given rate id - dolocid
			and returns an array of valid rateFamily members
			*/   
			var aValidRateFamily = [];
			if(APP.props.isAllLocation && APP.props.isAllLocation === true && (APP.props.oQuote.oOW.city===true||APP.props.oQuote.oOW.country===true||APP.props.oQuote.oOW.locList===true)){
				aRateFamily.forEach(element => {
					//since this is OW speficic we can rely on oOW.validCombo to validate whether rate ID is good
					if(APP.props.oRateChangeDetails[element][doLocId].oOW && APP.props.oRateChangeDetails[element][doLocId].oOW.validCombo === true) {
						aValidRateFamily.push(element);
					}
				});
			}
			/*
			fail safe if validated array is empty, set it back to original rate family 
			because we had to have at least one valid rate to get here. This maintains
			original rate family prior to this ticket's changes and prevents sending
			back an empty family which might cause issues downstream
			*/
			if(aValidRateFamily.length < 1){
				return aRateFamily;
			} else {
				return aValidRateFamily;
			}

		},
		trimRateFingers: function(aTrimmedRates){
			/* WEBAE3-6512 
			added this will return a trimmed array for car rate result display
			this expects either array of Rate IDs (aRates) or an array of objects (aStartRates) with a 'PACKAGE' property in each object
			original use case: 
				suppress ZD, ZR, ZB rate fingers on source US/CA sites but preserve
				rate relationships so insurance upgrades can still be offered
				
			WEBAE3-6534 - only show inclusive or "base" excess offer (make sure this excludes EUR travel partner accounts)
			WEBAE3-6580 - expand from EUR site to source EU (but not TravelPartner sites or AVD and FCR sites)
			STORE-1509 - make sure ZK doesn't appear on any matrix page
			*/
			var tmp_aTrimmedRates = _.filter(aTrimmedRates,function(thisRateID){
				var tempPackage = (thisRateID.PACKAGE) ? thisRateID.PACKAGE : APP.props.oRateFingers[thisRateID].package; //true = package defined in aStartRates | false = rateId sent so get package from rate
				//WEBAE3-6512 don't show specific package rate fingers US/CA
				if(['US','CA'].indexOf(AE.props.chaosSystem) >= 0) {
					if(!_.contains(['ZD','ZR','ZB','CG','ZK'],tempPackage)) return thisRateID;//STORE-1524 added CG package
                } else if(['EU','GB'].indexOf(AE.props.chaosSystem) >= 0 && ['AVD','FCR'].indexOf(AE.props.siteCode) < 0 && !AE.props.bIsTpDomain){
					//WEBAE3-6613 - extend EU rules to GB
					//WEBAE3-6534 only show "base" insurance/excess packages, hide the rest
					//WEBAE3-6580 expanded from EUR site to all source EU sites except AVD and FCR
					//WEBAE3-6580 hotfix DEU site pickup DE has different standard offers
					//WEBAE3-6658 removed rule that added ZQ to list of standard offers (6580)
					if(_.contains(['inclusive','ZE','ZS','ZK'],tempPackage)) { 
						return thisRateID;
					}
				} else if(['AU','NZ'].indexOf(AE.props.chaosSystem) >= 0 && ['FCR','DAP'].indexOf(AE.props.siteCode) < 0 && !AE.props.bIsDapTpDomain) {
					//WEBAE3-6614 - AU/NZ Hide all rate fingers from display aside from “base” insurance package offers
					if(!_.contains(['ZQ','ZR','ZB','ZK'],tempPackage)) return thisRateID;
				} 
				else {
					//STORE-1509 - make sure ZK never shows on matrix
					if(!_.contains(['ZK'],tempPackage)) return thisRateID;
				}
			});
			if( tmp_aTrimmedRates.length > 0 ){ aTrimmedRates = tmp_aTrimmedRates; }
			return aTrimmedRates;
		}		
	};
	//hide FCR price slider when no results
	try {
		if (AEdata.booking.quote && !_.isEmpty(AEdata.booking.quote)) {
			if (AEdata.booking.quote.ERROR) {
				$('.fcr-priceslider-container').addClass('trulyhidden');
				$('.fcr-mobile-filter-wrap').addClass('trulyhidden');
				$('#sortbyprice').addClass('trulyhidden');
				$('.searchwait-container').addClass('trulyhidden');
			}
		}
	}
	catch (err) {

	}

	return APP;
} )();



;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.booking = AE.booking || {};
AE.booking.matrix = AE.booking.matrix || {};
AE.booking.matrix.maps = AE.booking.matrix.maps || (function(){
	/*
	DEPENDENCIES: AE, AE.ui, AE.booking, AE.booking.matrix, AE.booking.matrix.results
	*/
	var APP = {
		init:function() {
			APP.props = {
				$isMapOneway		: false,																	// one way map or not
				$viewResized		: { map: false },															// Flag to refresh view if a window resize occurs
				$supplierMap		: '',																		// Large Location Map set on Build
				$suppMarkers		: { zDex: '', selectedMarker: '', markers: [], selLoc: '' },				// Supplier Map Marker Object
				$filterMarkers		: { fullSuppliers: [], filterSuppliers: [], fullLocs: [], filterLocs: [] },	// Supplier Map Marker Object
				$mapObj				: {},																		// Deferred Markers with labels script
				resultsLayout       : oSite.resultsLayout                                                       // WEBAE3-6161 Determines which results layout to use (matrix or no matrix)
			};
			if (AE.booking.matrix.results.props) { APP.props.$isMapOneway = AE.booking.matrix.results.props.isMapOneway; }

			if (true ){//AE.booking.matrix.props.colsByCat && AE.getSiteViewType() === 'palm') {
				// SUPPLIER FILTER
				_.each(AEdata.booking.quote.aSupps,function(suppID){
					var oSupp = AEdata.booking.quote.oSupps[suppID];
					if (oSupp) {
						var suppCase = oSupp.code.toUpperCase();
						var excludeNotLTR = (AEdata.booking.quote.oFilters.EXCLUSIVE && AEdata.booking.quote.oFilters.LTR)? true : false;
						var dropThis = (excludeNotLTR && !oSupp.isLTR)? true : false;
						if ( _.contains(APP.props.$filterMarkers.fullSuppliers, suppCase) !== true && !dropThis) {
							var sortOrder = (oSupp.filter).replace(/S/g, '');
							// Push all suppliers to global array
							APP.props.$filterMarkers.fullSuppliers.push(suppCase);
							// Build supplier filter
							APP.buildMapFilters('<img src="'+oSupp.logoURL+'" />', oSupp.name, oSupp.code, 'supplier', sortOrder);
						}
					}
				});
				// LOCATION TYPE FILTER
				var aPOLocTypes = _.uniq(_.pluck(_.filter(AEdata.booking.quote.oLocs,function(oLoc){return oLoc.isPU && oLoc.aCars.length;}),'type'));
				_.each(aPOLocTypes,function(thisType){
					var thisFilterVal = 'D', thisSortOrder = 3;
					if(thisType === 'A'){
						thisFilterVal = 'A';
						thisSortOrder = 1;
					} else if(thisType === 'R'){
						thisFilterVal = 'R';
						thisSortOrder = 2;
					} // Ignore 'O' types
					if(!_.contains(APP.props.$filterMarkers.fullLocs,'L'+thisFilterVal)){// DO THIS ONLY ONCE FOR EACH LOCATION TYPE
						// Push all location types to global array
						APP.props.$filterMarkers.fullLocs.push('L'+thisFilterVal);
						// Build location type filter
						APP.buildMapFilters(AE.booking.matrix.results.props.oTranslations.LOCTYPE[thisFilterVal], thisFilterVal, 'L'+thisFilterVal, 'loctype', thisSortOrder);
					}
				});
			}
			// Switch between map and matrix views
			$('#matrix__browse').on('click', function(event) {
				var $target = $(event.target);	// Target event clicked
				AE.booking.matrix.hideResults();

				if ( !$target.hasClass('selected') ) {
					// MATRIX VIEW CLICK
					if ( $target.hasClass('matrix__browse__type') ) {
						$('.view_container').addClass('bg--tertiary');
						$('.map_container, .matrix_container').toggleClass('visuallyhidden');

						if (AE.booking.matrix.props.colsByCat && AE.getSiteViewType() === 'palm') {
							$('#matrix__filters--loctype').closest('.styled--select').addClass('visuallyhidden');
						} else {
							$('.map_only_filters').toggleClass('visuallyhidden');
						}

						//$('.matrix__browse__type, .matrix__browse__loc').toggleClass('selected');
						$('#matrix_and_map').find('.control_container').removeClass('loc').addClass('type');

						// always refresh matrix on view switch
						AE.booking.matrix.manageResize();
					}

					// MAP VIEW CLICK
					if ( $target.hasClass('matrix__browse__loc') ) {
						$('.view_container').removeClass('bg--tertiary');
						$('.map_container, .matrix_container').toggleClass('visuallyhidden');

						if (AE.booking.matrix.props.colsByCat && AE.getSiteViewType() === 'palm') {
							$('#matrix__filters--loctype').closest('.styled--select').removeClass('visuallyhidden');
						} else {
							$('.map_only_filters').toggleClass('visuallyhidden');
						}

						//$('.matrix__browse__type, .matrix__browse__loc').toggleClass('selected');
						$('#matrix_and_map').find('.control_container').removeClass('type').addClass('loc');

						var $mapJSONdata = AE.booking.matrix.results.props.oLocations;

						// Check if map and API has been already loaded
						if ( !$($target).hasClass('map-visible') ) {
							$($target).addClass('map-visible'); // set class that map has been loaded

							// Has maps API been loaded
							if (!AE.maps.props.$mapAPILoaded) {
								AE.maps.loadGoogleMapsAPI();	// Call the function to load maps API

								// When both API and custom markers are done loading draw the map
								$.when( AE.maps.props.$dfd_api, AE.maps.props.$dfd_markers ).then(function() {
									APP.drawLocationFilterMap( $mapJSONdata );
									google.maps.event.trigger(APP.props.$supplierMap, 'resize');
								});
							} else {
								APP.drawLocationFilterMap( $mapJSONdata );
							}
						} else {
							// if top map exists run filtering function to display only locations matching filter settings
							if (APP.props.$supplierMap !== '') {
								APP.setFilteredMarkers();
							}
						}

						// if resize on matrix happened refresh already existing map
						if ( APP.props.$supplierMap !== '' && APP.props.$viewResized.map ) {
							google.maps.event.trigger(APP.props.$supplierMap, 'resize');
							APP.props.$viewResized.map = false;
						}

						// The matrix manageResize function will place the toggle, but with a map we should call this specifically.
						AE.booking.matrix.placeMapToggle();
					}
				}
			});

			AE.addResizeTask({
				func:function() {
					APP.resetMatrixAndMapView();

					/* 	RESIZE FUNCTION BELOW: In drawRateFingerMap function
						used to reset pins bounding within the new sized map
						LINE: 481, 799
					*/
					_.each(APP.MAP.maps,function(aeMap){
						aeMap.gMap.fitBounds(aeMap.bounds);
					});
				}
			});
		},

	/* SHARED & GENERAL MAP FUNCTIONS */
	/* ================================== */

		// FUNCTION: view state of non visible container does not reset properly set flags for refresh
		resetMatrixAndMapView : function() {
			// Logic for large supplier map
			if (APP.props.$supplierMap !== '' && $('.map_container').hasClass('visuallyhidden')) {
				APP.props.$viewResized.map = true;
			}

			// MAP "ONLY" Filter Visibility - WEBAE3-2782
			var isMapShown = $('#matrix_and_map .control_container').hasClass('loc');
			if (AE.getSiteViewType() === 'palm') {
				AE.booking.matrix.setColumnsByCategory();
				if (AE.booking.matrix.props.colsByCat) {
					$('#matrix__filters--loctype').closest('.styled--select').toggleClass('visuallyhidden');
					$('.map_only_filters').removeClass('visuallyhidden');
					if(!isMapShown){
						$('#matrix__filters--loctype').closest('.styled--select').addClass('visuallyhidden');
					}
				}
				if (isMapShown) {
					$('#matrix__filters--loctype').closest('.styled--select').removeClass('visuallyhidden');
				}
			} else {
				$('.map_only_filters').addClass('visuallyhidden');
				if (isMapShown) {
					$('.map_only_filters').removeClass('visuallyhidden');
				}
			}

			// Logic for ratefinger maps
			if (!_.isEmpty(APP.props.$mapObj)) {
				$.each(APP.props.$mapObj, function(index, map) {
					map.resize = true;
					if (APP.props.$isMapOneway) {
						map.dresize = true;
					}
				});
			}
		},

	/* LARGE SUPPLIER MAP FUNCTIONS */
	/* ================================== */

		// FUNCTION: draw large map to filter results, comparable to matrix
		drawLocationFilterMap : function (json) {
			var mapOptions = {
				mapTypeControl: false,
				streetViewControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false
			};
			var map = new google.maps.Map( $('#matrix_and_map .map_container')[0], mapOptions);
			var bounds = new google.maps.LatLngBounds();
			var mIndex = 0; // Marker Index
			APP.props.$supplierMap = map;
			
			$.each(json, function(index, item) {
				var validDropoffs = _.filter(item.aDOs,function(locID){return AE.booking.matrix.results.props.oLocations[locID].doStatus !== 'C';});

				if (item.puStatus !== 'C' && validDropoffs[0]) {

					// Add geo coordinates for each location
					var thisLatLng = new google.maps.LatLng(item.lat, item.long);

					// Will need to show closed locations
					//var defIcon = ((direction.toLowerCase() === 'pu' && item.PUSTAT === 'C') || (direction.toLowerCase() === 'do' && item.DOSTAT === 'C')) ? AE.maps.pin_image[item.LOCTYPE].none : AE.maps.pin_image[item.LOCTYPE].icon;
					
					//WEBAE3-7119 - make sure oSupp will be defined below as it causes the map to error
					if (item.aCars.length > 0 && typeof AE.booking.matrix.results.props.oSuppliers[item.suppID] !== 'undefined') {
						var oSupp = AE.booking.matrix.results.props.oSuppliers[item.suppID];

						// marker y-placement based on supplier logo scaled height
						var $imgHeight = APP.findImageHeightWidth(oSupp.logoURL);
						mIndex = mIndex + 1;

						// Other Override Maybe be Temporary
						if (item.type === 'O') { item.type === 'C'; }

						// define marker objects
						var marker = new MarkerWithLabel({
							position: thisLatLng,
							marker_id: item.ID,
							icon: AE.props.muraThemePath+'/images/map/hidden.png',
							zIndex: mIndex,
							locid: item.ID,
							loctype: 'L' + item.type,
							supp: oSupp.name,
							labelContent: '<div><img src="'+oSupp.logoURL+'"></div><i class="fa fa-caret-down"></i>',
							labelClass: 'supplier_labels',
							labelAnchor: new google.maps.Point(30, $imgHeight),
							supplier: oSupp.logoURL,
							map: map,
							title: ''
						});
						APP.props.$suppMarkers.markers.push(marker);

						// SUPPLIER FILTER
						var suppCase = oSupp.code.toUpperCase();
						var excludeNotLTR = (AEdata.booking.quote.oFilters.EXCLUSIVE && AEdata.booking.quote.oFilters.LTR)? true : false;
						var dropThis = (excludeNotLTR && !oSupp.isLTR)? true : false;
						if ( _.contains(APP.props.$filterMarkers.fullSuppliers, suppCase) !== true && !dropThis) {
							var sortOrder = (oSupp.filter).replace(/S/g, '');
							// Push all suppliers to global array
							APP.props.$filterMarkers.fullSuppliers.push(suppCase);
							// Build supplier filter
							APP.buildMapFilters('<img src="'+oSupp.logoURL+'" />', oSupp.name, oSupp.name, 'supplier', sortOrder);
						}

						// LISENTER EVENT: Marker Click
						google.maps.event.addListener(marker, 'click', function() {

							// if there is a selected marker already reset zIndex to initial setting
							if (APP.props.$suppMarkers.selectedMarker) {
								APP.props.$suppMarkers.selectedMarker.setZIndex(APP.props.$suppMarkers.zDex);
							}

							// write current marker settings to supplier map object
							APP.props.$suppMarkers.selectedMarker = marker;
							APP.props.$suppMarkers.zDex = marker.getZIndex();
							APP.props.$suppMarkers.selLoc = item;

							// Collect results associated with map marker (faster loop then underscore filter Nate W 2016-05-27)
							var $resultArr = [];
							for(var resultIdx = 0; resultIdx < item.aCars.length ; resultIdx++){
								var tempCarID = item.aCars[resultIdx],
									tempCar = AE.booking.matrix.results.props.oResults[tempCarID],
									filtersTR = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.TR) ),
									filtersFP = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.FP) ),
									filtersIN = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.IN) ),
									/* WEBAE3-3460 */
									filtersFT = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.FT) ),
									/* WEBAE3-3725 */
									filtersACK = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.ACK) ),
									/* WEBAE3-3633 */
									filtersPRO = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.PRO) ),
									/* WEBAE3-3620 */
									filtersDR = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.DR) ),
									/* WEBAE3-3828 */
									filtersAIR = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.AIR) ),
									/* WEABE3-3602 */
									filtersKM = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.KM) ),
									filtersAC = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.AC) ),
									/* WEBAE3-3811 */
									filtersPS = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.PS) ),
									/* WEBAE34114 */
									filtersCV = $.merge( [], AE.booking.matrix.getFilterArray(AE.booking.matrix.results.props.oFilters.CV) ),
									filterState = _.union(filtersTR,filtersFP,filtersIN,filtersFT,filtersKM,filtersAC,filtersDR,filtersPRO,filtersAIR,filtersPS);
								if(filterState.length === 0 || _.intersection(filterState,tempCar.aFilters).length > 0) $resultArr.push(tempCar);
							}
							// WEBAE3-3811
							// set data attributes for markers
							$(marker).data( "supplier", oSupp.filter );
							$(marker).data( "category", '' );
							$(marker).data( "location", item.ID );

							// load result rows
							AE.booking.matrix.showResults($(marker), $resultArr, item.ID);
							AE.booking.matrix.locations.BigMapClick(item.ID);

							// set selected marker and bring to front
							this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
						});
						// set markers to be contained within map bounds
						bounds.extend(thisLatLng);
					}
				}
			});
			map.fitBounds(bounds);

			// Reset map pins to be contained by bounding box on resize
			AE.addResizeTask({
				func:function() {
					map.fitBounds(bounds);
				}
			});

			APP.setFilteredMarkers();
		},

		// FUNCTION: Hide and show markers on current map to prevent a map redraw
		setFilteredMarkers : function () {
			var $filteredJSONdata = AE.booking.matrix.getResultsCars();	// filtered results
			// Set all supplier markers to hidden
			for (var i = 0; i < APP.props.$suppMarkers.markers.length; i++) {
				APP.props.$suppMarkers.markers[i].setMap(null);	// hide markers
			}

			// Loop through filtered results then result locations and build array of unique locations
			var $resultLocations = _.map($filteredJSONdata, function(num){
				return ( AE.booking.matrix.results.props.oResults[num.ID].aLocs );
			});

			var $resultLocations = _.uniq(_.flatten($resultLocations));

			// MAP ONLY FILTERING
			// Check if any supplier filters are present
			if ( !_.isEmpty(_.difference( APP.props.$filterMarkers.fullSuppliers, APP.props.$filterMarkers.filterSuppliers )) && !_.isEmpty(APP.props.$filterMarkers.filterSuppliers) ) {
				// filter results of suppliers
				$resultLocations = _.filter($resultLocations, function(num) {
					var thisLoc = AE.booking.matrix.results.props.oLocations[num];
					var thisSupp = AE.booking.matrix.results.props.oSuppliers[thisLoc.suppID];
					return ( _.contains(APP.props.$filterMarkers.filterSuppliers, thisSupp.code) );
				});
			}
			// Check if any Location type filters are present
			if ( !_.isEmpty(_.difference( APP.props.$filterMarkers.fullLocs, APP.props.$filterMarkers.filterLocs )) && !_.isEmpty(APP.props.$filterMarkers.filterLocs) ) {
				// filter results of location types
				$resultLocations = _.filter($resultLocations, function(num) {
					return ( _.contains(APP.props.$filterMarkers.filterLocs, 'L'+AE.booking.matrix.results.props.oLocations[num].type) );
				});
			}

			// loop through filtered results with location id's and if matching marker show marker
			$.each($resultLocations, function(index, ids) {
				for (var i = 0; i < APP.props.$suppMarkers.markers.length; i++) {
					if ( ids === APP.props.$suppMarkers.markers[i].locid ) {
						APP.props.$suppMarkers.markers[i].setMap(APP.props.$supplierMap);	// show markers
					}
				}
			});
		},

		// FUNCTION: build a filter for each supplier and location type
		buildMapFilters : function (label, name, value, type, sort) {
            if(APP.props.resultsLayout != 'nomatrix') { // WEBAE3-6161 (WEBAE3-5859 - All filters now being created in car_includes/car_getrates_ds.cfm - Derek Hill 12/8/2023)
                var targetDIV = $('#matrix__filters--'+type+'');	// Target container
                // EVENT ACTION HANDLED IN AE.tracking.js
                var track = encodeURIComponent('[{"GACATEGORY":"matrixFilters","GALABEL":"'+type+'_'+name.toLowerCase()+'"}]');
                $("<div/>", {// LEAH JAY WILEY
                        'class': 'matrix_filter',
                        sortby:	sort,
                        html: '<input type="checkbox" name="'+type+'_'+name+'" id="'+type+'_'+name+'" class="map_filter matrix_filter '+type+' trg__ga--Checkbox" data-gaarray="'+track+'" data-supplier="S'+sort+'" data-filter="'+value+'" tabindex="1"><label for="'+type+'_'+name+'">'+label+'</label>',
                }).appendTo(targetDIV);

                AE.booking.matrix.props.$filterChks = $('#matrix__filters input.matrix_filter')
                // Sort filters by sort order and re-append to filter block
                var listDiv = $('div.matrix_filter[sortby]', targetDIV);
                listDiv.sort(function(a, b){
                    return ($(a).attr('sortby') > $(b).attr('sortby')) ? 1 : -1;
                });
                $.each(listDiv, function(index, row){
                    targetDIV.append(row);
                });
            }
		},


		// FUNCTION: find scaled height of supplier logo for marker placement
		findImageHeightWidth : function (imgPath) {
			var $imgHeight = 0;
			var myImage = new Image();
				myImage.name = imgPath;
				myImage.src = imgPath;

			// get ratio of set width to image width and find scaled height
			// add height for container padding and down arrow
			$imgHeight = (myImage.height * (50/myImage.width)) + 15;

			return $imgHeight.toFixed(0); 	// return whole number
		},

	/* INDIVIDUAL CAR MAP FUNCTIONS */
	/* ================================== */
		MAP:{
			maps:[],
			create:function(carID){
				var oState = AE.booking.matrix.locations.getState(carID);
				if(oState){
					oState.pMap = APP.MAP.maps.length;
					var pMap = APP.MAP.makeMap(carID,oState.pLocs);
					if(!_.isEmpty(pMap)) APP.MAP.maps.push(pMap);// PU/Round Trip Map
					if(AE.booking.matrix.locations.isInterCityOW()){
						oState.dMap = APP.MAP.maps.length;
						var dMap = APP.MAP.makeMap(carID,oState.dLocs,true);// dLocs not populated at first
						if(!_.isEmpty(dMap)) APP.MAP.maps.push(dMap);// DO Map
					} else {
						oState.dMap = oState.pMap;
						APP.MAP.addMarkers(oState.pMap,_.difference(oState.dLocs,oState.pLocs));// add DO location IDs to pMap.markers
					}
				}
			},
			makeMap: function(carID,aLocIDs,isDO){
				if(isDO !== true) isDO = false;
				var aeMap = {}, mapClass = (isDO)? '.do_map' : '.pu_map',
				aMarkerIDs = (_.isArray(aLocIDs))? aLocIDs : [],
				mapOptions = {
					mapTypeControl: false,
					streetViewControl: false,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					scrollwheel: false
					// draggable: false,
		    		// panControl: false
				};

				if(AEdata.booking.quote.oCars[carID] && !_.isEmpty(aMarkerIDs)){
					_.extend(aeMap,{
						carID: carID,
						markers: [],
						loaded: AE.maps.props.$mapAPILoaded,
						gMap: new google.maps.Map( $('#'+ carID +' .result_map_container '+mapClass)[0], mapOptions),
						bounds: new google.maps.LatLngBounds()
					});
					_.each(aMarkerIDs,function(locID){
						var oMarker = APP.MAP.makeMarker(aeMap,locID);
						if(!_.isEmpty(oMarker)){
							aeMap.markers.push(oMarker);
						}
					});
					var thisNE = aeMap.bounds.getNorthEast();
					if (thisNE && thisNE.equals(aeMap.bounds.getSouthWest())) {// Don't zoom in too far on only one marker
						var extendPoint1 = new google.maps.LatLng(thisNE.lat() + 0.01, thisNE.lng() + 0.01);
						var extendPoint2 = new google.maps.LatLng(thisNE.lat() - 0.01, thisNE.lng() - 0.01);
						aeMap.bounds.extend(extendPoint1);
						aeMap.bounds.extend(extendPoint2);
					}
					aeMap.gMap.fitBounds(aeMap.bounds);
				}
				return aeMap;
			},
			makeMarker: function(aeMap,locID){
				var marker = {};
				if(AEdata.booking.quote.oLocs[locID]){
					var index = aeMap.markers.length, item = AEdata.booking.quote.oLocs[locID];
					// Add geo coordinates for each location
					var thisLatLng = new google.maps.LatLng(item.lat, item.long);

					// Set pin image by location and open/closed status - good for debugging maps (needs to use default for when we pick drop off first from large location map)
					// var defIcon = ((direction === 'PU' && item.puStatus === 'C') || (direction === 'DO' && item.doStatus === 'C')) ? AE.maps.pin_image[item.type].none : AE.maps.pin_image[item.type].icon;
					var defIcon = ( item.type ) ? AE.maps.pin_image[item.type].icon : AE.maps.pin_image[item.AEID].icon ;

					// define marker objects
					marker = new MarkerWithLabel({
						position: thisLatLng,
						marker_id: item.JSONID + '-' + aeMap.carID,
						icon: defIcon,
						zIndex: index,
						oIndex: index,
						isPU: item.isPU,
						isDO: item.isDO,
						cPU: item.puStatus,
						cDO: item.doStatus,
						carid: aeMap.carID,
						locid: item.ID,
						loctype: item.type,
						labelContent: '<div></div>',
						labelClass: 'marker_labels',
						labelAnchor: new google.maps.Point(21, 56),
						labelZIndex: index+1,
						map: aeMap.gMap,
						title: ''
					});

					aeMap.bounds.extend(thisLatLng);

					google.maps.event.addListener(marker, 'click', function(){
						if(AEdata.booking.quote.oCars[this.carid]){

							if(AE.booking.matrix.locations.getState(this.carid)){
								$('li#'+this.locid+'-'+this.carid).click();
								/*if(AE.booking.matrix.locations.getState(this.carid).pActive){
									AE.booking.matrix.locations.setP(this.carid,this.locid);
								} else {
									AE.booking.matrix.locations.setD(this.carid,this.locid);
								}*/
							}
						}
					});
				}
				return marker;
			},
			addMarkers:function(mapIdx,aLocIDs){
				var oMap = APP.MAP.maps[mapIdx];
				if(oMap && _.isArray(aLocIDs)){
					_.each(aLocIDs,function(locID){
						var oMarker = APP.MAP.makeMarker(oMap,locID);
						if(!_.isEmpty(oMarker)){
							oMap.markers.push(oMarker);
						}
					});
					oMap.gMap.fitBounds(oMap.bounds);
				}
			},
			updateMap:function(carID){
				var oState = AE.booking.matrix.locations.getState(carID);
				if(oState){
					APP.MAP.create(carID);
					var activeMapIdx = oState.pMap, isDO = false,
						isInterCityOW = AE.booking.matrix.locations.isInterCityOW(),
						visibleMap = 'pu_map',
						invisibleMap = 'do_map';
					if(isInterCityOW && !oState.pActive){
						activeMapIdx = oState.dMap;
						isDO = true;
						visibleMap = 'do_map';
						invisibleMap = 'pu_map';
					}
					$('#'+carID+' .'+visibleMap).removeClass('visuallyhidden').css('position','relative');
					$('#'+carID+' .'+invisibleMap).addClass('visuallyhidden');
					var oMap = APP.MAP.maps[activeMapIdx];
					if(!oMap && isDO){
						activeMapIdx = APP.MAP.maps.length;
						oState.dMap = activeMapIdx;
						oMap = APP.MAP.makeMap(carID,oState.dLocs,true);
					}
					if(AEdata.booking.quote.oLocs[oState.P] && !AEdata.booking.quote.oLocs[oState.D] && !isInterCityOW){
						APP.MAP.addMarkers(activeMapIdx,_.difference(oState.dLocs,oState.pLocs));
					}
					if(oMap){
						_.each(oMap.markers,function(oMarker){
							var iconSet = AE.maps.pin_image[oMarker.loctype], chosenOne=false, isPickup=false;
							if(typeof(iconSet) === 'undefined') iconSet = AE.maps.pin_image.D;
							oMarker.setIcon(iconSet.icon);
							oMarker.setVisible(false);
							if(!_.isObject(oMarker.getMap()) || _.isEmpty(oMarker.getMap())) oMarker.setMap(oMap.gMap);
							if(oState.pActive){
								if(_.contains(oState.pLocs,oMarker.locid)) oMarker.setVisible(true);
								if(oMarker.locid === oState.P) chosenOne = true;
								if(oMarker.locid === oState.D) isPickup = true;
							} else {
								if(_.contains(oState.dLocs,oMarker.locid)) oMarker.setVisible(true);
								if(oMarker.locid === oState.D) chosenOne = true;
								if(oMarker.locid === oState.P) isPickup = true;
							}
							if(chosenOne || isPickup){
								oMarker.setZIndex(_.max(_.pluck(oMap.markers,'zIndex')) + 1);
								if(isPickup) oMarker.setIcon(iconSet.pickup);
								if(chosenOne) oMarker.setIcon(iconSet.chosen);
							}
						});
						oMap.gMap.fitBounds(oMap.bounds);
					}
				}
			}
		}
	};
	return APP;
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.booking = AE.booking || {};
AE.booking.matrix = AE.booking.matrix || {};
AE.booking.matrix.locations = AE.booking.matrix.locations || (function(){
	var ajaxLock = false, state = {};
	function getCarPUs(carID){
		var arr = [];
		if(AEdata.booking.quote.oCars[carID]){
			arr = _.pluck(_.filter(AEdata.booking.quote.oLocs,function(tempLoc){
				return _.contains(tempLoc.aCars,carID) && tempLoc.isPU;
			}),'ID');
		}
		return arr;
	}
	function buildState(carID){
		if(AEdata.booking.quote.oCars[carID] && !state.hasOwnProperty(carID)){
			var aPlocs = [], aDlocs = [], oCar = AEdata.booking.quote.oCars[carID];
			aPlocs = _.pluck(_.filter(AEdata.booking.quote.oLocs,function(tempLoc){
				return _.contains(tempLoc.aCars,carID) && tempLoc.isPU;
			}),'ID');
			/* original way to get aDlocs
			aDlocs = _.pluck(_.filter(AEdata.booking.quote.oLocs,function(tempLoc){
				return oCar.suppID === tempLoc.suppID && tempLoc.isDO;
			}),'ID');
			*/
			//WEBAE3-4848 get dolocs from each puloc aDOs
			_.each(aPlocs,function(tempID){
				aDlocs = _.union(aDlocs,AEdata.booking.quote.oLocs[tempID].aDOs);
			});
			state[carID] = {
				ID:carID,P:'',D:'',drawn:false,pActive:true,pMap:'',dMap:'',dLocs:aDlocs,pLocs:aPlocs
			};
		} else {
            // WEBAE3-5224 reset drawn property to prevent blank location lists
            state[carID].drawn = false;
        }
	}
	function buildLocList(carID,pID){
		carID = carID || '';
		pID = pID || '';
		var $dfd = $.Deferred();
		AE.ui.disableClicks();

		if(!AE.maps.props.$mapAPILoaded){
			AE.maps.loadGoogleMapsAPI();
			$.when( AE.maps.props.$dfd_api, AE.maps.props.$dfd_markers ).then(function() { $dfd.resolve(); });
		} else {
			$dfd.resolve();
		}
		$dfd.done(function(){
			buildState(carID);
			var oState = state[carID];
			var showList = 'PU';
			if(!oState.drawn){
				var oLocGroups = _.groupBy(
					_.union(oState.pLocs,oState.dLocs),
					function(tempID){
						return AEdata.booking.quote.oLocs[tempID].type;
					}
				);
				var $df = $(document.createDocumentFragment()),
					$locList = $('#'+carID+'--locList'),
					$air = $( document.createElement( 'ul' ) ).addClass( 'air' ),
					$rail = $( document.createElement( 'ul' ) ).addClass( 'rail' ),
					$sea = $( document.createElement( 'ul' ) ).addClass( 'sea' ),
					$city = $( document.createElement( 'ul' ) ).addClass( 'city' ),
					hasAir = oLocGroups.hasOwnProperty('A'),
					hasRail = oLocGroups.hasOwnProperty('R'),
					hasSea = oLocGroups.hasOwnProperty('O'),
					hasCity = oLocGroups.hasOwnProperty('D');

				_.each(['A','R','O','D'],function(tempType){
					var aLocs = [], $parent = $city;
					if(tempType === 'A' && hasAir){
						aLocs = oLocGroups.A;
						$parent = $air;
					}
					if(tempType === 'R' && hasRail){
						aLocs = oLocGroups.R;
						$parent = $rail;
					}
					if(tempType === 'O' && hasSea){
						aLocs = oLocGroups.O;
						$parent = $sea;
					}
					if(tempType === 'D' && hasCity){
						aLocs = oLocGroups.D;
						$parent = $city;
					}
					aLocs = _.sortBy(aLocs,function(tempID){
						return AEdata.booking.quote.oLocs[tempID].locName;
					});
					_.each(aLocs, function(tempID){
						var $tempItem = $( document.createElement( 'li' ) ).addClass( AEdata.booking.quote.oLocs[tempID].type+' trg__locSel--li' ),
							$tempSpan = $( document.createElement( 'span' ) ).addClass( 'address trg__locSel--span' );
						$tempItem.attr('id',tempID+'-'+carID).attr('locid',tempID);
						if(!AEdata.booking.quote.oLocs[tempID].isPU) $tempItem.addClass('visuallyhidden');
						$tempSpan.append(AEdata.booking.quote.oLocs[tempID].locName.replace(/<br>|<br \/>|<br\/>/g,' '));
						// $tempSpan.prepend(AEdata.booking.quote.oLocs[tempID].suppCode,' ');// Display Supplier Code for debugging
						// $tempSpan.prepend(tempID,' ');// Display Location ID for debugging
						if(AE.props.siteCode == 'FCR') {
							$fcrIcon = '';
							$fcrIconInclude =  $( document.createElement( 'i' ) ).addClass('fcr-text_search_loc_icon pull-right  material-icons');

							switch (AEdata.booking.quote.oLocs[tempID].type) {
								case 'A':
									$fcrIcon = 'flight';
									$fcrIconInclude.addClass('fcr-rotate45');
									break;
								case 'R':
									$fcrIcon = 'train';
									break;
								case 'O':
									$fcrIcon = 'directions_boat';
									break;
								case 'D':
									$fcrIcon = 'place';
							}

							$fcrIconInclude.append($fcrIcon);
							$tempSpan.prepend($fcrIconInclude);
						}
						
						$tempItem.append($tempSpan);
						$parent.append($tempItem);
					});
				});

				if(hasAir)$df.append($air);
				if(hasRail)$df.append($rail);
				if(hasSea)$df.append($sea);
				if(hasCity)$df.append($city);
				$locList.append($df);
				state[carID].drawn = true;
				if(AEdata.booking.quote.oLocs.hasOwnProperty(pID)){
					state[carID].P = pID;
					if(state[carID].D === ''){
						if(_.contains(state[carID].dLocs,pID)){
							APP.setD(carID,pID);
						}
						showList = 'DO';
						state[carID].pActive = false;
						$('#'+carID+' .direction_bar .switch_pu').removeClass('current');
						$('#'+carID+' .direction_bar .switch_do').addClass('current').removeClass('disabled');
					}
				}
			}
			refreshLocList(carID,showList);
			AE.ui.enableClicks();
		});
	}
	function refreshLocList(carID,direction){
		carID = carID || '';
		if(direction !== 'DO') direction = 'PU';
		if(state[carID]){
			var oState = state[carID],typeFilter = false,filterType = 'D';
			$('#'+carID+' li.trg__locSel--li').addClass('visuallyhidden').removeClass('pickup selected');
			$('.current_pickup').remove();
			var aLocs = (direction !== 'DO')? oState.pLocs : oState.dLocs;
			if(direction === 'DO' && AEdata.booking.quote.oLocs.hasOwnProperty(oState.P)){
				aLocs = _.union(aLocs,AEdata.booking.quote.oLocs[oState.P].aDOs);
				// WEABE3-1067 - A solution finally presents itself! Hallelujah! 11/13/2019 LW
				var aPrunedLocs = [];
				
				var oLocGroups = _.groupBy(aLocs,function(locID){return AEdata.booking.quote.oLocs[locID].AEID;});

				_.each(oLocGroups,function(aLocGroup){
					//old way: if(aLocGroup.length) aPrunedLocs.push(aLocGroup[0]);
					//WEBAE3-4848 favor puloc is a DO option too
					if(aLocGroup.length) {
						if(direction == 'DO' && _.indexOf(aLocGroup,oState.P) !== -1){
							aPrunedLocs.push(aLocGroup[_.indexOf(aLocGroup, oState.P)]);							
						} else {
							aPrunedLocs.push(aLocGroup[0]);
						}	
					}
				});
				
				//WEBAE3-6800 skip AEID pruning for translation API all locs
				if(aPrunedLocs.length && !oSite.bUseTapi) aLocs = aPrunedLocs;
			}

			if(AEdata.booking.quote.oQuote.allLocations){
				var tempDeskType = (direction === 'DO')? AEdata.booking.quote.oQuote.oDO.deskType : AEdata.booking.quote.oQuote.oPU.deskType;
				var tempLocList = (direction === 'DO')? AEdata.booking.quote.oQuote.oDO.locList : AEdata.booking.quote.oQuote.oPU.locList;
				tempLocList = (typeof(tempLocList) === 'number')? tempLocList.toString() : tempLocList.split(',');
				if(tempDeskType !== 'CITY' && tempDeskType !== ''){
					typeFilter = true;
					switch(tempDeskType){
						case 'AIRPORT': case 'AIRPORT_TERMINAL--ITEM':
							filterType = 'A';
							break;
						case 'RAIL':
							filterType = 'R';
							break;
						case 'undefined':
							typeFilter = false;
							break;
						default:
							filterType = 'O';
							break;
					}
				}
			}
			if(typeFilter){
				aLocs = _.filter(aLocs,function(tempLocID){
					var typeMatch = AEdata.booking.quote.oLocs[tempLocID].type === filterType;
					var locMatch = _.contains(tempLocList,String(Number(tempLocID)));
					return typeMatch && locMatch;
				});
			}
			_.each(aLocs,function(tempLocID){
				var $tempLoc = $('li#'+tempLocID+'-'+carID).removeClass('visuallyhidden');
				if(oState.P === tempLocID || oState.D === tempLocID){
					var $currPU = $(document.createElement('div')).addClass('current_pickup');
					if(oState.P === tempLocID){
						$tempLoc.addClass('pickup');
						if(direction === 'DO'){
							$currPU.append(AE.booking.matrix.results.props.oTranslations.PUHEAD);
							$tempLoc.prepend($currPU);
						}
					} else {
						if(direction === 'PU'){
							$currPU.append(AE.booking.matrix.results.props.oTranslations.DOHEAD);
							$tempLoc.prepend($currPU);
						}
					}
					$tempLoc.addClass('selected');
				}
			});
			AE.booking.matrix.maps.MAP.updateMap(carID);
		}
	}
	function refreshRateList(carID,locID,direction){
		// console.log('==========');
		// console.log(['CAR',carID,'previous',locID,'direction',direction]);
		carID = carID || '';
		locID = locID || '';
		if(state.hasOwnProperty(carID)){
            //WEBAE3-5224 force currentLocID reset to show rates in matrix
			var currentLocID = '';//(direction !== 'DO')? state[carID].P : state[carID].D;
			// console.log(['current',currentLocID,AEdata.booking.quote.oCars[carID].aRates]);
			if(locID !== currentLocID){
				var oState = state[carID],
					aRateIDs = [],
					selector = '#'+carID+' .result_rate_container';
					$container = $(selector);
				$container.empty();

				if(AEdata.booking.quote.oLocs[oState.P] && AEdata.booking.quote.oLocs[oState.D]){
					aRateIDs = _.filter(AEdata.booking.quote.oCars[carID].aRates,function(rateID){
						return AEdata.booking.quote.oRates[rateID].locID === oState.P;
					});
				}
				// console.log(oState);
				// console.log(aRateIDs);
				function ajaxError(jqXHR, textStatus, errorThrown, _dfdRCC) {
					return _dfdRCC ? _dfdRCC.resolve(aRateIDs) : false;
				}

				if(!_.isEmpty(aRateIDs)){
					AE.ui.addSpinner(selector, { size:'5x', color: 'black' });
					var $dfd_RateChangeCheck = $.Deferred(),
						unavailableTxt = AE.booking.matrix.results.props.oTranslations.ONEWAY_INVALID;
					AE.ui.disableClicks();
					if(oState.P === oState.D){
						$dfd_RateChangeCheck.resolve(aRateIDs);
					} else if(!ajaxLock){
						ajaxLock = true;
						$.ajax({
							url:'/plugins/ae3/lib/BookingAjax.cfc',
							dataType:'json',
							data:{
								method 		: 'getRateChangeDetails',
								bookingid 	: AEdata.booking.props.uuid,
								rates 		: aRateIDs.toString(),
								dolocid 	: oState.D
							}
						}).done(function(data, textStatus, jqXHR){
							var aGoodRateIDs = [],rateIdx = 0;
							_.each(aRateIDs,function(rateID){
								var	oRateChanges = data[rateID][oState.D];
								AE.booking.matrix.results.props.oRateChangeDetails[rateID][oState.D] = oRateChanges;

								if(typeof oRateChanges === 'undefined') return ajaxError( jqXHR, 'usererror', $dfd_RateChangeCheck );
									oRateChanges.oOW = oRateChanges.oOW || {};
									oRateChanges.oError = oRateChanges.oError || {};
									oRateChanges.oOW.validCombo = oRateChanges.oOW.validCombo || false;

								if(!oRateChanges.oOW.validCombo){
									var nameKey = (AE.booking.matrix.locations.isInterCityOW())? 'cityName' : 'locName';
									unavailableTxt = oRateChanges.oError.MSG || AE.booking.matrix.results.props.oTranslations.ONEWAY_INVALID;
									unavailableTxt = unavailableTxt
										.replace('--SUPPLIER--',AEdata.booking.quote.oSupps[AEdata.booking.quote.oCars[carID].suppID].fullName)
										.replace('--PUCITY--',AEdata.booking.quote.oLocs[oState.P][nameKey])
										.replace('--DOCITY--',AEdata.booking.quote.oLocs[oState.D][nameKey]);
								} else {
									aGoodRateIDs.push(rateID);
								}
								rateIdx++;
								if(rateIdx === aRateIDs.length){
									$dfd_RateChangeCheck.resolve(aGoodRateIDs);
								}
							});
						}).fail( ajaxError );
					}

					$dfd_RateChangeCheck.done(function(aGoodRateIDs){
						//WEBAE3-6512 trim rateIds before processing display
						aGoodRateIDs = AE.booking.matrix.results.trimRateFingers(aGoodRateIDs);
						aRateIDs = _.sortBy(_.intersection(aRateIDs,aGoodRateIDs),function(rateID){return AEdata.booking.quote.oRates[rateID].rate});
						var resultTags = (aRateIDs[0])? AEdata.booking.quote.oCars[carID].aTags : [];
						AE.ui.removeSpinner(selector);
						$container.append(AE.booking.matrix.results.buildRateFingerBlock(aRateIDs, true, oState.P, oState.D, unavailableTxt, resultTags, true, AEdata.booking.quote.oCars[carID]));
                        if(oState.P === oState.D) {
                            $(selector+' .package_pricing .small--note').remove(); // WEBAE3-6565 Remove one way fee notice if not one way...
                        }
						AE.ui.enableClicks();		
						ajaxLock = false;
					});
				} else {
					if(AEdata.booking.quote.oLocs[oState.D]){
						// console.log('No Rates with Pickup at selected: '+oState.P);
						// console.log([oState.D,AEdata.booking.quote.oLocs[oState.P].aDOs]);
					} else {
						// console.log('No Dropoff selected: '+oState.D);
					}
					ajaxLock = false;
				}
			}
		}
	}
	var APP = {
		init:function(){
			AE.ui.addBodyClickTask({func: APP.onBodyClick});
		},
		isInterCityOW:function(){
			return (AEdata.booking.quote.oQuote.oOW.country || AEdata.booking.quote.oQuote.oOW.city)? true : false;
		},
		BigMapClick:function(locID){
			_.each(state,function(oState){APP.setP(oState.ID,locID);});
		},
		buildState:function(carID){
			if(AEdata.booking.quote.oCars[carID] && !state[carID]){
				state[carID] = {
					ID:carID,P:'',D:'',drawn:false,pActive:true,pMap:'',dMap:'',dLocs:[],pLocs:getCarPUs(carID)
				};
			}
		},
		getState:function(carID){
			if(!state[carID]) APP.buildState(carID);
			return state[carID];
		},
		setP:function(carID,pID,calledBySwitchLists,skipRoundTrip){
            
        // console.log('348: setP');
			if(state.hasOwnProperty(carID) && AEdata.booking.quote.oLocs.hasOwnProperty(pID)){
        // console.log('350: Pass setP if');
				var prevLocID = state[carID].P;
				state[carID].P = pID;
				refreshRateList(carID,prevLocID);
			}
		},
		setD:function(carID,dID){
            
        // console.log('358: setD');
			if(state.hasOwnProperty(carID) && AEdata.booking.quote.oLocs.hasOwnProperty(dID)){
        // console.log('360: Pass setD if');
				var prevLocID = state[carID].D === '' ? dID : state[carID].D;
				state[carID].D = dID;
				refreshRateList(carID,prevLocID,'DO');
			}
		},
		onBodyClick:function ( event, $target ) {
			if ($target.hasClass('location_button')) {
				buildLocList($target.data('resultmapid'), $target.data('locid'));
			}
			if ($target.hasClass('switch_pu') || $target.hasClass('switch_do')) {
				var direction = $target.data('di');
				if(direction !== 'DO') direction = 'PU';
				
				var $dirBar = $target.closest('.direction_bar');
				if($dirBar[0]){
					var switchEnabled = true, oState = state[$dirBar.data('resultmapid')];
					if(direction === 'DO' && oState.P === '') switchEnabled = false;
					if(switchEnabled){
						oState.pActive = direction !== 'DO';
						$target.addClass('current').removeClass('disabled')
						.siblings((direction === 'PU')? '.switch_do' : '.switch_pu').removeClass('current');
						refreshLocList(oState.ID,direction);
					}
				}
			}
			if ($target.hasClass('trg__locSel--li') || $target.hasClass('trg__locSel--span') || 
					$target.parent('.trg__locSel--li').length) {
				var locID = $target.attr('locid');
				carID = $target.attr('id');
				
				if(locID === undefined){
					locID = $target.closest('.trg__locSel--li').attr('locid');
					carID = $target.closest('.trg__locSel--li').attr('id');
				}
				
				var aRawCarID = carID.split('-');
				if(aRawCarID.length === 2)  carID = aRawCarID[1];

				if(state.hasOwnProperty(carID)){
					var showList = 'PU';
					if(state[carID].pActive){
						APP.setP(carID,locID);
						if(state[carID].D === ''){
							var locMatch = true, switchList = true,  aSuppMatch = [];
							if(AEdata.booking.quote.oQuote.allLocations && AEdata.booking.quote.oQuote.oDO.deskType !== 'CITY'){
								var tempLocList = AEdata.booking.quote.oQuote.oDO.locList.split(',');
								locMatch = _.contains(tempLocList,String(Number(locID)));
								aSuppMatch = _.filter(state[carID].dLocs,function(thisLocID){
									var suppMatch = AEdata.booking.quote.oLocs[thisLocID].suppCode === AEdata.booking.quote.oLocs[locID].suppCode;
									return suppMatch && _.contains(tempLocList,String(Number(thisLocID)));
								});
							}
							if(locMatch && _.contains(state[carID].dLocs,locID)){
								APP.setD(carID,locID);
							} else {
								if(aSuppMatch.length > 0){
									APP.setD(carID,aSuppMatch[0]);
									switchList = false;
								}
							}
							if(switchList){
								showList = 'DO';
								state[carID].pActive = false;
								$('#'+carID+' .direction_bar .switch_pu').removeClass('current');
								$('#'+carID+' .direction_bar .switch_do').addClass('current').removeClass('disabled');
							}
						}
					} else {
						APP.setD(carID,locID);
						showList = 'DO';
					}
					refreshLocList(carID,showList);
				}
			}
		}
	};
	return APP;
})();
/*
First Open
	Draw Maps
	Write PU Lists
	Select Default PU Loc

Clicking either the PU or DO tab should:
	Always highlight current PU/DO selections (if any)
	Retain any pricing that was already displayed
	never re-price

Selecting a PU or DO location should:
	Remain on the same tab
	Highlight the newly selected location
	Re-price using the newly selected location with the previously selected location for the tab not being interacted with

Exceptions to the above:
	When PU=null, the DO tab should not be clickable
	This should only happen when the PU list is initially displayed
		
	When DO=null, selecting a PU location loads the DO list
*/
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.booking = AE.booking || {};
AE.booking.matrix = AE.booking.matrix || {};
AE.booking.matrix.events = AE.booking.matrix.events || (function(){
    
    var APP = {
        init:function(){
            AE.ui.addBodyClickTask({ func:function(event, $target){
                if($target.closest('li').hasClass('trg__matrix--event')){
                    var eCodes = $target.closest('li').data('event-code');
                    if(typeof(eCodes) === 'string' && goodData){
                        var aCodes = eCodes.split(',');
                        if(eCodes.length === 0){// blank top-left square
                            emitEvent('matrixInteractions','classClick','allClasses');
                            emitEvent('Matrix Tracking','label tracking','Car Class Label');
                            emitEvent('Matrix Tracking','supplier','ALL');
                        } else {
                            if(_.contains(aCodes,'AC') && _.contains(aCodes,'AS')){// first column / row (lowest rate) heading
                                emitEvent('matrixInteractions','allResultsClick','allClasses');
                                emitEvent('Matrix Tracking','label tracking','Car Class Label');
                                emitEvent('Matrix Tracking','supplier','ALL');
                            } else {
                                var oCodes = _.groupBy(aCodes,function(item){return item[0];});
                                var hasCats = (oCodes.hasOwnProperty('C') && oCodes.C.length)? true : false,
                                    hasSups = (oCodes.hasOwnProperty('S') && oCodes.S.length)? true : false;
                                if(!hasCats && hasSups){// supplier heading
                                    var sName = getSupName(_.first(oCodes.S));
                                    emitEvent('Matrix Tracking','label tracking','All Results Label');
                                    emitEvent('Matrix Tracking','supplier',sName);
                                    emitEvent('matrixInteractions','supplierClick',sName);
                                    emitEvent('matrixInteractions','allResultsClick','allClasses');
                                } else if(hasCats && !hasSups){// categorgy heading
                                    var cName = getCatName(_.first(oCodes.C));
                                    emitEvent('Matrix Tracking','label tracking','Car Class Label');
                                    emitEvent('Matrix Tracking','supplier','ALL');
                                    emitEvent('Matrix Tracking','carClass',cName);
                                    emitEvent('matrixInteractions','allResultsClick',cName);
                                } else if(oCodes.hasOwnProperty('A')){// lowest rate cell
                                    var cName = getCatName(_.first(oCodes.C));
                                    emitEvent('Matrix Tracking','label tracking','Car Class Label');
                                    emitEvent('Matrix Tracking','supplier','ALL');
                                    emitEvent('Matrix Tracking','carClass',cName);
                                    emitEvent('matrixInteractions','allResultsClick',cName);
                                } else {// regular cell
                                    var sName = getSupName(_.first(oCodes.S)),cName = getCatName(_.first(oCodes.C));
                                    emitEvent('Matrix Tracking','label tracking','All Results Label');
                                    emitEvent('Matrix Tracking','carClass',cName);
                                    emitEvent('Matrix Tracking','supplier',sName);
                                    emitEvent('matrixInteractions','classClick',cName);
                                    emitEvent('matrixInteractions','supplierClick',sName);
                                }
                                function getCatName(catCode){
                                    return (AEdata.booking.quote.oCats.hasOwnProperty(catCode))? AEdata.booking.quote.oCats[catCode].track : '';
                                }
                                function getSupName(supCode){
                                    var aSupps = _.pluck(_.filter(AEdata.booking.quote.oSupps,function(oS){return oS.filter === supCode;}),'name');
                                    if(aSupps.length > 0){
                                        return aSupps[0].toLowerCase();
                                    } else {
                                        return '';
                                    }
                                }
                            }
                        }
                    } else {// blank top-left square
                        emitEvent('matrixInteractions','classClick','allClasses');
                        emitEvent('Matrix Tracking','label tracking','Car Class Label');
                        emitEvent('Matrix Tracking','supplier','ALL');
                    }
                }
            }});
        },
        /* WEBAE3-6014 SETUP GA4 Ecommerce Tracking  */
        buildGA4EcommerceItem: function(id, name, affiliation, category, price, quantity)
        {
            return {
                item_id         : id,           // (String) Required if no name is provided - vehicle rate ID (ex. II-2-CDAE-0002793775)
                item_name       : name,         // (String) Required if no ID is provided - vehicle name (ex. Opel Corsa)
                affiliation     : affiliation,  // (String) Not Required - vehicle provider (ex. Europcar)
                item_category   : category,     // (String) Not Required - vehicle SIPPS (ex. EDMR,EDMRZQ)
                price           : price,        // (Number/Float) Not Required - price (create separate items for each vehicle price)
                quantity        : quantity      // (Number/Float) Not Required - quantity
            }
        },
        buildEcommerceViewList: function(item_list_id, item_list_name, items)
        {
            var viewItemList = {
                item_list_id    : item_list_id,     // Required - list id (ex: matrix_results)
                item_list_name  : item_list_name,   // Required - list name (ex: Matrix Results)
                items           : items             // Required - array of items 
            }
            //console.log(viewItemList);
            return viewItemList;
        },
        buildEcommerceViewItem: function(currency, value, items)
        {
            var viewItem = {
                currency    : currency,     // Required if value is set
                value       : value,        // Not Required - value of item
                items       : items         // Required - array of items 
            }
            
            return viewItem;
        },
        buildEcommerceCheckout: function(currency, value, items)
        {
            var checkout = {
                currency    : currency,     // Required if value is set
                value       : value,        // Not Required - value of item
                items       : items         // Required - array of items 
            }
            
            return checkout;
        },
        buildEcommerceViewItem: function(currency, value, items)
        {
            var cartChange = {
                currency    : currency,     // Required if value is set
                value       : value,        // Not Required - value of item being viewed
                items       : items         // Required - array of items 
            }
            
            return cartChange;
        },
        buildEcommercePurchase: function(currency, value, transaction_id, items)
        {
            var purchase = {
                currency        : currency,         // Required if value is set
                value           : value,            // Not Required - value of items being added/removed from cart
                transaction_id  : transaction_id,   // Required - Booking Voucher Number
                items           : items             // Required - array of items 
            }
            
            return purchase;
        },
        emitGA4EcommerceEvent: function(eventType, ecomData)
        {        
            if(aeDataLayer) {
                aeDataLayer.push({ ecommerce: null }); // Clear any previous ecommerce object
                aeDataLayer.push({
                    event: eventType,       // Required - event type (ex. view_item_list)
                    ecommerce: ecomData     // Required - ecommerce event data
                });
            }
        }
    };
    
	function buildEvent(argCategory,argAction,argLabel){
		return {
		  'event' : 'gaEvent',				// gaEvent is the custom trigger in GTM for an event Tag
		  'eventCategory' : argCategory,	// Required - category
		  'eventAction' : argAction,		// Required - action
		  'eventLabel' : argLabel,			// Not Required - label
		  'eventValue' : undefined
		};
	}
    
	function emitEvent(argCategory,argAction,argLabel){
		var oEvent = buildEvent(argCategory,argAction,argLabel);
		// alert(argCategory+' '+argAction+' '+argLabel);
		if(aeDataLayer) aeDataLayer.push(oEvent);
	}
	var goodData = false;
	if(AEdata !== undefined && 
		AEdata.hasOwnProperty('booking') && 
		AEdata.booking.hasOwnProperty('quote') && 
		AEdata.booking.quote.hasOwnProperty('oCats') && 
		AEdata.booking.quote.hasOwnProperty('oSupps')
	){goodData = true;}
	return APP;
})();
;
var AE = AE || {};
AE.booking = AE.booking || {};
AE.booking.options = AE.booking.options || (function() {
    var APP = {
        init: function() {
            APP.props = {
                rateFamily: [],
                offerDerc: (AE.props.isAUNZ) ? true : false,
                offerBrp: (AE.props.isAUNZ) ? true : false,
                mixedFuelPolicy: false,
                mixedKm: false,
                maxIncludes: 0,
                jsonPost: {},
                gaEvents: {},
                test:'',
                gaEventCategory: ''
            };
            APP.props.rateFamily = APP.findRateFamily();
            APP.computeMaxIncludes();
            APP.setJsonPost();
            // Set gaEventCategory - only run once
            APP.props.gaEventCategory = APP.props.jsonPost.trackCategory + 'Chart_';
            var startRateType = (APP.props.jsonPost.insuranceUpgradeChoice === 'None_Selected') ? 'Basic' : APP.props.jsonPost.insuranceUpgradeChoice;
            var uniqRateTypes = [startRateType];
            APP.props.gaEventCategory += startRateType + '_to_';
            _.each(_.without(APP.props.rateFamily, AEdata.booking.state.rateID), function(tempRateID) {
                var tempRate = AEdata.booking.quote.oRates[tempRateID];
                if (tempRate) {
                    var tempPackage = tempRate.package || '';
                    if (tempPackage.length === 3) {
                        tempPackage = tempPackage.substring(0, 2).toUpperCase();
                    } else if (tempPackage.length) {
                        tempPackage = tempPackage[0].toUpperCase() + tempPackage.substring(1, tempPackage.length);
                    }
                    if (tempPackage && !_.contains(uniqRateTypes, tempPackage)) {
                        uniqRateTypes.push(tempPackage);
                        if (_.last(APP.props.gaEventCategory) !== '_') APP.props.gaEventCategory = APP.props.gaEventCategory + '_or_';
                        APP.props.gaEventCategory += tempPackage;
                    }
                }
            });
            //Offer BRP for AUS&NZL sourced affiliates
            if (AE.props.affiliate && AE.props.affiliate !='') {
                APP.props.offerBrp = (AE.props.isAUNZ) ? true : false;
            }

            if(AEdata.booking.quote.oQuote){
                 APP.props.offerBrp = (AEdata.booking.quote.oQuote.oPU.country == 'US') ? true : false;         

            }
            APP.setGaEvents();
            APP.fetch(true);
            if (!_.isEmpty(APP.props.rateFamily)) AE.ga.gaTrackEvent(APP.props.gaEvents.load.GACATEGORY, APP.props.gaEvents.load.GAACTION);
            if (AE.booking.options.ui) AE.booking.options.ui.init();

        },
        sortRateIDs: function(aRateIDs) {
            return _.sortBy(aRateIDs, function(tempRateID) {
                return AE.booking.props.oRateObjects[tempRateID].rate;
                /*return _.indexOf('basic,inclusive,ZC,ZD,ZE,RE,ZM,ZS,ZQ,ZR,ZX,ZB'.split(','),
                    AE.booking.props.oRateObjects[tempRateID].package.replace('1', '')
                );*/
            });
        },
        findRateFamily: function(onlyUpgrades, includeCousins, rateID) {
            onlyUpgrades = onlyUpgrades || true;
            includeCousins = includeCousins || true;
            rateID = rateID || AEdata.booking.state.rateID;
            var aRateIDs = [];
            if (AE.booking.props.oRateObjects[rateID]) {
                var thisRate = AE.booking.props.oRateObjects[rateID];
                var thisCar = AE.booking.props.oCarObjects[thisRate.carID];
                if (!thisCar.isLTR) {
                    aRateIDs = _.uniq(thisCar.aRates);

                    if (includeCousins) {
                        var aExcludeCodes = _.without(thisCar.aSIPPNotes, 'FE', 'FF', 'LK', 'ULK');
                        if(thisRate.package === 'ZD' || thisRate.package === 'ZR'){
                            aExcludeCodes = _.without(_.union(aExcludeCodes,[thisRate.package]),'ZQ');
                        } else if(thisRate.package === 'ZQ') {
                            //WEBAE3-6198 - FCR wants ZQ to upgrade to ZR
                            if(AE.props.siteCode !== 'FCR'){
                                aExcludeCodes = _.without(_.union(aExcludeCodes,['ZR']),'ZQ');}
                        }
                        var relatedCars = _.filter(AE.booking.props.oCarObjects,
                            function(tempCar) {
                                var aTempExcludeCodes = _.without(tempCar.aSIPPNotes, 'FE', 'FF', 'LK', 'ULK');
                                var closeSIPP = thisCar.SIPPfamily === tempCar.SIPPfamily; //thisCar.SIPP.substring(0,4) === tempCar.SIPP.substring(0,4);
                                var sameSupp = thisCar.suppCode === tempCar.suppCode;
                                var sameCodes = aExcludeCodes.length === aTempExcludeCodes.length && _.union(aExcludeCodes, aTempExcludeCodes).length === aExcludeCodes.length;
                                var sameOffers = tempCar.aOffers.length === thisCar.aOffers.length && _.union(tempCar.aOffers, thisCar.aOffers).length === thisCar.aOffers.length;
                                var differentID = thisCar.ID !== tempCar.ID;
                          
                                //WEBAE3-5595 - the logic above for sameOffers doesn't always work for FCR. Maybe because we don't group rates on the matrix for FCR. This works though.
                                if(AE.props.siteCode === 'FCR' && thisCar.aOffers.length > 0){
                                    for(i = 0; i < thisCar.aOffers[0].length; i++) {
                                        var found = $.inArray(thisCar.aOffers[0][i], tempCar.aOffers[0]);
                                        if( !(-1 == found) ) {
                                            var sameOffers = true;
                                        } else {
                                            var sameOffers = false;
                                        }
                                    }
                                }
                                
                                if (APP.props && closeSIPP && sameSupp && sameCodes && sameOffers && differentID) {
                                    if (APP.props.mixedFuelPolicy !== undefined && thisCar.oSIPPNotes.SIPPLINKFUELCODES !== tempCar.oSIPPNotes.SIPPLINKFUELCODES) APP.props.mixedFuelPolicy = true;
                                    if (APP.props.mixedKm !== undefined && thisCar.hasUnlimitedKm !== tempCar.hasUnlimitedKm) APP.props.mixedKm = true;
                                }

                                return closeSIPP && sameSupp && sameCodes && sameOffers && differentID;
                                
                            }
                            
                        );
                        _.each(relatedCars, function(tempCar) {
                            aRateIDs = _.union(aRateIDs, tempCar.aRates);
                        });
                          
                          
                    }
                    
                    aRateIDs = _.filter(aRateIDs,
                        function(thisRateID) {
                            return thisRate.locID === AE.booking.props.oRateObjects[thisRateID].locID;
                        }
                    );
                    if (onlyUpgrades) {
                        var aKeepPackages = ['IZ'];
                        //WEBAE3-6439 - change from 6085 updated to remove source EU so ZE upgrades determined in disownRateFamily
                        if (thisRate.package === 'ZE'){// WEBAE3-6085
                            if( _.contains(['GB'],AE.props.chaosSystem) && 
                                !_.contains(['ATP','DTP','AVD'],AE.props.mSiteCode)
                            ){
                                aKeepPackages = [];// Don't offer other ZX packages as upgrades for the ZE package that is most expensive
                                if(AEdata.booking.quote.oQuote.oPU.country === 'US'){
                                    // WEBAE3-6335 Detect ZBs so we can offer them as an upgrade
                                    aZBRateIDs = _.filter(aRateIDs, function(aSiblingID) {
                                        return AEdata.booking.quote.oRates[aSiblingID].package === 'ZB';
                                    });
                                    if(aZBRateIDs.length){
                                        aKeepPackages = ['IZ'];
                                    }
                                }
                            }
                        }
                        if (thisRate.packageType === 'II' || thisRate.packageType === 'IB') aKeepPackages.unshift('II');
                        if (thisRate.packageType === 'IB') aKeepPackages.unshift('IB');
                        aRateIDs = _.filter(aRateIDs, function(aSiblingID) {
                            return _.contains(aKeepPackages, aSiblingID.substring(0, 2));
                        });
                    }
                    aRateIDs = APP.sortRateIDs(aRateIDs);
                }
            }
            return aRateIDs;
        },
        disownRateFamily: function(argRateID,argRateFamily) {
            /* WEBAE3-5468 added optional rateID and rateFamily arguments that can be passed in when
            a matrix rate finger is clicked. This will force this function to only do insurance upgrade
            tests and prevent errors from objects that are only defined within the scope of the /options page
            This is needed so we can determine at time of matrix rate finger click whether an insurance 
            upgrade could apply
            */

            var checkInsuranceOnly = false;
            if(argRateID === undefined && argRateFamily === undefined) {
                var rateID = AEdata.booking.state.rateID || [];
                var aRateIDs = APP.props.rateFamily || [];
            } else {
                //WEBAE3-5468 use args from rate click 
                var rateID = argRateID;
                var aRateIDs = argRateFamily;
                checkInsuranceOnly = true;
            }
            if (AE.booking.props.oRateObjects[rateID]) {
                var thisRate = AE.booking.props.oRateObjects[rateID];
                var thisCar = AE.booking.props.oCarObjects[thisRate.carID];
                //STORE-1509 - added ZK option
                var aExpectations = 'ZN,ZE,ZE1,RE,ZB,ZC,ZD,ZR,ZS,ZS1,ZM,ZQ,ZK'.split(',');
                //STORE-1524 - added cover genius (CG) as possible Basic/IB upgrade
                if (thisRate.packageType === 'IB') aExpectations.push('inclusive','CG');
                //WEBAE3-6439 - added this rule per Nik to keep standard inclusive upgrade to ZR, ZQ only
                if (thisRate.packageType === 'II' && !_.contains(['ATP','DTP','AVD'],AE.props.mSiteCode) && _.contains(['EU'],AE.props.chaosSystem)) aExpectations = 'ZR,ZQ'.split(',');
               
                if (thisRate.packageType === 'IZ') {
                    aExpectations = ['ZB'];
                    switch (thisRate.package) {
                        case 'ZD':
                            //WEBAE3-6410 - US, CA: Insurance upgrade logic for new ZDZR rates
                            //WEBAE3-6410.2 - removed ATP exclusion
                            if(_.contains(['US','CA'],AE.props.chaosSystem)){
                                aExpectations = 'ZQ,ZB,ZR'.split(',');
                            } else {
                                aExpectations = 'ZQ,ZB'.split(',');
                            }
                            break;
                        case 'ZE':
                        case 'ZE1':
                        case 'ZN':
                            //WEBAE3-6439 - EU Insurance upgrade logic for new ZEZD rates
                            if(!_.contains(['ATP','DTP','AVD'],AE.props.mSiteCode) && _.contains(['EU'],AE.props.chaosSystem)){
                                aExpectations = 'ZD,ZR,ZS,ZS1,ZM,ZB'.split(',');
                            } else {
                                aExpectations = 'ZR,ZS,ZS1,ZM,ZB'.split(',');
                            }
                            break;
                        case 'ZQ':
                            aExpectations = 'ZR'.split(',');
                            break;
                        
                        //WEBAE3-6439 - EU Insurance upgrade logic for new ZS,ZSZD,ZSZB rates
                        case 'ZS': 
                                //EU only add ZD to ZB for options
                                if(!_.contains(['ATP','DTP','AVD'],AE.props.mSiteCode) && _.contains(['EU'],AE.props.chaosSystem)){
                                    aExpectations = 'ZD,ZB'.split(',');
                                }
                                break;
                        //WEBAE3-6522 proof of concept for ZAF capetown first car missing upgrade
                        case 'RE': case 'RM': // added RM for WEBAE3-6526 & WEBAE3-6524 insurance upgrades 
                            aExpectations.push('ZD');
                            aExpectations.push('ZR');
                            break;
                            
                    }
                }
                aRateIDs = _.filter(aRateIDs, function(thisRateID) {
                    return thisRateID === thisRate.ID || (AE.booking.props.oRateObjects[thisRateID] !== undefined && ('package' in AE.booking.props.oRateObjects[thisRateID]) && _.contains(aExpectations, AE.booking.props.oRateObjects[thisRateID].package));
                });

                var oFound = _.groupBy(aRateIDs, function(thisRateID) {
                    return AE.booking.props.oRateObjects[thisRateID].package;
                }); 

                var aShow = [];

                //STORE-1524 - basic rate & cg overrides ALL other aShow rules
                if(thisRate.package === 'basic' && oFound.CG) {
                    aShow.push('CG');
                } else if(thisRate.package === 'inclusive' && oFound.ZK) {
                    //STORE-1509 if inclusive rate and ZK is found just show it skip other rules
                    aShow.push('ZK');
                } else {
                    //run original aShow rules
                    //WEBAE3-6439 - EU specific rules - NOTE: remove ,'ZX','ZR','ZM' from _.contains check if these are wrong
                    if(!_.contains(['ATP','AVD','DTP'],AE.props.mSiteCode) && _.contains(['EU'],AE.props.chaosSystem) && _.contains(['ZD','ZE','ZS','ZB','ZX','ZR','ZM'],thisRate.package)) {
                        //if no SIPPsuffix, use package
                        //sippsuffix not needed? - it might be more than just a Z* modifiers and we determine package in rate aggregation for compound Z sippSuffixes like ZEZB
                        //let testPackage = (thisRate.SIPPsuffix.length === 0) ? thisRate.package : thisRate.SIPPsuffix;
                        switch (thisRate.package) {
                            case 'ZD':
                                if (oFound.ZB) { 
                                    aShow.push('ZB');
                                }
                                break;
                            case 'ZE':
                            case 'ZS':
                                if (oFound.ZB) {
                                    aShow.push('ZB');
                                }
                                //added this rule                            
                                if (oFound.ZD) {
                                    aShow.push('ZD');
                                }
                                break;
                            case 'ZB':
                                break;
                            
                            //rest of cases below from 6410: revise or delete?
                            case 'ZR':
                                break;
                            case 'ZX':
                                if (oFound.ZB) {
                                aShow.push('ZB');
                                }
                                break;
                            case 'ZM':
                                if (oFound.ZB) {
                                    aShow.push('ZB');
                                }
                                break;
                            //end of cases from 6410
                        }

                    }
                    //WEBAE3-6410 - US, CA: Insurance upgrade logic for new ZDZR rates
                    //WEBAE3-6410.2 - removed ATP exclusion
                    else if(_.contains(['US','CA'],AE.props.chaosSystem) && _.contains(['ZD','ZE','ZX','ZM','ZS','ZR','ZB'],thisRate.package)) {
                        switch (thisRate.SIPPsuffix) {
                            case 'ZD':
                                if (oFound.ZR && (oFound.ZR[0].includes('ZDZR') || oFound.ZR[0].includes('ZR'))) {
                                    aShow.push('ZR');
                                }
                                break;
                            case 'ZE':
                                if (oFound.ZB && oFound.ZB[0].includes('ZEZB')) {
                                    aShow.push('ZB');
                                }
                                break;
                            case 'ZEZB':
                                break;
                            case 'ZDZR':
                                break;
                            case 'ZR':
                                break;
                            case 'ZX':
                                if (oFound.ZB && oFound.ZB[0].includes('ZXZB')) {
                                    aShow.push('ZB');
                                }
                                break;
                            case 'ZXZB':
                                break;
                            case 'ZM':
                                if (oFound.ZB && oFound.ZB[0].includes('ZMZB')) {
                                    aShow.push('ZB');
                                }
                                break;
                            case 'ZMZB':
                                break;
                            case 'ZS':
                                if (oFound.ZB && oFound.ZB[0].includes('ZSZB')) {
                                    aShow.push('ZB');
                                }
                                break;
                            case 'ZSZB':
                                break;
                        }

                    }
                    //WEBAE3-6410 - I guess these rules don't apply to US/CA (except for ATP) anymore? Leaving a note here in case the 'else' needs to be removed.
                    else if (thisRate.packageType === 'IZ' && !oFound.ZB) {
                        switch (thisRate.package) {
                            case 'ZD':
                                if (oFound.ZQ) {
                                    aShow.push('ZQ');
                                }
                                break;
                            case 'ZE':
                            case 'ZE1':
                            case 'ZN': 
                                if (oFound.ZR) {
                                    //WEBAE3-6612 - AU,NZ: Remove ZE --> ZR insurance upgrade
                                    if(!_.contains(['AU','NZ'],AE.props.chaosSystem)){
                                        aShow.push('ZR');
                                }
                                } else if ((oFound.ZS || oFound.ZS1) && oFound.ZM) {
                                    aShow.push('ZS');
                                    aShow.push('ZS1');
                                    aShow.push('ZM');
                                } else if (oFound.ZS || oFound.ZS1) {
                                    aShow.push('ZS');
                                    aShow.push('ZS1');
                                } else if (oFound.ZM) {
                                    aShow.push('ZM');
                                }
                                break;
                            case 'ZQ':
                                if (oFound.ZR) {
                                    aShow.push('ZR');
                                }
                                break;
                            //WEBAE3-6522 - add upgrade path for RE to REZD, REZR
                            case 'RE': case 'RM': // added RM for WEBAE3-6526 & WEBAE3-6524 insurance upgrades 
                                if (oFound.ZD) {
                                    aShow.push('ZD');
                                }
                                if (oFound.ZR) {
                                    aShow.push('ZR');
                                }
                                break;
                        }
                    } else {
                        if (thisRate.packageType === 'IB') aShow.push('inclusive');

                        //WEBAE3-6476 - US,CA: When Basic or Inclusive are selected & only RE is found offer RE upgrade
                        if (_.contains(['US','CA'],AE.props.chaosSystem)) {
                            if (thisRate.packageType === 'II' && _.size(oFound) === 2 && oFound.RE) {
                                aShow.push('RE');
                            } else if (thisRate.packageType === 'IB' && _.size(oFound) === 3 && oFound.inclusive && oFound.RE) {
                                aShow.push('RE');
                            }
                        }

                        //WEBAE3-6410 - US, CA: Insurance upgrade logic for new ZDZR rates
                        //WEBAE3-6410.2 - removed ATP exclusion
                        if(_.contains(['US','CA'],AE.props.chaosSystem)) {
                            if (thisRate.packageType === 'IB' && oFound.ZR) {
                                aShow.push('ZR');
                            } else if (thisRate.packageType === 'IB' && !oFound.ZR && oFound.ZB) {
                                //WEBAE3-7113 added existence checked for ZB so we can cascade to ZE instead of forcing ZB
                                aShow.push('ZB');
                            } else if((thisRate.packageType === 'IB' && oFound.ZE)){
                                //WEBAE3-7113 show ZE if we have it, TBI/Skylink more likely to have this upgrade
                                aShow.push('ZE');                            
                            }

                            if (thisRate.packageType === 'II' && !oFound.ZD && !oFound.ZR) {
                                aShow.push('ZE');
                                aShow.push('ZB');
                                aShow.push('ZX');
                                aShow.push('ZM');
                                aShow.push('ZS');
                            } else if (thisRate.packageType === 'II' && oFound.ZD && oFound.ZR) {
                                aShow.push('ZD');
                                aShow.push('ZR');
                            }       
                        }
                        //WEBAE3-6410 - If not US,CA or aShow is empty, proceed.
                        //WEBAE3-6410 HOTFIX: added || _.contains(['ATP'],AE.props.mSiteCode)
                        //WEBAE3-6410.2 - removed ATP exclusion and hotfix patch
                        if ((_.contains(['US','CA'],AE.props.chaosSystem) && aShow.length === 0) || !_.contains(['US','CA'],AE.props.chaosSystem)) {
                            if (oFound.ZD && oFound.ZQ) {
                                //WEBAE3-6486 source EU ATP skips ZD->ZQ upgrade rule
                                if(_.contains(['EU'],AE.props.chaosSystem) && _.contains(['ATP'],AE.props.mSiteCode)) {
                                    switch (thisRate.package){
                                        case 'inclusive':
                                            aShow.push('ZQ');
                                            aShow.push('ZR');
                                            break;
                                        case 'ZD':
                                            aShow =['ZD'];//won't upgrade to itself
                                            break;                                        
                                    }
                                } else {
                                    //WEBAE3-6439 - make sure this doesn't fire if EU based ATP, DTP or AVD falls through
                                    if(!_.contains(['EU'],AE.props.chaosSystem) || (_.contains(['EU'],AE.props.chaosSystem) && !_.contains(['DTP','ATP','AVD'],AE.props.mSiteCode))){
                                        aShow.push('ZD');
                                        aShow.push('ZQ');
                                    }
                                }
                            } else if (oFound.ZQ && oFound.ZR) {
                                aShow.push('ZQ');
                                aShow.push('ZR');
                            } else if (oFound.ZQ) {
                                aShow.push('ZQ');
                            } else if (oFound.ZC && oFound.ZQ) {
                                aShow.push('ZC');
                                aShow.push('ZQ');
                            } else if ((oFound.ZE || oFound.ZE1 || oFound.ZN) && oFound.ZR) {
                                //WEBAE3-6486 source EU ATP skips ZE upgrade rule
                                if(_.contains(['EU'],AE.props.chaosSystem) && _.contains(['ATP'],AE.props.mSiteCode)) {
                                    aShow=['ZE'];
                                } else {
                                    aShow.push('ZE');
                                    aShow.push('ZE1');
                                    aShow.push('ZN');
                                    //WEBAE3-6612 - AU,NZ: Remove ZE --> ZR insurance upgrade
                                    if(!_.contains(['AU','NZ'],AE.props.chaosSystem)){
                                        aShow.push('ZR');
                                    }
                                }
                            } else if (oFound.ZD) {
                                aShow.push('ZD');
                            } else if (oFound.ZB) {
                                //WEBAE3-6486 source EU ATP skips ZS upgrade rule
                                if(_.contains(['EU'],AE.props.chaosSystem) && _.contains(['ATP'],AE.props.mSiteCode) && (thisRate.package === 'ZS'||thisRate.package === 'ZR')) { 
                                    aShow=[thisRate.package];//set to whatever package tripped this rule so we skip ins upgrade
                                } else {
                                    //WEBAE3-6439 - make sure this doesn't fire if EU based ATP, DTP or AVD falls through
                                    if(!_.contains(['EU'],AE.props.chaosSystem) || (_.contains(['EU'],AE.props.chaosSystem) && !_.contains(['DTP','ATP','AVD'],AE.props.mSiteCode))){
                                        aShow.push('ZB');
                                    }    
                                    
                                }     
                            } else if (oFound.ZC) {
                                aShow.push('ZC');
                            } else if (oFound.ZE || oFound.ZE1 || oFound.ZN) {
                                aShow.push('ZE');
                                aShow.push('ZE1');
                                aShow.push('ZN');
                            } else if (oFound.RE) {
                                aShow.push('RE');
                            } else if (oFound.ZR) {
                                aShow.push('ZR');
                            } else if ((oFound.ZS || oFound.ZS1) && oFound.ZM) {
                                aShow.push('ZS');
                                aShow.push('ZS1');
                                aShow.push('ZM');
                            } else if (oFound.ZS || oFound.ZS1) {
                                aShow.push('ZS');
                                aShow.push('ZS1');
                            } else if (oFound.ZM) {
                                aShow.push('ZM');
                            }
                        }
                    }
                }

                aRateIDs = _.filter(aRateIDs, function(thisRateID) {
                    return thisRateID === thisRate.ID || (AE.booking.props.oRateObjects[thisRateID] !== undefined && ('package' in AE.booking.props.oRateObjects[thisRateID]) && _.contains(aShow, AE.booking.props.oRateObjects[thisRateID].package));
                });
                
                //WEBAE3-6878 - Don't mix RE and RM rates
                if (thisRate.SIPP.includes('RE')) {
                    for (let i = 0; i < aRateIDs.length; i++) {
                        if(aRateIDs[i].includes('RM')){
                            aRateIDs.splice([i], 1);
                        }
                    }
                }
                if (thisRate.SIPP.includes('RM')) {
                    for (let i = 0; i < aRateIDs.length; i++) {
                        if(aRateIDs[i].includes('RE')){
                            aRateIDs.splice([i], 1);
                        }
                    }
                }

                //WEBAE3-6664 - EU: Remove insurance downgrades
                if (_.contains(['EU'],AE.props.chaosSystem)) {
                    if (oFound.ZD && thisRate.package == 'ZS') {
                        for (let i = 0; i < aRateIDs.length; i++) {
                            if(aRateIDs[i].includes('ZEZD')){
                                aRateIDs.splice([i], 1);
                            }
                        }
                    }
                    if (oFound.ZB && thisRate.package == 'ZS') {
                        for (let i = 0; i < aRateIDs.length; i++) {
                            if(aRateIDs[i].includes('ZEZB')){
                                aRateIDs.splice([i], 1);
                            }
                        }
                    }
                    if (oFound.ZD && thisRate.package == 'ZE') {
                        for (let i = 0; i < aRateIDs.length; i++) {
                            if(aRateIDs[i].includes('ZSZD')){
                                aRateIDs.splice([i], 1);
                            }
                        }
                    }
                    if (oFound.ZB && thisRate.package == 'ZE') {
                        for (let i = 0; i < aRateIDs.length; i++) {
                            if(aRateIDs[i].includes('ZSZB')){
                                aRateIDs.splice([i], 1);
                            }
                        }
                    }
                }

                //WEBAE3-5468 if not a matrix click, check everything
                if(!checkInsuranceOnly) {
                    var oFuel = _.groupBy(aRateIDs, function(thisRateID) {
                        return AE.booking.props.oCarObjects[AE.booking.props.oRateObjects[thisRateID].carID].oSIPPNotes.SIPPLINKFUELCODES;
                    });
                    aRateIDs = oFuel[thisCar.oSIPPNotes.SIPPLINKFUELCODES] || aRateIDs;
                    APP.props.mixedFuelPolicy = false;
                    oPostFuelFound = _.groupBy(aRateIDs, function(thisRateID) {
                        return AE.booking.props.oRateObjects[thisRateID].package;
                    });
                    _.each(_.omit(oFuel, thisCar.oSIPPNotes.SIPPLINKFUELCODES), function(theseRateIDs) {
                        _.each(theseRateIDs, function(thisRateID) {
                            if (!oPostFuelFound[AE.booking.props.oRateObjects[thisRateID].package]) {
                                aRateIDs.push(thisRateID);
                                APP.props.mixedFuelPolicy = true;
                            }
                        });
                    });
                    var oKm = _.groupBy(aRateIDs, function(thisRateID) {
                        return AE.booking.props.oCarObjects[AE.booking.props.oRateObjects[thisRateID].carID].hasUnlimitedKm;
                    });
                    aRateIDs = oKm[thisCar.hasUnlimitedKm] || aRateIDs;
                    APP.props.mixedKm = false;
                    oPostKmFound = _.groupBy(aRateIDs, function(thisRateID) {
                        return AE.booking.props.oRateObjects[thisRateID].package;
                    });
                    _.each(_.omit(oKm, thisCar.hasUnlimitedKm), function(theseRateIDs) {
                        _.each(theseRateIDs, function(thisRateID) {
                            if (!oPostKmFound[AE.booking.props.oRateObjects[thisRateID].package]) {
                                aRateIDs.push(thisRateID);
                                APP.props.mixedKm = true;
                            }
                        });
                    });
                    if (APP.props.mixedFuelPolicy || APP.props.mixedKm) {
                        aRateIDs = APP.sortRateIDs(aRateIDs);
                    }
                    APP.props.rateFamily = aRateIDs;
                }
            }
            return aRateIDs;
        },
        computeMaxIncludes: function() {
            if (APP.props.rateFamily.length) {
                _.each(APP.props.rateFamily,
                    function(tempRateID) {
                        var tempRate = AEdata.booking.quote.oRates[tempRateID];
                        var tempInsurance = AE.props.oTranslations.INSURANCES[tempRate.package];
                        var tempCar = AEdata.booking.quote.oCars[tempRate.carID];
                        var tempARR = AE.booking.applyInsuranceIncludeListOverrides(tempInsurance.ARR, tempCar.packagesDoInclude);
                        if (tempARR.length > APP.props.maxIncludes) APP.props.maxIncludes = tempARR.length;
                     }
                );
            }
        },
        setJsonPost: function(rateID, dropID) {
            rateID = rateID || AEdata.booking.state.rateID;
            dropID = dropID || AEdata.booking.state.dropID;
            if (AEdata.booking.quote.oRates[rateID]) {
                var thisRate = AEdata.booking.quote.oRates[rateID];
                APP.props.jsonPost = {
                    gaPostEvents: [],
                    sessid: AE.props.sessid,
                    aff: AEdata.booking.quote.oQuote.aff,
                    c: AEdata.booking.quote.oQuote.campaign,
                    quoteid: AEdata.booking.quote.oQuote.ID,
                    pucode: AEdata.booking.quote.oQuote.oPU.country,
                    CarSearchUUID: AEdata.booking.props.uuid,
                    rateID: rateID,
                    sipp: thisRate.SIPP,
                    rateType: (thisRate.packageType === 'IB') ? 'b' : 'i',
                    submitForm: (thisRate.packageType === 'IB') ? 'basic' : 'inclusive',
                    insuranceUpgradeChoice: (thisRate.packageType === 'IB') ? 'None_Selected' : (thisRate.packageType === 'II') ? 'Inclusive' : thisRate.package.substring(0, 2),
                    rowid: thisRate.row,
                    puloc: thisRate.locID,
                    doloc: dropID,
                    searchAge: AEdata.booking.quote.oQuote.age,
                    searchAgeCheckbox: AEdata.booking.quote.oQuote.searchAgeCheckbox,
                    insuranceUpgradeChecked: true,
                    trackCategory: (AEdata.booking.props.ismodify)? 'Modify2_' : 'Car2_',
                    bookingstep: 'bookform',
                    upgradeID: '',
                    EXCL_LTR: (AEdata.booking.props.type === 'lease')? AEdata.booking.quote.oFilters.LTR : false,
                    EXCL_CATS: ''
                };
                APP.props.jsonPost.EXCL_CATS = _.filter(
                    _.keys(AEdata.booking.quote.oFilters.CX),
                    function(catID) {
                        return AEdata.booking.quote.oFilters.CX[catID];
                    }
                ).toString();
            }
        },
        setGaEvents: function() {
            APP.props.gaEvents = {
                load: {
                    GACATEGORY: APP.props.gaEventCategory,
                    GAACTION: 'ShowScreen'
                },
                submit: {
                    GACATEGORY: APP.props.gaEventCategory,
                    GAACTION: 'FormSubmit',
                    GALABEL: (APP.props.jsonPost.insuranceUpgradeChoice === 'None_Selected') ? 'Basic' : APP.props.jsonPost.insuranceUpgradeChoice
                },
                noUpgrade: {
                    GACATEGORY: APP.props.jsonPost.trackCategory + 'Class_Upgrade',
                    GAACTION: 'UpgradeNotOffered',
                    GALABEL: APP.props.jsonPost.sipp
                }
            };
        },
        updateDailyDiffs: function() {
            if(AEdata.booking.quote.oRates[AEdata.booking.state.rateID]){
                var thisRate = AEdata.booking.quote.oRates[AEdata.booking.state.rateID];
                _.each(APP.props.rateFamily,
                    function(tempRateID) {
                        if(AEdata.booking.quote.oRates[tempRateID]){
                            var tempRate = AEdata.booking.quote.oRates[tempRateID];
                            var totalDiff = (thisRate.rate-tempRate.rate);
                            var dailyDiff = (thisRate.rate-tempRate.rate)/AEdata.booking.quote.totalDays;
                            if(Number(thisRate.estimate) > 0 && Number(tempRate.estimate) > 0 && AE.props.addFeesToRate) {
                                totalDiff = (thisRate.estimate-tempRate.estimate);
                                dailyDiff = (thisRate.estimate-tempRate.estimate)/AEdata.booking.quote.totalDays;
                            }
                            if(AE.props.siteCode === 'FCR'){
                                var diffSign = '$';
                            } else {
                                var diffSign = (dailyDiff <= 0) ? '+' : '-';
                            }
                            totalDiff = Math.abs(Math.round(totalDiff * 100) / 100).toFixed(2);
                            dailyDiff = Math.abs(Math.round(dailyDiff * 100) / 100).toFixed(2);
                            var totalDiffTxt = AE.props.oTranslations.CURRENCY_TEMPLATE.replace('.', totalDiff);
                            var dailyDiffTxt = AE.props.oTranslations.CURRENCY_TEMPLATE.replace('.', dailyDiff);
                            dailyDiffTxt = AE.props.oTranslations.PERDAY.replace('[price]', dailyDiffTxt);
                            //STORE-1524 add includes tax for CG diff
                            dailyDiffTxt = (tempRate.package === 'CG') ? dailyDiffTxt + ' ' + AE.props.oTranslations.INCLUDES_TAX_SHORT : dailyDiffTxt;
                            if(AE.props.siteCode === 'FCR'){
                                $('#' + tempRateID + '__diff').html(diffSign + dailyDiffTxt);
                                //totalAddOn = Math.abs(Math.round(thisRate.rate-tempRate.rate)).toFixed(2);
                                var totalAddOn = Math.abs(thisRate.rate-tempRate.rate).toFixed(2);
                                $('.addon-total').html(diffSign + totalAddOn);
                            } else {
                                $('#' + tempRateID + '__diff').html(diffSign + ' ' + dailyDiffTxt);
                                $('#' + tempRateID + '__totaldiff').html('(' + AE.props.oTranslations.TOTALPRICE + ' ' + totalDiffTxt + ')');
                            }
                        }
                    }
                );
            }
        },
        fetch: function(calledFromInit) {
            if(calledFromInit !== true) calledFromInit = false;
            if(!AE.props.oOptEquip.BRP || !APP.props.offerBrp)AE.props.oOptEquip.BRP=0;
            $.ajax({
                url: '/plugins/ae3/lib/BookingAjax.cfc',
                dataType: "json",
                data: {
                    method: 'getOptionDetails',
                    bookingid: AEdata.booking.props.uuid,
                    rateID: AEdata.booking.state.rateID,
                    dropID: AEdata.booking.state.dropID,
                    derc: (!calledFromInit && APP.props.offerDerc) ? AE.props.oOptEquip.DERC : 'null',
                    brp: (!calledFromInit && APP.props.offerBrp) ? AE.props.oOptEquip.BRP : 'null',
                    chk_cncl: (AE.props.oOptEquip.cancelIns) ? AE.props.oOptEquip.cancelIns : 'null',
                },
                success: function(data) {
                    APP.props.jsonPost.gaPostEvents = [];
                    if (data.upgradeID && data.upgradeID.length && data.upgradeID.length > 0) {
                        APP.props.jsonPost.bookingstep = 'getupgrade';
                        APP.props.jsonPost.upgradeID = data.upgradeID;
                    } else {
                        APP.props.jsonPost.gaPostEvents.push(APP.props.gaEvents.noUpgrade);
                    }
                    APP.props.jsonPost.gaPostEvents.push(APP.props.gaEvents.submit);
                    if(AE.props.siteCode !== 'FCR') {
                        AE.booking.options.ui.updateLineItems(data.oLineItems,data.thisOWFUnknown);
                    }
                    AE.booking.options.ui.updateForm();
                    AE.booking.options.ui.enableSubmit();
                }
            });
        }
    };
    return APP;
})();
;var AE = AE || {};
AE.booking = AE.booking || {};
AE.booking.options = AE.booking.options || {};
AE.booking.options.ui = AE.booking.options.ui || ( function() {
	var UI = {
		init: function() {
			var containerSelector = 'div#insuranceUI';
			UI.props = {
				$form: $('form#form--getoptions'),
				$button: $('button#option_update__btn--main'),
				$btnDERC: $('.selDERC'),
				$btnBRP: $('.selBRP'),
				$btnBRPicon: $('.selBRP i.fa'),
				$btnDERCicon: $('.selDERC i.fa'),
				$inputDERC: $('input#options_derc'),
				$inputBRP: $('input#options_brp'),
				$alertDERC: $('#alertDERC'),
				containerSelector: containerSelector,
				$container: $(containerSelector),
				boundingContentRendered: false,
				$df: $( document.createDocumentFragment() ),
				$lineItems: $('div.utbar__container--lineItems'),
				$totals: $('span.total__container--utbar'),
				TEASER:'',
				useLayout: UI.useWhichLayout(),
				lineItemProps: UI.getLineItemProps(),
				//WEBAE3-6402 extend this setting to US,CA
                useWEBAE3_5468: ['EU','GB','US','CA'].indexOf(AE.props.chaosSystem) >= 0 || AE.props.isAirCanada,
                //WEBAE3-7103 - display total rental cost if AU/NZ
                displayTotals: ['AU','NZ'].indexOf(AE.props.chaosSystem) >= 0,
				//WEBAE3-5653 - Added US / CA to customLayout
                customLayout: {
					//EU: ((['UK'].indexOf(AE.props.mSiteCode) >= 0) || (['EU'].indexOf(AE.props.chaosSystem) >= 0 && ['AVD','ATP','DTP'].indexOf(AE.props.mSiteCode) < 0)), //WEBAE3-5563 - Modify layout for EU/GB Chaos sites)
                    //WEBAE3-7083 remove AUNZ override and set all to true if not FCR
                    AUNZ: AE.props.siteCode !== 'FCR',//(['AUS','NZL','DAU','DNZ','DAP','GCR'].indexOf(AE.props.mSiteCode) >= 0 && !AEdata.booking.props.iswl),
					//WEBAE3-6402 extend EU settings to US,CA
                    //WEBAE3-7054 remove EU override and set all to true if not FCR
                    EU: AE.props.siteCode !== 'FCR', //((['UK'].indexOf(AE.props.mSiteCode) >= 0 || ['CA'].indexOf(AE.props.chaosSystem) >= 0 || ['US'].indexOf(AE.props.chaosSystem) >= 0 || AE.props.isAirCanada) || (['EU'].indexOf(AE.props.chaosSystem) >= 0 && ['AVD','ATP','DTP'].indexOf(AE.props.mSiteCode) < 0)), //WEBAE3-5563 - Modify layout for EU/GB Chaos sites)
                    fromInsuranceClick: false //WEBAE3-5563 - detect form update on insurance click as opposed to page load
                }
			};
            
			AE.ui.addSpinner(containerSelector,{size:'5x'});
			//AE.addResizeTask({func: function (){UI.buttonResizeDERC();}});
			AE.addResizeTask({func: function (){UI.buttonResizeInsuranceContainer();}});

			if (UI.props.$btnDERC[0]) UI.props.$btnDERC.on('click', function ( event ) { 
				UI.DERCClick(event); 
			});
			
			if (UI.props.$btnBRP[0]) UI.props.$btnBRP.on('click', function ( event ) { 
				UI.BRPClick(event); 
			});

            //WEBAE3-7110 - add body class to target whitelabel sites with css
            if(AEdata.booking.props.iswl) {
                $('.insurance-container').addClass('iswl');
            }
			AE.booking.options.disownRateFamily();
			UI.props.useLayout = UI.useWhichLayout();
			UI.setTeaser();
            UI['buildLayout' + UI.props.useLayout](AE.booking.options.props.rateFamily);
			UI.render();
			if (UI.useChartLayout()) {
				AE.addResizeTask({
					func: function () {
						UI.manageResize();
					},
					args: []
				});
			}
			
			// wait 2/10th second to allow the page to fully render
			setTimeout(function(){
				$('.package-cost-info').removeClass('fill-space');//.addClass('fill-space-2');
			},200);

			if(AE.props.siteCode == 'FCR') {
				$( function() {
					$( ".optionalEquip" ).selectmenu({
						classes: {
						"ui-selectmenu-menu": "fcr-opt-equip_selector"
						  }
						,appendTo: '#aebooking'
					});
				} );

				$( ".optionalEquip" ).selectmenu({
					position: { my : "left-10 top", at: "left bottom"},
					change: function( event, ui) {
						$(this).trigger('change')
					}
				}/*,
				console.log("hey there this ==", $(this))*/

				)
				// , of: "fcr-options-input"

			// 	// $( ".sortbyprice" ).selectmenu({
			// 	// 	change: function( event, ui ) {
			// 	// 		if (ui.item.value == 'high') {
			// 	// 			$('#sp_sp').prop('checked', true).trigger('change');
			// 	// 		} else if (ui.item.value == 'low') {
			// 	// 			$('#sp_sp').prop('checked', false).trigger('change');
			// 	// 		}
			// 	// 	}
			// 	// });
		
			}
			UI.fcrOptionalItems();

		},
		getLineItemProps: function() {
			return {
				now:{
					divider:true,
					title:AE.props.oTranslations.LINE.PAY_TODAY,
					titleClass:'push-half--top',
					className:'line__item--now',
					toolTip:''
				},
				inRate:{
					divider:false,
					title:AE.props.oTranslations.LINE.INCLUDED_IN_RATE,
					titleClass:'push-half--top',
					className:'line__item--now rate_includes_container',
					toolTip:''
				},
				local:{
					divider:false,
					title:AE.props.oTranslations.LINE.PAY_LOCALLY,
					titleClass:'push-half--top',
					className:'line__item--local',
					toolTip:AE.props.oTranslations.LINE.PAY_LOCALLY_WARNING
				}
			};
		},
		manageResize: function() {
			UI.props.useLayout = UI.useWhichLayout();
			UI['buildLayout' + UI.props.useLayout](AE.booking.options.props.rateFamily);
			UI.render();
			setTimeout(function(){
				$('.package-cost-info').removeClass('fill-space');//.addClass('fill-space-2');
			},200);	
		},
		useWhichLayout: function(){
			// TODO: WEBAE3-1659 establish triggers to have this function return 2 and cause buildLayout2 function to run
			if (UI.useChartLayout() == true && AE.getSiteViewType() !== 'palm') {
				return 2;
			} else {
				return (AE.booking.options.props.rateFamily.length > 1) ? 1 : 0;
			}
		},
		useChartLayout: function () {
			return AEdata.booking.props.insuranceGrid;
		},
		setTeaser: function(){
			if(AE.booking.options.props.rateFamily.length > 1){
				var choiceType = 'II';
				var teasePackage = AEdata.booking.quote.oRates[AE.booking.options.props.rateFamily[1]].package;// _.last(AE.booking.options.props.rateFamily)
				if(AE.props.oTranslations.INSURANCES[teasePackage]){
					var oTeasePackage = AE.props.oTranslations.INSURANCES[teasePackage];
					if(AEdata.booking.quote.oRates[_.first(AE.booking.options.props.rateFamily)].packageType === 'IB'){
						var choiceType = 'IB';
					}
					UI.props.TEASER = (oTeasePackage.TEASER !== undefined) ? oTeasePackage.TEASER[choiceType] : '';
				}
			}
		},
		buildLayout0:function() {
            //show default continue button
            $('#option_update__btn--main').show();
            
			if ((AEdata.booking.quote.oQuote.oRules.oDERC.OFFER && AEdata.showDERC) || AEdata.booking.quote.oQuote.oRules.oBRP.OFFER ){
				$('#options_header').html(AE.props.oTranslations.INSURANCES.HEADER);
				//$('.optional_equipment_header.toggler').removeClass('open');
				//$('.toggle_plus_minus.island .togglee').addClass('visuallyhidden');
				$('.optional_equipment_header.toggler').addClass('open');
			}
		},
		// Layout1 = palm sized screens
		buildLayout1: function(aRateIDs) {
			$('#options_header').html(AE.props.oTranslations.INSURANCES.HEADER);
			//$('.optional_equipment_header.toggler').removeClass('open');
			//$('.toggle_plus_minus.island .togglee').addClass('visuallyhidden');
			$('.optional_equipment_header.toggler').addClass('open'); 
		
			//WEBAE3-6198 - prune rateFamily based on FCR rules
			if(AE.props.siteCode === 'FCR'){
				idxZQ = AE.booking.options.props.rateFamily.findIndex(element => element.includes("ZQ"));
				idxZR = AE.booking.options.props.rateFamily.findIndex(element => element.includes("ZR"));
				idxZB = AE.booking.options.props.rateFamily.findIndex(element => element.includes("ZB"));
				idxZC = AE.booking.options.props.rateFamily.findIndex(element => element.includes("ZC"));
				idxZE = AE.booking.options.props.rateFamily.findIndex(element => element.includes("ZE"));
				
				if(idxZQ > 0 && idxZR > 0){
					//remove ZQ
					AE.booking.options.props.rateFamily.splice(idxZQ, 1);
				}

				if(idxZQ > 0 && idxZB > 0){
					//remove ZB
					AE.booking.options.props.rateFamily.splice(idxZB, 1);
				}

				if(idxZE > 0 && idxZR > 0){
					//remove ZE
					AE.booking.options.props.rateFamily.splice(idxZE, 1);
				}
			}
			
			aRateIDs = aRateIDs || [];
			var prevRateID='',packagesShown = 0,maxItems = 0, IBshown=false, IIshown=false, packageType=AEdata.booking.state.rateID.substring(0,2),usedItems = [];
			var CoverGeniusRateID = '';//STORE-1524 will get set to CG rate ID if we have a CG upgrade offered
			var hasZK =  false;//STORE-1509 need to know if we have a ZK upgrade before setting up inclusions
			_.each(aRateIDs,
				function(thisRateID){
					CoverGeniusRateID = (AEdata.booking.quote.oRates[thisRateID].package === 'CG') ? thisRateID : CoverGeniusRateID;
					hasZK = (AEdata.booking.quote.oRates[thisRateID].package === 'ZK') ? true : hasZK;//STORE-1509
				}
			);

			_.each(aRateIDs,
				function(thisRateID) {
					// WEBAE3-5595 - added condition for FCR ERP and BP upgrade
					if (AEdata.booking.quote.oRates[thisRateID] && AE.props.siteCode !== 'FCR' || (AE.props.siteCode === 'FCR' && AEdata.booking.quote.oRates[thisRateID] && thisRateID === _.last(aRateIDs) && (AEdata.booking.quote.oRates[thisRateID].package === 'ZB' || AEdata.booking.quote.oRates[thisRateID].package === 'ZC' || AEdata.booking.quote.oRates[thisRateID].package === 'ZR' || (AEdata.booking.quote.oRates[thisRateID].package === 'ZQ' && idxZQ !== 0)))) {
						packagesShown++;
						var thisRate = AEdata.booking.quote.oRates[thisRateID];
						var thisCar  = AEdata.booking.quote.oCars[thisRate.carID];
						var thisSupp  = AEdata.booking.quote.oSupps[thisRate.suppID];
						var $rate    = $(document.createElement('div'))
							.addClass('grid__item insurance-package palm-one-whole');
						var $packageContainer = $(document.createElement('div'))
							.addClass('toggle');
					
						if (AE.props.siteCode === 'FCR'){
							var $top = $(document.createElement('div'))
							.addClass('package-header toggler toggler--palm grid__item one-whole hard--left')
							//.attr('data-togglee','#radio__insurance--'+thisRate.ID+'--details');

							var $title = $(document.createElement('div'))
							.addClass('package-titles palm-one-half')
							.append($(document.createElement('label'))
							.append(AE.props.oTranslations.INSURANCES[thisRate.package].COL));
							
							if(AEdata.booking.quote.oRates[thisRateID].package === 'ZB') {
								var $logo = $(document.createElement('div'))
								.addClass('package-logo-zb')
								.append($(document.createElement('img'))
								.append(AE.props.oTranslations.INSURANCES[thisRate.package].IMAGE));
							}
							if(AEdata.booking.quote.oRates[thisRateID].package === 'ZC') {
								var $logo = $(document.createElement('div'))
								.addClass('package-logo-zc')
								.append($(document.createElement('img'))
								.append(AE.props.oTranslations.INSURANCES[thisRate.package].IMAGE));
							}
							if(AEdata.booking.quote.oRates[thisRateID].package === 'ZR') {
								var $logo = $(document.createElement('div'))
								.addClass('package-logo-zr')
								.append($(document.createElement('img'))
								.append(AE.props.oTranslations.INSURANCES[thisRate.package].IMAGE));
							}
							if(AEdata.booking.quote.oRates[thisRateID].package === 'ZQ') {
								var $logo = $(document.createElement('div'))
								.addClass('package-logo-zq')
								.append($(document.createElement('img'))
								.append(AE.props.oTranslations.INSURANCES[thisRate.package].IMAGE));
							}
						} else if(UI.props.customLayout.EU){// WEBAE3-5954

							var $top = $(document.createElement('div'))
							.addClass('package-title-header grid__item one-whole hard--left hard--right align-center');// package-header
							var $pTitle = $(document.createElement('p'))
								.css('font-size','1rem')
								.append($(document.createElement('strong'))
									.append(AE.props.oTranslations.INSURANCES[thisRate.package].TITLE)
								);
							
							if(thisRateID !== _.first(aRateIDs)){
								$pTitle.append($(document.createElement('span'))
									.attr('id',thisRateID+'__diff')
									.addClass('push-half--left')
								);
							}
							var $title = $(document.createElement('div'))
								.addClass('package-titles')
								.append($pTitle);
						} else {
							var $top = $(document.createElement('div'))
							.addClass('package-header toggler toggler--palm align-center grid__item one-whole palm-three-quarters hard--left bg--primary inverse')
							.attr('data-togglee','#radio__insurance--'+thisRate.ID+'--details');
                        
							var $title = $(document.createElement('div'))
								.addClass('package-titles')
								.append($(document.createElement('h5'))
								.append(AE.props.oTranslations.INSURANCES[thisRate.package].TITLE));
						}
						
                        
						var displayRate = thisRate.rateCurr;
						
						if (Number(thisRate.estimate) > 0 && AE.props.addFeesToRate) {
							var tempEstimate = Math.abs(Math.round(Number(thisRate.estimate) * 100) / 100).toFixed(2);
							displayRate = AE.props.oTranslations.CURRENCY_TEMPLATE.replace('.',tempEstimate);
						}

						var $diffContainer = $(document.createElement('div'))
                            .addClass('package-cost-info radio__insurance--'+thisRate.ID+'--details fill-space');
                        var $diffText = $(document.createElement('h3'))
                            .attr('id',thisRateID+'__diff');
                        // WEBAE3-7054 Remove total rental estimate cost for all but AU/NZ
                        if(UI.props.displayTotals) {
                            $diffText.css('font-weight', 600);
                            $diffContainer.append($(document.createElement('p'))
                                        .attr('id', thisRateID+'__totaldiff'));
                        }
                            
                        $diffContainer.prepend($diffText);

						if(AE.props.siteCode === 'FCR'){
							$top.append($logo.append($diffContainer));
						}
						
						if(UI.props.customLayout.EU){
							// WEBAE3-7054 Remove total rental estimate cost
                            if(thisRateID !== _.first(aRateIDs) && UI.props.displayTotals){
								$title.append($(document.createElement('p'))
                                    .attr('id', thisRateID+'__totaldiff')
									.css('font-size','1rem')
								);
							}
							$top.append($title);
						} else {
							$top.append($title.append($diffContainer));
						}
						
						if (AE.props.siteCode === 'FCR'){
							
							var $lapUpIncludeContainer = $(document.createElement('div'))
							.addClass('grid__item one-whole hard--left');

							var $lapUpIncludeList = $(document.createElement('ul'))
								.addClass('package-lineitems hard--left soft-half--top ');
						} else {
							
							var $lapUpIncludeContainer = $(document.createElement('div'))
							.addClass('grid__item one-whole trulyhidden--palm hard--left');
							
							var $lapUpIncludeList = $(document.createElement('ul'))
								.addClass('package-lineitems hard--left soft-half--top align-center trulyhidden--palm');
						}
					
						$lapUpIncludeContainer.append($lapUpIncludeList);
						
						if(AE.props.siteCode === 'FCR'){
							var $buttonContainer = $(document.createElement('div'))
							.addClass('grid__item one-whole hard--left package-btn-wrapper');
							if(AEdata.booking.quote.totalDays === 1) {
								var $addontotalWrapper = $(document.createElement('div'))
								.addClass('addon-total-wrapper remove-rhythm')
									.html('<span class="addon-total"></span><br><span class="numdays">' + AEdata.booking.quote.totalDays + ' ' + AE.props.oTranslations.DAY + '</span>');
							} else {
								var $addontotalWrapper = $(document.createElement('div'))
								.addClass('addon-total-wrapper remove-rhythm')
									.html('<span class="addon-total"></span><br><span class="numdays">' + AEdata.booking.quote.totalDays + ' ' + AE.props.oTranslations.NUMDAYS + '</span>');

							}
						} else {
							var $buttonContainer = $(document.createElement('div'))
							.addClass('grid__item one-whole palm-one-quarter hard--left package-btn-wrapper');
						}
						var $buttonWrapper = $(document.createElement('div'))
							.addClass('package-button align-center remove-rhythm')
								.on( 'click', function ( event ) { 
									UI.radioInsuranceClick(thisRate.ID); 
								});
						
						if(AE.props.siteCode === 'FCR'){
							var $buttonInput = $(document.createElement('input')).addClass('radio__insurance')
							.attr('id','radio__insurance--'+thisRate.ID)
							.attr('name','rateID')
							.attr('type','checkbox')
							.attr('value',thisRate.ID)
							.on( 'click', function ( event ) { event.stopPropagation(); } );
						} else {
							var $buttonInput = $(document.createElement('input')).addClass('radio__insurance')
							.attr('id','radio__insurance--'+thisRate.ID)
							.attr('name','rateID')
							.attr('type','radio')
							.attr('value',thisRate.ID)
							.on( 'click', function ( event ) { event.stopPropagation(); } );
						}
						var $buttonLabel = $(document.createElement('label'))
							.attr('for','radio__insurance--'+thisRate.ID);
						if(AE.props.siteCode === 'FCR'){
							labelText = AE.props.oTranslations.BTN_ADDTOBOOKING;
						} else {
							labelText = AE.props.oTranslations.OPTION_SELECT;
						}
						var $buttonText = $(document.createElement('span'))
							.html(labelText);
						
							if (thisRateID !== _.first(aRateIDs)) $buttonText.html(AE.props.oTranslations.OPTION_UPGRADE);
							if(AE.props.siteCode === 'FCR'){	
								
								$buttonContainer.append($addontotalWrapper);
								
								$buttonContainer.append($buttonWrapper.append($buttonInput).append($buttonLabel.append($buttonText)));
							} else {
								$buttonContainer.append($buttonWrapper.append($buttonInput).append($buttonLabel.append($buttonText)));
							}
						
						if (AE.props.siteCode === 'FCR'){
							var $palmIncludeList = $(document.createElement('ul'))
								.attr('id','radio__insurance--'+thisRate.ID+'--details')
								.addClass('togglee trulyhidden--palm trulyhidden--lap trulyhidden--desk trulyhidden--desk-wide');
						} else if(UI.props.customLayout.EU){
							var $palmIncludeList = $(document.createElement('ul'))
								.attr('id','radio__insurance--'+thisRate.ID+'--details')
								.addClass('trulyhidden--lap trulyhidden--desk trulyhidden--desk-wide');
						} else {
							var $palmIncludeList = $(document.createElement('ul'))
							.attr('id','radio__insurance--'+thisRate.ID+'--details')
							.addClass('visuallyhidden togglee trulyhidden--lap trulyhidden--desk trulyhidden--desk-wide');
						}
						
						var bestPackage = false;
						
						if (thisRateID === _.last(aRateIDs)) {// Best Value
							$buttonWrapper.addClass('btn--promo');
							if(AE.props.siteCode === 'FCR'){
                                $buttonText.html(AE.props.oTranslations.BTN_ADDTOBOOKING);
							} else {
								$buttonText.html(AE.props.oTranslations.OPTION_BEST);
							}
							bestPackage = true;
							if (aRateIDs.length > 1) {
								if(AEdata.booking.quote.oRates[prevRateID]) {
									var prevRate = AEdata.booking.quote.oRates[prevRateID];
									var prevCar = AEdata.booking.quote.oCars[prevRate.carID];
									var prevSupp = AEdata.booking.quote.oSupps[prevRate.suppID];
									var prevARR = AE.props.oTranslations.INSURANCES[prevRate.package].ARR;
									if(prevSupp.isLTR && AE.props.oTranslations.INSURANCES[prevRate.package].hasOwnProperty('ARRLTR')){
										prevARR = AE.props.oTranslations.INSURANCES[prevRate.package].ARRLTR;
									}
									var prevIncludes = AE.booking.applyInsuranceIncludeListOverrides(prevARR,prevCar.packagesDoInclude);
								}
							}
						}

						if (thisRate.ID === AEdata.booking.state.rateID) {
							$diffContainer.addClass('visuallyhidden');
							$buttonWrapper.addClass('selected');
							$buttonInput.prop('checked',true);
							$buttonText.html(AE.props.oTranslations.OPTION_SELECTED);
						}
                        
                        //WEBAE3-5563 - Display booking buttons to trigger hidden radio buttons and submit
                        if(UI.props.customLayout.EU || UI.props.customLayout.AUNZ) {
							// WEBAE3-7054 Restructure Options buttons
                            var lastRateID = AEdata.booking.quote.oRates[aRateIDs[aRateIDs.length - 1]].ID;
                            var iTrans  = AE.props.oTranslations.INSURANCES;
                            var bookingLang = 'RISK';
                            var extraText = '';
							//WEBAE3-7151 - revert text back to package name
                            //if(thisRateID === lastRateID) {
                                bookingLang = 'CONTINUEWITH';
                                extraText = ' '+AE.props.oTranslations.INSURANCES[thisRate.package].TITLE;
                            //}
                            var btnHTML = iTrans.bookingUpgradeSelect[bookingLang] + extraText;
                            
                            var $buttonBook = $('<button type="button" class="book-upgrade-btn">')
                            .attr('data-radio', 'radio__insurance--' + thisRate.ID)
                            .html(btnHTML)
                            .on('click', function()
                            {
                                AE.ui.dialog.setDialogTriggered();
                                AE.booking.saveQuote.deactivateExitModal();
                                $(this).append('<i class="fas fa-cog fa-spin fa-2x"></i>');
                                $('label[for="'+$(this).attr('data-radio')+'"]').click();
                            });
                            
                            $buttonContainer.append($buttonBook);
                        }
                        
						var isARRLTRavailable = false;
						if(thisSupp.isLTR && AE.props.oTranslations.INSURANCES[thisRate.package].hasOwnProperty('ARRLTR')){
							isARRLTRavailable = true;
						}

						if(AE.props.siteCode === 'FCR') {
							if(AE.props.chaosSystem === 'NZ') {
								var theseIncludes = AE.booking.applyInsuranceIncludeListOverrides(AE.props.oTranslations.INSURANCES[thisRate.package].ARRFCRNZ,thisCar.packagesDoInclude);
							} else {
								var theseIncludes = AE.booking.applyInsuranceIncludeListOverrides(AE.props.oTranslations.INSURANCES[thisRate.package].ARR,thisCar.packagesDoInclude);
							}
						} else if(isARRLTRavailable){
							var theseIncludes = AE.booking.applyInsuranceIncludeListOverrides(AE.props.oTranslations.INSURANCES[thisRate.package].ARRLTR,thisCar.packagesDoInclude);
						} else {
							var theseIncludes = AE.booking.applyInsuranceIncludeListOverrides(AE.props.oTranslations.INSURANCES[thisRate.package].ARR,thisCar.packagesDoInclude);
						}
						
						//STORE-1509 if inclusive package and ZK upgrade is offered, change inclusive inclusions
						//SAT-1820 disabled this call so that inclusions on the mobile view are correct
						//theseIncludes = (thisRate.package === 'inclusive' && hasZK) ? AE.booking.applyInsuranceIncludeListOverrides(AE.props.oTranslations.INSURANCES[thisRate.package].ARR_ZK,thisCar.packagesDoInclude) : theseIncludes;

						if (AE.booking.options.props.mixedKm) theseIncludes = _.without(theseIncludes,AE.props.oTranslations.SIPPNOTES.LK.TEXT,AE.props.oTranslations.SIPPNOTES.ULK.TEXT);
						
						//STORE-1524 for CG, only show CG inclusions
						if(CoverGeniusRateID !== ''){
							theseIncludes = (thisRate.package !== 'CG') ? [] : theseIncludes;
							prevIncludes = [];
						}
						
						var incCount = 1;
						_.each(theseIncludes,
							function(item) {
								var item        = item.trim();
                                if(item.indexOf('(VAT)') < 0) {
                                    var noBreakItem = item.replace(/[\n\r]/g, '');
                                    var noLiItem    = noBreakItem.indexOf('>') >= 0 ? item.split('>')[1].replace('</li', '').trim() : noBreakItem.toLowerCase().replace(/[^A-Za-z0-9\s!?]/g,'');
                                    var noCapsItem  = noLiItem.toLowerCase().replace(/[^A-Za-z0-9\s!?]/g,'');
                                    if(UI.props.customLayout.EU){
                                        item = '<i class="fas fa-check-circle text--green"></i> '+item;
                                    }

                                    if (bestPackage && AE.props.siteCode != 'FCR') {
                                        if(prevIncludes && !_.contains(prevIncludes,item) && !_.contains(prevIncludes,noBreakItem) && !_.contains(usedItems,noCapsItem)) item = '<div class="package-feature">'+item+'</div>';
                                    } else if (thisRateID !== _.first(aRateIDs) && UI.props.customLayout.EU) {
                                        if(	incCount > 1 && // VAT is always first item, but doesn't get loaded for the first rate the same way as others
                                            !_.contains(prevIncludes,item) && 
                                            !_.contains(prevIncludes,noBreakItem) && 
                                            !_.contains(usedItems,noCapsItem)) {
                                                item = '<div class="package-feature">'+item+'</div>';
                                        } else {
                                            usedItems.push(noCapsItem);
                                        }
                                    } else {
                                        usedItems.push(noCapsItem);
                                    }
                                    var $itemLi = $(document.createElement('li')).append(item);
                                    if (incCount === theseIncludes.length) $itemLi.addClass('last-include');
                                    incCount++;
                                    $lapUpIncludeList.append($itemLi);
                                    $palmIncludeList.append($(document.createElement('li')).append(item));
                                } else {
                                    incCount++;
                                }
							}
						);

						var itemCount = theseIncludes.length;
						if (false && AE.booking.options.props.mixedFuelPolicy) {// Suppress Fuel Policy Indication per WEBAE3-2314
							var thisFuel = AE.props.oTranslations.SIPPNOTES[thisCar.oSIPPNotes.SIPPLINKFUELCODES] || {TEXT:'--'};
							var fuelItem = thisFuel.TEXT;
							if (bestPackage && fuelItem !== undefined) {
								if (prevRateID){
									if (AEdata.booking.quote.oRates[prevRateID]) {
										var prevCar = AEdata.booking.quote.oCars[AEdata.booking.quote.oRates[prevRateID].carID];
										if (prevCar.fuel !== thisCar.fuel && AE.props.siteCode != 'FCR') fuelItem = '<div class="package-feature">'+fuelItem+'</div>';
									}
								}
							}
							
							$lapUpIncludeList.append($(document.createElement('li')).append(fuelItem));
							$palmIncludeList.append($(document.createElement('li')).append(fuelItem));
							itemCount++;
						}
						if (AE.booking.options.props.mixedKm) {
							var kmItem = '--';
							if (thisCar.hasUnlimitedKm) kmItem = AE.props.oTranslations.SIPPNOTES.ULK.TEXT;
							if (thisCar.oSIPPNotes.ISLIMITEDKMSIPP) kmItem = AE.props.oTranslations.SIPPNOTES.LK.TEXT;
							if (bestPackage && kmItem !== undefined){
								if (prevRateID){
									if (AEdata.booking.quote.oRates[prevRateID]) {
										var prevCar = AEdata.booking.quote.oCars[AEdata.booking.quote.oRates[prevRateID].carID];
										if (prevCar.km !== thisCar.km && AE.props.siteCode != 'FCR') kmItem = '<div class="package-feature">'+kmItem+'</div>';
									}
								}
							}
							
							$lapUpIncludeList.append($(document.createElement('li')).append(kmItem));
							$palmIncludeList.append($(document.createElement('li')).append(kmItem));
							itemCount++;
						}
						
                        //WEBAE3-5468 Mobile Rate Details Link for EU/GB
                        if(UI.props.useWEBAE3_5468 && !UI.props.customLayout.EU) {
							var cterms = JSON.parse(decodeURIComponent(document.getElementById('data-car-terms').dataset['carTerms']));
                            var $rateDetailsLink = $(document.createElement('a')).addClass('car-terms').attr('data-car-terms', encodeURIComponent(JSON.stringify(cterms))).attr('data-rate-id', thisRate.ID);
                            $rateDetailsLink.html('<i class="fas fa-plus"></i> '+AE.props.oTranslations.TERMSLINK);
                            $palmIncludeList.append($(document.createElement('li')).append($rateDetailsLink));
                        }
                        
						if (itemCount > maxItems) maxItems = itemCount;

						prevRateID = thisRateID;
						$packageContainer.append($top).append($lapUpIncludeContainer);
						if(UI.props.customLayout.EU){
							//STORE-1524 if we have CG and this is a basic rate, inclusions will be empty so don't add extra padding
							$packageContainer.append($palmIncludeList.addClass('checkmark-item-spacing'));
							if(CoverGeniusRateID !== '' && thisRate.package !== 'basic') {
								$packageContainer.append($palmIncludeList.addClass('checkmark-item-spacing push-half--bottom'));
							}
							
							$buttonContainer.removeClass('palm-one-quarter')
								.addClass('palm-one-whole options--alt-preserve-btn-width');
							$packageContainer.append($buttonContainer);
						} else {
							$packageContainer
								.append($buttonContainer)
								.append($palmIncludeList);
						}

						//STORE-1524 add CG dislaimer
						if(CoverGeniusRateID !== ''  && CoverGeniusRateID === thisRateID){
							var $cgNote = $(document.createElement('div'));
							$cgNote.addClass('covergenius-note-mobile').html(AEdata.booking.quote.oRedBook[CoverGeniusRateID].STCOVERGENIUS.ITEM);
							$packageContainer.append($cgNote);
							//change second paragraph
							$("#insp2").html(AE.props.oTranslations.INSURANCES.OPTIONS_FOOTER_CG);
						}
						if(AE.props.siteCode === 'FCR') {
						    UI.props.$df.append($rate.append($packageContainer));
                        } else {
							//WEBAE3-7151 - reverse order (UI.props.$df.append instead of prepend)
						    UI.props.$df.append($rate.append($packageContainer));
                        }
					}
				}
			);
			// wouldn't we need something here, the packageClass, to make another column like shown on?
			var packageClass = (packagesShown > 2) ? 'one-third' : (packagesShown > 1) ? 'one-half' : 'one-whole';
            if(AE.props.siteCode != 'FCR') {
			    UI.props.$df.find('.grid__item.insurance-package.palm-one-whole').addClass(packageClass);
            }
			if(aRateIDs.length > 1) {
				_.each(UI.props.$df.find('ul.package-lineitems'),function(ul) {
					var $ul = $(ul);
					var addBlanks = maxItems - $ul.children().length;
					if (addBlanks > 0) {
						for (var i=0;i<addBlanks;i++) {
							var $blank = $(document.createElement('li')).append('--');
							$blank.insertAfter($ul.find('.last-include'));
						}
					}
				});

			}
		},
		// Layout2 = lab abd above sized screens
		buildLayout2: function(aRateIDs) {
			if (aRateIDs.length > 1) {
				$('#options_header').html(AE.props.oTranslations.INSURANCES.HEADER);
				//$('.optional_equipment_header.toggler').removeClass('open');
				//$('.toggle_plus_minus.island .togglee').addClass('visuallyhidden');
				$('.optional_equipment_header.toggler').addClass('open');
				var $chart = $(document.createElement('table')).addClass('insurance__options');
				var $trHeadTitle = $(document.createElement('tr'));
				var $trHeadCost = $(document.createElement('tr'));
				var $trSelect = $(document.createElement('tr')).addClass('insurance__options last');
				var aRowIndexes = [];
				var aChecks = [];
				var aFuelChecks = [];
				var aKmChecks = [];
				var columnWidthClass = (aRateIDs.length > 2) ? 'one-quarter' : 'one-third';
				var CoverGeniusRateID = '';//STORE-1524 will get set to CG rate ID if we have a CG upgrade offered
				$chart.addClass(columnWidthClass + '-layout');
				$chart.append($trHeadTitle).append($trHeadCost);
				UI.props.$df.append($chart);
				
				//STORE-1509 - need to know if we ZK upgrade before we get into building grid
				var hasZK = _.some(aRateIDs, function(id) {
					return  AEdata.booking.quote.oRates[id].package === "ZK";
				});

				_.each(aRateIDs, function (thisRateID) {
					if (AEdata.booking.quote.oRates[thisRateID]) {
						var thisRate = AEdata.booking.quote.oRates[thisRateID];
						///var STOPTIONFLAGS = AEdata.booking.quote.oRedBook[thisRate.ID].STOPTIONFLAGS.SHOWSKIRACK;
						var thisCar = AEdata.booking.quote.oCars[thisRate.carID];
						var thisSupp = AEdata.booking.quote.oSupps[thisRate.suppID];
						var thisRateLang = AEdata.booking.quote.oLang.INSURANCES[thisRate.package];
						var thisLblARR = _.clone(thisRateLang.lblARR);
						//STORE-1509 hacky override for inclusive array if ZK upgrade
						/* SAT-1819 no longer need this because it's intent was to rewrite inclusions without CDW or theft
						if(hasZK && thisRate.package === 'inclusive') {
							thisLblARR = [8];//SAT-1819 - removed 31 (loss of use)
						}*/
						var dropLiability = false;
						if (_.contains(thisCar.aSIPPNotes,'XL')) dropLiability = true;
						if (thisCar.suppCode === 'FOX'){
							if (!AEdata.booking.quote.oLang.INSURANCES.oExceptions.showLiability.FOX) {
								dropLiability = true;
							}
						}
						var packageCouldDropLiability = false;
						if (thisRate.packageType === 'IB') {
							packageCouldDropLiability = true;
						} else if (thisRate.packageType === 'IZ') {
							if (!_.contains(['ZD','ZE','ZE1','ZB'],thisRate.package)) {
								packageCouldDropLiability = true;
							}
						}
						if (packageCouldDropLiability) {
							if (thisCar.suppCode === 'THT') {
								if (!AEdata.booking.quote.oLang.INSURANCES.oExceptions.showLiability.basicTHT) {
									dropLiability = true;
								}
							} else if (!AEdata.booking.quote.oLang.INSURANCES.oExceptions.showLiability.basicIL) {
								dropLiability = true;
							}
						}
						if (dropLiability) {
							thisLblARR = _.without(thisLblARR,8);
						}

						aRowIndexes = _.union(aRowIndexes, thisLblARR);
						//STORE-1524 drop fire and liability rows if Cover Genius upgrade and set CG rateID to true
						if(thisRate.package === 'CG') {
							CoverGeniusRateID = thisRateID;//STORE-1524 set to CG rate ID if we have a CG upgrade offered
							aRowIndexes = _.without(aRowIndexes,4,8);
						}
						//STORE-1509 drop cdw, fire and theft rows if ZK
						//SAT-1819 - removed 2 and 13 so that CDW and theft show
						if(thisRate.package === 'ZK') {
							aRowIndexes = _.without(aRowIndexes,4);
						}
						aChecks.push(thisLblARR);
						aFuelChecks.push(_.contains(thisCar.aSIPPNotes, 'FF'));
						aKmChecks.push(_.contains(thisCar.aSIPPNotes, 'ULK'));
						
						var $thRateCost = $(document.createElement('th')).addClass(columnWidthClass);
						$trHeadCost.append($thRateCost);
						
						var $thRateTitle = $(document.createElement('th')).addClass(columnWidthClass);
						$trHeadTitle.append($thRateTitle);
						
						var $rate = $(document.createElement('div'))
							.addClass('insurance-package');
						
						var $packageContainer = $(document.createElement('div'));
						
						var $topTitle = $(document.createElement('div'))
							.addClass('align-center grid__item hard--left bg--primary insurance-package-title');
						
						var $topCost = $(document.createElement('div'))
							.addClass('package-header align-center grid__item hard--left bg--primary');
						
                        if(AEdata.booking.props.iswl) {
                            $topCost.addClass('inverse');
                        }

						var addInfoIcon='<i class="fa fa-info-circle text--primary" style="margin-left: 5px;"></i>';
						var tooltipText = '<strong>'+AE.props.oTranslations.INSURANCES[thisRate.package].INCLUDES+':</strong>';
						
						if(thisSupp.isLTR && AE.props.oTranslations.INSURANCES[thisRate.package].hasOwnProperty('ARRLTR')){
							for(var i=0; i < AE.props.oTranslations.INSURANCES[thisRate.package].ARRLTR.length; i++) {
								tooltipText += '<br>'+AE.props.oTranslations.INSURANCES[thisRate.package].ARRLTR[i]
							}
						} else {
							for(var i=0; i < AE.props.oTranslations.INSURANCES[thisRate.package].ARR.length; i++) {
								tooltipText += '<br>'+AE.props.oTranslations.INSURANCES[thisRate.package].ARR[i]
							}
						}

						//WEBAE3-5468 set info icon for applicable chaos terms
						var $titleTitle = $(document.createElement('div'))
							.addClass('package-titles insurance-package')
							.append($(document.createElement('h5'))
								.append(AE.props.oTranslations.INSURANCES[thisRate.package].TITLE));
							    //WEBAE3-7083 - Remove tooltips
                                //.append($(document.createElement('div')).addClass('more-info-text').html(tooltipText));
                            
						if (thisRate.packageType === 'IB' && !UI.props.useWEBAE3_5468) {
								$titleTitle.find('.more-info-text').addClass( 'grid' ).wrapInner( '<div class="grid__item one-half"></div>' );
								$titleTitle.find('.more-info-text').append( $( document.createElement( 'div' ) ).addClass( 'grid__item one-half soft-half--left' )
										.append( $( document.createElement( 'strong' ) ).append( $.trim( AE.props.oTranslations.STBASICEXCLUSIONS.HEAD ) ) )
										.append( $( document.createElement( 'br' ) ) )
										.append( $.trim( AE.props.oTranslations.STBASICEXCLUSIONS.BODY ) )
								);
						}

						// Pull out common reference
						let cterms = JSON.parse(decodeURIComponent(document.getElementById('data-car-terms').dataset['carTerms']));
						
						if (UI.props.useWEBAE3_5468) {
								$titleTitle.removeClass('more-info-tip');
								// WEBAE3-5563 - only append info icon if not site using GBR/EU layout
								if(!UI.props.customLayout.EU) {
									$titleTitle.addClass('car-terms').attr('data-car-terms', encodeURIComponent(JSON.stringify(cterms))).attr('data-rate-id', thisRate.ID).find('h5').append(addInfoIcon);
								}
						}

						if (AE.props.useWEBAE3_4586 && !UI.props.useWEBAE3_5468) {
							$titleTitle.removeClass('more-info-tip').addClass('car-terms more-info-tip-rates has-h5-first-child');
							$titleTitle.attr('data-car-terms', encodeURIComponent(JSON.stringify(cterms))).attr('data-rate-id', thisRate.ID);
						}

						//Removed because of errors on WEBAE3-5653

						// $(document).ready (function (){

						// var skiflag = AEdata.booking.quote.oRedBook[thisRate.ID]?.STOPTIONFLAGS.SHOWSKIRACK;
						
						// if (skiflag === true) {
						// 	var hasSkiexisting = localStorage.getItem('aeSearch');
						// 	hasSkiexisting = hasSkiexisting ? JSON.parse(hasSkiexisting) : {};
						// 	hasSkiexisting['HasoptionalSkis'] = skiflag;
						// 	localStorage.setItem('aeSearch', JSON.stringify(hasSkiexisting));
						// }

						// else if (skiflag === false) {
						// 	var hasSkiexisting = localStorage.getItem('aeSearch');
						// 	hasSkiexisting = hasSkiexisting ? JSON.parse(hasSkiexisting) : {};
						// 	hasSkiexisting['HasoptionalSkis'] = skiflag;
						// 	localStorage.setItem('aeSearch', JSON.stringify(hasSkiexisting));
						// }


						// });
						
						var $titleCost = $(document.createElement('div'))
							.addClass('package-titles');
						
						var displayRate = thisRate.rateCurr;
						
						if (Number(thisRate.estimate) > 0 && AE.props.addFeesToRate) {
							var tempEstimate = Math.abs(Math.round(Number(thisRate.estimate) * 100) / 100).toFixed(2);
							displayRate = AE.props.oTranslations.CURRENCY_TEMPLATE.replace('.',tempEstimate);
						}

						var $diffContainer = $(document.createElement('div'))
                            .addClass('package-cost-info radio__insurance--'+thisRate.ID+'--details');
                        var $diffText = $(document.createElement('h3'))
                            .attr('id',thisRateID+'__diff');
                        // WEBAE3-7054 Remove total rental estimate cost for all but AU/NZ
                        if(UI.props.displayTotals) {
                            $diffText.css('font-weight', 600);
                            $diffContainer.append($(document.createElement('p'))
                                        .attr('id', thisRateID+'__totaldiff'));
                        }
                            
                        $diffContainer.prepend($diffText);
						
						$topCost.append($titleCost.append($diffContainer));
						$thRateCost.append($rate.append($packageContainer.append($topCost)));
						$thRateTitle.append($topTitle.append($titleTitle));
						var $tdRadio = $(document.createElement('td'));
						$trSelect.append($tdRadio); 
						$tdRadio.on( 'click', function ( event ) { 
							UI.radioInsuranceClick(thisRate.ID); 
						});
						var $buttonInput = $(document.createElement('input')).addClass('radio__insurance')
							.attr('id','radio__insurance--' + thisRate.ID)
							.attr('name','rateID')
							.attr('type','radio')
							.attr('value',thisRate.ID)
							.on( 'click', function ( event ) { event.stopPropagation(); } );

						if (thisRateID === AEdata.booking.state.rateID) {
							$buttonInput.prop('checked', true);
							$diffContainer.addClass('visuallyhidden');
						}
						
						var $buttonLabel = $(document.createElement('label'))
							.attr('for','radio__insurance--' + thisRate.ID);
                            
                        $tdRadio.append($buttonInput, $buttonLabel);
                        
                        //WEBAE3-5563 - Display booking buttons to trigger hidden radio buttons and submit
                        if(UI.props.customLayout.EU || UI.props.customLayout.AUNZ) {
                            var curRateTxt = $('.li--rate--now--txt').text();
                            
                            // WEBAE3-7054 Restructure Options buttons
                            var lastRateID = AEdata.booking.quote.oRates[aRateIDs[aRateIDs.length - 1]].ID;
                            var iTrans  = AE.props.oTranslations.INSURANCES;
                            var bookingLang = 'RISK';
                            var extraText = '';
							//WEBAE3-7151 - revert text back to package name
                            //if(thisRateID === lastRateID) {
                                bookingLang = 'CONTINUEWITH';
                                extraText = ' '+AE.props.oTranslations.INSURANCES[thisRate.package].TITLE;
                            //}
                            var btnHTML = iTrans.bookingUpgradeSelect[bookingLang] + extraText;
                            
                            var $buttonBook = $('<button type="button">')
                            .attr('data-radio', 'radio__insurance--' + thisRate.ID)
                            .html(btnHTML);
                            
                            var $bookBtnWrapper = $('<div class="btn-book-wrapper">')
                            .on('click', function()
                            {
                                AE.ui.dialog.setDialogTriggered();
                                AE.booking.saveQuote.deactivateExitModal();
                                $(this).find('button').append('<i class="fas fa-cog fa-spin fa-2x"></i>');
                                $('input#'+$(this).find('button').attr('data-radio')).click();
                            });
                            
                            $tdRadio.append($bookBtnWrapper.append($buttonBook));
                        }
					}
				});
                //STORE-1524 - no chosen by for Cover Genius
				//STORE-1509 - no chosen by for ZK
                if(CoverGeniusRateID === '' && !hasZK){
					var $chosenby = $(document.createElement('p')).addClass('chosen-by align-right').html(AE.props.oTranslations.INSURANCES.bookingUpgradeSelect.CHOSENBY);
					UI.props.$df.append($chosenby);
				}

				aRowIndexes = _.uniq(aRowIndexes);
				if (_.contains(aRowIndexes,8) && aRowIndexes[0] !== 8) {
					aRowIndexes = _.union([8],aRowIndexes);
				}
				
				$trHeadCost.prepend($(document.createElement('th')).append('&nbsp;')); //empty table cell
				
				$trHeadTitle.prepend($(document.createElement('th'))
                .addClass(columnWidthClass)
                .addClass('uppercase')
                .append(AEdata.booking.quote.oLang.INSURANCES.chartLabel));
				
				$trSelect.prepend($(document.createElement('th'))
					.addClass('insurance__options select')
					.html('&nbsp;'));
				
				_.each(aRowIndexes, function(rowIdx) {
					var $trRow = $(document.createElement('tr')).addClass('insurance__options');
					$chart.append($trRow);
					var $thLabel = $(document.createElement('th')).addClass('insurance__options');
					$thLabel.append(AEdata.booking.quote.oLang.INSURANCES.aRowLabels[rowIdx - 1]).addClass('label');
					$trRow.append($thLabel).addClass('insurance__options');
					_.each(aChecks, function(theseChecks) {
						var $tdCheck = $(document.createElement('td')).addClass('insurance__options');
						if (_.contains(theseChecks, rowIdx)) {
							$tdCheck.append($('<i></i>').addClass('fas fa-check fa-2x add_green_highlight')); // use font awesome
						} else {
							//WEBAE3-7151 - remove red Xs
                            //WEBAE3-7054 Add X to empty spots
							//STORE-1524 restore red Xs
							$tdCheck.append($('<i></i>').addClass('fas fa-x fa-2x')); // use font awesome
                        }
						$trRow.append($tdCheck).addClass( 'insurance__options');
					});
				});
				
				if (false && AE.booking.options.props.mixedFuelPolicy) {// Suppress Fuel Policy Indication per WEBAE3-2314
					var $trFuelRow = $(document.createElement('tr'));
					$chart.append($trFuelRow);
					var $thFuelLabel = $(document.createElement('th'));
					$thFuelLabel.append(AEdata.booking.quote.oLang.INSURANCES.aRowLabels[4]);
					$trFuelRow.append($thFuelLabel);
					_.each(aFuelChecks, function(fuelCheck) {
						var $tdCheck = $(document.createElement('td'));
						if (fuelCheck === true) {
							$tdCheck.append($('<i></i>').addClass('fas fa-check fa-2x add_green_highlight')); // use font awesome
						}
						$trFuelRow.append($tdCheck).addClass('insurance__options');
					});
				}
				
				if (AE.booking.options.mixedKm) {	
					var $trKmRow = $(document.createElement('tr'));
					$chart.append($trKmRow);
					var $thKmLabel = $(document.createElement('th'));
					$thKmLabel.append(AEdata.booking.quote.oLang.SIPPNOTES.ULK.TEXT);
					$trKmRow.append($thKmLabel).addClass('insurance__options');
					_.each(aKmChecks, function(kmCheck) {
						var $tdCheck = $(document.createElement('td'));
						if (kmCheck === true) {
							$tdCheck.append($('<i></i>').addClass('fas fa-check fa-2x add_green_highlight insurance__options')); // use font awesome
						}
						$trKmRow.append($tdCheck);
					});
				}
				//STORE-1524 add row for CG disclaimer
				if(CoverGeniusRateID !== '') {
					var $trCgRow = $(document.createElement('tr'));
					$chart.append($trCgRow);
					var $tdCG = $(document.createElement('td'));
					$tdCG.attr('colspan', 3);
					$tdCG.addClass('covergenius-note').html(AEdata.booking.quote.oRedBook[CoverGeniusRateID].STCOVERGENIUS.ITEM);
					$trCgRow.append($tdCG);
					//change second paragraph
					$("#insp2").html(AE.props.oTranslations.INSURANCES.OPTIONS_FOOTER_CG);
				}
				$chart.append($trSelect).addClass('insurance__options');
			} else {
				UI.buildLayout0();
			}
		},
		renderBoundingContent: function() {
			if ( AE.booking.options.props.rateFamily.length <= 1 ) {
				UI.props.boundingContentRendered = true;
			}
			if (!UI.props.boundingContentRendered) {
				if(AEdata.booking.quote.oRates[AEdata.booking.state.rateID]){
					var thisRate = AEdata.booking.quote.oRates[AEdata.booking.state.rateID];
					if(UI.props.TEASER !== ''){
						//WEBAE3-5595 - FCR AU/NZ: Enable Excess Refund Protection (ERP) and Breakdown Protection (BP)
						if(AE.props.siteCode === 'FCR' && AE.booking.options.props.rateFamily[1].includes('ZB') === true){
							$(document.createElement('h2')).addClass('fcr_header').append(AE.props.oTranslations.INSURANCES.ZB.TITLE).insertBefore(UI.props.$container); 
						}
						if(AE.props.siteCode === 'FCR' && AE.booking.options.props.rateFamily[1].includes('ZC') === true){
							$(document.createElement('h2')).addClass('fcr_header').append(AE.props.oTranslations.INSURANCES.ZC.TITLE).insertBefore(UI.props.$container);
						}
						//WEBAE3-6198 - FCR AU/NZ: Create ZQ Add-On promo for /options page
						if(AE.props.siteCode === 'FCR' && AE.booking.options.props.rateFamily[1].includes('ZQ') === true){
							$(document.createElement('h2')).addClass('fcr_header').append(AE.props.oTranslations.INSURANCES.ZQ.TITLE).insertBefore(UI.props.$container);
						}
						//WEBAE3-6214 - FCR AU/NZ: Create ZR Add-On promo for /options page
						if(AE.props.siteCode === 'FCR' && AE.booking.options.props.rateFamily[1].includes('ZR') === true){
							$(document.createElement('h2')).addClass('fcr_header').append(AE.props.oTranslations.INSURANCES.ZR.TITLE).insertBefore(UI.props.$container);
						}

						//console.log(AEdata.booking.quote);
						//console.log(AE.booking.options.props.rateFamily);
						//console.log(thisRate);
						//console.log(AE.props.oTranslations);
						
						if(AE.props.siteCode === 'FCR') {
							if(AE.booking.options.props.rateFamily[1].includes('ZB') === true || AE.booking.options.props.rateFamily[1].includes('ZC') === true || AE.booking.options.props.rateFamily[1].includes('ZR') === true || AE.booking.options.props.rateFamily[1].includes('ZQ') === true){
								$(document.createElement('p')).addClass('fcr_teasera').append(UI.props.TEASER).insertBefore(UI.props.$container);
							}
						} else {
                            // WEBAE3-7083 - Update teaser to use options_header LGMT
                            $(document.createElement('p')).html(AE.props.oTranslations.INSURANCES.OPTIONS_HEADER).insertBefore(UI.props.$container);
                            /* WEBAE3-7083 - Only display message for US */
							//STORE-1524 - show second paragraph on CA site
                            if(['US','CA'].indexOf(AE.props.chaosSystem) >= 0) {
								$(document.createElement('p'))
								.attr('id','insp2')//STORE-1524 id added to change
                                .addClass('grid__item one-whole hard')
                                    .append(AE.props.oTranslations.INSURANCES.OPTIONS_FOOTER)
                                    .insertBefore(UI.props.$container);
                            }
                        }
						if(thisRate.zxType !== 'ZE' && thisRate.packageType !== 'IB' && AEdata.booking.quote.oRedBook[thisRate.ID]){
							var oLocalFees = AEdata.booking.quote.oRedBook[thisRate.ID].STLOCALFEES;
							var pos218 = _.indexOf(oLocalFees.ID,218);
							var pos235 = _.indexOf(oLocalFees.ID,235);
							if(pos218 > -1 || pos235 > -1){
								var exHead = '';
								if(AEdata.booking.quote.oLang.DERC){
									exHead = AEdata.booking.quote.oLang.DERC.EXCESS_FEES;
								} else if(AEdata.booking.quote.oLang.EXCESS_FEES) {
									exHead = AEdata.booking.quote.oLang.EXCESS_FEES
								}
								if(AE.props.siteCode === 'FCR') {
									if(AE.booking.options.props.rateFamily[1].includes('ZB') === true){
										if(AE.props.chaosSystem === 'NZ') {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZB.TEASER.IBFCRNZ).insertBefore(UI.props.$container);
										} else {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZB.TEASER.IB).insertBefore(UI.props.$container);
										}
									}
									if(AE.booking.options.props.rateFamily[1].includes('ZC') === true){
										if(AE.props.chaosSystem === 'NZ') {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZC.TEASER.IBFCRNZ).insertBefore(UI.props.$container);
										} else {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZC.TEASER.IB).insertBefore(UI.props.$container);
										}
									}
									
									if(AE.booking.options.props.rateFamily[1].includes('ZQ') === true){
										if(AE.props.chaosSystem === 'NZ') {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZQ.TEASER.IBFCRNZ).insertBefore(UI.props.$container);
										} else {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZQ.TEASER.IB).insertBefore(UI.props.$container);
										}
									}

									if(AE.booking.options.props.rateFamily[1].includes('ZR') === true){
										if(AE.props.chaosSystem === 'NZ') {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZR.TEASER.IBFCRNZ).insertBefore(UI.props.$container);
										} else {
											$(document.createElement('div')).addClass('localexcess fcr_note fcr_push-bottom').append(AE.props.oTranslations.INSURANCES.ZR.TEASER.IB).insertBefore(UI.props.$container);
										}
									}
								} else {
									//WEBAE3-7151 - remove flush--bottom class
									$(document.createElement('h4')).addClass('')
										.append(exHead).insertBefore(UI.props.$container);
									var $feeUL = $(document.createElement('ul')).addClass('apply-half-rhythm push--left')
										.insertBefore(UI.props.$container);
									//WEBAE3-7151 - add bold to items below
									if(pos218 > -1){
										$feeUL.append($(document.createElement('li')).append('<b style="font-weight: bold !important;">'+oLocalFees.ITEM[pos218]+'</b>'));
									}
									if(pos235 > -1){
										$feeUL.append($(document.createElement('li')).append('<b style="font-weight: bold !important;">'+oLocalFees.ITEM[pos235]+'</b>'));
									}
								}
							}
						}
					}
				}
				if(AE.props.siteCode === 'FCR') {
					if(AE.booking.options.props.rateFamily[1].includes('ZB') === true){
						//WEBAE3-6077 - FCR AU/NZ - Remove Lloyds disclaimer text for ERP/BP offerings 
						/*$(document.createElement('p'))
						.addClass('grid__item one-whole push-half--top hard--left fcr_insurance_alert')
							.append(AE.props.oTranslations.INSURANCES.ALERT_FCR_ZB)
							.insertAfter(UI.props.$container);*/
					} else if (AE.booking.options.props.rateFamily[1].includes('ZC') === true){
						//WEBAE3-6077 - FCR AU/NZ - Remove Lloyds disclaimer text for ERP/BP offerings 
						/*$(document.createElement('p'))
						.addClass('grid__item one-whole push-half--top hard--left fcr_insurance_alert')
							.append(AE.props.oTranslations.INSURANCES.ALERT_FCR_ZC)
							.insertAfter(UI.props.$container);*/
					}/* else {
						$(document.createElement('p'))
						.addClass('grid__item one-whole push-half--top hard--left fcr_insurance_alert')
							.append(AE.props.oTranslations.INSURANCES.ALERT)
							.insertAfter(UI.props.$container);
					}*/
				} else {
					/* WEBAE3-5745 - Don't display message for certain sites */
					/* WEBAE3-7083 - remove footer alert (moved above options table for US)
					if(['US'].indexOf(AE.props.chaosSystem) >= 0) {
                        $(document.createElement('p'))
                        .addClass('grid__item one-whole push-half--top hard--left insurance-alert')
                            .append(AE.props.oTranslations.INSURANCES.OPTIONS_FOOTER)
                            .insertAfter(UI.props.$container);
					}
                    */
				}
				UI.props.boundingContentRendered = true;
			}
		},
		radioInsuranceClick: function(clickedID){
			clickedID = clickedID || '';
			if (AEdata.booking.quote.oRates[clickedID]) {
				UI.disableSubmit();
                
				var thisRate = AEdata.booking.quote.oRates[clickedID];
				var thisCar = AEdata.booking.quote.oCars[thisRate.carID];
				var thisLoc = AEdata.booking.quote.oLocs[thisRate.locID];
				AEdata.booking.state.rateID = clickedID;
                
                if(UI.props.customLayout.EU || UI.props.customLayout.AUNZ) {
					$('.insurance__options.last > td, .insurance-package .package-btn-wrapper').addClass('btn-disabled');
                } else {
					if(AE.props.siteCode !== 'FCR'){
                    	AE.booking.options.updateDailyDiffs();
					}
                }
                
                /*WEBAE3-4757 if rate chosen can't have cancel insurance but original rate did
                then we need to change AE.props.optEquip.cancelIns to 0 so bookingajax details
                call returns correct rate info for utility bar display.
                Conversely, if original rate had cancelIns from matrix, we should put it back
                for details call and utility bar display.
                AE.props.oOptEquip.cancelIns is also used to set chk_cncl hidden input on the
                insurance upgrade form submit only
                */
                hasOptEquipCancelTest = AE.props.oOptEquip.hasOwnProperty('cancelIns');
                hasCancelInsTest = AEdata.booking.state.hasOwnProperty('hasCancelIns');//hasCancelIns reflects initial cancel insurance status on page load
                if(hasOptEquipCancelTest && hasCancelInsTest && AEdata.booking.state.hasCancelIns) {
                    if(thisRate.cancelCost == 0) {
                        AE.props.oOptEquip.cancelIns = 0;//no cancel insurance available, deactivate option
                    }
                    if(thisRate.cancelCost !== 0) {
                        AE.props.oOptEquip.cancelIns = 1;//cancel insurance available, reactivate option
                    }	
                }
                
				AE.booking.options.setJsonPost();
				AE.booking.options.setGaEvents();
                
                //WEBAE3-5563 - Prevent excess load caused by updating the UI if not necessary
                if(!UI.props.customLayout.EU && !UI.props.customLayout.AUNZ) {
                    $('.utb__SIPP').html('('+thisRate.SIPP+')');
                    $('.package-cost-info').removeClass('visuallyhidden');
                    $('.package-cost-info.radio__insurance--'+clickedID+'--details').addClass('visuallyhidden');
					if(AE.props.siteCode === 'FCR'){
						if ($('.package-button').hasClass('selected')){
							$('.package-button').removeClass('selected');
							$('input#radio__insurance--'+clickedID).prop('checked',false);
							clickedID = _.first(AE.booking.options.props.rateFamily)
							$('input[name="rateID"]').val(clickedID);
							AE.booking.options.setJsonPost(clickedID,AEdata.booking.state.dropID);

							$('.fcr_price_today').html('$'+AEdata.booking.quote.oRates[clickedID].deposit.toFixed(2));
							$('.fcr-total_price_sp').html(AEdata.booking.quote.oRates[clickedID].deposit.toFixed(2));
							$('.fcr_insurance_package').html(OGlineItemLabel);
							
							$('#amex_estimate').html(OGamex_estimate);
							$('#mastercard_estimate').html(OGmastercard_estimate);
							$('#visa_estimate').html(OGvisa_estimate);
						} else {
							$('.package-button').addClass('selected');
							$('input#radio__insurance--'+clickedID).prop('checked',true);
							clickedID = _.last(AE.booking.options.props.rateFamily)
							$('input[name="rateID"]').val(clickedID);
							//AE.booking.options.setJsonPost(clickedID,AEdata.booking.state.dropID);
							
							var amex_estimate = (amex_percent / 100) * AEdata.booking.quote.oRates[clickedID].deposit;
							var mastercard_estimate = (mastercard_percent / 100) * AEdata.booking.quote.oRates[clickedID].deposit;
							var visa_estimate = (visa_percent / 100) * AEdata.booking.quote.oRates[clickedID].deposit;
							
							$('#amex_estimate').html('$'+amex_estimate.toFixed(2));
							$('#mastercard_estimate').html('$'+mastercard_estimate.toFixed(2));
							$('#visa_estimate').html('$'+visa_estimate.toFixed(2));

							$('.fcr_price_today').html('$'+AEdata.booking.quote.oRates[clickedID].deposit.toFixed(2));
							$('.fcr-total_price_sp').html(AEdata.booking.quote.oRates[clickedID].deposit.toFixed(2));
							if(AE.booking.options.props.rateFamily[1].includes('ZB') === true){
								$('.fcr_insurance_package').html(rental_with + ' ' + AE.props.oTranslations.INSURANCES.ZB.TAB);
							}
							if(AE.booking.options.props.rateFamily[1].includes('ZC') === true){
								$('.fcr_insurance_package').html(rental_with + ' ' + AE.props.oTranslations.INSURANCES.ZC.TAB);
							}
							if(AE.booking.options.props.rateFamily[1].includes('ZQ') === true){
								$('.fcr_insurance_package').html(rental_with + ' ' + AE.props.oTranslations.INSURANCES.ZQ.TAB);
							}
							if(AE.booking.options.props.rateFamily[1].includes('ZR') === true){
								$('.fcr_insurance_package').html(rental_with + ' ' + AE.props.oTranslations.INSURANCES.ZR.TAB);
							}

						}
					} else {
						$('.package-button').removeClass('selected');
						$('input.radio__insurance').prop('checked',false);
						$('input#radio__insurance--'+clickedID).prop('checked',true).closest('.package-button').addClass('selected');
					}
                    
                    // update text on other buttons
                    _.each(AE.booking.options.props.rateFamily,
                        function(tempRateID) {
                            var newText = AE.props.oTranslations.OPTION_UPGRADE;
                            if(tempRateID === clickedID) {
								if(AE.props.siteCode === 'FCR'){
									newText = AE.props.oTranslations.BTN_ADDTOBOOKING;
									$('.package-cost-info').removeClass('visuallyhidden');
									//$('.package-cost-info.radio__insurance--'+clickedID+'--details').addClass('visuallyhidden');
								} else {
									newText = AE.props.oTranslations.OPTION_SELECTED;
								}
                            } else if (tempRateID === _.last(AE.booking.options.props.rateFamily)) {
								if(AE.props.siteCode === 'FCR'){
									newText = AE.props.oTranslations.BTN_ADDTOBOOKING;
								} else {
									newText = AE.props.oTranslations.OPTION_BEST;
								}
                            } else if (tempRateID.substring(0,2) === 'IB') {
								if(AE.props.siteCode === 'FCR'){
									newText = AE.props.oTranslations.BTN_ADDTOBOOKING;
								} else {
                                	newText = AE.props.oTranslations.OPTION_SELECT;
								}
                            }
                            $('label[for="radio__insurance--'+tempRateID+'"] span').html(newText);
                        }
                    );
                    
                    // SIPP Note Refresh
                    var theseSIPPNotes = thisCar.aSIPPNotes;
                    if(thisLoc.type === 'A' && !_.contains(theseSIPPNotes,'ONAIR') && !_.contains(theseSIPPNotes,'OFFAIR')){
                        if(thisLoc.onAirport){
                            theseSIPPNotes = _.union(['ONAIR'],thisCar.aSIPPNotes);
                        } else {
                            theseSIPPNotes = _.union(['OFFAIR'],thisCar.aSIPPNotes);
                        }
                    }
                    $('#utbar__container--side--sippnotes .trg__book-widget--sippnotes,#utbar__container--top--sippnotes .trg__book-widget--sippnotes')
                        .html(AE.booking.matrix.results.buildSippNotes(theseSIPPNotes));
                        
                    // AE.ui.addSpinner('.utbar__container--paySummary',{color:'black',size:'3x'});
                    // UI.props.$lineItems.addClass('visuallyhidden');
                    // UI.props.$totals.addClass('visuallyhidden');
                    // Get Insruance Details
                    
                    // Determine visibility for DERC
                    UI.DERCVisibility();
                    //WEBAE3-5000 if Uplift payment modal is present, toggle and update based on insurance upgrade selected
                    if($('span[data-up-price-value]').length){
                        if(thisRate.deposit < AEdata.uplift.minCost || thisRate.deposit > AEdata.uplift.maxCost) {
                            $('.aeUplift-modal-container').addClass('hideme');
                        } else {
                            $('.aeUplift-modal-container').removeClass('hideme');
                        }
                        $('span[data-up-price-value]').attr('data-up-price-value',Math.round(thisRate.deposit*100))
                        window.Uplift.Payments.load({"order_amount": 0});
                    }
                }
                
				AE.booking.options.fetch();
                UI.props.customLayout.fromInsuranceClick = true;
			}
			
            // Adjust Package Cost Text and note to be bottom aligned
            AE.booking.setPackageCostPosition();
		},
		updateForm: function(){
			UI.props.$form.find('input[name="jsonPost"]').val(encodeURIComponent(JSON.stringify(AE.booking.options.props.jsonPost)));
			if (AE.booking.options.props.jsonPost.bookingstep === 'getupgrade' ) {
				UI.props.$form.attr('action','https://'+AE.url.props.host+'/'+AEdata.booking.paths.UP+'/')
					.find('input[name="bookingstep"]').val('getupgrade');
			} else {
				UI.props.$form.attr('action','https://'+AE.url.props.host+'/'+AEdata.booking.paths.BK+'/')
					.find('input[name="bookingstep"]').val('bookform');
			}
			//no FCR car upgrade
			if (AE.booking.options.props.jsonPost.bookingstep === 'getupgrade' && AE.props.siteCode === 'FCR' ) {
				UI.props.$form.attr('action','https://'+AE.url.props.host+'/'+AEdata.booking.paths.BK+'/')
					.find('input[name="bookingstep"]').val('bookform');
					AE.booking.options.props.jsonPost.bookingstep = 'bookform';
			}
            
            if((UI.props.customLayout.EU || UI.props.customLayout.AUNZ) && UI.props.customLayout.fromInsuranceClick) {
				$('#option_update__btn--main').click();
            }
		},
		updateLineItems: function(oLI,thisOWFUnknown) {//console.log([oLI,thisOWFUnknown]);
			oLI = oLI || {};
			_.extend({now:[],inRate:[],local:[]},oLI);// Object values over-write right-to-left
			var $dfLI = $( document.createDocumentFragment() );
			var redraw = false;
			var rentalTotal = 0;
			if((AEdata.booking.props.oTP.A || AEdata.booking.props.oTP.D) && (AEdata.booking.state.pickupID !== AEdata.booking.state.dropoffID)){
				// 3721
				var owfFound = _.findWhere(_.union(oLI.local,oLI.now,oLI.inRate),{SOURCE: 'OWF'});
				if(owfFound === undefined){
					var formattedSPoof = AEdata.booking.quote.oLang.CURRENCY_TEMPLATE.replace('.',Math.round(0).toFixed(2));
					if(thisOWFUnknown) formattedSPoof = AEdata.booking.quote.oLang.LINE.UNKNOWN;
					oLI.inRate.push({
						ADDTOTOTAL: false,
						CURR: formattedSPoof,
						CURRENCYCODE: "",
						ESTIMATE: false,
						FEE: 0,
						FEECLASS: "",
						PREVCURR: formattedSPoof,
						PREVFEE: 0,
						SOURCE: "OWF",
						TEXT: AEdata.booking.quote.oLang.LINE.DROP_FEE,
						TEXTCLASS: "",
						TOOLTIP: "",
						TYPE: "inRate",
						VOUCH: false,
						spoof: true
					});
				}
			}
			_.each(['local','now','inRate'],function(key) {
				var tempArr = oLI[key];
				if (!_.isEmpty(tempArr)) {
					var tempProps = UI.props.lineItemProps[key] || UI.props.lineItemProps.now;
					var tempTotal = 0;
					var showZero = false;
					_.each(tempArr,function(tempItem){
						//WEBAE3-4047 convert strings to numbers so that math works
						tempTotal = tempTotal;
						tempItem.FEE = tempItem.FEE;
						if (tempItem.ADDTOTOTAL) tempTotal += tempItem.FEE;
						if (tempItem.spoof) showZero = true;
						//WEBAE3-6211 - show 0 cost one way fees - Mike 3 Jun 2024
						if (tempItem.SOURCE === 'OWF') showZero = true;
					});//only add fee to total if required
					
					if (tempTotal > 0 || showZero) {
						redraw = true;
						var $wrapper = $(document.createElement('div')).attr('data-amount',tempTotal)
							.addClass('grid__item one-whole '+tempProps.className);
						var $title = $(document.createElement('h5'))
							.addClass('flush--bottom '+tempProps.titleClass+' ')
							.append(tempProps.title+' ');

						if (tempProps.toolTip && tempProps.toolTip.length > 0) {
							$title.addClass('more-info-tip')
								.append($(document.createElement('div'))
								.addClass('more-info-text')
								.append(tempProps.toolTip));
						}

						$dfLI.append($wrapper.append($title));
						
						if (key !== 'inRate') rentalTotal += tempTotal;
						
						_.each(tempArr,function(oFee) {
							var $dfFee = $( document.createDocumentFragment() );
							var $note = $(document.createElement('div'))
								.addClass('grid__item three-fifths lap-one-half hard--left '+oFee.TEXTCLASS)
								.append(oFee.TEXT+' ');	

							//WEBAE3-4886 don't show the fee if it's 0 - Mike 23 May 2022
							//WEBAE3-6211 - show 0 cost one way fees - Mike 3 Jun 2024
							if (oFee.FEE == 0 && !oFee.SOURCE === 'OWF') $note
								.addClass('visuallyhidden')

							if (oFee.ESTIMATE) $note
									.append($(document.createElement('span'))
									.addClass('options-footnote pmnt-option-footnote')
									.append(AE.props.oTranslations.LINE.ESTIMATE));
							
							if (oFee.TOOLTIP && oFee.TOOLTIP.length > 0) $note
									.addClass('more-info-tip')
									.append($(document.createElement('div'))
									.addClass('more-info-text').append(oFee.TOOLTIP));

							if (AE.props.useWEBAE3_4586 && oFee.TYPE == 'now') {
								$note.removeClass('more-info-tip').addClass('car-terms more-info-tip-rates');
								$note.attr('data-car-terms', document.getElementById('data-car-terms').dataset['carTerms']);
								//WEBAE3-6125 - add data-rate-id so can we get specific rate terms only
								$note.attr('data-rate-id', AEdata.booking.state.rateID);
							}
							
							//WEBAE3-4574 - add info icon and modalname to line item
							if (oFee.modalName && oFee.modalName.length > 0) {
								$note.attr('data-modalname',oFee.modalName);
								$note.addClass('more-info-tip');
							}

							var $amount = $(document.createElement('div'))
								.addClass('grid__item two-fifths lap-one-half align-right '+oFee.FEECLASS);
							//WEBAE3-4886 don't show the fee if it's 0 - Mike 23 May 2022
							//WEBAE3-6211 - show 0 cost one way fees - Mike 3 Jun 2024
							if (oFee.FEE == 0 && !oFee.SOURCE === 'OWF') $amount
								.addClass('visuallyhidden')

							if (!oFee.ADDTOTOTAL) {
								if(oFee.spoof){// 3721
									$amount.append(oFee.CURR);
								} else {//only show amount if it's added to total cost
									$amount.append(' ');
								}
							} else if ((oFee.FEE && oFee.FEE > 0) || (oFee.CURR && oFee.CURR.length > 0)) {
									if (oFee.PREVFEE && oFee.PREVFEE > 0 && oFee.PREVFEE > oFee.FEE && AE.props.siteCode !== 'DAU' && AE.props.siteCode !== 'DNZ') $amount.append($(document.createElement('div')).addClass('cardetails-beforesale top-vbleed').append(oFee.PREVCURR));
									//WEBAE3-6633 - DTP UK - Add OWF in Local Currency near the Source Currency OWF Messaging during the booking process
									if(oFee.SOURCE === 'OWF' && oFee.TYPE === 'local' && oSite.mSiteCode === 'DTP' && AE.props.siteCode === 'GBR' && AEdata.booking.quote.oCurrency.QUOTE !== AE.props.localCurrency){
										if(AE.props.localCurrencySymbol.charAt(0) === '&'){
											var localCurrencySymbol = localCurrencySymbol+';'
										} else if(AE.props.localCurrencySymbol.charAt(AE.props.localCurrencySymbol.length - 1) !== '$'){
											var localCurrencySymbol = localCurrencySymbol+';'
										} else {
											var localCurrencySymbol = AE.props.localCurrencySymbol;
										}
										var localOWF  = (oFee.FEE * AE.props.localExchangeRate).toFixed(2);
										$amount.append(oFee.CURR +' ('+localCurrencySymbol+localOWF+')');
									} else {
										$amount.append(oFee.CURR);
									}
							} else {
								$amount.append('--');
							}
							
							//WEBAE3-6211 - show 0 cost one way fees - Mike 3 Jun 2024
							if (oFee.ESTIMATE && key === 'inRate' && oFee.FEE <= 0 && !oFee.SOURCE === 'OWF') return null;// WEBAE3-907 - if we can't give a non-zero amount to a fee included in the rate, don't display it
							$wrapper.append($dfFee.append($note,$amount));

                            if(oFee == _.last(tempArr) && key == 'local') {
                                
                                var $dfLocalTotal = $( document.createDocumentFragment() );
                                var $totalLocal = $(document.createElement('div'))
                                    .addClass('border--top push-half--top soft-half--top');
                                var $totalLabel = $(document.createElement('div'))
                                    .addClass('grid__item three-fifths lap-one-half hard--left '+oFee.TEXTCLASS)
                                    .append($(document.createElement('h5'))
                                    .addClass('flush--top')
                                    .append(AE.props.oTranslations.LINE.FEES_DUE));
                                //if(oFee.ESTIMATE) $note.append($(document.createElement('span')).addClass('options-footnote').append('totally fees');
                                //if(oFee.TOOLTIP && oFee.TOOLTIP.length > 0) $note.addClass('more-info-tip').append($(document.createElement('div')).addClass('more-info-text').append(oFee.TOOLTIP));
                                var localTotal = Math.abs(Math.round(tempTotal*100)/100).toFixed(2);
                                var localTotalTxt = AE.props.oTranslations.CURRENCY_TEMPLATE.replace('.',localTotal);
                                var $totalAmount = $(document.createElement('div')).addClass('grid__item two-fifths lap-one-half align-right '+oFee.FEECLASS).append($(document.createElement('h5')).addClass('flush--top').append($(document.createElement('span')).addClass('local__container--utbar').append(localTotalTxt)).append($(document.createElement('div')).addClass('options-footnote flush--top').append(AE.props.oTranslations.LINE.ESTIMATE)));
                                $totalLocal.append($totalLabel,$totalAmount);

                                /*if((oFee.FEE && oFee.FEE > 0) || (oFee.CURR && oFee.CURR.length > 0)){
                                    if(oFee.PREVFEE && oFee.PREVFEE > 0 && oFee.PREVFEE > oFee.FEE) $amount.append($(document.createElement('div')).addClass('cardetails-beforesale top-vbleed').append(oFee.PREVCURR));
                                    $amount.append(oFee.CURR);
                                } else {
                                    $amount.append('--');
                                }*/
                                $wrapper.append($dfLocalTotal.append($totalLocal));

                                tempProps.divider = true;
                                $wrapper.append($(document.createElement('div'))
                                    .addClass('border--bottom push-half--bottom push-half--top'));

                            }

						});
					}
				}
			});

			if (redraw) {
				UI.props.$lineItems.html($dfLI);
				rentalTotal = Math.abs(Math.round(rentalTotal*100)/100).toFixed(2);
				rentalTotalTxt = AE.props.oTranslations.CURRENCY_TEMPLATE.replace('.',rentalTotal);
				UI.props.$totals.html(rentalTotalTxt);

				//WEBAE3-7194 - DAP Net account - Cancel Insurance is not being added to total due
				if(typeof dapnetratewithoutcancel !== 'undefined' && oSite.isPaymentNet) {

					if($('#chk_cncl').prop('checked')){
						$('#payamount').html(dapnetratewithcanceldisplay);
						$('#netrate').val(dapnetratewithcancel);
					} else {
						$('#payamount').html(dapnetratewithoutcanceldisplay);
						$('#netrate').val(dapnetratewithoutcancel);
					} 
				}
				if(oLI.charge && $('.total__container--tp')[0]){
					$('.total__container--tp .tp--total--label,.total__container--tp .tp--local--label').removeClass('visuallyhidden');
					$('.total__container--tp .tp--total').removeClass('visuallyhidden').html(oLI.charge.total);
					$('.total__container--tp .tp--local').removeClass('visuallyhidden').html(oLI.charge.local);
					$('.total__container--tp .tp--now strong').html(oLI.charge.now);
					if(oLI.charge.total === oLI.charge.now){
						$('.total__container--tp .tp--total,.total__container--tp .tp--total--label').addClass('visuallyhidden');
						$('.total__container--tp .tp--local,.total__container--tp .tp--local--label').addClass('visuallyhidden');
					}
				}
			}

            UI.updateChargeCurrencyDisplay();
			// AE.ui.removeSpinner('.utbar__container--paySummary');
			// UI.props.$lineItems.removeClass('visuallyhidden');
			// UI.props.$totals.removeClass('visuallyhidden');
		},
        updateChargeCurrencyDisplay: function() {
            // WEBAE3-6521 - Display charged currency if site is using a different display currency - Derek 14 Nov 2024
            $('.rate--now--charged--label, .rate--now--charged--amt').remove(); // remove any old amounts
            const $el = $('.li--rate--now--amt');
            let totalCharge = $el.eq(0).closest('.line__item--now').attr('data-amount');
            const base_currency  = AEdata.booking.quote.oCurrency.BASE;
            const quote_currency = AEdata.booking.quote.oCurrency.QUOTE;

            if(base_currency != quote_currency) {
                const currency_list    = AE.props.oTranslations.CURRENCY_LIST;
                const charged_currency = AE.props.oTranslations.CHARGED_CURRENCY;
                let charged_label  = charged_currency.replace('[CURRENCY]', '');
                let charged_symbol = '&dollar;'; // use HTML Entities so they don't get translated and break

                if(currency_list.hasOwnProperty(base_currency)) {
                    charged_label  = charged_currency.replace('[CURRENCY]', base_currency);
                    charged_symbol = currency_list[base_currency];
                }
                
                // Calculate charge amount with exchange rate and round to 2 decimal places
                const exchange_amount = (Math.round((totalCharge/(AEdata.booking.quote.oCurrency[quote_currency].EX1) + Number.EPSILON) * 100) / 100).toFixed(2);

                var $chargeCurrency = $(document.createDocumentFragment());
                var $chargeCurLabel = $(document.createElement('div'))
                    .addClass('grid__item three-fifths lap-one-half rate--now--charged--label')
                    .html(charged_label);
                var $chargeCurTotal = $(document.createElement('div'))
                    .addClass('grid__item two-fifths lap-one-half align-right rate--now--charged--amt')
                    .html(charged_symbol+exchange_amount);

                $el.parent().after($chargeCurrency.append($chargeCurLabel, $chargeCurTotal));
            }
        },
		disableSubmit: function() {
			UI.props.$button.prop('disabled',true);
		},
		enableSubmit: function() {
			UI.props.$button.prop('disabled',false);
		},
		DERCClick: function() {
			AE.props.oOptEquip.DERC = (AE.props.oOptEquip.DERC === 0) ? 1 : 0;
			UI.props.$inputDERC.val(AE.props.oOptEquip.DERC);
			if (AE.props.oOptEquip.DERC) {
				UI.props.$btnDERCicon.removeClass('fa-square').addClass('fa-check-square');
				UI.props.$alertDERC.addClass('trulyhidden');
			} else {
				UI.props.$btnDERCicon.removeClass('fa-check-square').addClass('fa-square');
				UI.props.$alertDERC.removeClass('trulyhidden');
			}
			AE.booking.options.fetch();
		},
		BRPClick: function() {
			AE.props.oOptEquip.BRP = (AE.props.oOptEquip.BRP === 0) ? 1 : 0;
			UI.props.$inputBRP.val(AE.props.oOptEquip.BRP);
			if (AE.props.oOptEquip.BRP == 1) {
				UI.props.$btnBRPicon.removeClass('fa-square').addClass('fa-check-square');
			} else {
				UI.props.$btnBRPicon.removeClass('fa-check-square').addClass('fa-square');
			}
				AE.booking.options.fetch();
		},
		DERCVisibility: function() {
			var arrExclude = AEdata.noDERClist.split(','),
				oRate = AE.booking.props.oRateObjects[AEdata.booking.state.rateID];
			if ( _.contains(arrExclude, oRate.package.substring(0,2)) ) {
				// Hide DERC and deactivate the fake checkbox
				$('#insurance-derc').addClass('trulyhidden');
				AE.props.oOptEquip.DERC = 0;
				UI.props.$inputDERC.val(AE.props.oOptEquip.DERC);
				UI.props.$btnDERCicon.removeClass('fa-check-square').addClass('fa-square');
				UI.props.$alertDERC.removeClass('trulyhidden');
			} else {
				// Show DERC
				$('#insurance-derc').removeClass('trulyhidden');
			}
		},

		buttonResizeDERC: function() {
			if (AE.getSiteViewType() === 'palm') {
				UI.props.$btnDERCicon.removeClass('fa-5x').addClass('fa-3x');
			} else {
				UI.props.$btnDERCicon.addClass('fa-5x').removeClass('fa-3x');
			}
		},

		buttonResizeInsuranceContainer: function() {
			$el = $("div.insurance-content.togglee"); 
			if (AE.getSiteViewType() !== 'palm') {
				$el.removeClass('visuallyhidden');
			}
			else{
				$eleToggle = $('div[data-togglee=".insurance-content.togglee"]'); 
				$eleToggle.addClass('open');
				$el.removeClass('visuallyhidden');	
			}
		},
		fcrOptionalItems: function(event){
			UI.fcrPayOnArrivalTotal()
			var $optionalEqupSelect = $(".optionalEquip");
			// var $optionalEqupSelect = $(".ui-selectmenu-text");

			// Updates the totals and displays charge amounts on optional items if they are already selected
			$optionalEqupSelect.each(function ( i ) {
				var $blockWrapper = $(this).closest($(".fcr_block_wrapper"));
				var $optCheckedVal = $blockWrapper.find($( "select option:selected" )).val();
				var $chrgAmntPageLoad = $blockWrapper.find($( ".chrg_amnt" )).attr("data-charge-amount");
				var $chrgDurationPageLoad = $blockWrapper.find($( ".chrg_amnt" )).attr("data-trip-duration");
				var $itemTypePageLoad = $blockWrapper.find($( ".chrg_amnt" )).attr("data-item-type");
				var $chrgFreqPageLoad = $blockWrapper.find($( ".chrg_amnt" )).attr("data-rental-frequency");
				if($chrgFreqPageLoad == 'PERDAY'){
					var $totalChargePageLoad = ($chrgAmntPageLoad * $optCheckedVal * $chrgDurationPageLoad).toFixed(2);
					var $gpsTotalChargePageLoad = ($chrgAmntPageLoad * $chrgDurationPageLoad).toFixed(2);
				}else{
					var $totalChargePageLoad = ($chrgAmntPageLoad * $optCheckedVal).toFixed(2);
					var $gpsTotalChargePageLoad = $chrgAmntPageLoad;
				}
				
				if ($optCheckedVal > 0){
					$blockWrapper.find($(".option_item_count")).text('  ' + $optCheckedVal)
					$blockWrapper.find($( ".chrg_amnt" )).text($totalChargePageLoad)
					$blockWrapper.find($(".option_added")).show()
					UI.fcrPayOnArrival($optCheckedVal, $totalChargePageLoad, $itemTypePageLoad )
					UI.fcrPayOnArrivalTotal()
				}else if($optCheckedVal == "ON") {
					$blockWrapper.find($(".option_item_count")).text('  ')
					$blockWrapper.find($( ".chrg_amnt" )).text($gpsTotalChargePageLoad)
					$blockWrapper.find($(".option_added")).show()
					UI.fcrPayOnArrival(1, $gpsTotalChargePageLoad, $itemTypePageLoad)
					UI.fcrPayOnArrivalTotal()
				};
			});

			// Updates the totals and displays charge amounts on optional items as they are added
			$optionalEqupSelect.change(function () {
				var $fcrBlockWrapper = $(this).closest($(".fcr_block_wrapper"));
				var $count = $fcrBlockWrapper.find($( "select option:selected" )).val();
				var $chrgAmnt = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-charge-amount");
				var $chrgAmntMax = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-charge-amount-max");
				var $chrgAmntWeeklyMax = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-charge-perweek-max");
				var $chrgAmntMonthlyMax = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-charge-permonth-max");
				var $chrgDuration = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-trip-duration");
				var $itemType = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-item-type");
				var $chrgFreq = $fcrBlockWrapper.find($( ".chrg_amnt" )).attr("data-rental-frequency");
				
				if ($count == 'ON') {
					$count = 1;
				}
				if($chrgFreq == 'PERDAY' || $chrgFreq == 'PERWEEK' || $chrgFreq == 'PERMONTH'){

					// new charge function goes here. sets up cost variables for $totalCharge and $gpsTotalCharge

					//handle weekly and monthly max charges
					//for perday fees, we want the actual full weeks/months plus the remaining days.
					var $numWeeks = Math.floor(Number($chrgDuration) / 7);
					var $numMonths = Math.floor(Number($chrgDuration) / 30);
					var $additionalDays = 0; //populate below
					
					if ($chrgFreq == 'PERDAY'){
						var $chrgDuration = $chrgDuration;
					} else if ($chrgFreq == 'PERWEEK') {
						//for perweek fees, it's an extra week if it crosses into another one
						var $numWeeks = Math.ceil(Number($chrgDuration) / 7);
						var $chrgDuration = $numWeeks;
					} else if ($chrgFreq == 'PERMONTH') {
						//for permonth fees, it's an extra month if it crosses into another one
						var $numMonths = Math.ceil(Number($chrgDuration) / 30);
						var $chrgDuration = $numMonths;
					}


					if ($chrgAmntWeeklyMax > 0 && $chrgFreq !== 'PERWEEK') {
						var $chrgAmntMax = $chrgAmntWeeklyMax * $numWeeks;
						var $additionalDays = $chrgDuration - ($numWeeks * 7);
						var $chrgAmnt = $chrgAmntMax + ($additionalDays * $chrgAmnt);

					} else if ($chrgAmntMonthlyMax > 0 && $chrgFreq !== 'PERMONTH') {
						var $chrgAmntMax = $chrgAmntMonthlyMax * $numMonths;
						var $additionalDays = $chrgDuration - ($numMonths * 30);
						var $chrgAmnt = $chrgAmntMax + ($additionalDays * $chrgAmnt);

					} else {
						if (($chrgAmnt * $chrgDuration) > $chrgAmntMax && $chrgAmntMax > 0) {
							var $chrgAmnt = $chrgAmntMax;
						} else {
							var $chrgAmnt = $chrgAmnt * $chrgDuration;
						}
					}
					
					var $totalCharge = ($chrgAmnt * $count).toFixed(2);
					var $gpsTotalCharge = $totalCharge;


				}else if ($chrgFreq == 'PERRENTAL' || $chrgFreq == 'FLATFEE') {
					var $totalCharge = (Number($chrgAmnt) * Number($count)).toFixed(2);
					var $gpsTotalCharge = (Number($chrgAmnt) * Number($count)).toFixed(2);
				}
				
				if ($itemType === 'fcr_arrival_gps') {
					$fcrBlockWrapper.find($(".option_item_count")).text('  ')
					$fcrBlockWrapper.find($( ".chrg_amnt" )).text($gpsTotalCharge)
					$fcrBlockWrapper.find($(".option_added")).fadeIn()
					var $gpsCountOn = 1;
					UI.fcrPayOnArrival($gpsCountOn, $gpsTotalCharge, $itemType)
					UI.fcrPayOnArrivalTotal()
				}else if ($count > 0) {
					$fcrBlockWrapper.find($(".option_item_count")).text('  ' + $count + ' x ')
					$fcrBlockWrapper.find($( ".chrg_amnt" )).text($totalCharge)
					$fcrBlockWrapper.find($(".option_added")).fadeIn()
					UI.fcrPayOnArrival($count, $totalCharge, $itemType )
					UI.fcrPayOnArrivalTotal()
				}else if($count == "ON"){
					$fcrBlockWrapper.find($(".option_item_count")).text('  ')
					$fcrBlockWrapper.find($( ".chrg_amnt" )).text($gpsTotalCharge)
					$fcrBlockWrapper.find($(".option_added")).fadeIn()
					var $gpsCountOn = 1;
					UI.fcrPayOnArrival($gpsCountOn, $gpsTotalCharge, $itemType)
					UI.fcrPayOnArrivalTotal()
				}else{
					$fcrBlockWrapper.find($(".option_item_count")).text('  No')
					$fcrBlockWrapper.find($( ".chrg_amnt" )).text("0")
					$fcrBlockWrapper.find($(".option_added")).fadeOut()
					UI.fcrPayOnArrival($count, $totalCharge, $itemType )
					UI.fcrPayOnArrivalTotal()
				}
			});
		},
		fcrPayOnArrival: function ($count, $cost, $itemType){
			if (AE.props.siteCode === 'FCR') {
				var $itemBlock = $(".fc_arrival_item-block");
				var $itemClassName = $itemType.slice(0, 0) + '.' + $itemType.slice(0)

				if ($itemBlock.hasClass($itemType) && $count > 0){
					$($itemClassName).find($(".fcr_arrival_item_count")).text($count + ' x')
					$($itemClassName).find($(".fcr_arrival_item_price")).text($cost)
					$($itemClassName).fadeIn().css("display","flex");
				} else if ($itemBlock.hasClass($itemType) && $count == 0) {
					$($itemClassName).fadeOut();
					$($itemClassName).find($(".fcr_arrival_item_price")).text($cost)

				}
			}
		},
		fcrPayOnArrivalTotal: function() {
			var $totalPrice = []
			$(".fcr_arrival_item_price").each( function() {
				var $priceStr = $(this).text().trim()
				//console.log('this price string == ',$priceStr)

				// if($priceStr.includes('$')) {
				if($priceStr) {
					// $priceStr = $priceStr.slice(1);
					var $priceInt = parseFloat($priceStr)
					$totalPrice.push($priceInt)

					var arrSum = function(arr){
						return arr.reduce(function(a,b){
							return a + b
						}, 0);
					}
					//console.log('total price == ',$totalPrice)
					$totalPriceSum = arrSum($totalPrice).toFixed(2)
					$(".fcr_poa-total-price").text($totalPriceSum)
				}
			})
		},
		render: function() {
			AE.ui.removeSpinner(UI.props.containerSelector);
			UI.renderBoundingContent();
			UI.props.$container.html(UI.props.$df);
			AE.booking.options.updateDailyDiffs();
			UI.updateForm();
			UI.DERCVisibility();
		}

		
		
		// TODO: WEBAE3-1659 add resize task function here that detects viewType and toggles UI.props.useLayout or W.E. between 1 and 2
		// BUT ONLY IF IT IS INITIALIZED AS 2...prpbably need to set new property on init to flag instance as needing this
		// 1 for palm if new prop is true
		// 2 for not-palm if new prop is true
		// manage re-rendering when layout changes
		// then register resize task in init function
	};

	

	return UI;
	
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking.optEquip = AE.booking.optEquip || (function () {
	/*
	DEPENDENCIES: AE, AE.booking
	*/
	var APP = {
		init: function () {
			/*
			This is where we set variables and things that will only live inside the closure. Local
			variables will only live in here, and will not be accessible to the browser's inspector.

			Props are defined only upon init, so we can load the modules in any order. If we declared
			them outside of init then modules calling other modules would throw errors. This way, those
			calls are only made after everything is loaded and the various init functions are called.

			The APP object is just a shorthand so we can have an easy reference instead of the possibly
			long, dot-syntaxed name that will be returned. You can call this by "APP" only in here.
			After this is all returned, other modules will know the object by its full name. In this
			case, that would be AE.booking.
			*/
			var oBase = {
				infantSeat: 0,
				childSeat: 0,
				boosterSeat: 0,
				skiRack: 0,
				snowChains: 0,
				winterization: 0,
				GPS: 0,
				MiFi: 0
			};
			APP.props = {
				gaUpdateEvent: {
					GACATEGORY: (AEdata && AEdata.booking && AEdata.booking.props.ismodify) ? 'modOptionalEquip' : 'carOptionalEquip',
					GAACTION: (AEdata && AEdata.booking && AEdata.booking.state.step) ? AEdata.booking.state.step : '',
					GALABEL: 'Submitted'
				},
				oSelectors: {
					widgets: '.option_container--utbar',
					frmMain: 'form#form--getoptions',
					frmTop: 'div#option_update--top',
					frmSide: 'div#option_update--side',
					btnMain: '#option_update__btn--main',
					btnTop: '#option_update__btn--top',
					btnSide: '#option_update__btn--side',
					infantSeat: 'select[name="selInfantSeatFilter"]',
					childSeat: 'select[name="selChildSeatFilter"]',
					boosterSeat: 'select[name="selBoosterSeatFilter"]',
					skiRack: 'select[name="selSkiRacks"]',
					snowChains: 'select[name="options_snowChains"]',
					winterization: 'select[name="options_snowChains"]',
					GPS: 'select[name="options_gps"]',
					MiFi: 'select[name="options_mifi"]'
				},
				oFieldNames: {
					SELINFANTSEATFILTER: 'infantSeat',
					SELCHILDSEATFILTER: 'childSeat',
					SELBOOSTERSEATFILTER: 'boosterSeat',
					SELSKIRACKS: 'skiRack',
					OPTIONS_SNOWCHAINS: 'snowChains',
					OPTIONS_GPS: 'GPS',
					OPTIONS_MIFI: 'MiFi'
				},
				oCurrent: {},
				oInput: {},
				oPrices: {},
				oLabels: {
					infantSeat: 'INFANTLABEL',
					childSeat: 'CHILDLABEL',
					boosterSeat: 'BOOSTERLABEL',
					skiRack: 'SKILABEL',
					snowChains: 'WINTERLABEL',
					winterization: 'WINTERLABEL',
					GPS: 'GPSLABEL',
					MiFi: 'MIFILABEL'
				},
				_optEquipSelectUpdated: {},
				_optEquipLoadVals: {},
				_optEquipBaseFilter: {}
			};
			_.extend(APP.props.oCurrent, oBase);
			if (AE.props.oOptEquip) _.extend(APP.props.oCurrent, AE.props.oOptEquip);
			_.extend(APP.props.oInput, APP.props.oCurrent);
			_.extend(APP.props.oPrices, oBase);
			if (AE.props.oEquipPrices) _.extend(APP.props.oPrices, AE.props.oEquipPrices);
			if (AEdata && AEdata.booking && AEdata.booking.state.step !== 'searchwait' && AEdata.booking.state.step !== 'getrates' && AEdata.booking.state.step !== 'expiredquote') APP.synchSelections();
			// When one dropdown changes, change others and oInput
			AE.ui.addBodyChangeTask({
				func: function (event) {
					APP.onBodyChange(event);
				}
			});
			
			// Clicking Buttons runs trackAcc and either submit main form or run AJAX in utilitybar
			AE.ui.addBodyClickTask({
				func: APP.onBodyClick
			});
			
			// RENDER UI WIDGETS
			APP.renderStaticBlocks();

			//$(".infant").html(APP.props.oCurrent.infantSeat);
			
			if (AEdata && AEdata.booking && AEdata.booking.state.step !== 'getoptions') { APP._checkOptEquipObjects(); }
			
			// flag for right side #option_container--side
			APP._optEquipOpenClose();
		},
		// optEquipOpenClose() flag for right side #option_container--side
		_optEquipOpenClose: function() {
			if ( AEdata && AEdata.booking && AEdata.booking.props && AEdata.booking.props.isOptEquipOpen ) {
				return $('#option_update--side,option_update--top').removeClass('visuallyhidden');
			} else {
				return $('#option_update--side,option_update--top').addClass('visuallyhidden');
			}
		},
		_toggleEnableBtnControl: function (obj, enable) {
			var $obj = $(obj);
			var _enable = enable; // it's a bool, yo
			var _class = 'ui-state-disabled';

			$obj.attr('disabled', !_enable);

			return _enable ? $obj.removeClass(_class) : $obj.addClass(_class);
		},
		_checkOptEquipObjects: function () {
			// Get all selects in the form
			var _selectArray = $(APP.props.oSelectors.frmSide).find('select');

			// Traverse through selects to set up values for APP.props._optEquipSelectUpdated & APP.props._optEquipLoadVals
			for (var i = 0; i < _selectArray.length; i++) {
				var _sel = $(_selectArray[i]);
				var _selName = _sel.attr('name');
				var _selVal = _sel.val();
				// Get initial select values on page load and do not manipulate this object again,
				// storing initial values for reference in the onBodyChange task
				APP.props._optEquipLoadVals[_selName] = _selVal;
				// Duplicate {prop:key} assignments to APP.props._optEquipSelectUpdated (which gets updated on select value change)
				APP.props._optEquipSelectUpdated[_selName] = _selVal;
			}

			APP._toggleEnableBtnControl(APP.props.oSelectors.btnTop, false);
			APP._toggleEnableBtnControl(APP.props.oSelectors.btnSide, false);
		},
		_preCheckOptEquipObjects: function () { //WEBAE3-5765
			// Get all selects in the form
			var _selectArray = $(APP.props.oSelectors.frmSide).find('select');
			var _selectArrayOrig = $(APP.props.oSelectors.frmMain).find('select');
			// Traverse through selects to set up values for filtering of static results WEBAE3-5765
			if(_selectArray.length || _selectArrayOrig.length ){
				if(_selectArray.length){
					for (var i = 0; i < _selectArray.length; i++) {
						var _selFieldVal = APP.props.oFieldNames[$(_selectArray[i]).attr('name').toUpperCase()];
						APP.props._optEquipBaseFilter[_selFieldVal] = 1;
					}
				}
				if(_selectArrayOrig.length){
					for (var i = 0; i < _selectArrayOrig.length; i++) {
						var _selFieldVal = APP.props.oFieldNames[$(_selectArrayOrig[i]).attr('name').toUpperCase()];
						APP.props._optEquipBaseFilter[_selFieldVal] = 1;
					}
				}
			} else { //WEBAE3-5765 - for confirmation page 
				_.each(
					_.keys(APP.props.oCurrent),
					function (fieldKey) {
						APP.props._optEquipBaseFilter[fieldKey] = 1;
					}
				);
			}
		},
		_setOptEquipObjects: function (target) {
			var $target = target;
			var _shouldUpdate = false;
			var _targName = $target.attr('name');
			var _targetUpdatedVal = $target.val();

			// Update property array
			APP.props._optEquipSelectUpdated[_targName] = _targetUpdatedVal;

			_shouldUpdate = !_.isMatch(APP.props._optEquipLoadVals, APP.props._optEquipSelectUpdated);

			if (APP.props._optEquipLoadVals[_targName] && APP.props._optEquipLoadVals[_targName] != _targetUpdatedVal && _shouldUpdate) {
				APP._toggleEnableBtnControl(APP.props.oSelectors.btnTop, true);
				APP._toggleEnableBtnControl(APP.props.oSelectors.btnSide, true);
			} else {
				APP._toggleEnableBtnControl(APP.props.oSelectors.btnTop, false);
				APP._toggleEnableBtnControl(APP.props.oSelectors.btnSide, false);

				for (var i in APP.props._optEquipSelectUpdated) {
					if (APP.props._optEquipSelectUpdated[i] != APP.props._optEquipLoadVals[i]) {
						APP._toggleEnableBtnControl(APP.props.oSelectors.btnTop, true);
						APP._toggleEnableBtnControl(APP.props.oSelectors.btnSide, true);
					}
				}
			}
		},
		// Body Click Watch Tasks
		onBodyClick: function (event, $target) {
			targetSelector = '#' + event.target.id;
			//WEBAE3-4612 - added check on car class upgrade for cancel insurance cost change
			if (targetSelector === '#carUpgradeY'){
				event.preventDefault();
                
                // WEBAE3-4941 Disable "don't upgrade" button if "upgrade" is chosen
                $('#carUpgradeN').prop('disabled', true);
				var fireFormSubmit = true;//controls whether default or cancel ins modal does final form submit
				var targetFormId = 'upgradeFormY';
				//make sure we have all data points for this before running rules
				if (AEdata && AEdata.booking && AEdata.booking.state){
					origRateTest = AEdata.booking.state.hasOwnProperty('rateIDorig');
					hasCancelInsTest = AEdata.booking.state.hasOwnProperty('hasCancelIns');
					//console.log('State ',AEdata.booking.state, 'Target ', targetSelector)
					if(origRateTest && hasCancelInsTest && AEdata.booking.state.hasCancelIns) {
						//console.log('Origratetest ', origRateTest, 'Has Cancel ins', hasCancelInsTest, 'HAS CANCEL 2 ', AEdata.booking.state.hasCancelIns)
						var originalCost = AEdata.booking.quote.oRates[AEdata.booking.state.rateIDorig].cancelCostCurr;
						var newRateId = document.querySelector(targetSelector).dataset.newrateid;
						var newCost = AEdata.booking.quote.oRates[newRateId].cancelCostCurr;
						//var newCostnumeric = AEdata.booking.quote.oRates[AEdata.booking.state.rateID].cancelCost;
						//WEBAE3-5692 - Curious how it occurred when the check below
						//checks that they are not equal
						//console.log('OPEQ orig cost ', originalCost, 'OPEQ new cost ', newCost);
						//console.log('Orig cost ', originalCost, 'New cost', newCost, 'NewCostNUM', newCostnumeric)
						if(originalCost !== newCost) {
							//STORE-1509 no modal if adding ZK
							if(AEdata.booking.quote.oRates[newRateId].package === 'ZK') {
								//remove cancel option because it's now part of the package
								$('input[name="chk_cncl"]').val(0);//remove cancel ins on submit and oBK update
							} else {
								//new insurance cost so pop modal and prevent submit here, modal will submit
								fireFormSubmit = false;
								var threshold = AEdata.booking.quote.oQuote.oRules.oCancelIns.hasOwnProperty('cancelInsPriceLimitCurr') ? AEdata.booking.quote.oQuote.oRules.oCancelIns.cancelInsPriceLimitCurr :'';
								AE.booking.showCancelInsCostChange(originalCost,newCost,targetFormId,threshold);
							}
						}
					}
				}
				//only fire this if cancel ins modal didn't pop up
				
				if(fireFormSubmit){
					document.getElementById(targetFormId).submit();
				}
			} else if(targetSelector === '#carUpgradeN') {
                // WEBAE3-4941 Disable "upgrade" button if "don't upgrade" is chosen
                $('#carUpgradeY').prop('disabled', true);
            }

			//WEBAE3-4612 - added check on insurance upgrade for cancel insurance cost change
			if (_.contains([APP.props.oSelectors.btnMain, APP.props.oSelectors.btnTop, APP.props.oSelectors.btnSide], targetSelector)) {
				if (targetSelector === APP.props.oSelectors.btnMain) {
					//console.log('State ',AEdata.booking.state, 'RATEID ',AEdata.booking.state.rateID, 'RATEORIG',AEdata.booking.state.rateIDorig)
					event.preventDefault();
					var fireFormSubmit = true;//controls whether default or cancel ins modal does final form submit
					var targetFormId = $(APP.props.oSelectors.frmMain)[0].id;
					//before determining whether to fire cancel inc cost change modal, handle GA stuff
					arrEvents = APP.trackAccessories();
					if (arrEvents.length > 0) { AE.ga.gaArrayProcess(arrEvents); }

					if (AEdata && AEdata.booking && AEdata.booking.state){
						origRateTest = AEdata.booking.state.hasOwnProperty('rateIDorig');
						hasCancelInsTest = AEdata.booking.state.hasOwnProperty('hasCancelIns');
						var originalCost = AEdata.booking.quote.oRates[AEdata.booking.state.rateIDorig].cancelCostCurr;
						var newCost = AEdata.booking.quote.oRates[AEdata.booking.state.rateID].cancelCostCurr;
						if(origRateTest && hasCancelInsTest && AEdata.booking.state.rateID !== AEdata.booking.state.rateIDorig && AEdata.booking.state.hasCancelIns && originalCost !== newCost) {
							//STORE-1509 no modal if adding ZK
							if(AEdata.booking.quote.oRates[AEdata.booking.state.rateID].package === 'ZK') {
								//remove cancel option because it's now part of the package
								$('input[name="chk_cncl"]').val(0);//remove cancel ins on submit and oBK update
							} else {
								//WEBAE3-4757 - when upgrade rate is too high for cancel insurance, make sure hidden chk_cncl reflects last user choice
								$('input[name="chk_cncl"]').val(AE.props.oOptEquip.cancelIns);
								fireFormSubmit = false;
								var threshold = AEdata.booking.quote.oQuote.oRules.oCancelIns.hasOwnProperty('cancelInsPriceLimitCurr') ? AEdata.booking.quote.oQuote.oRules.oCancelIns.cancelInsPriceLimitCurr :'';
								AE.booking.showCancelInsCostChange(originalCost,newCost,targetFormId,threshold);
							}
						}
					}
					//only fire this if cancel ins modal didn't pop up
					if(fireFormSubmit){
						//VM
						//
						$(APP.props.oSelectors.frmMain).submit();
						$.ajax({
							url: '/plugins/ae3/lib/BookingAjax.cfc',
							dataType: "json",
							data: {
								method: 'updateOptEquip',
								bookingid: AEdata.booking.props.uuid,
								selInfantSeatFilter: $('#selInfantSeatFiltertop').val(),
								selChildSeatFilter: $('#selChildSeatFiltertop').val(),
								selBoosterSeatFilter: $('#selBoosterSeatFiltertop').val(),
								selSkiRacks: $('#selSkiRackstop').val(),
								options_snowChains: $('#options_snowChainstop').val(),
								options_gps: $('#options_gpstop').val(),
								options_mifi: $('#options_mifitop').val()
							},
						});
					}

				} else {
					APP.onFireChange();
					var position = (targetSelector === APP.props.oSelectors.btnSide) ? 'side' : 'top';
					APP.updateAccessories($(targetSelector), position);
					if (AEdata && AEdata.booking && AEdata.booking.state.step !== 'getoptions') {
						APP._checkOptEquipObjects();
					}
				}
			}
		},

		onFireChange: function () {
			APP.buildStaticSelectionBlock();
			//alert('Infant seat: ',infval)
			var delayInMilliseconds = 1000; //.5 seconds
				setTimeout(function() {
			}, delayInMilliseconds);
		},

		// Body Change Watch Tasks
		onBodyChange: function (event) {
			var $target    = $(event.target);
			var targetID   = event.target.id;
			var targetTag  = event.target.tagName.toUpperCase();
			var targetType = event.target.type.toUpperCase();
			var targetName = event.target.name.toUpperCase();
			
			if ( ($target.parent().closest('#option_update--side').length) || ($target.parent().closest('#option_update--top').length) ) {
				if (targetTag === 'SELECT') {
					if ($(APP.props.oSelectors.frmSide).has($target)) { APP._setOptEquipObjects($target); }
					var fieldName = APP.props.oFieldNames[targetName] || '';
					if (_.contains(_.keys(APP.props.oInput), fieldName)) {
						var selVal = $target.val();
						if (Number($target.val()) === NaN) { selVal = ($target.val() === 'ON') ? 1 : 0; }
						APP.props.oInput[fieldName] = selVal;
						$(APP.props.oSelectors[fieldName]).val(selVal);
					}
				}
			}
		},
		synchSelections: function () { // Set all dropdowns to match oInput values
			var $df = $(document.createDocumentFragment());
			APP._preCheckOptEquipObjects();
			_.each(
				_.keys(APP.props.oCurrent),
				function (fieldKey) {
					var tempVal = APP.props.oCurrent[fieldKey];
					if (fieldKey === 'GPS' && $.isNumeric(tempVal)) { tempVal = (tempVal > 0) ? 'ON' : ''; }
					$(APP.props.oSelectors[fieldKey]).val(tempVal);
					if (fieldKey !== 'SUCCESS' && fieldKey !== 'DERC' && fieldKey !== 'BRP' && fieldKey !== 'cancelIns' && (APP.props.oCurrent[fieldKey] > 0 || tempVal === 'ON')) {
						if(fieldKey in APP.props._optEquipBaseFilter){
							$df.append(APP.buildSelectionLine(
								AE.booking.matrix.results.props.oTranslations.OPTEQUIP[APP.props.oLabels[fieldKey]],
								APP.props.oCurrent[fieldKey],
								'' // APP.props.oCurrent[fieldKey] * APP.props.oPrices[fieldKey]
							));
						}
					}
				}
			);
			if (_.max(_.omit(APP.props.oCurrent, 'SUCCESS', 'DERC', 'GPS')) === 0 && APP.props.oCurrent.GPS !== 'ON' && APP.props.oCurrent.GPS !== 1) {
				if(!_.isEmpty(AE.booking.matrix.results.props.oTranslations)){
				$df.append(
					$(document.createElement('div'))
					.addClass('grid__item one-whole')
					.append(AE.booking.matrix.results.props.oTranslations.OPTEQUIP.TXT_NONE_CHOSEN)
				);
			}}
			$(APP.props.oSelectors.widgets).append($df);
		},
		buildSelectionLine: function (label, quantity, amount) {
			label = label || '';
			quantity = quantity || 0;
			amount = amount || '';
			var amountFormat = '';
			if (Number(amount) !== NaN && Number(amount) > 0) {
				amountFormat = AE.booking.matrix.results.props.oTranslations.CURRENCY_TEMPLATE.replace('.', Number(amount));
			} else {
				amount = 0;
			}
			var $df = $(document.createDocumentFragment()),
				$leftDiv = $(document.createElement('div')).addClass('grid__item one-half').append(label),
				$countDiv = $(document.createElement('span')).addClass('float--left').append((isNaN(quantity)) ? 1 : quantity),
				$rightDiv = $(document.createElement('div'))
				.addClass('grid__item one-half align-right line__item--local')
				.append($countDiv).append(amountFormat).attr('data-amount', amount);
			$df.append($leftDiv).append($rightDiv);
			return $df;
		},
		buildStaticSelectionBlock: function (oSelections) { // For displaying Static Options Selections, like for Voucher Lookup
			oSelections = oSelections || {};
			var $df = $(document.createDocumentFragment());
			//$(".infant").html(APP.props.oCurrent.infantSeat);
			_.each(
				_.keys(oSelections),
				function (fieldKey) {
					if (Number(oSelections[fieldKey]) !== NaN && Number(oSelections[fieldKey]) > 0) {
						$df.append(APP.buildSelectionLine(
							AE.booking.matrix.results.props.oTranslations.OPTEQUIP[APP.props.oLabels[fieldKey]],
							oSelections[fieldKey],
							''
						));
					}
				}
			);
			if (_.max(oSelections) === 0) {
				if(!_.isEmpty(AE.booking.matrix.results.props.oTranslations)){
				$df.append(
					$(document.createElement('div'))
					.addClass('grid__item one-whole')
					.append(AE.booking.matrix.results.props.oTranslations.OPTEQUIP.TXT_NONE_CHOSEN)
				);
			}}
			return $df;
		},
		renderStaticBlocks: function () {
			$('#selSkiRackstop').change(function(){
				//alert($(this).val());
				var skiValue = $(this).val();
				//console.log(skiValue);
				var boxexisting = localStorage.getItem('aeSearch');
				boxexisting = boxexisting ? JSON.parse(boxexisting) : {};
				boxexisting['optionalSkis'] = skiValue;
				localStorage.setItem('aeSearch', JSON.stringify(boxexisting));
			})

			$.each($('.trg__book-widget--optequip--static'), function (i) {
				/*	EXPECTED MARKUP	*/
				/*
					<div class="trg__book-widget--optequip--static" data-infant="int" data-child="int" data-booster="int" data-chains="int" data-skirack="int" data-gps="int" data-mifi="int"></div>
				*/
				//WEBAE3-4734 - not sure why snowchains and winterization were both being output with the same value. I know CROS returns 'chains', and the translation for snowchains is 'Winterization' anyway, so I commented winterization out. - Mike 9 Mar 2022
				var oSelections = $(this).data();
				$(this).append(APP.buildStaticSelectionBlock({
					infantSeat: oSelections.infant,
					childSeat: oSelections.child,
					boosterSeat: oSelections.booster,
					skiRack: oSelections.skirack,
					snowChains: oSelections.chains,
					//winterization: oSelections.chains,
					GPS: oSelections.gps,
					MiFi: oSelections.mifi
				}));
			});
		},

		trackAccessories: function () { // Return Array of all optional equipment selection change events
			var arrEvents = [];
			var stCurrent = APP.props.oCurrent;
			var stInput = APP.props.oInput;
			if (stInput.infantSeat != stCurrent.infantSeat) {
				var stInfantSeatEvent = _.clone(APP.props.gaUpdateEvent);
				stInfantSeatEvent.GALABEL = '';
				if ($.isNumeric(stInput.infantSeat)) stInfantSeatEvent.GAVALUE = stInput.infantSeat;
				if (stInput.infantSeat === 0 || stInput.infantSeat === '' || stInput.infantSeat === undefined) {
					if (stCurrent.infantSeat != '' && stCurrent.infantSeat != undefined) stInfantSeatEvent.GALABEL = 'InfantSeat_unchecked';
				} else {
					stInfantSeatEvent.GALABEL = 'InfantSeat_checked';
				}
				if (stInfantSeatEvent.GALABEL != '') arrEvents.push(stInfantSeatEvent);
			}
			if (stInput.childSeat != stCurrent.childSeat) {
				var stChildSeatEvent = _.clone(APP.props.gaUpdateEvent);
				stChildSeatEvent.GALABEL = '';
				if ($.isNumeric(stInput.childSeat)) stChildSeatEvent.GAVALUE = stInput.childSeat;
				if (stInput.childSeat === 0 || stInput.childSeat === '' || stInput.childSeat === undefined) {
					if (stCurrent.childSeat != '' && stCurrent.childSeat != undefined) stChildSeatEvent.GALABEL = 'ChildSeat_unchecked';
				} else {
					stChildSeatEvent.GALABEL = 'ChildSeat_checked';
				}
				if (stChildSeatEvent.GALABEL != '') arrEvents.push(stChildSeatEvent);
			}
			if (stInput.boosterSeat != stCurrent.boosterSeat) {
				var stBoosterSeatEvent = _.clone(APP.props.gaUpdateEvent);
				stBoosterSeatEvent.GALABEL = '';
				if ($.isNumeric(stInput.boosterSeat)) stBoosterSeatEvent.GAVALUE = stInput.boosterSeat;
				if (stInput.boosterSeat === 0 || stInput.boosterSeat === '' || stInput.boosterSeat === undefined) {
					if (stCurrent.boosterSeat != '' && stCurrent.boosterSeat != undefined) stBoosterSeatEvent.GALABEL = 'BoosterSeat_unchecked';
				} else {
					stBoosterSeatEvent.GALABEL = 'BoosterSeat_checked';
				}
				if (stBoosterSeatEvent.GALABEL != '') arrEvents.push(stBoosterSeatEvent);
			}
			if (stInput.skiRack != stCurrent.skiRack) {
				var stSkiRackEvent = _.clone(APP.props.gaUpdateEvent);
				stSkiRackEvent.GALABEL = '';
				if ($.isNumeric(stInput.skiRack)) stSkiRackEvent.GAVALUE = stInput.skiRack;
				if (stInput.skiRack === 0 || stInput.skiRack === '' || stInput.skiRack === undefined) {
					if (stCurrent.skiRack != '' && stCurrent.skiRack != undefined) stSkiRackEvent.GALABEL = 'SkiRack_unchecked';
				} else {
					stSkiRackEvent.GALABEL = 'SkiRack_checked';
				}

				if (stSkiRackEvent.GALABEL != '') arrEvents.push(stSkiRackEvent);
			}
			if (stInput.GPS != stCurrent.GPS) {
				var stGPSEvent = _.clone(APP.props.gaUpdateEvent);
				stGPSEvent.GALABEL = '';
				if (stInput.GPS === 0 || stInput.GPS === '' || stInput.GPS === undefined) {
					if (stCurrent.GPS != '' && stCurrent.GPS != undefined) stGPSEvent.GALABEL = 'GPS_unchecked';
				} else {
					stGPSEvent.GALABEL = 'GPS_checked';
				}
				if (stGPSEvent.GALABEL != '') arrEvents.push(stGPSEvent);
			}
			if (stInput.MiFi != stCurrent.MiFi) {
				var stMIFIEvent = _.clone(APP.props.gaUpdateEvent);
				stMIFIEvent.GALABEL = '';
				if (stInput.MiFi === 0 || stInput.MiFi === '' || stInput.MiFi === undefined) {
					if (stCurrent.MiFi != '' && stCurrent.MiFi != undefined) stMIFIEvent.GALABEL = 'MIFI_unchecked';
				} else {
					stMIFIEvent.GALABEL = 'MIFI_checked';
				}
				if (stMIFIEvent.GALABEL != '') arrEvents.push(stMIFIEvent);
			}
			if (arrEvents.length > 0) arrEvents.push(APP.props.gaUpdateEvent);

			return arrEvents;
		},
		updateAccessories: function (button, position) { // Function used by utility bar
			position = position || '';
			$(APP.props.oSelectors.widgets).empty();
			// AE.ui.addSpinner('.option_container--utbar', {
			// 	size: '2x',
			// 	color: 'black'
			// });
			arrEvents = APP.trackAccessories();
			if (arrEvents.length > 0) {

				//WEBAE3-5133 disable checkout buttons before XHR call
				AE.booking.enableCheckoutSubmit(false);
				$.ajax({
					url: '/plugins/ae3/lib/BookingAjax.cfc',
					dataType: "json",
					data: {
						method: 'updateOptEquip',
						bookingid: AEdata.booking.props.uuid,
						selInfantSeatFilter: APP.props.oInput.infantSeat,
						selChildSeatFilter: APP.props.oInput.childSeat,
						selBoosterSeatFilter: APP.props.oInput.boosterSeat,
						selSkiRacks: APP.props.oInput.skiRack,
						options_snowChains: APP.props.oInput.snowChains,
						options_gps: APP.props.oInput.GPS,
						options_mifi: APP.props.oInput.MiFi
					},
					success: function (data) {
						$(document).ready(function() {
							//VM - WEBAE3-5170

							$(".initialopt").css("display", "none");
							$(".jsopt").css("display", "block");
							
							if (data.GPS == 'ON') {
								APP.props.oInput.GPS = 1
							}
							if (data.infantSeat == 0) {
								$(".infantjs").css("display", "none");					
								$(".infantmid").css("display", "none");
							}
							else {
								$(".infantjs").css("display", "inline-block");					
								$(".infantmid").css("display", "inline-block");
							}
							if (data.childSeat == 0) {
								$(".childjs").css("display", "none");					
								$(".childmid").css("display", "none");
							}
							else {
								$(".childjs").css("display", "inline-block");					
								$(".childmid").css("display", "inline-block");
							}
							if (data.boosterSeat == 0) {
								$(".boosterjs").css("display", "none");					
								$(".boostermid").css("display", "none");
							}
							else {
								$(".boosterjs").css("display", "inline-block");					
								$(".boostermid").css("display", "inline-block");
							}
							if (data.GPS == 0) {
								$(".gpsjs").css("display", "none");					
								$(".gpsmid").css("display", "none");
							}
							else {
								$(".gpsjs").css("display", "inline-block");					
								$(".gpsmid").css("display", "inline-block");
							}
							if (data.skiRack == 0) {
								$(".skijs").css("display", "none");					
								$(".skimid").css("display", "none");
							}
							else {
								$(".skijs").css("display", "inline-block");					
								$(".skimid").css("display", "inline-block");
							}
							if (data.snowChains == 0) {
								$(".snowjs").css("display", "none");					
								$(".snowmid").css("display", "none");
							}
							else {
								$(".snowjs").css("display", "inline-block");					
								$(".snowmid").css("display", "inline-block");
							}
							if (data.infantSeat == 0 && data.childSeat == 0 && data.boosterSeat == 0 && data.GPS == 0 ) {
								$(".jsoptnone").css("display", "inline-block");
							}
							else {
								$(".jsoptnone").css("display", "none");
							}
							$(".infant").html(APP.props.oInput.infantSeat);
							$(".child").html(APP.props.oInput.childSeat);
							$(".booster").html(APP.props.oInput.boosterSeat);
							$(".gps").html(APP.props.oInput.GPS);
							
						});
						//Spinner temporarily removed
						//AE.ui.removeSpinner(APP.props.oSelectors.widgets);
						if (data.SUCCESS) {
							
							_.extend(APP.props.oCurrent, data);
							APP.synchSelections();
							AE.ga.gaArrayProcess(arrEvents);
							// Update local line item total
							var newLocalTotal = 0;
							var newNowTotal = 0;
							var $localLineItems = $('#utbar__container--' + position + ' .line__item--local');
							var $nowLineItems = $('#utbar__container--' + position + ' .line__item--now');
							$localLineItems.each(function () {
								newLocalTotal += $(this).data('amount');
							});
							$nowLineItems.each(function () {
								if (!$(this).hasClass('rate_includes_container')) newNowTotal += $(this).data('amount');
							});
							if (isNaN(newLocalTotal)) newLocalTotal = 0;
							if (isNaN(newNowTotal)) newNowTotal = 0;

							var newLocalCurr = Math.abs(Math.round(Number(newLocalTotal) * 100) / 100).toFixed(2);
							var newTotalCurr = Math.abs(Math.round(Number(newLocalTotal + newNowTotal) * 100) / 100).toFixed(2);
							newLocalCurr = AE.booking.matrix.results.props.oTranslations.CURRENCY_TEMPLATE.replace('.', newLocalCurr);
							newTotalCurr = AE.booking.matrix.results.props.oTranslations.CURRENCY_TEMPLATE.replace('.', newTotalCurr);

							$('.local__container--utbar').empty();
							$('.local__container--utbar').append(newLocalCurr);
							if (newLocalTotal > 0) {
								$('.local__heading').removeClass('visuallyhidden');
							} else {
								$('.local__heading').addClass('visuallyhidden');
							}

							$('.total__container--utbar').empty();
							$('.total__container--utbar').append(newTotalCurr);

							if ($localLineItems.length > 0 && newLocalTotal > 0) {
								$('.line__item--now').removeClass('visuallyhidden');
								$('.total__container--utbar').parent().removeClass('visuallyhidden');
							}
							if ($nowLineItems.length === 0 && newNowTotal === 0) {
								$('.line__item--now[data-amount="0"]').not('.rate_includes_container').addClass('visuallyhidden');
								if ($nowLineItems.length === 0) $('.total__container--utbar').parent().addClass('visuallyhidden');
							}
						} else {
							// sorry message in a dialog?
						}
					},
                    complete:function(){
                        //WEBAE3-5133 XHR done renable checkout buttons
                        AE.booking.enableCheckoutSubmit(true);
                    }
					 //,
					//failure: function( data ) {
					// updateAccessories Fail
					//}
				});

			}
		}
	};
	
	return APP;
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */
AE.booking = AE.booking || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking.searchwait = AE.booking.searchwait || (function(){
	var APP = {
		init:function() {
			APP.props = {
				1 	: $('.message-1'),
				2 	: $('.message-2'),
				3 	: $('.message-3'),
				4 	: $('.message-4'),
				5 	: $('.message-5'),
				6 	: $('.message-6'),
				7 	: $('.message-7')
			};

			   
			         


			// WEBAE3-3713 - make sure saved filter selections are cleared when new booking session begins
			localStorage.removeItem('aeFilters');

			// ************** IMPORTANT NOTE: **************
			// The results of the following function call have been hard-coded into the search-wait page.
			// AE.ui.addSpinner( '.wait-load', { size:'5x', color : '#0B2033'});
			//
			// This is being done because the timing of the JavaScript framework doesn't always have time 
			// to run on that page, since it redirects to the matrix after a variable amount of time. 
			// Normally this would be discouraged, but hard-coding in this one place eliminates a multitude 
			// of timing issues. Keep in mind that we will need to change the code in the target file if 
			// we ever decide to change the markup for our spinners.
			// Source file: car_includes/car_searchwait_ds.cfm
			APP.transitionScreen(1);
		},
		transitionScreen:function(interval) {

			if(interval < 7){
				setTimeout(function(){
					var $dfd_fade = $.Deferred();

					$(APP.props[interval][0]).fadeOut('10','linear', function(){$dfd_fade.resolve()});
					interval++;
					$dfd_fade.done(function() {
						$(APP.props[interval][0])
							.css('opacity', 0)
							.show('slide', {direction: 'right'}, 1000)
							.animate(
								{ opacity: 1 },
								{ queue: false, duration: 1000 }
							);
					});
					APP.transitionScreen(interval);
				}, 3000);
			}
		}
	};
	return APP;
})();

;
var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
This object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking.saveQuote = AE.booking.saveQuote || (function () {
	/*
	DEPENDENCIES: AE, AE.props, AE.booking, AE.ui.dialog
	*/
	var APP = {
		init: function () {

			var _mouseExitTimeArr = AEdata.SAVEQUOTE.EXIT_DIALOG_TIMER || [1,1,1,1];
			_mouseExitTimeArr = typeof _mouseExitTimeArr == 'string' ? JSON.parse( _mouseExitTimeArr ) : _mouseExitTimeArr;

			APP.props = {
				dialogID: 'save-quote',
				ridSubmit: false,
				dialogSelector: '#',
				ONEWAY: false, // Is it a One Way Booking?
				exitModalShown: ((AECookie != undefined && AECookie.read('exitModalShown')) || AEdata.booking.props.ismodify || AEdata.booking.props.iswl || !AEdata.booking.props.showEmailQuote) ? true : false,
				timedModel: 'timedModal',
				exitModel: 'timedModal exit',
				mouseExitDirectionTimers: {
					top: _mouseExitTimeArr[0],
					right:_mouseExitTimeArr[1],
					bottom:_mouseExitTimeArr[2],
					left:_mouseExitTimeArr[3],
				},
				timedTrigger: 'EM',
				exitTrigger: 'EX',
				timedCategory: 'EmailQuoteModal',
				exitCategory: 'EmailQuoteExitOverlay',
				emailTest: /^[\w&]([\w\-\.'&]*)@([\w\-\.]*)(\.[a-z]{2,6}(\.[a-z]{2}){0,2})$/i,
				cookieExpires: 60, // Using "new" instead of "create", which allows us to set the minutesToLive property in AECookie.
				sitesWithExtraFields: ['AOR','AUT','BFR','BRA','CHE','CHF','CHI','DEU','ESL','ESP','EUR','FRA','GBR','IRL','ITA'],
				sitesWithNameField: ['AUS','DAP','DAU','DNZ','GCR','NZL','PEU','RAU','RNZ']
			};
			APP.props.dialogSelector += APP.props.dialogID;
			APP.props.showExtraFields = _.contains(APP.props.sitesWithExtraFields, AE.props.siteCode);
			APP.props.showNameField = _.contains(APP.props.sitesWithNameField, AE.props.siteCode);


			switch ($.trim(AEdata.booking.state.step).toLowerCase()) {
				case 'getoptions':
				case 'getupgrade':
				case 'bookform':

					if (AE.getSiteViewType() !== 'palm') {
						APP.activateExitModal();
					}
					break;
			}

			/*
			AE.ui.dialog.addDialogHandler(
				{
					func:function(event){if($(event.target).hasClass('email-quote')) APP.dialog(event);}}
				);
			*/

			// Needs a body click task, because this dialog appears on multiple steps.
			AE.ui.addBodyClickTask({
				func: APP.onBodyClick
			});

			// validate email address with regex before submitting
			/*
			$('body').on('focusout', function(event){
				if(event.target.id === "saveQuote-email") {
					if( APP.props.emailTest.test(event.target.value) ){
						$('#saveQuote-email').parent().removeClass('ui-state-invalid').addClass('ui-state-valid');
					} else {
						$('#saveQuote-email').parent().removeClass('ui-state-valid').addClass('ui-state-invalid');
					}
				}
			});
			*/

		},
		checkField: function (id) {
			// Checks the field, manages the validation class and returns a boolean at the end.

			var $target = $('#' + id),
				isValid = null;

			switch (id) {
				case "saveQuote-email":
					APP.props.ridSubmit = false;
					if (!isNaN($target.val()) && ($target.val().length === 3 || $target.val().length === 4)) {
						APP.props.ridSubmit = true;
						isValid = true;
						$target.parent().removeClass('ui-state-invalid').addClass('ui-state-valid');
					} else if (APP.props.emailTest.test($target.val())) {
						isValid = true;
						$target.parent().removeClass('ui-state-invalid').addClass('ui-state-valid');
					} else {
						isValid = false;
						$target.parent().removeClass('ui-state-valid').addClass('ui-state-invalid');
					}
					break;

					// Fall through if needed so we can run the same code for each of these cases.
				case "customer_firstname":
				case "customer_lastname":
				case "customer_phonenumber":
					if ($target.val() !== "") {
						isValid = true;
						$target.parent().removeClass('ui-state-invalid').addClass('ui-state-valid');
					} else {
						isValid = false;
						$target.parent().removeClass('ui-state-valid').addClass('ui-state-invalid');
					}
					break;
			}
			return isValid;
		},
		checkAll: function () {
			// Runs when the button is pressed. Does validation with classes and returns a boolean.

			var valid = true;
			$("#save-quote .saveQuote-input").each(function (index) {

				// Set the boolean result of the function call to a variable.
				isValid = APP.checkField($(this).attr('id'));

				// If any of the fields fail, then the form fails.
				if (!isValid) {
					valid = false;
				}
			});
			return valid;
		},
		dialog: function (event, isExit) {
			APP.props.exitModalShown = true;
			var $target = $(event.target);
			isExit = isExit || false;
			var gaCategory = (isExit) ? 'EmailQuoteExitOverlay' : 'EmailQuoteModal';
			var gaBookingStep = $.trim(AEdata.booking.state.step).toLowerCase();
			var arrFingers = [];
			if ($target && $target.data('fingers')) {
				arrFingers = JSON.parse(decodeURIComponent($target.data('fingers')));
			}
			var data_oneway = AEdata.SAVEQUOTE.ONEWAY;
			var data_puLocId = AEdata.SAVEQUOTE.PULOCID;
			var data_puLocName = AEdata.SAVEQUOTE.PULOCNAME;
			var data_doLocId = AEdata.SAVEQUOTE.DOLOCID;
			var data_doLocName = AEdata.SAVEQUOTE.DOLOCNAME;
			var data_carRateType = AEdata.SAVEQUOTE.CARRATETYPE;
			var data_sipps = AEdata.SAVEQUOTE.SIPPS;
			var data_fingerId = AEdata.SAVEQUOTE.FINGERID;
			if (arrFingers.length) {
				var fingerID = arrFingers[0];
				var fingerPackageType = fingerID.substring(0,2);
				var aPackageFilters = AE.booking.matrix.getFilterArray(AEdata.booking.quote.oFilters.IN);
				if(aPackageFilters.length){
					var fingerIndex = 0;
					while(!_.contains(aPackageFilters,fingerPackageType)){
						fingerIndex++;
						fingerID = arrFingers[fingerIndex];
						fingerPackageType = fingerID.substring(0,2);
					}
				}
				// Collect information from the matrix results data (it is unavailable in CarSearchData on the getRates step)
				var fingerData = AE.booking.matrix.results.props.oRateFingers[fingerID];
				var resultData = AE.booking.matrix.results.props.oResults[fingerData.carID];
				var pickupData = AE.booking.matrix.results.props.oLocations[fingerData.locID];
				var doLocID = ($target.data('dolocid')) ? $target.data('dolocid') : '';
				if (doLocID === '') {
					doLocID = (_.contains(pickupData.aDOs, pickupData.ID)) ? pickupData.ID : pickupData.aDOs[0];
				}
				var dropoffData = AE.booking.matrix.results.props.oLocations[doLocID];
				var arrSipps = resultData.aSIPPs;
				data_oneway = (fingerData.locID !== doLocID) ? true : false;
				data_puLocId = pickupData.ID;
				data_puLocName = pickupData.locName;
				data_doLocId = dropoffData.ID;
				data_doLocName = dropoffData.locName;
				data_carRateType = (fingerData.packageType === 'IB' || fingerData.packageType === "IB") ? 'b' : 'i';
				data_sipps = arrSipps[0];
				data_fingerId = fingerData.ID;
			}

			var noThanksClick = false;
			var emailFormSubmit = false;
			var gaLabel = gaBookingStep;

			/* Match AE2's labels */
			switch (gaBookingStep) {
				case "getrates":
					// matrix page
					gaLabel = "CarLink";
					break;
				case "getoptions":
					// insurance upgrade page
					gaLabel = "Upgrade";
					break;
				case "getupgrade":
					// car class upgrade page
					gaLabel = "CarUpgrade";
					break;
				case "bookform":
					// checkout page
					gaLabel = "Checkout";
					break;
				default:
					gaLabel = gaBookingStep;
					break;
			}

			var oButtons = {}; // Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text

			oButtons[AEdata.SAVEQUOTE.BTN_SENDQUOTE] = function () { // Accept Button
				emailFormSubmit = true;
				// Fire off a Google Analytics (GA) tracking event
				var gaObject = [{
					"GACATEGORY": gaCategory,
					"GAACTION": "Submit",
					"GALABEL": gaLabel
				}];
				AE.ga.gaArrayProcess(gaObject);

				if (AE.forms) {
					AE.forms.emailClean('#saveQuote-email');
				}
				var thisEmail = $('#saveQuote-email').val();
				var thisNewsletter = $('#saveQuote-newsletter').prop('checked');

				// Fire off a Google Analytics (GA) tracking event to track if the customer "opted in" or not to the newsletter
				var newsletterCheckbox = (thisNewsletter) ? 'Checked' : 'Unchecked';
				var gaObject = [{
					"GACATEGORY": gaCategory,
					"GAACTION": "OptIn",
					"GALABEL": newsletterCheckbox
				}];
				AE.ga.gaArrayProcess(gaObject);

				// Check Valid email entry before sending to email quote. The checkAll function validates and returns a boolean.
				if (APP.checkAll()) {
					var dataToSubmit = {
						method: 'saveEmailQuoteRequest',
						email: thisEmail,
						newsletter: thisNewsletter,
						carsearchuuid: AEdata.booking.props.uuid,
						bookingstep: AEdata.booking.state.step,
						fromExit: isExit,
						aff: AE.props.affiliate,
						SIPP: data_sipps, // Sends in first SIPP in rate
						PULOCID: data_puLocId,
						PULOCNAME: data_puLocName,
						DOLOCID: data_doLocId,
						DOLOCNAME: data_doLocName,
						CARRATETYPE: data_carRateType,
						QUOTEID: AEdata.booking.quote.oQuote.ID,// this isn't reliable - LJW - AE.booking.matrix.results.props.quoteID,
						rateID: data_fingerId
					};

					if (APP.props.showExtraFields) {
						dataToSubmit.customer_firstname = $('#customer_firstname').val();
						dataToSubmit.customer_lastname = $('#customer_lastname').val();
						dataToSubmit.customer_phonenumber = $('#customer_phonenumber').val();
					} else if(APP.props.showNameField) {
						dataToSubmit.customer_firstname = $('#customer_firstname').val();
					}

					//Process the submitted form
					$.ajax({
						url: '/plugins/ae3/lib/BookingAjax.cfc',
						dataType: 'text',
						data: dataToSubmit
					}).done(function (data) {
						// Disable Exit Overlay when user submits a save quote request
						APP.props.exitModalShown = true;
						AECookie.create('exitModalShown', true, APP.props.cookieExpires);
						AECookie.create('exitModalEmail', thisEmail, APP.props.cookieExpires); // save email for reuse
						if(APP.props.ridSubmit){
							$(APP.props.dialogSelector)
								.addClass('hard--top')
								.find('h4.align-center.push--top')
								.html(data);
						} else {
							setTimeout(function () {
								$(APP.props.dialogSelector).dialog('close')
							}, 500); // close thank you message
						}
						return data;
					}).fail(function () {
						/*
						AE.ui.dialog.empty(APP.props.dialogSelector);
						$(APP.props.dialogSelector).append(
							$(document.createElement('h4'))
								.addClass('align-center')
								.append(AEdata.SAVEQUOTE.ERRORTXT)
						);
						*/

						// Disable Exit Overlay when user submits a save quote request
						APP.props.exitModalShown = true;
						//AECookie.create('exitModalShown',true,APP.props.cookieExpires);
						//AECookie.create('exitModalEmail',thisEmail,APP.props.cookieExpires); // save email for reuse

						AECookie.new({
							name: 'exitModalShown',
							value: true,
							minutesToLive: APP.props.cookieExpires
						});
						AECookie.new({
							name: 'exitModalEmail',
							value: thisEmail,
							minutesToLive: APP.props.cookieExpires
						}); // save email for reuse

						setTimeout(function () {
							$(APP.props.dialogSelector).dialog('close')
						}, 500); // close thank you message
						return {};
					});

					// Always want thank you message to show so and then disappear so fail or success always show.
					$(APP.props.dialogSelector).empty();
					$(APP.props.dialogSelector).siblings('.ui-dialog-buttonpane').remove();
					$(APP.props.dialogSelector).append(
						$(document.createElement('h4'))
						.addClass('align-center push--top')
						.attr('data-google_conversion_id', '')
						.attr('data-google_conversion_label', '')
						.append(AEdata.SAVEQUOTE.TXT_THANKYOU)
					);
				} else {
					// Failed validation.
					$('#saveQuote-email').parent().addClass('ui-state-invalid');
				}
			};
			oButtons[AEdata.SAVEQUOTE.TXT_NOTHANKS] = function () { // Decline Button
				noThanksClick = true;
				AE.ui.dialog.close();
				APP.props.exitModalShown = (AECookie.read('exitModalShown')) ? true : false
			};

			var divFinePrint = $(document.createElement('div'))
				.addClass('cardetails-smallprint push-half--bottom push-half--left')
				.append(AEdata.SAVEQUOTE.MODAL_FINEPRINT);
			if (data_oneway) divFinePrint.append($(document.createElement('div')).addClass('push-half--top').append(AEdata.SAVEQUOTE.TXT_ONEWAY_NOTE));

			AE.ui.dialog.launch({
				id: APP.props.dialogID,
				width: ($(window).width() > 700) ? 350 : '100%',
				height: 'auto',
				close: function () {
					// Remove event listener for input fields in the exit modal.
					$(".saveQuote-input").off(".exitModal");

					// Only fire off a "closed modal" Google Analytics (GA) tracking event if no other action took place (like a form submit)
					if (!emailFormSubmit) {
						var gaCloseLabel = (noThanksClick) ? 'noThanks_' + gaLabel : 'close_' + gaLabel;
						var gaObject = [{
							"GACATEGORY": gaCategory,
							"GAACTION": "Close",
							"GALABEL": gaCloseLabel
						}];
						AE.ga.gaArrayProcess(gaObject);
					}
				},
				open: function () {
					// Fire off a Google Analytics (GA) tracking event that the modal opened
					var gaObject = [{
						"GACATEGORY": gaCategory,
						"GAACTION": "Open",
						"GALABEL": gaLabel
					}];
					AE.ga.gaArrayProcess(gaObject);
				},
				buttons: oButtons,
				buttonOpts: {
					after: divFinePrint,
					setClass: 'align-center soft-half--left',
					lastButtonClass: 'btn--link hard--left flush--top one-whole trg__ga--Click',
					firstButtonClass: 'btn--primary btn--keep-icon one-whole trg__ga--Click',
				},
				content: APP.buildForm(isExit)
			});

			// Namespacing this listener because it's attached to dynamic elements and must be removed after those elements are removed.
			$("input.saveQuote-input").on("blur.exitModal", function (evt) {
				APP.checkField(evt.target.id);
			});
		},

		buildForm: function (isExit) {
			// var gaCategory = (isExit) ? 'EmailQuoteExitOverlay' : 'EmailQuoteModal';
			//WEBAE3-1722 - start with saveQuotePrefill to get account info or nulls if not logged in
			var emailPrefil = (AECookie.read('exitModalEmail')) ? AECookie.read('exitModalEmail') : '';//cookie trumps account data
			var fnamePrefil = '';
			var lnamePrefil = '';
			var phonePrefil = '';
			if (AEdata.saveQuotePrefill) {
				emailPrefil = (emailPrefil == '') ? AEdata.saveQuotePrefill.email : emailPrefil;
				fnamePrefil = AEdata.saveQuotePrefill.fname;
				lnamePrefil = AEdata.saveQuotePrefill.lname;
				phonePrefil = AEdata.saveQuotePrefill.phone;
			}
			var extraFields = null;

			if (APP.props.showExtraFields) {
				extraFields = $(document.createDocumentFragment())
					.append(
						$(document.createElement('div'))
						.append(
							$(document.createElement('input'))
							.attr('id', 'customer_firstname')
							.attr('name', 'customer_firstname')
							.attr('type', 'text')
							.attr('value', fnamePrefil)
							.attr('placeholder', AEdata.SAVEQUOTE.TXT_FNAME)
							.addClass('saveQuote-input push-half--top')
						)
					).append(
						$(document.createElement('div'))
						.append(
							$(document.createElement('input'))
							.attr('id', 'customer_lastname')
							.attr('name', 'customer_lastname')
							.attr('type', 'text')
							.attr('value', lnamePrefil)
							.attr('placeholder', AEdata.SAVEQUOTE.TXT_LNAME)
							.addClass('saveQuote-input push-half--top')
						)
					).append(
						$(document.createElement('div'))
						.append(
							$(document.createElement('input'))
							.attr('id', 'customer_phonenumber')
							.attr('name', 'customer_phonenumber')
							.attr('type', 'text')
							.attr('value', phonePrefil)
							.attr('placeholder', AEdata.SAVEQUOTE.TXT_PHONE)
							.addClass('saveQuote-input push-half--top')
						)
					);
			} else if (APP.props.showNameField){
				extraFields = $(document.createDocumentFragment()).append(
					$(document.createElement('div'))
					.append(
						$(document.createElement('input'))
						.attr('id', 'customer_firstname')
						.attr('name', 'customer_firstname')
						.attr('type', 'text')
						.attr('value', fnamePrefil)
						.attr('placeholder', AEdata.SAVEQUOTE.TXT_FNAME)
						.addClass('saveQuote-input push-half--top')
					)
				);
			}

			let hideNewsletterClass = _.contains(['AVD'], AE.props.siteCode) ? 'trulyhidden' : '';

			return $(document.createDocumentFragment())
				.append($(document.createElement('h3'))
					.append((isExit) ? AEdata.SAVEQUOTE.EXIT_OVERLAY_TITLE : AEdata.SAVEQUOTE.MODAL_HEADER)
				).append($(document.createElement('div'))
					.addClass('push-half--bottom')
					.append((isExit) ? AEdata.SAVEQUOTE.EXIT_OVERLAY_TEXT : AEdata.SAVEQUOTE.MODAL_INSTRUCTIONS)
				).append(extraFields).append($(document.createElement('div'))
					.append($(document.createElement('input'))
						.attr('id', 'saveQuote-email')
						.attr('name', 'saveQuote-email')
						.attr('type', 'email')
						.attr('value', emailPrefil)
						.attr('placeholder', AEdata.SAVEQUOTE.LABEL)
						.addClass('push-half--top push--bottom saveQuote-input')
					).append($(document.createElement('div')).addClass(hideNewsletterClass)
						.append($(document.createElement('input'))
							.attr('id', 'saveQuote-newsletter')
							.attr('name', 'saveQuote-newsletter')
							.attr('type', 'checkbox')
							.attr('checked',oSite.NewsletterCheckedByDefault)//WEBAE3-6283
							.addClass('saveQuote-newsletter trg__ga--Checkbox')
						).append($(document.createElement('label'))
							.attr('for', 'saveQuote-newsletter')
							.append($(document.createElement('span'))
								.append(AEdata.SAVEQUOTE.TXT_NEWSLETTER_LABEL))
						)
					)
				);
		},
		onBodyClick: function (event, $target) {
			if ($target.hasClass('email-quote')) {
				APP.dialog(event);
			}
		},
		activateExitModal: function () {

			if (!APP.props.exitModalShown) {
				return false; //WEBAE3-7083 - Deactivate Email Modal //AE.ui.liveTimer.init(APP.showExitModal, APP.props.mouseExitDirectionTimers);
			} else {
				return false;
			}
		},

		deactivateExitModal: function () {
			document.documentElement.removeEventListener('mouseleave', APP.showExitModal);
		},
		showExitModal: function () {
			if (!APP.props.exitModalShown && !$('input').is(':focus') && !AE.ui.dialog.isDialogTriggered()) {
				APP.dialog(false, true);

				APP.props.exitModalShown = true;
				AECookie.new({
					name: 'exitModalShown',
					value: 'true',
					encodeValue: 'true',
					daysToLive: 0,
					minutesToLive: APP.props.cookieExpires
				});
			}
		}
	};
	return APP;
})();
;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

/*
The AE.ui object will be the returned result of a self-invoked function. This allows us to expose methods
for use by other modules while protecting some variables in a closure. If the AE.ui object is already
defined then it's not altered. This prevents us from running the entire function each time one of its
internal methods are called.
*/
AE.booking.terms = AE.booking.terms || (function(){
	/*
	DEPENDENCIES: AE, AE.booking, AE.ui.dialog
	*/

	var APP = {
		init:function() {

			/* Establish the props object only upon init. No need to do the work if the module isn't being called. */
			APP.props = {
				dialogID		: 		'car-terms',
				hasCustomEvents:		false, // Signal to AE.ui that content should be cloned with events
				showAccept 		: 		($('#aemodify .checkout_container')[0] || (AEdata && AEdata.booking && AEdata.booking.state.step == 'bookform')) ? true : false,
				termsAccepted	:		false,		// Prevent Displaying Terms Buttons Multiple Times
				$checkBox		: 		$('input#tc.terms_conditions'),
				$required		: 		$('input#tc.terms_conditions').attr('data-required-view'), //false (and now NO) = modal does not open on check and no "accept/decline" buttons are shown
				$link			:		$('label[for="tc"] a.car-terms')
			};

			// If checkBox click and terms have not been accepted show terms
			APP.props.$checkBox.on('click',function(event){
				// If APP.props.termsAccepted is already TRUE when you click the checkbox, then the prop should become false again to refelct the checkbox
				if(APP.props.termsAccepted === true){
					APP.props.termsAccepted = false;
				} else {
					// use data attribute to not require showing terms on checkbox click
					APP.props.termsAccepted = (APP.props.$required === 'NO' || APP.props.$required === 'false') ? true : false;
					if (!APP.props.termsAccepted) {
						APP.props.$link.click();
						event.preventDefault();
					}
				}
			});

			// Needs a body click task, because this dialog appears on multiple steps.
			AE.ui.addBodyClickTask({func: APP.onBodyClick});

			// Manage resize
			//AE.addResizeTask({func:function() {APP.manageResize();}});

			//For Salesforce email quote rate details deep link
			if (AEdata.URL.SHOWTERMS === 'true') {
				$('.car-terms').click();
			}
		},
		dialog:function(event) {

			var buildData = true, bypassButtons = false, showFullTerms = false;
			var dialogClassMods = AE.props.useWEBAE3_4586 ? 'webae3-4586' : ''
			var $target = $(event.target);
			var termsData = {}, termsDataTemp = {};

			event.preventDefault(); // Prevent link for bubbling and also register as a checkbox click

			//WEBAE3-4861 Don't launch rate modal on these more-info-tip-rates for cancel insurance
			if($target.data('modalname') && $target.data('modalname').length && $target.data('modalname') == 'cancelModal')
				return;

			//WEBAE3-4586 Establish the context of this dialog
			if($target.hasClass('more-info-tip-rates'))
				bypassButtons = true;

			if($target.hasClass('full-terms')) {
				showFullTerms = true;
				dialogClassMods = '';
			}

			if($target.data('car-terms') && $target.data('car-terms').length){

				termsData = JSON.parse(decodeURIComponent($target.data('car-terms')));

				var noButtonTerms = ($target.hasClass('dialog--noButtons')) ? false : true; // override dialog buttons in modify where there are multiple terms calls
				if (APP.props.termsAccepted) {noButtonTerms = false;} // Already accepted terms no need to require accepting a second time

				if(!termsData.LOADED && !termsData.BLANKTXT.length){
					var aRates = [];
					if(AE.booking.options.props && AE.booking.options.props.rateFamily && !_.isEmpty(AE.booking.options.props.rateFamily)){
						//WEBAE3-5468 When the contextual rateId is available, use it alone (replace below with commented out)
						if($target.data('rate-id') && $target.data('rate-id').length) {
							termsData.RATEID = $target.data('rate-id');
							aRates = Array.of(termsData.RATEID);
						} else {
							aRates = AE.booking.options.props.rateFamily;
						}
					} else if(AE.booking.options.props && AEdata.booking.state.rateID){
						aRates.push(AEdata.booking.state.rateID);
					} else if(termsData.availableRates){
						aRates = termsData.availableRates;
					} else if(AE.booking.matrix.results.props.oResults) {
						var thisResult = AE.booking.matrix.results.props.oResults[$target.parents('.result_container')[0].id];
						//console.log('RRes', thisResult)
						oRates = _.groupBy(thisResult.aRates,function(rateID){
							return AE.booking.matrix.results.props.oRateFingers[rateID].package;
						});
						aRates = [];
						_.each(oRates,function(rateGroup){
							aRates.push(_.first(rateGroup));
						});
						aRates = _.sortBy(aRates,function(rateID){
							return AE.booking.matrix.results.props.oRateFingers[rateID].rate;
						});

						//WEBAE3-6606 - FCR: Update T&C Modal to only display tabs for rates being displayed
						///WEBAE3-6614 - extend to origin AU/NZ (but not DAP)
						if(AE.props.siteCode == 'FCR' || (_.contains(['AU','NZ'],AE.props.chaosSystem) && AE.props.siteCode !== 'DAP' && !AE.props.bIsDapTpDomain)) {
							aRates = AE.booking.matrix.results.trimRateFingers(aRates);
						}
						
						termsData.CARNAME = $.trim(thisResult.iName);
						if($target.data('rate-id') && $target.data('rate-id').length) {
							//WEBAE3-4878 When the contextual rateId is available, use it alone
							termsData.RATEID = $target.data('rate-id');
							aRates = Array.of(termsData.RATEID);
						}
					}
					termsData.aRates = aRates || [];
					AE.ui.dialog.launch({
						id: APP.props.dialogID,
						dialogClass: `top-dialog ${dialogClassMods}`,
						width: ($(window).width() > 900) ? 850 : '80%'
					});

					//WEBAE3-5540
					//$('.car-terms').before('<div class="text--primary waitspace"><i class="fa fa-plus"></i>' + AE.booking.matrix.results.props.oTranslations.TERMSLINK + '</div>');

					// WEBAE3-5691 - remove waitspace ^ and pointer events instead of hiding to prevent layout shift and multiple click
					$('.car-terms').css('pointer-events', 'none'); // Orig: $('.car-terms').css('display', 'none');

					var xhr = $.ajax({
						url:'/plugins/ae3/lib/BookingAjax.cfc',
						dataType:'json',
						data:{
							method 				: 'getResultTerms',
							bookingID			: AEdata.booking.props.uuid,
							rates 				: aRates.toString()
						}
					}).done(function(data){
						termsData.aTabs = data.aTabs;

						$('.car-terms').css('pointer-events', 'all'); // Orig: $('.car-terms').css('display', 'block');
						//$('.waitspace').remove(); // Unneccesary as of WEBAE3-5691

						$('.car-terms').click(function(){
							xhr.abort();
						});

						$('.ui-dialog-titlebar-close').click(function(){
							//$('.waitspace').remove();
							$('.car-terms').css('pointer-events', 'all');
						});

						//loading
						if ($(".top-dialog")[0]) { // load the ajax only if the modal is open. If the modal was closed then the termsData will not load.
								// Terms is defined
							buildDialog(termsData);
						}
						//finished loading
					}).fail(function(){
						$('.car-terms').css('pointer-events', 'all');
						//$('.waitspace').remove();
						//return {};
					});
				} else if(!termsData.LOADED && termsData.BLANKTXT.length){

					var docFrag = $(document.createDocumentFragment());
					docFrag.append($(document.createElement('h4')).append(termsData.TNCTXT+' - '+termsData.CARNAME+', '+termsData.CARCLASS))
						.append($(document.createElement('div')).append($.trim(termsData.BLANKTXT)));

					buildData = false; // don't use functions to build content and no buttons

					buildDialog(docFrag);
				} else {
					buildDialog(termsData);
				}

				function buildDialog(termsData){

					var builtMarkup = {};
					var showAcceptDeclineButtons = APP.props.showAccept && noButtonTerms && buildData && !bypassButtons;
					if(AEdata.hasOwnProperty('booking') && (AE.props.useWEBAE3_4586) && !showAcceptDeclineButtons && !showFullTerms)
						builtMarkup = buildSimpleMarkup(termsData)
					else
						builtMarkup = buildMarkup(termsData);

					// ADD in check if this is from link to check state of checkbox before adding buttons
					if(showAcceptDeclineButtons){

						var oButtons = {};// Preparing the Object ahead of the dialog operation allows for Dynamic Button name/text
						oButtons[termsData.ACCBTN] = function() {// Accept Button
							APP.props.$checkBox.prop('checked',true);
							APP.props.termsAccepted = true;
							AE.ui.dialog.close();
						};
						oButtons[termsData.DECBTN] = function() {// Decline Button
							APP.props.$checkBox.prop('checked',false);
							AE.ui.dialog.close();
						};

						var buttonOpts = {
							setClass: 'align-center soft-half--left fcr_btn-rev',
							lastButtonClass: 'btn--base',
							firstButtonClass: 'btn--primary',
							before: $(document.createElement('div')).addClass('align-center').append(termsData.ACCPROMPT),
							exclusiveClose: true
						}

						// Add content to the dialog.
						/*
						AE.ui.dialog.addContent( buildMarkup(termsData) );
						AE.ui.dialog.applyButtonOptions( buildMarkup(buttonOpts) );
						AE.ui.dialog.applyJQUI();
						AE.ui.dialog.update();
						*/

						AE.ui.dialog.launch({
							id: APP.props.dialogID,
							dialogClass: 'top-dialog',
							content: builtMarkup,
							cloneContentEvents: APP.props.hasCustomEvents,
							buttons: oButtons,
							applyUI: true,
							buttonOpts: buttonOpts,
							width: ($(window).width() > 900) ? 850 : '80%'
						});

					} else {
						if ( $('.ui-dialog')[0]) {
							// Add content to the dialog if one is already open.
							AE.ui.dialog.addContent( (buildData) ? builtMarkup : termsData );
							AE.ui.dialog.applyJQUI();
							AE.ui.dialog.update();
						} else {
							// Otherwise, just launch a new dialog.
							AE.ui.dialog.launch({
								id: APP.props.dialogID,
								dialogClass: `top-dialog ${dialogClassMods}`,
								applyUI: true,
								content: (buildData) ? builtMarkup : termsData,
								cloneContentEvents: APP.props.hasCustomEvents,
								width: ($(window).width() > 900) ? 850 : '80%'
							});
						}
					}
					// WEBAE3-4267 remove 'Instructions' after accept button has been clicked or checkbox has been marked
					if (APP.props.termsAccepted) {
							$('.fcr_smallprint').hide();
					}
				}

				function buildSimpleMarkup(termsData) {
					//Local Fees & Info, Inclusive Package, Refundable Excess with Super Cover, Zero Excess..., General Business Terms
					var arrTabs = [];
					var docFrag = $(document.createDocumentFragment());

					docFrag.append(`<div class='important-information'>
						<div class='important-information-text'>${termsData.HEADERIMPORTANTINFORMATION}</div>
					</div>`);

					//Terms and Conditions - Citroen C3, Class Compact
					docFrag.append($(document.createElement('h4')).append(termsData.TNCTXT+' - '+termsData.CARNAME+', '+termsData.CARCLASS));

					//WEBAE3-4843 Prepend any relevant insurance descriptions to the modal
					// Resolve rateId so we can pull data from AEdata.booking.quote.oRates
					// the oRates data should have a packageType property (e.g. 'RE', 'ZE', 'inclusive'...) which we can use to look up
					// the appropriate insurance LGMT object in AE.booking.matrix.results.props.oTranslations.INSURANCES[<property>]
					const RATEID = termsData.hasOwnProperty('RATEID') ? termsData.RATEID : AEdata.booking.state.rateID;
					const RATEDATA = AEdata.booking.quote.oRates[ RATEID ];
					const supplierData = AEdata.booking.quote.oSupps[RATEDATA.suppID];
					const OBJINSURANCE = AE.booking.matrix.results.props.oTranslations.INSURANCES[ RATEDATA.package ];
					const HEADER = document.createElement( 'h6' );
					const INCLUDESUL = document.createElement( 'ul' );
					let ARRINSURANCE = OBJINSURANCE.ARR || [];
					if(supplierData.isLTR){// WEBAE3-6327 - Use alternative package insurance arrays for lease rates
						if(OBJINSURANCE.hasOwnProperty('ARRLTR')){
							ARRINSURANCE = OBJINSURANCE.ARRLTR;
						}
					}
					ARRINSURANCE = AE.booking.applyInsuranceIncludeListOverrides(ARRINSURANCE,AEdata.booking.quote.oCars[RATEDATA.carID].packagesDoInclude);
					//STORE-1524 - add extra bullet point for Cover Genius provided by note
					if(OBJINSURANCE.TXT_CG_PROVIDEDBY){
						ARRINSURANCE.push(OBJINSURANCE.TXT_CG_PROVIDEDBY);
					}
					HEADER.append( $("<div/>").html(OBJINSURANCE.INCLUDES).text() );
					for ( var i = 0; i < ARRINSURANCE.length; i++ ) {
						let tempLI = document.createElement( 'li' );
						tempLI.innerHTML = ($.trim( ARRINSURANCE[ i ] ));
						// For this feature, ensure text nodes are all wrapped in LI
						const NODEITER = document.createNodeIterator(tempLI, NodeFilter.SHOW_TEXT);
						let currentNode, nodeArr = [];
						while (currentNode = NODEITER.nextNode()) {
							nodeArr.push(currentNode);
						}
						for ( var j = 0; j < nodeArr.length; j++ ) {
							let includesLI = document.createElement( 'li' );
							includesLI.append($.trim(nodeArr[j].textContent));
							INCLUDESUL.append(includesLI);
						}
					}
					docFrag.append(HEADER, INCLUDESUL);

					//WEBAE3-4586 Only process "important information" sections and keep in specific order
					aImportantInformationOrder = ["stLocalFees", "stDriverInfo", "stFuelPolicy", "stManDeposit", "stPaymentPolicy"];
                    
                    //WEBAE3-6425 Include Cancel Policy for spefic DTP accounts. Keep in sync with rules applied in /plugins/ae3/modules/booking/model/BookingKernel.cfc -> showRedbookCancelPolicy()
                    if(oSite.bIsTpDomain && (AE.props.affiliate.toLowerCase().indexOf('dahukfc') >= 0 || AE.props.affiliate.toLowerCase() == 'goodwin12')) {
                        aImportantInformationOrder.push("stCancelPolicy");
                    }
                    
					aImportantInformationOrder.forEach(section => {
						if(section == "stManDeposit") {
							blockData = termsData.aTabs[1].ARR;
							arrTabs.push(buildSimpleBlock(termsData.aTabs[1].LBL,blockData,$.trim(termsData.ACCHEAD),$.trim(termsData.DEFHEAD)))
						} else {
							blockData = termsData.aTabs[0].ARR.filter(a => a.SECTION == section);
							arrTabs.push(buildSimpleBlock(termsData.aTabs[0].LBL,blockData,$.trim(termsData.ACCHEAD),$.trim(termsData.DEFHEAD)))
						}
					});

					arrTabs.forEach(tab => {
						docFrag.append(tab.CONTENT);
					});

					return docFrag;
				}

				function buildMarkup(termsData) {
					var docFrag = $(document.createDocumentFragment());
					var arrTabs = [];
					var tabClass = '';//one-whole';
					docFrag.append($(document.createElement('h4')).append(termsData.TNCTXT+' - '+termsData.CARNAME+', '+termsData.CARCLASS));
					_.each(_.uniq(termsData.aTabs,function(oTab){return oTab.LBL;}),function(oTab){
						arrTabs.push(buildBlock(oTab.LBL,oTab.ARR,$.trim(termsData.ACCHEAD),$.trim(termsData.DEFHEAD)));
					});

					// Construct Tabbed View
					if(arrTabs.length > 0){
						var divTCandRB = $(document.createElement('div')).addClass('tab_container');
						var ulTabs = $(document.createElement('ul'));
						divTCandRB.append(ulTabs);
						for(var k=0;k<arrTabs.length;k++){
							ulTabs.append($(document.createElement('li')).addClass(tabClass+' cardetails-smallprint').append($(document.createElement('a')).attr('href','#dialog__tab--'+k).append(arrTabs[k].TAB)));
							divTCandRB.append($(document.createElement('div')).attr('id','dialog__tab--'+k).append(arrTabs[k].CONTENT));
						}

						docFrag.append(divTCandRB);
					}
					if(AE.props.siteCode == 'FCR') {
						var thisDiv = $(document.createElement('div')).addClass('ui-dialog-titlebar-bottom ui-widget-header ui-helper-clearfix').append('<div class="ui-dialog-titlebar-close"><a onclick="AE.ui.dialog.close();"><b>CLOSE</b></a></div>');
						//var thisHead = $(document.createElement('div')).addClass('push-half--top push-half--bottom soft--left soft--right').append('<b>test</b>');
						//contentDiv.append(thisDiv.append(thisHead));
						docFrag.append(thisDiv);
					}
					return docFrag;
				}

				//WEBAE3-4586 This function behaves like @buildBlock but adds no style or behavior classes
				function buildSimpleBlock(title,array,acceptTxt,defaultHead) {
					docFrag = $(document.createDocumentFragment());

					var contentDiv = $(document.createElement('div'));
					docFrag.append(contentDiv);

					for(var i=0;i<array.length;i++){
						var thisHeadTxt = $.trim(array[i].TITLE).split('\n')[0];
						thisHeadTxt = thisHeadTxt.split('*')[0];
						if(array[i].ITEM.length === 1 && array[i].ITEM[0] === ''){
							var emptyITEM = true;
						} else {
							var emptyITEM = false;
						}
						if(array[i].HTML){
							contentDiv.append(array[i].HTML);
						} else {
							if(thisHeadTxt.length < 2) { thisHeadTxt = defaultHead; }
							if(AE.props.siteCode == 'FCR' && thisHeadTxt !== 'GPS') {
								thisHeadTxt = thisHeadTxt.toLowerCase();
							}
							if(!emptyITEM) contentDiv.append($(document.createElement('h6')).append(thisHeadTxt));
						}
						var theseItems = array[i].ITEM;
						if(array[i].STARS){
							theseItems = theseItems[0].split('*');
						}
						var thisDiv = $(document.createElement('div'));
						if(array[i].SECTION !== 'stLTRDropFees') {
							var thisUl = $(document.createElement('ul'));
							if(!emptyITEM) contentDiv.append(thisDiv.append(thisUl));
							for(var j=0;j<theseItems.length;j++){
								if (typeof theseItems[j].TEXT === 'string') {
									if (theseItems[j].ISHEADER) {
										thisUl.append($(document.createElement('li')).addClass('font-bold').append($.trim(theseItems[j].TEXT)));
									} else {
										thisUl.append($(document.createElement('li')).append($.trim(theseItems[j].TEXT)));
									}
								} else if (!theseItems[j].match(/~\[.+\]\|/)) {
									if ($.trim(theseItems[j]).length) thisUl.append($(document.createElement('li')).append($.trim(theseItems[j])));
								}
							}
							if(array[i].CODE === 'IZC' || array[i].CODE === 'IZB'){
								if(typeof array[i].URL === 'string' && array[i].URL.length){
									thisUl.append($(document.createElement('li')).append( array[i].DESCRIPTION+' <a href="'+array[i].URL+'" target="_blank" class="text--primary">('+array[i].LABEL+')</a>' ));
								} else {
									thisUl.append($(document.createElement('li')).append( array[i].DESCRIPTION));
								}
							}
						} else if(!emptyITEM){
							var thisHead = $(document.createElement('div')).addClass('push-half--top push-half--bottom soft--left soft--right').append('<b>'+$.trim(array[i].ITEM.HEAD)+'</b>');
							var thisNote = $(document.createElement('div')).addClass('push-half--top push-half--bottom soft--left soft--right').append($.trim(array[i].ITEM.NOTE));
							var thisTableContainer = $(document.createElement('div')).addClass('dropfees--table push-half--top push-half--bottom soft--left soft--right')
							var thisTable = $(document.createElement('table')).addClass('table--striped');
							contentDiv.append(thisDiv.append(thisHead));
							thisDiv.append(thisNote);
							thisDiv.append(thisTableContainer);
							thisTableContainer.append(thisTable);
							var tableData = array[i].ITEM.TABLE;
							for(var j=0;j<tableData.length;j++){
								var element = (j===0) ? 'th' : 'td';
								var thisTR = $(document.createElement('tr'));
								thisTable.append(thisTR);
								thisTR.append($(document.createElement(element)).append( $.trim(tableData[j].LOCATION) ));
								thisTR.append($(document.createElement(element)).append( $.trim(tableData[j].CARFEES) ));
								// thisTR.append($(document.createElement(element)).append( $.trim(tableData[j].VANFEES) ));
							}
						}
					}
					return {TAB:title,CONTENT:docFrag};
				}

				/**
				 * Creates a document fragment containing a toggle link to expand or collapse all accordion sections within a specified container.
				 * This function initializes the link with "Expand All" text and toggles the state of the accordion headers and their corresponding
				 * panels upon each click, switching between "Expand All" and "Collapse All".
				 *
				 * @param {jQuery} contentDiv - The jQuery object containing the accordion headers and panels.
				 * @returns {DocumentFragment} A document fragment containing a styled div with a toggle link for expanding or collapsing all accordion sections.
				 *
				 * @example
				 * const accordionContainer = $('#accordion');
				 * document.body.appendChild(buildExpandCollapseAllFrag(accordionContainer));
				 */
				function buildExpandCollapseAllFrag(contentDiv) {
					let $contentDiv = $(contentDiv); // we expect jquery so make it explicit
					let expand = true;

					function expandOrCollapse(eventContext) {
						let $accordionPanel = $(eventContext).closest('.ui-tabs-panel');
						toggleUIAccordions($accordionPanel, expand);
						updateAccordionState($accordionPanel);
					}

					function toggleUIAccordions($accordionPanel, isExpanding) {
						$accordionPanel.find(".ui-accordion-header").each((_, header) => {
							const $header = $(header); // Cache the jQuery object

							if (isExpanding) {
								$header
									.addClass("ui-accordion-header-active")
									.attr("aria-expanded", "true");
								$header.next().slideDown().attr("aria-hidden", "false");
								$header
									.children(".ui-accordion-header-icon")
									.removeClass("ui-icon-triangle-1-e")
									.addClass("ui-icon-triangle-1-s");
							} else {
								$header
									.removeClass("ui-accordion-header-active")
									.attr("aria-expanded", "false");
								$header.next().slideUp().attr("aria-hidden", "true");
								$header
									.children(".ui-accordion-header-icon")
									.removeClass("ui-icon-triangle-1-s")
									.addClass("ui-icon-triangle-1-e");
							}
						});
					}

					function updateAccordionState($accordionPanel) {
						let $controlAnchor = $accordionPanel.find("a.termsTreeControl")
						let $headers = $accordionPanel.find(".ui-accordion-header");
						let allClosed = true;
						let allOpen = true;

						$headers.each(function () {
							if ($(this).hasClass("ui-accordion-header-active")) {
								allClosed = false;
							} else {
								allOpen = false;
							}
						});

						expand = !allOpen || allClosed;
						$controlAnchor[0].textContent = expand ? "Open All Items" : "Close All Items";
					}

					const fragment = document.createDocumentFragment();

					const div = document.createElement("div");
					div.className = "accordion_container__controls";

					const anchor = document.createElement("a");
					anchor.classList.add("termsTreeControl");
					anchor.href = "javascript:void(0);";
					anchor.textContent = "Open All Items"; // Set the initial text for the anchor

					$(div).on("click", "a.termsTreeControl", function () {
						expandOrCollapse(this);
					});

					$contentDiv.accordion({
						collapsible: true,
						active: false,
						heightStyle: "content",
						beforeActivate: function (event, ui) {
							event.preventDefault(); // Prevents the default toggle behavior

							// Toggle visibility based on the current state of the panel
							if (ui.newPanel.length && ui.newPanel.is(":hidden")) {
								ui.newHeader.addClass("ui-accordion-header-active");
								ui.newHeader
									.children(".ui-accordion-header-icon")
									.removeClass("ui-icon-triangle-1-e")
									.addClass("ui-icon-triangle-1-s");
								ui.newHeader.attr("aria-expanded", true);
								ui.newPanel.attr("aria-hidden", false).slideDown();
							} else if (ui.newPanel.length && ui.newPanel.is(":visible")) {
								ui.newHeader.removeClass("ui-accordion-header-active");
								ui.newHeader
									.children(".ui-accordion-header-icon")
									.removeClass("ui-icon-triangle-1-s")
									.addClass("ui-icon-triangle-1-e");
								ui.newHeader.attr("aria-expanded", false);
								ui.newPanel.attr("aria-hidden", true).slideUp();
							}

							updateAccordionState(ui.newPanel.closest('.ui-tabs-panel'));
						},
					}); // This variant will allow other ui-accordion-header elements to remain open unless they are clicked "directly"

					div.appendChild(anchor);
					fragment.appendChild(div);

					return fragment;
				}

				/**
				 * Prints the context of the given car header and expanded terms section. All parameters are cloned.
				 * @param {jQuery} $carHeader - jQuery reference to a .carDetailsGrid to use as header.
				 * @param {jQuery} $expandedTermsSection - jQuery reference to terms section elements to expand.
				 * @param {boolean} [usePreview=true] - Flag indicating whether to use print preview or not.
				 * @returns {void}
				 */
				function printContext(
					$carHeader,
					$expandedTermsSection,
					usePreview = true
				) {
					// Function to check if all resources are loaded
					const checkAllLoaded = () => {
						if (loadedLinkCount >= totalLinkCount && usePreview) {
							// necessary for Chrome to handle favicon on about:blank
							setTimeout(() => printWindow.document.head.appendChild(faviconClone), 50);
							printWindow.focus(); // necessary for IE >= 10
						}
					};

					// clone everything to reference in the print window
					const headerClone = document.querySelector("header").cloneNode(true);
					const carClone = $carHeader[0].cloneNode(true);
					const termsClone = $expandedTermsSection[0].cloneNode(true);
					const faviconClone = document.head.querySelector("link[rel='shortcut icon'").cloneNode(true);
					const linkClones = Array.from(
						document.body.querySelectorAll("link")
					).map((link) => link.cloneNode(true));
					const totalLinkCount = linkClones.length;
					let loadedLinkCount = 0;

					// Prevent horizontal scrollbar in print view
					headerClone.classList.remove(
						"site--bleed-padding",
						"site--full-bleed"
					);

					// The media query gets muddled and elements which should be XOR show up in the print preview so we remove them here
					carClone
						.querySelectorAll("[class*='trulyhidden']")
						.forEach((element) => {
							if (
								element.classList.contains("grid__item") ||
								element.classList.contains("cardetails-data-toggler")
							)
								element.remove();
						});

					// Remove the link back to terms
					const hiddenTermsLink = carClone.querySelector(
						".text--primary.car-terms"
					);
					if (hiddenTermsLink != null) hiddenTermsLink.remove();

					// Fix the rendered shape for empty cardetails-features
					carClone
						.querySelectorAll(".cardetails-features span")
						.forEach((span) => {
							span.childNodes.forEach((node) => {
								if (
									!(node.nodeType === Node.TEXT_NODE && node.textContent.trim())
								) {
									span.append(document.createTextNode("\u00A0"));
								}
							});
						});

					// display all the accordion content, mock expanded header state, remove interactivity hints
					termsClone
						.querySelectorAll(".ui-accordion-header")
						.forEach((header) => {
							header.style.cursor = "auto";
							header
								.querySelectorAll("span.ui-icon-triangle-1-e")
								.forEach((span) =>
									span.classList.replace(
										"ui-icon-triangle-1-e",
										"ui-icon-triangle-1-s"
									)
								);
						});
					termsClone
						.querySelectorAll(".ui-accordion-content")
						.forEach((element) => (element.style.display = ""));

					const fragment = document.createDocumentFragment();
					fragment.append(headerClone, carClone, termsClone);

					// Open a new tab
					const printWindow = window.open("about:blank", "_blank");
					printWindow.document.open();
					printWindow.document.write(`
						<html>
							<head>
								<style>
									body {
										display: block;
										overflow: visible !important;
									}
								</style>
								<title>Print Preview</title>
								<script>
									function openPrintDialog() {
										setTimeout(function() {
											window.print();
										}, 0);
									}
        				</script>
							</head>
							<body class="wrap wrap--sized">
							<button style="margin-top: 1em;text-align: center;" class="grid__item btn--primary trulyhidden--print" onclick="openPrintDialog();" type="button">Print</button>
							</body>
						</html>
					`);
					// Removed from body to suppress automatic print dialog opening
					// onload="setTimeout(() => window.print(), 250);"
					printWindow.document.close(); // Close the document to further writing

					// Append the links and fragment to the body of the new document
					linkClones.forEach((linkClone) => {
						linkClone.onload = () => {
							loadedLinkCount++;
							checkAllLoaded(); // Check if all links are loaded
						};
						linkClone.onerror = () => {
							loadedLinkCount++; // Assume loaded on error to avoid deadlock
							checkAllLoaded();
						};
						printWindow.document.head.appendChild(linkClone);
					});

					printWindow.document.body.appendChild(fragment);
				}

				function getOrAssembleCarHeader() {
					let $carHeader = $target.closest(".carDetailsGrid");

					// Handle results case first
					if ($carHeader.length !== 0)
						return $carHeader;

					// We are beyond results so we must construct our car from the current context
					let $carHeaderDiv = $(document.createElement("div")).addClass("grid");

					// When present this represents the current selection context (options, upgrade, checkout)
					let $carDetailsContainer = $target.closest("[id$='utbar__container--side']");
					if ($carDetailsContainer.length === 0) {
						// Otherwise this is an existing reservation view
						$carDetailsContainer = $target.closest("#resInfo");
						if ($carDetailsContainer.length === 0) {
							// Otherwise this is the original detail during modify
							$carDetailsContainer = $target.closest("#modify_utbar__container--top");
							if ($carDetailsContainer.length === 0) {
								// Otherwise this is the confirmation form
								$carDetailsContainer = $target.closest(".confirmation-summary");
								if ($carDetailsContainer.length === 0) {
									// Checkout form link has no ancestral path to current car header details
									$carDetailsContainer = $("#utbar__container--side");
								}
							}
						}
					}

					// We can render printable terms without the header so warn and return
					if ($carDetailsContainer.length === 0) {
						console.warn("Unable to construct printable car header.");
						return $carHeaderDiv;
					}

					// Locate the data in the DOM
					const $carImage = $carDetailsContainer.find(".cardetails-carimg").first().clone();
					const $carOperator = $carDetailsContainer.find(".cardetails-caroperator").first().clone();
					const $carName = $carDetailsContainer.find(".cardetails-carname").first().clone();
					const $carType = $carDetailsContainer.find("div.cardetails-cartype").first().clone();
					const $carDetailsFeatures = $carDetailsContainer.find(".cardetails-features").first().clone();
					const $carDetailsSippNotes = $carDetailsContainer.find(".cardetails-sippnotes").first().clone();

					// Repackage the image and operator grids
					const $imageAndOperatorWrapper = $(document.createElement("div")).addClass("grid__item one-half palm-one-whole carDetailsImage");
					const $imageAndOperator = $(document.createElement("div")).addClass("grid carDetailsMobileGrid");
					$carOperator.find("span").each(function() {Array.from(this.childNodes).forEach((node) => {if (node.nodeType === 3) {this.removeChild(node);}})});
					$imageAndOperator.append($carImage, $carOperator.removeClass().addClass("grid__item cardetails-caroperator small-stars palm-one-half push-half--top"));
					$imageAndOperatorWrapper.append($imageAndOperator);

					// Repackage the car name to be consistent
					const $carNameHeader = $(document.createElement("h2"));
					$carNameHeader.text($carName.text());
					$carNameHeader.addClass("flush--bottom carDetailsPalm_head trulyhidden--palm");

					const $allOtherDetails = $(document.createElement("div")).addClass("grid__item one-half palm-one-whole");
					$allOtherDetails.append($carNameHeader, $carType, $carDetailsFeatures, $carDetailsSippNotes);

					$carHeaderDiv.append($imageAndOperatorWrapper, $allOtherDetails);

					return $carHeaderDiv;
				}

				/**
				 * Creates and returns a document fragment containing an accordion container for printing terms.
				 *
				 * @param {string} contentDivSelector - A valid CSS query selector that identifies the terms content.
				 * @return {DocumentFragment} - The created document fragment containing the accordion container.
				 */
				function printTermsSection(contentDivSelector) {
					const fragment = document.createDocumentFragment();

					const div = document.createElement("div");
					div.className = "accordion_container__controls trulyhidden--palm";

					const anchor = document.createElement("a");
					anchor.classList.add("printTermsControl");
					anchor.href = "javascript:void(0);";
					anchor.textContent = "Print Terms";

					$(div).on("click", "a.printTermsControl", function () {
						printContext(getOrAssembleCarHeader(), $(contentDivSelector));
					});

					div.append(anchor);
					fragment.append(div);

					return fragment;
				}

				function generateUniqueId(prefix = 'id') {
					const datePart = new Date().getTime(); // Gets the current timestamp
					const randomPart = Math.floor(Math.random() * 1000000); // Generates a random number up to 1,000,000
					return `${prefix}-${datePart}-${randomPart}`;
				}

				function buildBlock(title,array,acceptTxt,defaultHead){
					docFrag = $(document.createDocumentFragment());
					acceptTxt = acceptTxt || '';
					if(APP.props.showAccept) docFrag.append($(document.createElement('div')).addClass('cardetails-smallprint fcr_smallprint').append(acceptTxt));
					let uniqueContentId = generateUniqueId('contentDiv');
					var $contentDiv = $(document.createElement('div')).addClass('accordion_container--collapsed').attr('id', uniqueContentId);
					docFrag.append($contentDiv);

					// WEBAE3-6186, WEBAE3-6185 Enable expand/collapse all and print controls here
					if (['DAP'].indexOf(AE.props.mSiteCode) >= 0) {
						if (title === 'Local Fees & Info') {
							$contentDiv.removeClass('accordion_container--collapsed').addClass('accordion_container--all');
							docFrag.append(buildExpandCollapseAllFrag($contentDiv));
							APP.props.hasCustomEvents = true;
						} else {
							docFrag.append(printTermsSection(`#${uniqueContentId}`));
							APP.props.hasCustomEvents = true;
						}
					}

					for(var i=0;i<array.length;i++){
						var thisHeadTxt = $.trim(array[i].TITLE).split('\n')[0];
						thisHeadTxt = thisHeadTxt.split('*')[0];
						if(array[i].ITEM.length === 1 && array[i].ITEM[0] === ''){
							var emptyITEM = true;
						} else {
							var emptyITEM = false;
						}
						if(array[i].HTML){
							$contentDiv.removeClass('accordion_container--collapsed accordion_container--all').addClass('border--top soft-half--left soft-half--right').append(array[i].HTML);
							$contentDiv.find('#termscontent a').addClass('text--primary');
						} else {
							if(thisHeadTxt.length < 2) { thisHeadTxt = defaultHead; }
							if(AE.props.siteCode == 'FCR' && thisHeadTxt !== 'GPS') {
								thisHeadTxt = thisHeadTxt.toLowerCase();
							}
							if(!emptyITEM) $contentDiv.append($(document.createElement('h6')).append(thisHeadTxt));
						}
						var theseItems = array[i].ITEM;
						if(array[i].STARS){
							theseItems = theseItems[0].split('*');
						}
						var thisDiv = $(document.createElement('div'));
						if(array[i].SECTION !== 'stLTRDropFees') {
							var thisUl = $(document.createElement('ul'));
							if(!emptyITEM) $contentDiv.append(thisDiv.append(thisUl));
							for(var j=0;j<theseItems.length;j++){
								if (typeof theseItems[j].TEXT === 'string') {
									if (theseItems[j].ISHEADER) {
										thisUl.append($(document.createElement('li')).addClass('font-bold').append($.trim(theseItems[j].TEXT)));
									} else {
										thisUl.append($(document.createElement('li')).append($.trim(theseItems[j].TEXT)));
									}
								} else if (!theseItems[j].match(/~\[.+\]\|/)) {
									if ($.trim(theseItems[j]).length) thisUl.append($(document.createElement('li')).append($.trim(theseItems[j])));
								}
							}
							if(array[i].CODE === 'IZC' || array[i].CODE === 'IZB'){
								if(typeof array[i].URL === 'string' && array[i].URL.length){
									thisUl.append($(document.createElement('li')).append( array[i].DESCRIPTION+' <a href="'+array[i].URL+'" target="_blank" class="text--primary">('+array[i].LABEL+')</a>' ));
								} else {
									thisUl.append($(document.createElement('li')).append( array[i].DESCRIPTION));
								}
							}
						} else if(!emptyITEM){
							var thisHead = $(document.createElement('div')).addClass('push-half--top push-half--bottom soft--left soft--right').append('<b>'+$.trim(array[i].ITEM.HEAD)+'</b>');
							var thisNote = $(document.createElement('div')).addClass('push-half--top push-half--bottom soft--left soft--right').append($.trim(array[i].ITEM.NOTE));
							var thisTableContainer = $(document.createElement('div')).addClass('dropfees--table push-half--top push-half--bottom soft--left soft--right')
							var thisTable = $(document.createElement('table')).addClass('table--striped');
							$contentDiv.append(thisDiv.append(thisHead));
							thisDiv.append(thisNote);
							thisDiv.append(thisTableContainer);
							thisTableContainer.append(thisTable);
							var tableData = array[i].ITEM.TABLE;
							for(var j=0;j<tableData.length;j++){
								var element = (j===0) ? 'th' : 'td';
								var thisTR = $(document.createElement('tr'));
								thisTable.append(thisTR);
								thisTR.append($(document.createElement(element)).append( $.trim(tableData[j].LOCATION) ));
								thisTR.append($(document.createElement(element)).append( $.trim(tableData[j].CARFEES) ));
								// thisTR.append($(document.createElement(element)).append( $.trim(tableData[j].VANFEES) ));
							}
						}
					}

					if ($contentDiv.data("ui-accordion")) {
						// This indicates we setup custom accordion behavior before the accordion was fully built and now should refresh
						$contentDiv.accordion("refresh");
					}

					return {TAB:title,CONTENT:docFrag};
				}
			}
		},
		onBodyClick:function(event,$target){
			if ($target.hasClass('car-terms')) {
				APP.dialog(event);
			} else if($target.hasClass('rate-title') &&
				($target.parent().hasClass('car-terms') || $target.parent().hasClass('more-info-tip'))
			){
				$target.parent().trigger('click');
			}
			return false;
		}
	};
	return APP;
})();

;var AE = AE || {}; /* Add to Base object or create it if it doesn't exist. */

AE.ui.modify = AE.ui.modify || (function(){
	/* 
	DEPENDENCIES: AE, AE.ui, AE.forms
	*/

	var UI = {
		init:function() {
			//console.log('modify init');
			UI.handleWalkin($('#aemodify form#frSimpleMod select#airline').val());
			UI.handleCancelCodeSelect();
			// Lock Driver Information In Checkout form on Lookup Page
			$('#aemodify .checkout_container').find('input#firstname,input#lastName,input#age,input#email,input#reemail,input#airline,input#airlinename2,input#flightnum').prop('readonly',true);
			//,input#numPass,input#telephone Removed number of pass and telephone
			$('#aemodify #search-form').addClass('visuallyhidden');
			
			legacyBookingModalShown = false;
			AE.ui.addBodyClickTask({func: UI.onBodyClick});
			AE.ui.addBodyChangeTask({func: UI.onBodyChange});
			UI.scrollToResAction();

		},
		handleWalkin:function(airlineCode) {
			airlineCode = airlineCode || 'WI';
			if(airlineCode === 'WI'){
				$('#aemodify form#frSimpleMod input#flightnum').val('00').prop('readonly',true);
				//$('#aemodify form#frSimpleMod select#datetime').val('').prop('readonly',true);
			} else {
				$('#aemodify form#frSimpleMod input#flightnum').prop('readonly',false);
				//$('#aemodify form#frSimpleMod select#datetime').prop('readonly',false);
			}
		},
		handleCancelCodeSelect:function(cancelCode){
			cancelCode = cancelCode || '';
			var code = $.trim(cancelCode);
			$('div#submitCancel,div#detailCancel,div#detailCancel div.cancel__detail').addClass('visuallyhidden');
			if(code.length) $('div#submitCancel,div#detailCancel,div#detailCancel div.cancel__detail.code--'+code).removeClass('visuallyhidden');
		},
		handleCancelCanContact:function($target){
			if($target.attr('id') === 'canContact'){
				$('div.canContactY,div.canContactN').addClass('visuallyhidden');
				if($target.prop('checked')){
					$('div.canContactY').removeClass('visuallyhidden');
				} else {
					$('div.canContactN').removeClass('visuallyhidden');
				}
			}
		},
		onBodyClick:function(event,$target){
			var targetID = event.target.id;
			var targetTag = event.target.tagName.toUpperCase();
			UI.handleCancelCanContact($target);
			if($target.attr('id') === 'btSimpleModSubmit' || $target.attr('id') === 'btCancel'){
				// Prevent double clicking submit buttons for modify forms without guardian
				$target.prop('disabled',true).closest('form').submit();
			} else if($target.attr('id') === 'btConvertSubmit' || $target.attr('id') === 'btElecPaymentSubmit' || $target.attr('id') === 'btCancel'){
				// Prevent double clicking submit buttons for modify forms without guardian
				$target.prop('disabled',true).closest('form').submit();
			} 
			//WEBAE3--4778 fix the issue with the accordion +/- not showing correctly and it is desired that all accordions must close while just one is open at a time
			
			else if ($target.hasClass('toggle_pm_header')){
				//console.log("accordion-test-WEBAE3-4478");
			
				$('.toggle_pm_header').each(function() {
   						
   						 if($(this).hasClass('closed')){
   						 	$(this).next().addClass('visuallyhidden')
   							}
  				});

  				//search form under modify needs to display -moved inside content div to display properly and have hide class taken out for it's use here
  				$(' #toggleeNewSearch #search-form ').removeClass('visuallyhidden');
				
				//WEBAE3-6715 - Translation API: Display "cancel/rebook" message when legacy bookings are looked up
				//WEBAE3-7022 - Translation API: Remove cookie that limits legacy cancel/re-book warning to 1 per session
				//WEBAE3-7116 - added !oSite.bForceLegacy so we don't pop this warning if we're not using Rev
				if ($target.attr('id') === 'togglerNewSearch' && oSite.bLegacyVoucher && oSite.bUseTapi && !oSite.bForceLegacy){

					var oButtons = {};
					oButtons[oSite.oTranslations.BTN_CONTINUE] = function () {
                        AE.ui.dialog.close();
                    };

					var oContent = $( document.createDocumentFragment() )
					.append( $( document.createElement( 'div' ) )
							.append( oSite.oTranslations.LBKDIALOG )
					);

					/*if(legacyBookingModalShown === true || document.cookie.indexOf('legacyBookingModalShown') >= 0){
						showLBDialog = false;
					} else {
						
					}*/
					showLBDialog = true;
					if($('#togglerNewSearch').hasClass('open') && showLBDialog === true){
						AE.ui.dialog.launch({
							id: 'legacyBookingDialog',
							dialogClass: 'top-dialog',
							buttons: oButtons,
							titleBar: false,
							buttonOpts: {
									buttonsClass: 'btn--primary fcr-buttom-primary',
									exclusiveClose: true
							},
							content: oContent,
							width: ($(window).width() > 900) ? 850 : '80%'
						});

						/*legacyBookingModalShown = true;
						window.AECookie.create('legacyBookingModalShown', true);
						document.cookie = "legacyBookingModalShown=true;";*/
						
					}
				}
			}
		


				//original code here
				/*else if ($target.attr('id') === 'togglerNewSearch '){

					if($target.hasClass('open')){
						$('#aemodify #search-form').removeClass('visuallyhidden')
					} else {
						$('#aemodify #search-form').addClass('visuallyhidden')
					}
				}*/
	
		},


		onBodyChange:function(event,$target){

			var targetID = event.target.id;
			var targetTag = event.target.tagName.toUpperCase();
			var targetType = event.target.type.toUpperCase();
			
			switch(targetTag){
				case 'INPUT':
					
					break;
				case 'SELECT':
					if(targetID.toUpperCase() === 'AIRLINE') UI.handleWalkin($target.val());
					if(targetID.toUpperCase() === 'CANCELCODE') UI.handleCancelCodeSelect($target.val());
					break;
				case 'TEXTAREA':
					
					break;
			}
		},

		scrollToResAction:function() {
			/* Scrolls page to 'Confirm Your Booking' section of /my-booking after car image loads */
			var resActionToggle = $("#resAction").find("h4")[0];
			var targetIdName = 'resAction';
			//WEBAE3-4603 target cc payment info if cc error on payment
			if (AEdata.modify && AEdata.modify.ccerror) {
				targetIdName = 'ccInfoBlock';
			}
			if(resActionToggle){
				if (resActionToggle.classList.contains('open')) {
					setTimeout(function(){
						document.getElementById(targetIdName).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
						}, 500); // wait for the image to load
				};
			}
		}
	}

	return UI;
})();
/*
AE.init.general: Resolves the deferred object for the booking modules.
*/
objDFD.booking.resolve();